import { useAnalytics, hasWindow, hasDocument, useQuery, DefaultText, DefaultImage, InternalLink, MarkupText, ExternalLink, useScrollPosition, baseAdvertisementBlock, useAdvertisement, DefaultAdvertiseGroupRef, ActionLink, DefaultActionList, DefaultSocialIconActionList, DefaultImageAction, baseMenuFavoritesBtn, baseLanguagePicker, useWindowDimensions, DefaultActionWithSubActions, isCurrentPage, DefaultActionWithSubActionsList, baseCookieBanner, baseFinancingBanner, baseFinancingContent, baseFavoriteBtn, baseCompareBtn, useClientSettings, formatPrice, navigateInternalUrl, formatNumber, baseVehicleCard, baseFavoriteVehicles, getStickiesOffset, navigateInternalPage, baseCompare, baseCompareBanner, useOuterClick, baseDealerContactForm, DealerContactTypes, hasValue, isValidEmail, useContentBlockImpressionWhenInViewport, formatPriceByCulture, b64DecodeUnicode, ImageLightBox, ImageViewer, Turntable, ImageThumbnails, baseVehicleDetail, DefaultPrimaryAction, DefaultAdditionalVehicleImages, baseTypedFilter, FilterTypes, baseFilter, baseModelFilterForMakeModel, baseMakeFilterForMakeModel, withFilters, baseNotifyBtn, basePagination, baseVehiclesPaged, withSort, baseVehiclesAndFilters, baseMakeSearchAgentCriteriaForMakeModel, baseModelSearchAgentCriteriaForModel, baseTypedSearchAgentCriteria, SearchAgentCriteriaTypes, baseSearchAgentCriteria, baseSearchAgentField, baseSearchAgentTopBar, baseSearchAgentForm, baseSearchAgent, baseSearchBox, baseSliderWithCustomImageCard, useDeviceType, DefaultAction } from '@digitalexperience/dealer-website-core';
export { CaptchaProvider, DataContext, DataContextProvider, defaults as coreDefaults, types as coreTypes, utils as coreUtils, useAnalytics, useSession } from '@digitalexperience/dealer-website-core';
import React, { useEffect, useState, useRef, Fragment, forwardRef } from 'react';
import { flatten, chunk, head, filter, find, times, map, includes, slice, isEmpty, range, uniq, forEach, some, orderBy, sortBy, mapValues, keyBy, min, max, last, findIndex as findIndex$1, isEqual as isEqual$1, toLower, parseInt as parseInt$1, each, keys as keys$1 } from 'lodash';
import { useTranslation } from 'react-i18next';
import { Fade } from 'react-reveal';
import ReactInputMask from 'react-input-mask';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Sticky from 'react-stickynode';
import Select, { components } from 'react-select';
import Slider, { Range } from 'rc-slider';
import Modal from 'react-modal';
import Fade$1 from 'react-reveal/Fade';
import Scrollbars from 'react-custom-scrollbars-2';

var fonts = [];
var icons = [];
var css = [];
var config = {
  defaultCulture: 'nl',
  fonts: fonts,
  icons: icons,
  css: css
};

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

var DealerLocatorWidget = function DealerLocatorWidget(_ref) {
  var height = _ref.height,
    context = _ref.context;
  var _useAnalytics = useAnalytics(context),
    _useAnalytics$buttonC = _useAnalytics.buttonClickEventAnalytics,
    buttonClickEventAnalytics = _useAnalytics$buttonC === void 0 ? function (data) {
      return null;
    } : _useAnalytics$buttonC;
  var onClickButttonItinerary = function onClickButttonItinerary(e) {
    buttonClickEventAnalytics({
      analyticsButtonName: 'to-calculate-itinerary',
      analyticsButtonType: 'button',
      analyticsButtonCategory: 'outbound-link',
      analyticsButtonPosition: 'DealerLocatorWidget',
      url: e.target.href
    });
  };
  var onClickButttonContact = function onClickButttonContact(e) {
    buttonClickEventAnalytics({
      analyticsButtonName: 'to-dealersite-general-contact-dealer',
      analyticsButtonType: 'button',
      analyticsButtonCategory: 'outbound-link',
      analyticsButtonPosition: 'DealerLocatorWidget',
      url: e.target.href
    });
  };
  var addOnClicksToButtons = function addOnClicksToButtons() {
    try {
      var _buttonContainer$getE, _buttonContainer$getE2;
      var buttonsContainers = document.getElementsByClassName('container-button');
      if (!buttonsContainers || buttonsContainers.length == 0) return;
      var buttonContainer = buttonsContainers.item(0);
      var itineraryButton = (_buttonContainer$getE = buttonContainer.getElementsByClassName('calculate-your-itinerary')) === null || _buttonContainer$getE === void 0 ? void 0 : _buttonContainer$getE.item(0);
      var contactButton = (_buttonContainer$getE2 = buttonContainer.getElementsByClassName('btn-primary')) === null || _buttonContainer$getE2 === void 0 ? void 0 : _buttonContainer$getE2.item(0);
      if (itineraryButton) {
        itineraryButton.onclick = onClickButttonItinerary;
      }
      if (contactButton) {
        contactButton.onclick = onClickButttonContact;
      }
    } catch (_unused) {}
  };
  var handleClickContainer = function handleClickContainer(e) {
    addOnClicksToButtons();
  };
  var handleLoadedDealerLocatorScript = function handleLoadedDealerLocatorScript() {
    var _context$dealerGroups;
    var settings = {
      language: context.culture,
      templateCode: 'MW',
      setFocusOnLoading: false
    };
    if (((_context$dealerGroups = context.dealerGroups) === null || _context$dealerGroups === void 0 ? void 0 : _context$dealerGroups.length) > 0) {
      settings = _extends({}, settings, {
        commercialGroupIds: context.dealerGroups.map(function (g) {
          return g.externalReference;
        })
      });
    } else if (context.dealerGroup) {
      settings = _extends({}, settings, {
        commercialGroupIds: [context.dealerGroup.externalReference]
      });
    }
    try {
      window.DealerLocatorWidget.mount(settings);
    } catch (ex) {
      try {
        window.DealerLocatorWidget.unmount(settings);
        window.DealerLocatorWidget.mount(settings);
      } catch (ex) {
        console.log('something wrong with the map');
        console.log(ex);
      }
    }
  };
  useEffect(function () {
    var scriptElement;
    if (hasWindow()) {
      scriptElement = document.createElement('script');
      scriptElement.src = 'https://dealerlocator.dieteren.be/react/js/dealerLocatorWidget.js';
      scriptElement.id = 'dealer-locator-widget-script';
      scriptElement.async = true;
      scriptElement.onload = handleLoadedDealerLocatorScript;
      document.body.appendChild(scriptElement);
    }
    return function () {
      scriptElement && document.body.removeChild(scriptElement);
    };
  }, [hasWindow()]);
  if (context.builder) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        height: height
      }
    }, "Dealer locator widget");
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "dealer-locator-widget overflow-hidden",
    style: {
      height: height
    },
    onClick: handleClickContainer
  }));
};
DealerLocatorWidget.defaultProps = {
  height: 600
};
DealerLocatorWidget.human = {
  nl: '',
  fr: '',
  en: ''
};
DealerLocatorWidget.preview = function () {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: 150
    }
  }, " DealerLocatorWidget ");
};

var bodyBerline = "berline~bnasZUiu.png";

var bodyBestelwagens = "bestelwagens~ZJfLagqA.png";

var bodyBreak = "break~AsSlbEPa.png";

var bodyCabrio = "cabrio~gSWXsVLx.png";

var bodyCoupe = "coupe~UlSbNUpD.png";

var bodyMonovolume = "monovolume~LMBBZNcJ.png";

var bodySuv = "suv~sQvZbxvT.png";

var CMS_URL = 'https://lma.qa.digex.be/';
var useAsset = function useAsset(resource) {
  return require("/" + resource)["default"];
};
var getBodyImageSrc = function getBodyImageSrc(key) {
  if (!key) return '';
  switch (key) {
    case 'sedan':
      return useAsset(bodyBerline);
    case 'convertible':
      return useAsset(bodyCabrio);
    case 'coupe':
      return useAsset(bodyCoupe);
    case 'off_road':
    case 'off-road/pick-up':
      return useAsset(bodySuv);
    case 'bus_van':
    case 'van':
      return useAsset(bodyMonovolume);
    case 'station_wagon':
      return useAsset(bodyBreak);
    case 'transporter':
      return useAsset(bodyBestelwagens);
    default:
      return '';
  }
};
var STICKY_STATUS = {
  STATUS_FIXED: 2,
  STATUS_RELEASED: 1,
  STATUS_ORIGINAL: 0
};
var formatNumberToMin2Digits = function formatNumberToMin2Digits(number) {
  return parseFloat(number).toLocaleString('nl-NL', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  });
};
var formatDate = function formatDate(date) {
  var today = new Date(date);
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0');
  var yyyy = today.getFullYear();
  return dd + '/' + mm + '/' + yyyy;
};
var scrollToTarget = function scrollToTarget(id, offset, behavior) {
  if (offset === void 0) {
    offset = 0;
  }
  if (behavior === void 0) {
    behavior = 'smooth';
  }
  if (hasDocument()) {
    var targetEl = document.getElementById(id);
    if (targetEl) {
      var pos = targetEl.style.position;
      var top = targetEl.style.top;
      targetEl.style.position = 'relative';
      targetEl.style.top = -offset + "px";
      targetEl.scrollIntoView({
        behavior: behavior,
        block: 'start'
      });
      targetEl.style.top = top;
      targetEl.style.position = pos;
    }
  }
};
var getElementByClassName = function getElementByClassName(className) {
  var elems = document.getElementsByClassName(className);
  if ((elems === null || elems === void 0 ? void 0 : elems.length) > 0) {
    var el = undefined;
    if (elems.length === 1) {
      el = head(elems);
    } else if (elems.length > 1) {
      el = head(filter(elems, function (el) {
        return el.offsetTop > 0;
      }));
    }
    return el;
  }
  return undefined;
};
var scrollToTargetV2 = function scrollToTargetV2(element, offset, behavior) {
  if (offset === void 0) {
    offset = 0;
  }
  if (behavior === void 0) {
    behavior = 'smooth';
  }
  if (hasDocument()) {
    if (element) {
      try {
        var pos = element.style.position;
        var top = element.style.top;
        element.style.position = 'relative';
        element.style.top = -offset + "px";
        element.scrollIntoView({
          behavior: behavior,
          block: 'start'
        });
        element.style.top = top;
        element.style.position = pos;
      } catch (e) {}
    }
  }
};
var FINANCING_TYPE_KEYS = {
  CLASSIC: 'classic',
  BALLOON: 'balloon',
  LEASE: 'lease',
  RENT: 'rent',
  LONG_TERM_RENTAL: 'long_term_rental'
};
var initialMessage = function initialMessage(language) {
  var message = 'Hallo, \ni am interested in this vehicle.\nCan you contact me about this?\nThanks';
  if (language === 'nl') {
    message = 'Goeiedag,\nik ben geïnteresseerd in dit voertuig.\nKan u mij hierover contacteren?\nBedankt';
  } else if (language === 'fr') {
    message = 'Bonjour,\nje suis intéressé(e) par ce véhicule.\nPouvez-vous me recontacter ?\nMerci.';
  }
  return message;
};
var isLocalhost = function isLocalhost() {
  if (hasWindow()) {
    return window.location.hostname === 'localhost' || window.location.hostname === '[::1]' || window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/);
  }
  return false;
};
var prefix = isLocalhost() ? CMS_URL : '';
var IMAGES = {
  'aap-white-logo-nl': prefix + "/media/files/24983711558159821651733262889104721655642003168688474333233505583863837122530.webp",
  'aap-white-logo-fr': prefix + "/media/files/61668516104905540876722693365814219757404275413809527021406063580897126798224.webp",
  'aap-red-logo-fr': prefix + "/media/files/31309157155305422269148263492447118615019174716530461264594500754068521620161.webp",
  'aap-red-logo-nl': prefix + "/media/files/111146629052420823494320228555730163365362420598547888932277873273332138910489.webp",
  'aap-card-image': prefix + "/media/files/90784065381916984290371243364889789788066509493727666186604600326051660279997.webp",
  'myway-dark-text-logo-nl': prefix + "/media/files/57261910179577664520659858258409484135779643279873283819693557183988423641089.webp",
  'myway-white-text-logo-nl': prefix + "/media/files/17021007270125651290218638529824150026309579398161708558688264714546919827689.webp",
  'myway-card-cover': prefix + "/media/files/110937108703390755130633244001318562603921902742010942507288151780041961511643.webp"
};
var datePickerLocale = function datePickerLocale(language) {
  if (language === 'nl') {
    return 'nl-NL';
  } else if (language === 'fr') {
    return 'fr-FR';
  }
  return 'nl-NL';
};
var monthsForLocale = function monthsForLocale(localeName, monthFormat) {
  if (localeName === void 0) {
    localeName = 'es-MX';
  }
  if (monthFormat === void 0) {
    monthFormat = 'long';
  }
  var format = new Intl.DateTimeFormat(localeName, {
    month: monthFormat
  }).format;
  return Array.from(Array(12).keys()).map(function (m) {
    return format(new Date(Date.UTC(2021, m % 12)));
  });
};
var privacyUrl = function privacyUrl(context) {
  var language = context.culture ? context.culture : 'nl';
  if (hasWindow()) {
    return window.location.origin + "/" + language + "/privacy";
  }
  return '';
};
var compareBannerVisible = function compareBannerVisible(className) {
  if (className === void 0) {
    className = 'vehicles-compare-parent';
  }
  if (hasDocument()) {
    var elems = document.getElementsByClassName(className);
    return elems && elems.length > 0;
  }
  return false;
};
var BRANDING = {
  myway: 'myway',
  aap: 'aap',
  lma: 'lma'
};
var LABELS = {
  MYWAY: 'myway_(vw_skoda_audi_seat)',
  AAP: 'audi_approved_plus',
  LMA: 'lma'
};
var increasedForVAT = function increasedForVAT(value) {
  var percent = 21 / 100 * value;
  return value + percent;
};
var isMyWayLabel = function isMyWayLabel(labels) {
  var isMyWay = find(labels, function (label) {
    return label.key === LABELS.MYWAY;
  });
  return !!isMyWay;
};
var isAapLabel = function isAapLabel(labels) {
  var isAap = find(labels, function (label) {
    return label.key === LABELS.AAP;
  });
  return !!isAap;
};
var getBrandByLabelsV2 = function getBrandByLabelsV2(labels) {
  if (isMyWayLabel(labels)) {
    return BRANDING.myway;
  } else if (isAapLabel(labels)) {
    return BRANDING.aap;
  } else {
    return BRANDING.lma;
  }
};
var getElementByClassNameOrNull = function getElementByClassNameOrNull(element, className) {
  if (!element || !className) return null;
  var sections = element.getElementsByClassName(className);
  return sections ? head(sections) : null;
};
var getDocumentFirstElementByClassName = function getDocumentFirstElementByClassName(className) {
  if (hasDocument()) {
    return getElementByClassNameOrNull(document, className);
  }
  return null;
};
var addSeparatorToVehiclesList = function addSeparatorToVehiclesList(numberCardsPerRow, currentList, separatorType) {
  if (separatorType === void 0) {
    separatorType = 'separator';
  }
  var addEvery = numberCardsPerRow;
  var itemToAdd = {
    _type: separatorType
  };
  return flatten(chunk(currentList, addEvery).map(function (section) {
    return section.length === addEvery ? [].concat(section, [itemToAdd]) : section;
  }));
};
var countriesListWithMask = [{
  locale: 'BE',
  key: 'belgian',
  label: function label(t) {
    return t('Belgium');
  },
  code: '+32',
  priority: '1',
  phoneMask: '+32 999 99 99 99',
  vatMask: 'BE 9999 999 999',
  vatLength: 15
}, {
  locale: 'DE',
  key: 'german',
  label: function label(t) {
    return t('Germany');
  },
  code: '+49',
  priority: '2',
  phoneMask: '+49 99 99999999',
  vatMask: 'DE 999999999',
  vatLength: 12
}, {
  locale: 'FR',
  key: 'french',
  label: function label(t) {
    return t('France');
  },
  code: '+33',
  priority: '3',
  phoneMask: '+33 9 99 99 99 99',
  vatMask: 'FR **999999999',
  vatLength: 14
}, {
  locale: 'LU',
  key: '',
  label: function label(t) {
    return t('Luxembourg');
  },
  code: '+352',
  priority: '4',
  phoneMask: '+352 99 99 99 99',
  vatMask: 'LU 99999999',
  vatLength: 11
}, {
  locale: 'NL',
  key: 'dutch',
  label: function label(t) {
    return t('Netherlands');
  },
  code: '+31',
  priority: '5',
  phoneMask: '+31 999 999 999',
  vatMask: 'NL 999999999 B99',
  vatLength: 16
}, {
  locale: 'AT',
  key: '',
  label: function label(t) {
    return t('Austria');
  },
  code: '+43',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}, {
  locale: 'BG',
  key: '',
  label: function label(t) {
    return t('Bulgaria');
  },
  code: '+359',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}, {
  locale: 'HR',
  key: '',
  label: function label(t) {
    return t('Croatia');
  },
  code: '+385',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}, {
  locale: 'CY',
  key: '',
  label: function label(t) {
    return t('Cyprus');
  },
  code: '+357',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}, {
  locale: 'CZ',
  key: '',
  label: function label(t) {
    return t('Czech Republic');
  },
  code: '+420',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}, {
  locale: 'DK',
  key: '',
  label: function label(t) {
    return t('Denmark');
  },
  code: '+45',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}, {
  locale: 'EE',
  key: '',
  label: function label(t) {
    return t('Estonia');
  },
  code: '+372',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}, {
  locale: 'FI',
  key: '',
  label: function label(t) {
    return t('Finland');
  },
  code: '+358',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}, {
  locale: 'GR',
  key: '',
  label: function label(t) {
    return t('Greece');
  },
  code: '+30',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}, {
  locale: 'HU',
  key: '',
  label: function label(t) {
    return t('Hungary');
  },
  code: '+36',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}, {
  locale: 'IE',
  key: '',
  label: function label(t) {
    return t('Ireland');
  },
  code: '+353',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}, {
  locale: 'IT',
  key: '',
  label: function label(t) {
    return t('Italy');
  },
  code: '+39',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}, {
  locale: 'LV',
  key: '',
  label: function label(t) {
    return t('Latvia');
  },
  code: '+371',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}, {
  locale: 'LT',
  key: '',
  label: function label(t) {
    return t('Lithuania');
  },
  code: '+370',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}, {
  locale: 'MT',
  key: '',
  label: function label(t) {
    return t('Malta');
  },
  code: '+356',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}, {
  locale: 'PL',
  key: '',
  label: function label(t) {
    return t('Poland');
  },
  code: '+48',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}, {
  locale: 'PT',
  key: '',
  label: function label(t) {
    return t('Portugal');
  },
  code: '+351',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}, {
  locale: 'RO',
  key: '',
  label: function label(t) {
    return t('Romania');
  },
  code: '+40',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}, {
  locale: 'SK',
  key: '',
  label: function label(t) {
    return t('Slovakia');
  },
  code: '+421',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}, {
  locale: 'SI',
  key: '',
  label: function label(t) {
    return t('Slovenia');
  },
  code: '386',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}, {
  locale: 'ES',
  key: '',
  label: function label(t) {
    return t('Spain');
  },
  code: '+34',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}, {
  locale: 'SE',
  key: '',
  label: function label(t) {
    return t('Sweden');
  },
  code: '46',
  priority: '6',
  phoneMask: '',
  vatMask: ''
}];
var resolveDeliveryCost = function resolveDeliveryCost(productsAndServices) {
  if (!productsAndServices) return undefined;
  return find(productsAndServices, function (product) {
    return product.code === 'delivery_cost';
  });
};
var genderOptions = function genderOptions(t) {
  return [{
    value: 'Mr.',
    label: t('Mr')
  }, {
    value: 'Miss',
    label: t('Miss')
  }];
};

var ErrorIndicator = function ErrorIndicator(_ref) {
  var error = _ref.error,
    icon = _ref.icon;
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full bg-red-200 flex items-center rounded"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-16 bg-red-300 flex items-center justify-center rounded-l"
  }, /*#__PURE__*/React.createElement("i", {
    className: icon + " text-2xl text-red-900"
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-auto text-black opacity-75 items-center px-4 py-4  flex items-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "leading-tight"
  }, error))));
};
ErrorIndicator.defaultProps = {
  error: 'Er ging iets mis. Probeer later opnieuw.',
  icon: 'fad fa-exclamation-circle'
};

var DataQueryV2 = "query VehiclesFilter {\n  vehiclesFilter {\n    labels {\n      key\n      count\n      url\n    }\n  }\n  vehiclesCount\n}";
var resolveDataByLabel = function resolveDataByLabel(label, data, context) {
  var _data$vehiclesFilter;
  if (!data) return undefined;
  if (label === LABELS.LMA) {
    return {
      count: data.vehiclesCount,
      url: context.defaultPageNames.vehicles
    };
  }
  var item = find(data === null || data === void 0 ? void 0 : (_data$vehiclesFilter = data.vehiclesFilter) === null || _data$vehiclesFilter === void 0 ? void 0 : _data$vehiclesFilter.labels, function (record) {
    return record.key === label;
  });
  return item ? {
    count: item.count,
    url: item.url
  } : {
    count: undefined,
    url: ''
  };
};
var resolveMyWayText = function resolveMyWayText(count, language) {
  var content = 'Het officiële label voor tweedehandswagens van Volkswagen, SEAT, CUPRA, Škoda en Volkswagen Commercial Vehicles';
  var buttonLabel = "Ontdek onze " + (count || '') + " MyWay voertuigen";
  if (language === 'fr') {
    content = "Le label officiel des voitures d'occasion de Volkswagen, SEAT, CUPRA, Škoda et Volkswagen Commercial Vehicles";
    buttonLabel = "D\xE9couvrez nos " + (count || '') + " v\xE9hicules MyWay";
  }
  if (language === 'en') {
    content = 'The official label for used cars from Volkswagen, SEAT, CUPRA, Škoda and Volkswagen Commercial Vehicles.';
    buttonLabel = "Discover our " + (count || '') + " MyWay vehicles";
  }
  return {
    content: content,
    buttonLabel: buttonLabel
  };
};
var resolveAapText = function resolveAapText(count, language) {
  var content = 'Een premium tweedehandswagen met uitgebreide garanties';
  var buttonLabel = "Ontdek onze " + (count || '') + " Audi Approved :plus voertuigen";
  if (language === 'fr') {
    content = "Une voiture d'occasion premium avec des garanties étendues";
    buttonLabel = "D\xE9couvrez nos " + (count || '') + " v\xE9hicules Audi Approved :plus";
  }
  if (language === 'en') {
    content = 'A premium second-hand car with extended warranty';
    buttonLabel = "Discover our " + (count || '') + " Audi Approved :plus vehicles";
  }
  return {
    content: content,
    buttonLabel: buttonLabel
  };
};
var MyWayBlock = function MyWayBlock(_ref) {
  var count = _ref.count,
    url = _ref.url,
    context = _ref.context;
  var _resolveMyWayText = resolveMyWayText(count, context.culture),
    content = _resolveMyWayText.content,
    buttonLabel = _resolveMyWayText.buttonLabel;
  return /*#__PURE__*/React.createElement(InternalLink, {
    page: url,
    className: "cursor-pointer banner-json-image-and-text-block",
    context: context
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full max-w-md mx-auto h-full"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: 320
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: IMAGES['myway-card-cover'],
    alt: "My Way",
    className: "w-full h-full object-cover"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 p-30px",
    style: {
      background: '#11597D'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center mb-5",
    style: {
      height: 32
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: IMAGES['myway-white-text-logo-nl'],
    className: "h-full object-cover",
    alt: "My Way logo"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 text-18 text-white font-bold mb-4"
  }, content), /*#__PURE__*/React.createElement("div", {
    className: "underline text-18 text-white font-bold"
  }, buttonLabel))));
};
var AudiBlock = function AudiBlock(_ref2) {
  var count = _ref2.count,
    url = _ref2.url,
    context = _ref2.context;
  var _resolveAapText = resolveAapText(count, context.culture),
    content = _resolveAapText.content,
    buttonLabel = _resolveAapText.buttonLabel;
  return /*#__PURE__*/React.createElement(InternalLink, {
    page: url,
    className: "cursor-pointer banner-json-image-and-text-block",
    context: context
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full max-w-md mx-auto h-full"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: 320
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: IMAGES['aap-card-image'],
    alt: "Audi approved plus",
    className: "w-full h-full object-cover"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 p-30px bg-gray-50"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-5",
    style: {
      height: 32
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: context.culture === 'nl' ? IMAGES['aap-red-logo-nl'] : IMAGES['aap-red-logo-fr'],
    className: "h-full object-cover",
    alt: "Audi approved plus"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 text-18 text-gray-600 font-bold mb-4"
  }, content), /*#__PURE__*/React.createElement("div", {
    className: "underline text-18 text-gray-600 font-bold"
  }, buttonLabel))));
};
var CustomBlock = function CustomBlock(_ref3) {
  var count = _ref3.count,
    url = _ref3.url,
    text = _ref3.text,
    image = _ref3.image,
    context = _ref3.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(InternalLink, {
    page: url,
    className: "cursor-pointer banner-json-image-and-text-block",
    context: context
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full max-w-md mx-auto h-full"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: 320
    }
  }, /*#__PURE__*/React.createElement("img", {
    srcSet: (image === null || image === void 0 ? void 0 : image.mobile) + " 300w, " + (image === null || image === void 0 ? void 0 : image.tablet) + " 768w, " + (image === null || image === void 0 ? void 0 : image.desktop) + " 1280w",
    src: image === null || image === void 0 ? void 0 : image.mobile,
    alt: image === null || image === void 0 ? void 0 : image.alt,
    className: "w-full h-full object-cover"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 p-30px bg-gray-50"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: text,
    context: context,
    data: count ? {
      count: count,
      url: url
    } : {}
  }), /*#__PURE__*/React.createElement("div", {
    className: "underline text-18 text-gray-600 font-bold mt-4"
  }, t('Discover our'), " ", count || '', " ", t('used cars')))));
};
var BannerJsonImageAndText = function BannerJsonImageAndText(_ref4) {
  var image = _ref4.image,
    text = _ref4.text,
    context = _ref4.context;
  var _useQuery = useQuery(context),
    data = _useQuery.data,
    fetchData = _useQuery.fetchData,
    loading = _useQuery.loading,
    error = _useQuery.error;
  var _useState = useState({
      myway: {
        count: undefined,
        url: ''
      },
      aap: {
        count: undefined,
        url: ''
      },
      lma: {
        count: undefined,
        url: ''
      }
    }),
    dataByLabel = _useState[0],
    setDataByLabel = _useState[1];
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  useEffect(function () {
    fetchData(DataQueryV2, undefined);
  }, []);
  useEffect(function () {
    if (data) {
      setDataByLabel({
        myway: resolveDataByLabel(LABELS.MYWAY, data, context),
        aap: resolveDataByLabel(LABELS.AAP, data, context),
        lma: resolveDataByLabel(LABELS.LMA, data, context)
      });
    }
  }, [data]);
  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "relative"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pt-16 z-10 container grid grid-cols-1 lg:grid-cols-3 gap-5 mb-5 md:mb-12"
    }, times(3, function (item) {
      return /*#__PURE__*/React.createElement("div", {
        key: item,
        className: "flex flex-col w-full max-w-md mx-auto animate-pulse"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          height: 320
        },
        className: "bg-gray-200 animate-pulse w-full"
      }), /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col flex-1 p-30px"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mb-5 h-6 w-1/3 bg-gray-200 animate-pulse"
      }), /*#__PURE__*/React.createElement("div", {
        className: "mb-1 h-2 w-full bg-gray-200 animate-pulse"
      }), /*#__PURE__*/React.createElement("div", {
        className: "mb-1 h-2 w-full bg-gray-200 animate-pulse"
      }), /*#__PURE__*/React.createElement("div", {
        className: "mb-5 h-2 w-2/3 bg-gray-200 animate-pulse"
      }), /*#__PURE__*/React.createElement("div", {
        className: "h-2 w-full bg-gray-200 animate-pulse"
      })));
    })), /*#__PURE__*/React.createElement("div", {
      className: "absolute w-full h-full top-0 left-0 right-0 mx-auto bg-white border-t border-secondary-two",
      style: {
        maxWidth: 1600,
        zIndex: '-1'
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "hidden lg3:block absolute w-1/2 h-full right-0 bg-white border-t border-secondary-two top-0",
      style: {
        zIndex: '-1'
      }
    }));
  }
  if (!loading && error) {
    return /*#__PURE__*/React.createElement("div", {
      className: "container mt-12"
    }, /*#__PURE__*/React.createElement(ErrorIndicator, {
      error: t('Something went wrong.')
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container pt-16 grid grid-cols-1 lg:grid-cols-3 gap-5 mb-5 md:mb-12 z-10"
  }, /*#__PURE__*/React.createElement(MyWayBlock, {
    context: context,
    count: dataByLabel.myway.count,
    url: dataByLabel.myway.url
  }), /*#__PURE__*/React.createElement(AudiBlock, {
    context: context,
    count: dataByLabel.aap.count,
    url: dataByLabel.aap.url
  }), /*#__PURE__*/React.createElement(CustomBlock, {
    context: context,
    count: dataByLabel.lma.count,
    url: dataByLabel.lma.url,
    text: text,
    image: image
  })), /*#__PURE__*/React.createElement("div", {
    className: "absolute w-full h-full top-0 left-0 right-0 mx-auto bg-white border-t border-secondary-two",
    style: {
      maxWidth: 1600,
      zIndex: '-1'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "hidden lg3:block absolute w-1/2 h-full right-0 bg-white border-t border-secondary-two top-0",
    style: {
      zIndex: '-1'
    }
  }));
};
BannerJsonImageAndText.defaultProps = {
  text: DefaultText,
  image: DefaultImage
};
BannerJsonImageAndText.human = {
  nl: '',
  fr: '',
  en: ''
};
BannerJsonImageAndText.preview = function () {
  return /*#__PURE__*/React.createElement("div", null, "BannerJsonImageAndText");
};

var myWayLogoBig = "myway-logo-big~DIoniLNd.png";

var myWayLogoTransparent = "transparent-myway-logo~bpcLNEDz.png";

var selfcheck = "selfcheck~HedqmMTb.png";

var aapLogoNl = "aap-red-nl~bexvtiOu.png";

var aapLogoFr = "aap-red-fr~KGEJzWPI.png";

var MyWayBlock$1 = {
  items: [{
    icon: 'icon-certificate',
    text: {
      fr: 'D’un programme de <strong>garantie à la carte</strong>',
      nl: 'Een <strong>garantieprogramma</strong> op maat'
    }
  }, {
    icon: 'icon-24',
    text: {
      fr: 'D’une <strong>garantie mobilité 24h/24h</strong>',
      nl: 'Een <strong>24/24</strong> uur-mobiliteitsgarantie'
    }
  }, {
    icon: 'icon-ruler',
    text: {
      fr: 'D’une <strong>offre personnalisée</strong>',
      nl: 'Een offerte <strong>op maat</strong>'
    }
  }, {
    icon: 'icon-document-check',
    text: {
      fr: 'D’un <strong>contrôle approfondi</strong> effectué par le <strong>réseau officiel</strong>',
      nl: 'Een <strong>grondig nazicht</strong> uitgevoerd binnen het officiële netwerk'
    }
  }, {
    icon: 'icon-document',
    text: {
      fr: 'D’un <strong>historique d’entretien connu</strong>',
      nl: 'Een <strong>gekende onderhoudshistoriek</strong>'
    }
  }, {
    icon: 'icon-hand',
    text: {
      fr: 'De la <strong>garantie satisfait</strong> ou <strong>remboursé</strong>',
      nl: 'Niet tevreden, <strong>geld terug-garantie</strong>'
    }
  }]
};
var AudiBlock$1 = {
  items: [{
    text: {
      fr: 'Bien <strong>vérifié sur 111 points</strong>',
      nl: 'Grondig <strong>gecontroleerd op 111 punten</strong>'
    }
  }, {
    text: {
      fr: 'De <strong>0 à 72 mois</strong>',
      nl: 'Van <strong>0 tot 72 maanden oud</strong>'
    }
  }, {
    text: {
      fr: 'Avec une <strong>assistance à vie</strong>',
      nl: 'Met <strong>levenslange bijstand</strong>'
    }
  }, {
    text: {
      fr: '<strong>Garantie de 2 à 5 ans</strong>',
      nl: '<strong>2 tot 5 jaar garantie</strong>'
    }
  }, {
    text: {
      fr: '<strong>150.000 km maximum</strong>',
      nl: '<strong>Maximum 150.000 km</strong>'
    }
  }, {
    text: {
      fr: "Équipé d'un <strong>carnet d'entretien Audi</strong> à jour et <strong>d'une histoire connue</strong>",
      nl: 'Voorzien van een up-to-date Audi-<strong>onderhoudsboekje</strong> en een <strong>bekende voorgeschiedenis</strong>'
    }
  }]
};
var MyWayCard = function MyWayCard(_ref) {
  var currentLang = _ref.currentLang,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col py-10 px-8 md:px-10 bg-myway-darkest max-w-md lg:max-width-full mx-auto",
    style: {
      backgroundImage: "url('" + useAsset(myWayLogoTransparent) + "')",
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap items-center whitespace-nowrap text-24 font-semibold text-white mb-10"
  }, /*#__PURE__*/React.createElement("span", null, t('An')), /*#__PURE__*/React.createElement("img", {
    src: useAsset(myWayLogoBig),
    alt: "My Way logo",
    className: "mx-2 h-7"
  }), /*#__PURE__*/React.createElement("span", null, t('MyWay-vehicle')), /*#__PURE__*/React.createElement("span", null, t('enjoy ALWAYS'))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 text-white space-y-5"
  }, map(MyWayBlock$1.items, function (item) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mr-2 pt-1",
      style: {
        width: 30,
        minWidth: 30
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: item.icon + " text-myway-light",
      style: {
        fontSize: 25
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "text-16",
      dangerouslySetInnerHTML: {
        __html: item.text[currentLang]
      }
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-10 inline-block"
  }, /*#__PURE__*/React.createElement(ExternalLink, {
    context: context,
    url: "https://www.myway.be/" + currentLang + "/home",
    className: "button myway-button inline-block",
    analyticsButtonText: t('To') + " MyWay.be",
    analyticsButtonName: "to-myway",
    analyticsButtonPosition: "BannerMyWaySelfCheckAudiApproved"
  }, t('To'), " MyWay.be")));
};
var SelfcheckCard = function SelfcheckCard(_ref2) {
  var context = _ref2.context;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col border-4 border-gray-300 py-10 px-8 md:px-10 max-w-md lg:max-width-full mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full mb-8",
    style: {
      height: 210
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: useAsset(selfcheck),
    className: "h-full w-full object-cover",
    alt: "Selfcheck"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-24 font-bold text-gray-900 mb-5 px-4"
  }, t('Curious about what your current car is worth?')), /*#__PURE__*/React.createElement("div", {
    className: "text-18 font-light text-gray-900 mb-5 px-4"
  }, t('Follow a few short steps and receive a realistic indication of the value of your car within 5 minutes.')), /*#__PURE__*/React.createElement("div", {
    className: "text-18 font-light text-gray-900 px-4 mb-7"
  }, t('Zo simpel en vooral snel gaat het.'))), /*#__PURE__*/React.createElement("div", {
    className: "inline-block px-4"
  }, /*#__PURE__*/React.createElement(ExternalLink, {
    context: context,
    url: context.selfcheckUrl,
    className: "button primary-button inline-block",
    analyticsButtonText: "" + t('Get a takeover price'),
    analyticsButtonName: "to-car-quotation",
    analyticsButtonPosition: "BannerMyWaySelfCheckAudiApproved"
  }, t('Get a takeover price'))));
};
var AudiCard = function AudiCard(_ref3) {
  var context = _ref3.context,
    currentLang = _ref3.currentLang;
  var _useTranslation3 = useTranslation(),
    t = _useTranslation3.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col border-4 border-aap py-10 px-8 md:px-10 bg-gray-100 max-w-md lg:max-width-full mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full mb-12"
  }, /*#__PURE__*/React.createElement("img", {
    src: useAsset(currentLang === 'fr' ? aapLogoFr : aapLogoNl),
    style: {
      height: 50
    },
    alt: "Audi approved plus"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 text-gray-900 space-y-5"
  }, map(AudiBlock$1.items, function (item) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fal fa-check mr-2"
    }), /*#__PURE__*/React.createElement("div", {
      className: "text-16",
      dangerouslySetInnerHTML: {
        __html: item.text[currentLang]
      }
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "inline-block mt-10"
  }, /*#__PURE__*/React.createElement(ExternalLink, {
    context: context,
    url: "https://www.audiapprovedplus.be/" + currentLang,
    className: "button aap-button inline-block",
    analyticsButtonText: t('To') + " Audi Approved :plus",
    analyticsButtonName: "to-aap",
    analyticsButtonPosition: "BannerMyWaySelfCheckAudiApproved"
  }, t('To'), " Audi Approved :plus")));
};
var BannerMyWaySelfCheckAudiApproved = function BannerMyWaySelfCheckAudiApproved(_ref4) {
  var context = _ref4.context;
  var currentLang = context !== null && context !== void 0 && context.culture ? context.culture : 'nl';
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: "container grid grid-cols-1 lg:grid-cols-3 gap-5 mb-5 mb-12"
    }, /*#__PURE__*/React.createElement(MyWayCard, {
      context: context,
      currentLang: currentLang
    }), /*#__PURE__*/React.createElement(AudiCard, {
      context: context,
      currentLang: currentLang
    }), /*#__PURE__*/React.createElement(SelfcheckCard, {
      context: context,
      currentLang: currentLang
    }))
  );
};
BannerMyWaySelfCheckAudiApproved.defaultProps = {};
BannerMyWaySelfCheckAudiApproved.human = {
  nl: '',
  fr: '',
  en: ''
};
BannerMyWaySelfCheckAudiApproved.preview = function () {
  return /*#__PURE__*/React.createElement("div", null, "Banner Myway - Selfcheck - Audi Approved Plus");
};

var BannerUspAndTitle = function BannerUspAndTitle(_ref) {
  var title = _ref.title,
    usps = _ref.usps,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container mb-5 md:mb-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-50 px-8 md:px-12 py-15"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex justify-center mb-11"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: title,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-3 gap-5"
  }, map(usps, function (usp, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center",
      key: "usp-" + i
    }, /*#__PURE__*/React.createElement("div", {
      className: "mr-5"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fal fa-check-circle text-4xl text-primary"
    })), /*#__PURE__*/React.createElement(MarkupText, {
      text: usp,
      context: context
    }));
  }))));
};
BannerUspAndTitle.defaultProps = {
  title: DefaultText,
  usps: [{
    text: ''
  }, {
    text: ''
  }, {
    text: ''
  }]
};
BannerJsonImageAndText.human = {
  nl: '',
  fr: '',
  en: ''
};
BannerUspAndTitle.preview = function () {
  return /*#__PURE__*/React.createElement("div", null, "BannerUspAndTitle");
};

var salonDealsLogo = "salon-deals-logo~xOhOquqS.png";

var salonDealsCars = "salon-deals~NmiTatzf.png";

var carPointer = "salon-deals-car-pointer~BdeTlCNH.png";

var fuelCard = "fuelcard~uyPkJRBa.svg";

function useScreens() {
  var _useState = useState(0),
    width = _useState[0],
    setWidth = _useState[1];
  var handleResize = function handleResize() {
    setWidth(window.innerWidth);
  };
  useEffect(function () {
    if (hasWindow()) {
      handleResize();
      window.addEventListener('resize', handleResize);
    }
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  var getScreensBasedOnWidth = function getScreensBasedOnWidth() {
    return {
      isXs: width < 400,
      isSm: width >= 400 && width < 640,
      isMd: width >= 640 && width < 768,
      isMd2: width >= 768 && width < 800,
      isMd3: width >= 800 && width < 810,
      isLg: width >= 810 && width < 1025,
      isLg2: width >= 1025 && width < 1280,
      isLg3: width >= 1280 && width < 1440,
      isXl: width >= 1440 && width < 1476,
      isXl2: width >= 1476
    };
  };
  return _extends({}, getScreensBasedOnWidth());
}

var DesktopView = function DesktopView(_ref) {
  var context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useScrollPosition = useScrollPosition(),
    scrollPosition = _useScrollPosition.scrollPosition;
  var buttonsRef = useRef();
  var carPointerRef = useRef();
  var rightButtonEnd = useRef();
  var carPointerInitialPosition = 344;
  var carPointerHeight = 80;
  var carPointerWidth = 42;
  var calculatePosition = function calculatePosition() {
    var _buttonsRef$current;
    var startOffsetTop = buttonsRef === null || buttonsRef === void 0 ? void 0 : (_buttonsRef$current = buttonsRef.current) === null || _buttonsRef$current === void 0 ? void 0 : _buttonsRef$current.offsetTop;
    var startReached = scrollPosition > 304;
    var rotation = 0;
    var left = 24;
    var top = -carPointerInitialPosition + scrollPosition;
    if (startReached) {
      rotation = scrollPosition - 304 + 24 + 21;
      rotation = rotation > 90 ? -90 : -rotation;
      left = scrollPosition - 304 + 24 + 21;
      top = -1 * top > carPointerHeight / 2 ? -top : -8;
    }
    if (scrollPosition > startOffsetTop - carPointerInitialPosition + carPointerHeight + 40) {
      var _buttonsRef$current2;
      var resettedScrollPosition = scrollPosition + carPointerInitialPosition - 80 - 40 - startOffsetTop;
      var buttonsWrapperWidth = buttonsRef === null || buttonsRef === void 0 ? void 0 : (_buttonsRef$current2 = buttonsRef.current) === null || _buttonsRef$current2 === void 0 ? void 0 : _buttonsRef$current2.offsetWidth;
      left = buttonsWrapperWidth - carPointerWidth - 66 - 80 + resettedScrollPosition > buttonsWrapperWidth - 66 ? buttonsWrapperWidth - 66 : buttonsWrapperWidth - carPointerWidth - 48 - 80 + resettedScrollPosition;
      rotation = rotation + resettedScrollPosition;
      rotation = -1 * rotation > 45 ? -45 : -rotation;
      top = resettedScrollPosition - top;
      if (scrollPosition > startOffsetTop - carPointerInitialPosition + 2 * carPointerHeight) {
        rotation = 0;
      }
    }
    return {
      rotation: rotation,
      left: left,
      top: top
    };
  };
  var _calculatePosition = calculatePosition(),
    rotation = _calculatePosition.rotation,
    left = _calculatePosition.left,
    top = _calculatePosition.top;
  return /*#__PURE__*/React.createElement("div", {
    className: "container pt-26 pb-16 overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-white relative z-2 pb-16",
    style: {
      width: 'calc(100% - 100px)',
      paddingRight: 100,
      marginLeft: 100,
      borderBottomLeftRadius: 100
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-39 leading-60 text-secondary text-center mb-4"
  }, context.culture === 'fr' ? 'Besoin d’une nouvelle voiture ?' : context.culture === 'en' ? 'Need a new car?' : 'Een nieuwe auto nodig?'), /*#__PURE__*/React.createElement("div", {
    className: "font-medium leading-55 text-center mb-12",
    style: {
      color: '#02142F',
      fontSize: 21
    }
  }, context.culture === 'fr' ? 'Du 14 janvier au 31 janvier 2023' : context.culture === 'en' ? 'From January 14 to January 31, 2023' : 'Van 14 januari tot en met 31 januari 2023'), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-full mb-12"
  }, /*#__PURE__*/React.createElement("img", {
    src: useAsset(salonDealsLogo),
    className: "h-39",
    alt: t('Salon deals')
  })), /*#__PURE__*/React.createElement("div", {
    className: "font-light leading-31 text-center px-46",
    style: {
      color: '#02142F',
      fontSize: 21
    }
  }, context.culture === 'fr' ? 'Avec nos offres Salon Deals, vous profitez d’avantages exceptionnels sur une sélection de voitures toutes marques :' : context.culture === 'en' ? 'With our Salon Deals offers, you benefit from exceptional advantages on a selection of vehicles of all brands:' : 'Met onze Salon Deals geniet je van uitzonderlijke voordelen op een selectie wagens van allerhande merken:')), /*#__PURE__*/React.createElement("div", {
    ref: buttonsRef,
    className: "relative"
  }, /*#__PURE__*/React.createElement("img", {
    src: useAsset(carPointer),
    ref: carPointerRef,
    id: "vehicle-pointer",
    alt: t('Vehicle pointer'),
    className: "absolute",
    style: {
      height: carPointerHeight,
      width: carPointerWidth,
      transition: 'all 0.2s linear 0s',
      top: top,
      left: left,
      transform: "rotate(" + rotation + "deg)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center h-22"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-96 w-1/4 absolute -top-74 left-0 border-l border-b border-dashed border-secondary",
    style: {
      borderBottomLeftRadius: 180
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-74 w-1/4 absolute -top-74 left-22 border-l border-b border-dashed border-secondary",
    style: {
      borderBottomLeftRadius: 110
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center relative w-1/3 h-full border-t border-b border-dashed border-secondary bg-white z-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center h-30 absolute -top-4 -left-2/3 z-2 pr-6 md2:min-w-96",
    style: {
      background: 'transparent linear-gradient(270deg, #2D4B8C 0%, #20A1DB 100%) 0% 0% no-repeat padding-box',
      borderRadius: 100
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center min-w-22 w-22 min-h-22 h-22 bg-white rounded-full -ml-6 mr-6",
    style: {
      boxShadow: '-5px -3px 16px #00000029'
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-shield text-35",
    style: {
      color: "#20A1DB"
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-left text-white font-bold text-18 leading-28 max-w-50 md2:max-w-60"
  }, context.culture === 'fr' ? 'Jusqu’à ' : context.culture === 'en' ? 'Up to' : 'Tot', ' ', /*#__PURE__*/React.createElement("span", {
    className: "text-24"
  }, "4 ", context.culture === 'fr' ? 'ans ' : context.culture === 'en' ? 'years' : 'jaar'), ' ', context.culture === 'fr' ? 'de garantie supplémentaire*' : context.culture === 'en' ? 'of additional warranty*' : 'extra garantie*')), /*#__PURE__*/React.createElement("div", {
    className: "font-bold text-27 text-secondary leading-59 pr-4 bg-white"
  }, context.culture === 'fr' ? 'OU' : context.culture === 'en' ? 'OR' : 'OF'), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center h-30 absolute -top-4 -right-2/3 z-2 pr-6 md2:min-w-96",
    style: {
      background: 'transparent linear-gradient(270deg, #2D4B8C 0%, #20A1DB 100%) 0% 0% no-repeat padding-box',
      borderRadius: 100
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center min-w-22 w-22 min-h-22 h-22 bg-white rounded-full -ml-6 mr-6",
    style: {
      boxShadow: '-5px -3px 16px #00000029'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: useAsset(fuelCard),
    style: {
      height: 36
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-left text-white font-bold text-18 leading-28 max-w-50 md2:max-w-60"
  }, context.culture === 'fr' ? 'Jusqu’à ' : context.culture === 'en' ? 'Up to' : 'Tot', ' ', /*#__PURE__*/React.createElement("span", {
    className: "text-24"
  }, "\u20AC 750"), ' ', context.culture === 'fr' ? 'de carte carburants offerts (TVA incl.)*' : context.culture === 'en' ? 'fuel card offered*' : 'gratis tankkaart (incl. btw)*'), /*#__PURE__*/React.createElement("div", {
    ref: rightButtonEnd,
    className: "mr-0 w-1 opacity-0"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-1/4 absolute top-0 right-0 border-r border-t border-dashed border-secondary",
    style: {
      borderTopRightRadius: 180,
      height: 'calc(100% + 4rem)'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-1/4 absolute top-22 right-22 border-r border-t border-dashed border-secondary",
    style: {
      borderTopRightRadius: 110,
      height: 'calc(100% - 1.5rem)'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center relative z-2 pt-20",
    style: {
      width: 'calc(100% - 89px)',
      paddingLeft: 89,
      borderTopRightRadius: 110
    }
  }, /*#__PURE__*/React.createElement(InternalLink, {
    context: context,
    page: context.defaultPageNames.vehicles,
    search: 'label=salondeal',
    className: "button primary-button"
  }, context.culture === 'fr' ? 'Voir toutes nos offres' : context.culture === 'en' ? 'See all our offers' : 'Bekijk al onze aanbiedingen')), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center relative z-1",
    style: {
      width: 'calc(100% - 89px)',
      paddingleft: 89,
      marginRight: 89
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: useAsset(salonDealsCars),
    className: "bg-white relative z-1",
    alt: "Salon deals cars",
    style: {
      maxWidth: 786
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center mt-16 font-semibold text-39 text-secondary mb-8"
  }, context.culture === 'fr' ? 'Passez la cinquième avec nos Salon Deals' : context.culture === 'en' ? 'Discover all our Salon Deals' : 'Kom snel onze Salon Deals ontdekken!'), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center text-black font-light text-21"
  }, context.culture === 'fr' ? 'Vous vous voyez déjà au volant ? Nous aussi !' : context.culture === 'en' ? 'Do you already see yourself behind the wheel? We too!' : 'Zie je jezelf al achter het stuur? Wij ook!')));
};
var MobileView = function MobileView(_ref2) {
  var _startRef$current, _document$getElementB, _document$getElementB2, _document$getElementB3;
  var context = _ref2.context;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var _useScrollPosition2 = useScrollPosition(),
    scrollPosition = _useScrollPosition2.scrollPosition;
  var carPointerHeight = 80;
  var carPointerInitialPosition = carPointerHeight / 2;
  var carPointerWidth = 42;
  var startRef = useRef();
  var buttonsEndRef = useRef();
  var buttonsStartOffsetTop = startRef === null || startRef === void 0 ? void 0 : (_startRef$current = startRef.current) === null || _startRef$current === void 0 ? void 0 : _startRef$current.offsetTop;
  var buttonsEndOffsetTop = hasDocument() && hasWindow() ? ((_document$getElementB = document.getElementById('buttons-end')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.getBoundingClientRect().top) + window.scrollY : 0;
  var vehiclePointerOffsetTop = hasDocument() && hasWindow() ? ((_document$getElementB2 = document.getElementById('vehicle-pointer')) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.getBoundingClientRect().top) + window.scrollY + carPointerInitialPosition : 0;
  var roadWrapperHeight = hasDocument() && hasWindow() ? (_document$getElementB3 = document.getElementById('road-wrapper')) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.getBoundingClientRect().height : 0;
  var startReached = scrollPosition > buttonsStartOffsetTop;
  var endReached = scrollPosition > buttonsEndOffsetTop - buttonsStartOffsetTop;
  var calculatePosition = function calculatePosition() {
    var rotation = 0;
    var left = 0;
    var top = startReached ? scrollPosition - buttonsStartOffsetTop - carPointerInitialPosition : -carPointerInitialPosition;
    if (endReached) {
      rotation = vehiclePointerOffsetTop - buttonsEndOffsetTop;
      rotation = rotation > 90 ? -90 : -rotation;
      left = scrollPosition + buttonsStartOffsetTop - buttonsEndOffsetTop > 0 ? scrollPosition + buttonsStartOffsetTop - buttonsEndOffsetTop : left;
      top = vehiclePointerOffsetTop > buttonsEndOffsetTop + carPointerHeight ? roadWrapperHeight - 48 - carPointerInitialPosition : top;
    }
    return {
      rotation: rotation,
      left: left,
      top: top
    };
  };
  var _calculatePosition2 = calculatePosition(),
    rotation = _calculatePosition2.rotation,
    left = _calculatePosition2.left,
    top = _calculatePosition2.top;
  return /*#__PURE__*/React.createElement("div", {
    className: "py-16 overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-5 bg-white relative z-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-39 leading-60 text-secondary text-center mb-4"
  }, context.culture === 'fr' ? 'Besoin d’une nouvelle voiture ?' : context.culture === 'en' ? 'Need a new car?' : 'Een nieuwe auto nodig?'), /*#__PURE__*/React.createElement("div", {
    className: "font-medium leading-55 text-center mb-12",
    style: {
      color: '#02142F',
      fontSize: 21
    }
  }, context.culture === 'fr' ? 'Du 14 janvier au 31 janvier 2023' : context.culture === 'en' ? 'From January 14 to January 31, 2023' : 'Van 14 januari tot en met 31 januari 2023'), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-full mb-12"
  }, /*#__PURE__*/React.createElement("img", {
    src: useAsset(salonDealsLogo),
    className: "h-24",
    alt: t('Salon deals')
  })), /*#__PURE__*/React.createElement("div", {
    ref: startRef
  }), /*#__PURE__*/React.createElement("div", {
    className: "font-light leading-31 text-center",
    style: {
      color: '#02142F',
      fontSize: 21
    }
  }, context.culture === 'fr' ? 'Avec nos offres Salon Deals, vous profitez d’avantages exceptionnels sur une sélection de voitures toutes marques :' : context.culture === 'en' ? 'With our Salon Deals offers, you benefit from exceptional advantages on a selection of vehicles of all brands:' : 'Met onze Salon Deals geniet je van uitzonderlijke voordelen op een selectie wagens van allerhande merken:')), /*#__PURE__*/React.createElement("div", {
    id: "road-wrapper",
    className: "relative mt-22 py-34"
  }, /*#__PURE__*/React.createElement("img", {
    src: useAsset(carPointer),
    alt: t('Vehicle pointer'),
    id: "vehicle-pointer",
    className: "absolute",
    style: {
      height: carPointerHeight,
      width: carPointerWidth,
      transition: 'all 0.2s linear 0s',
      top: top,
      left: "calc(50% - " + carPointerWidth / 2 + "px + " + left + "px)",
      transform: "rotate(" + rotation + "deg)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-y-0 right-0 border-l border-b border-dashed border-secondary",
    style: {
      borderBottomLeftRadius: 180,
      width: 'calc(50% + 3rem)'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "absolute top-0 bottom-22 right-0 border-l border-b border-dashed border-secondary",
    style: {
      borderBottomLeftRadius: 110,
      width: 'calc(50% - 3rem)'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "wrapper flex flex-col items-center justify-center relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex self-center items-center h-30 z-2 pr-6 ml-5 max-w-80 sm:max-w-96",
    style: {
      background: 'transparent linear-gradient(270deg, #2D4B8C 0%, #20A1DB 100%) 0% 0% no-repeat padding-box',
      borderRadius: 100
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center min-w-22 w-22 min-h-22 h-22 bg-white rounded-full -ml-6 mr-6",
    style: {
      boxShadow: '-5px -3px 16px #00000029'
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-shield text-35 text-primary"
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-left text-white font-semibold text-18 leading-28"
  }, context.culture === 'fr' ? 'Jusqu’à ' : context.culture === 'en' ? 'Up to' : 'Tot', ' ', /*#__PURE__*/React.createElement("span", {
    className: "text-24"
  }, "4 ", context.culture === 'fr' ? 'ans' : context.culture === 'en' ? 'years' : 'jaar', ' '), ' ', context.culture === 'fr' ? 'de garantie supplémentaire*' : context.culture === 'en' ? 'of additional warranty*' : 'extra garantie*')), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center font-bold text-27 text-secondary leading-59 text-center my-12 static"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-22 mx-1 bg-transparent -z-1"
  }, context.culture === 'fr' ? 'OU' : context.culture === 'en' ? 'OR' : 'OF')), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center h-30 z-2 pr-6 ml-5 max-w-80 sm:max-w-96",
    style: {
      background: 'transparent linear-gradient(270deg, #2D4B8C 0%, #20A1DB 100%) 0% 0% no-repeat padding-box',
      borderRadius: 100
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center min-w-22 w-22 min-h-22 h-22 bg-white rounded-full -ml-6 mr-6",
    style: {
      boxShadow: '-5px -3px 16px #00000029'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: useAsset(fuelCard),
    style: {
      height: 36
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-left text-white font-semibold text-18 leading-28"
  }, context.culture === 'fr' ? 'Jusqu’à ' : context.culture === 'en' ? 'Up to' : 'Tot', ' ', /*#__PURE__*/React.createElement("span", {
    className: "text-24"
  }, "\u20AC 750"), ' ', context.culture === 'fr' ? 'de carte carburants offerts (TVA incl.)*' : context.culture === 'en' ? 'fuel card offered*' : 'gratis tankkaart (incl. btw)*')), /*#__PURE__*/React.createElement("div", {
    id: "buttons-end",
    ref: buttonsEndRef
  }))), /*#__PURE__*/React.createElement("div", {
    className: "px-5 mt-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center mb-8"
  }, /*#__PURE__*/React.createElement(InternalLink, {
    context: context,
    page: context.defaultPageNames.vehicles,
    search: 'label=salondeal',
    className: "button primary-button"
  }, context.culture === 'fr' ? 'Voir toutes nos offres' : context.culture === 'en' ? 'See all our offers' : 'Bekijk al onze aanbiedingen')), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center mb-16"
  }, /*#__PURE__*/React.createElement("img", {
    src: useAsset(salonDealsCars),
    className: "max-w-full",
    alt: "Salon deals cars"
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-center font-semibold text-27 text-secondary mb-4"
  }, context.culture === 'fr' ? 'Passez la cinquième avec nos Salon Deals' : context.culture === 'en' ? 'Discover all our Salon Deals' : 'Kom snel onze Salon Deals ontdekken!'), /*#__PURE__*/React.createElement("div", {
    className: "text-center text-black font-light text-17"
  }, context.culture === 'fr' ? 'Vous vous voyez déjà au volant ? Nous aussi !' : context.culture === 'en' ? 'Do you already see yourself behind the wheel? We too!' : 'Zie je jezelf al achter het stuur? Wij ook!')));
};
var SalonDealsHero = function SalonDealsHero(_ref3) {
  var context = _ref3.context;
  var _useScreens = useScreens(),
    isXs = _useScreens.isXs,
    isSm = _useScreens.isSm,
    isMd = _useScreens.isMd,
    isMd2 = _useScreens.isMd2,
    isMd3 = _useScreens.isMd3,
    isLg = _useScreens.isLg,
    isLg2 = _useScreens.isLg2;
  if (isXs || isSm || isMd || isMd2 || isMd3 || isLg || isLg2) {
    return /*#__PURE__*/React.createElement(MobileView, {
      context: context
    });
  }
  return /*#__PURE__*/React.createElement(DesktopView, {
    context: context
  });
};
SalonDealsHero.human = {
  nl: '',
  fr: '',
  en: ''
};
SalonDealsHero.preview = SalonDealsHero;

var AdvertiseComponent = function AdvertiseComponent(_ref) {
  var groupName = _ref.groupName,
    vehicleReference = _ref.vehicleReference,
    context = _ref.context;
  var _useAdvertisement = useAdvertisement(context),
    advertisement = _useAdvertisement.advertisement,
    fetchAdvertisement = _useAdvertisement.fetchAdvertisement;
  var _useAnalytics = useAnalytics(context),
    analyticsTracker = _useAnalytics.analyticsTracker;
  var onClickFunction = function onClickFunction(e) {
    if (hasWindow() && analyticsTracker !== undefined) {
      var _e$target$dataset, _e$target$dataset2, _e$target$dataset3, _e$target$dataset4, _e$target$dataset5, _e$target$dataset6, _buttonEvent$info;
      var buttonEvent = analyticsTracker.buttonCtaEventInitialize({
        analyticsButtonName: ((_e$target$dataset = e.target.dataset) === null || _e$target$dataset === void 0 ? void 0 : _e$target$dataset.analyticsButtonName) || '',
        analyticsButtonType: ((_e$target$dataset2 = e.target.dataset) === null || _e$target$dataset2 === void 0 ? void 0 : _e$target$dataset2.analyticsButtonType) || 'advertise-link',
        analyticsButtonCategory: ((_e$target$dataset3 = e.target.dataset) === null || _e$target$dataset3 === void 0 ? void 0 : _e$target$dataset3.analyticsButtonCategory) || '',
        analyticsButtonText: ((_e$target$dataset4 = e.target.dataset) === null || _e$target$dataset4 === void 0 ? void 0 : _e$target$dataset4.analyticsButtonText) || e.target.innerText || '',
        analyticsButtonTarget: ((_e$target$dataset5 = e.target.dataset) === null || _e$target$dataset5 === void 0 ? void 0 : _e$target$dataset5.analyticsButtonTarget) || e.target.href,
        analyticsButtonPosition: ((_e$target$dataset6 = e.target.dataset) === null || _e$target$dataset6 === void 0 ? void 0 : _e$target$dataset6.analyticsButtonPosition) || 'AdvertiseComponent'
      }, context);
      if (buttonEvent !== null && buttonEvent !== void 0 && (_buttonEvent$info = buttonEvent.info) !== null && _buttonEvent$info !== void 0 && _buttonEvent$info.buttonName) {
        analyticsTracker.analyticsEventSubmit(buttonEvent);
      }
    }
  };
  useEffect(function () {
    if (analyticsTracker === undefined || !hasWindow() || !advertisement) {
      return;
    }
    var links = document.getElementById("" + groupName).getElementsByTagName('a');
    if (!links) return;
    Array.from(links).forEach(function (linkElement) {
      var _linkElement$dataset;
      if ((_linkElement$dataset = linkElement.dataset) !== null && _linkElement$dataset !== void 0 && _linkElement$dataset.analyticsButtonName) {
        linkElement.onclick = onClickFunction;
      }
    });
  }, [analyticsTracker, advertisement]);
  useEffect(function () {
    fetchAdvertisement(groupName, vehicleReference);
  }, [groupName, vehicleReference]);
  return /*#__PURE__*/React.createElement("div", {
    id: groupName,
    dangerouslySetInnerHTML: {
      __html: advertisement
    }
  });
};
var AdvertiseComponent$1 = baseAdvertisementBlock(AdvertiseComponent);

var AdvertisementBanner = function AdvertisementBanner(_ref) {
  var group = _ref.group,
    context = _ref.context;
  if (group.groupId === undefined && context.builder) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        minHeight: 50
      }
    }, " Advertisement block");
  }
  return /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: 50
    }
  }, /*#__PURE__*/React.createElement(AdvertiseComponent$1, {
    groupName: group.groupId,
    context: context
  }));
};
AdvertisementBanner.defaultProps = {
  group: DefaultAdvertiseGroupRef
};
AdvertisementBanner.human = {
  nl: 'Advertisement block',
  fr: 'Advertisement block',
  en: 'Advertisement block'
};
AdvertisementBanner.preview = function () {
  return /*#__PURE__*/React.createElement("div", null, "Advertisement block");
};

var Breadcrumbs = function Breadcrumbs(_ref) {
  var _context$defaultPageN;
  var context = _ref.context,
    className = _ref.className;
  var languages = ['en', 'fr', 'nl'];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var getPageFromPath = function getPageFromPath() {
    if (hasWindow()) {
      var _filter;
      return (_filter = filter(window.location.pathname.split('/'), function (path) {
        return path !== '' && !includes(languages, path);
      })) === null || _filter === void 0 ? void 0 : _filter.pop();
    }
  };
  var findCurrentPage = function findCurrentPage() {
    if (hasWindow()) {
      return find(context.allPagesData, function (data) {
        return data.url === window.location.pathname;
      });
    }
  };
  var checkIfHomePage = function checkIfHomePage() {
    var _findCurrentPage;
    if (!hasWindow()) return;
    return ((_findCurrentPage = findCurrentPage()) === null || _findCurrentPage === void 0 ? void 0 : _findCurrentPage.key) === 'index';
  };
  var currentPage = findCurrentPage();
  return /*#__PURE__*/React.createElement("div", {
    className: "relative bg-lma-gray"
  }, /*#__PURE__*/React.createElement("div", {
    className: className + " container py-10 flex"
  }, context !== null && context !== void 0 && context.lmaHomePage ? /*#__PURE__*/React.createElement(ExternalLink, {
    url: context === null || context === void 0 ? void 0 : context.lmaHomePage,
    className: "text-primary underline flex-none",
    target: "_self",
    context: context
  }, t('Home')) : /*#__PURE__*/React.createElement(InternalLink, {
    page: context === null || context === void 0 ? void 0 : (_context$defaultPageN = context.defaultPageNames) === null || _context$defaultPageN === void 0 ? void 0 : _context$defaultPageN.home,
    className: "text-primary underline flex-none",
    context: context
  }, t('Home')), !checkIfHomePage() && /*#__PURE__*/React.createElement("span", {
    className: "mx-2"
  }, "-"), !checkIfHomePage() && /*#__PURE__*/React.createElement("span", {
    className: "text-primary flex-none capitalize"
  }, currentPage !== null && currentPage !== void 0 && currentPage.description ? currentPage.description : getPageFromPath())), /*#__PURE__*/React.createElement("div", {
    className: "absolute w-full bg-lma-gray h-40",
    style: {
      zIndex: -1
    }
  }));
};
Breadcrumbs.defaultProps = {
  className: 'container py-5 flex items-center'
};
Breadcrumbs.human = {
  nl: '',
  fr: '',
  en: ''
};
Breadcrumbs.preview = Breadcrumbs;

var FooterMenuContactMenuSocialsCopyrightBottomMenu = function FooterMenuContactMenuSocialsCopyrightBottomMenu(_ref) {
  var menu = _ref.menu,
    contact_menu = _ref.contact_menu,
    socials = _ref.socials,
    copyright = _ref.copyright,
    bottom_menu = _ref.bottom_menu,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var md2Rows = Math.ceil(menu.length / 2);
  var lgRows = Math.ceil(menu.length / 3);
  var lg3Rows = Math.ceil(menu.length / 4);
  var md2Grid = "md2:grid-cols-2 md2:grid-rows-" + md2Rows;
  var lgGrid = "lg:grid-cols-3 lg:grid-rows-" + lgRows;
  var lg3Grid = "lg3:grid-cols-4 lg3:grid-rows-" + lg3Rows;
  return /*#__PURE__*/React.createElement("footer", {
    className: "border-b-8 border-primary bg-lma-gray"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container py-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md3:flex-row justify-between mb-0 md3:mb-20 mt-10 space-y-10 md3:space-y-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md2:grid-flow-col-dense " + md2Grid + " " + lgGrid + " " + lg3Grid + " mb-auto gap-x-16 gap-y-4"
  }, map(menu, function (menuItem, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      style: {
        height: 24
      }
    }, /*#__PURE__*/React.createElement(ActionLink, {
      key: "menu-item-" + index,
      action: menuItem,
      context: context
    }, /*#__PURE__*/React.createElement("div", {
      className: "block py-1 md3:py-0",
      style: {
        color: '#696969'
      }
    }, menuItem.title)));
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md2:grid-cols-2 mb-10 md3:mb-0 md2:gap-x-18 grid-flow-row auto-rows-max gap-y-4"
  }, map(contact_menu, function (contactMenuItem, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      style: {
        height: 24
      }
    }, /*#__PURE__*/React.createElement(ActionLink, {
      key: "secondary-menu-item-" + index,
      action: contactMenuItem,
      context: context
    }, /*#__PURE__*/React.createElement("div", {
      className: "block py-1 md3:py-0",
      style: {
        color: '#696969'
      }
    }, contactMenuItem.title)));
  })), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-20 font-bold mb-4"
  }, t('Follow us')), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, map(socials, function (socialItem, index) {
    return /*#__PURE__*/React.createElement(ActionLink, {
      key: "social-action-" + index,
      action: socialItem.action,
      context: context
    }, /*#__PURE__*/React.createElement("i", {
      className: socialItem.icon + " " + (index === 0 ? 'ml-0' : 'ml-6') + " text-xl"
    }));
  })))), /*#__PURE__*/React.createElement("div", {
    className: "block lg:flex lg:items-start border-0 md3:border-t border-t-secondary pt-0 md3:pt-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-none font-bold mr-0 lg:mr-10",
    style: {
      color: '#696969'
    }
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: copyright,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row justify-start md3:justify-between w-full flex-wrap"
  }, map(bottom_menu, function (bottomMenuItem, index) {
    return /*#__PURE__*/React.createElement(ActionLink, {
      key: "bottom-menu-item-" + index,
      action: bottomMenuItem,
      context: context
    }, /*#__PURE__*/React.createElement("span", {
      className: "block py-1 md3:py-0 mr-5 md3:mr-0",
      style: {
        color: '#696969'
      }
    }, bottomMenuItem.title));
  })))));
};
FooterMenuContactMenuSocialsCopyrightBottomMenu.defaultProps = {
  menu: DefaultActionList,
  contact_menu: DefaultActionList,
  top_menu: DefaultActionList,
  socials: DefaultSocialIconActionList,
  copyright: DefaultText,
  bottom_menu: DefaultActionList
};
FooterMenuContactMenuSocialsCopyrightBottomMenu.human = {
  nl: 'Footer',
  fr: 'Footer',
  en: 'Footer'
};
FooterMenuContactMenuSocialsCopyrightBottomMenu.preview = function () {
  return /*#__PURE__*/React.createElement("div", null, "Footer");
};

var FooterMenuContactMenuSocialsCopyrightBottomMenuWithLogo = function FooterMenuContactMenuSocialsCopyrightBottomMenuWithLogo(_ref) {
  var _logo$image, _logo$image2, _logo$image3, _logo$image4, _logo$image5;
  var logo = _ref.logo,
    menu = _ref.menu,
    middle_menu = _ref.middle_menu,
    contact_menu = _ref.contact_menu,
    socials = _ref.socials,
    copyright = _ref.copyright,
    bottom_menu = _ref.bottom_menu,
    context = _ref.context;
  var _useState = useState('contact'),
    activeMenu = _useState[0],
    setActiveMenu = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var renderMobile = function renderMobile() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "py-6 border-b border-gray-300"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between font-normal text-black",
      onClick: function onClick() {
        return setActiveMenu(activeMenu === 'menu' ? '' : 'menu');
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "flex flex-1 text-20"
    }, t('Fast to')), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
      className: "fal " + (activeMenu === 'menu' ? 'fa-angle-up' : 'fa-angle-down')
    }))), /*#__PURE__*/React.createElement("div", {
      className: "space-y-5 " + ((menu === null || menu === void 0 ? void 0 : menu.length) > 0 && activeMenu === 'menu' ? 'block mt-5' : 'hidden')
    }, map(menu, function (menuItem, index) {
      return /*#__PURE__*/React.createElement(ActionLink, {
        key: "menu-item-" + index,
        action: menuItem,
        context: context
      }, /*#__PURE__*/React.createElement("div", {
        className: "block text-16 font-normal hover:text-lma",
        style: {
          color: '#2e3b4c',
          height: 23
        }
      }, menuItem.title));
    }))), /*#__PURE__*/React.createElement("div", {
      className: "py-6 border-b border-gray-300"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between font-normal text-black",
      onClick: function onClick() {
        return setActiveMenu(activeMenu === 'makes' ? '' : 'makes');
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "flex flex-1 text-20"
    }, t('Makes')), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
      className: "fal " + (activeMenu === 'makes' ? 'fa-angle-up' : 'fa-angle-down')
    }))), /*#__PURE__*/React.createElement("div", {
      className: "space-y-5 " + (activeMenu === 'middle_menu' ? 'block mt-5' : 'hidden')
    }, map(middle_menu, function (menuItem, index) {
      return /*#__PURE__*/React.createElement(ActionLink, {
        key: "menu-item-" + index,
        action: menuItem,
        context: context
      }, /*#__PURE__*/React.createElement("div", {
        className: "block text-16 font-normal hover:text-lma",
        style: {
          color: '#2e3b4c',
          height: 23
        }
      }, menuItem.title));
    }))), /*#__PURE__*/React.createElement("div", {
      className: "py-6 border-b border-gray-300"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between font-normal text-black",
      onClick: function onClick() {
        return setActiveMenu(activeMenu === 'contact' ? '' : 'contact');
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "flex flex-1 text-20"
    }, t('Contact')), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
      className: "fal " + (activeMenu === 'contact' ? 'fa-angle-up' : 'fa-angle-down')
    }))), /*#__PURE__*/React.createElement("div", {
      className: "space-y-5 " + ((contact_menu === null || contact_menu === void 0 ? void 0 : contact_menu.length) > 0 && activeMenu === 'contact' ? 'block mt-5' : 'hidden')
    }, map(contact_menu, function (contactMenuItem, index) {
      return /*#__PURE__*/React.createElement(ActionLink, {
        key: "secondary-menu-item-" + index,
        action: contactMenuItem,
        context: context
      }, /*#__PURE__*/React.createElement("div", {
        className: "block text-16 font-normal",
        style: {
          color: '#2e3b4c',
          height: 23
        }
      }, contactMenuItem.title));
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col mt-6"
    }, /*#__PURE__*/React.createElement("div", {
      className: "space-y-3"
    }, map(bottom_menu, function (bottomMenuItem, index) {
      return /*#__PURE__*/React.createElement(ActionLink, {
        key: "bottom-menu-item-" + index,
        action: bottomMenuItem,
        context: context
      }, /*#__PURE__*/React.createElement("div", {
        className: "block text-14 font-light font-primary",
        style: {
          color: '#696969'
        }
      }, bottomMenuItem.title));
    })), /*#__PURE__*/React.createElement("div", {
      className: "mt-3",
      style: {
        color: '#696969'
      }
    }, /*#__PURE__*/React.createElement(MarkupText, {
      text: copyright,
      context: context
    }))));
  };
  return /*#__PURE__*/React.createElement("footer", {
    className: ""
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col space-y-10 md:space-y-0 md:flex-row container pb-6 border-t border-gray-300"
  }, /*#__PURE__*/React.createElement("div", {
    className: "region-footer-top-left mt-12"
  }, /*#__PURE__*/React.createElement(ActionLink, {
    action: logo.action,
    context: context,
    className: "mb-6",
    style: {
      maxWidth: 190
    }
  }, /*#__PURE__*/React.createElement("img", {
    srcSet: (logo === null || logo === void 0 ? void 0 : (_logo$image = logo.image) === null || _logo$image === void 0 ? void 0 : _logo$image.mobile) + " 300w, " + (logo === null || logo === void 0 ? void 0 : (_logo$image2 = logo.image) === null || _logo$image2 === void 0 ? void 0 : _logo$image2.tablet) + " 768w, " + (logo === null || logo === void 0 ? void 0 : (_logo$image3 = logo.image) === null || _logo$image3 === void 0 ? void 0 : _logo$image3.desktop) + " 1280w",
    src: logo === null || logo === void 0 ? void 0 : (_logo$image4 = logo.image) === null || _logo$image4 === void 0 ? void 0 : _logo$image4.mobile,
    alt: logo === null || logo === void 0 ? void 0 : (_logo$image5 = logo.image) === null || _logo$image5 === void 0 ? void 0 : _logo$image5.alt,
    className: "w-full"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, map(socials, function (socialItem, index) {
    return /*#__PURE__*/React.createElement(ActionLink, {
      key: "social-action-" + index,
      action: socialItem.action,
      context: context
    }, /*#__PURE__*/React.createElement("i", {
      className: socialItem.icon + " " + (index === 0 ? 'ml-0' : 'ml-6') + " text-xl"
    }));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "block md:hidden"
  }, renderMobile()), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex md:flex-wrap region-footer-top-right"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mr-10 mt-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-bold mb-8 text-black text-20"
  }, t('Fast to')), /*#__PURE__*/React.createElement("div", {
    className: "space-y-5"
  }, map(menu, function (menuItem, index) {
    return /*#__PURE__*/React.createElement(ActionLink, {
      key: "menu-item-" + index,
      action: menuItem,
      context: context
    }, /*#__PURE__*/React.createElement("div", {
      className: "block text-17 font-normal hover:text-lma",
      style: {
        color: '#2e3b4c',
        height: 23
      }
    }, menuItem.title));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "mr-10 mt-12"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "font-bold mb-8 text-black text-20"
  }, t('Makes')), /*#__PURE__*/React.createElement("div", {
    className: "space-y-5"
  }, map(middle_menu, function (menuItem, index) {
    return /*#__PURE__*/React.createElement(ActionLink, {
      key: "menu-item-" + index,
      action: menuItem,
      context: context
    }, /*#__PURE__*/React.createElement("div", {
      className: "block text-17 font-normal hover:text-lma",
      style: {
        color: '#2e3b4c',
        height: 23
      }
    }, menuItem.title));
  })))), /*#__PURE__*/React.createElement("div", {
    className: "mt-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-bold mb-8 text-black text-20"
  }, t('Contact')), /*#__PURE__*/React.createElement("div", {
    className: "space-y-5"
  }, map(contact_menu, function (contactMenuItem, index) {
    return /*#__PURE__*/React.createElement(ActionLink, {
      key: "secondary-menu-item-" + index,
      action: contactMenuItem,
      context: context
    }, /*#__PURE__*/React.createElement("div", {
      className: "block text-17 font-normal",
      style: {
        color: '#2e3b4c',
        height: 23
      }
    }, contactMenuItem.title));
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block container lg:flex lg:items-start border-0 md3:border-t border-t-secondary pt-0 pb-0 md3:pb-12 md3:pt-8 mt-0 md3:mt-20"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-none font-bold mr-0 lg:mr-10",
    style: {
      color: '#696969'
    }
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: copyright,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-end w-full flex-wrap space-x-6"
  }, map(bottom_menu, function (bottomMenuItem, index) {
    return /*#__PURE__*/React.createElement(ActionLink, {
      key: "bottom-menu-item-" + index,
      action: bottomMenuItem,
      context: context
    }, /*#__PURE__*/React.createElement("div", {
      className: "block py-1 md3:py-0 text-14 font-light font-primary underline hover:text-lma",
      style: {
        color: '#696969'
      }
    }, bottomMenuItem.title));
  }))));
};
FooterMenuContactMenuSocialsCopyrightBottomMenuWithLogo.defaultProps = {
  logo: DefaultImageAction,
  menu: DefaultActionList,
  middle_menu: DefaultActionList,
  contact_menu: DefaultActionList,
  top_menu: DefaultActionList,
  socials: DefaultSocialIconActionList,
  copyright: DefaultText,
  bottom_menu: DefaultActionList
};
FooterMenuContactMenuSocialsCopyrightBottomMenuWithLogo.human = {
  nl: 'Footer',
  fr: 'Footer',
  en: 'Footer'
};
FooterMenuContactMenuSocialsCopyrightBottomMenuWithLogo.preview = function () {
  return /*#__PURE__*/React.createElement("div", null, "Footer");
};

var FavoriteBtnWithCounter = function FavoriteBtnWithCounter(_ref) {
  var totalFavoritesCount = _ref.totalFavoritesCount,
    onClick = _ref.onClick;
  var renderMobile = function renderMobile() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
      className: "fal fa-heart text-3xl"
    }), hasWindow() && totalFavoritesCount > 0 && /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center text-xs bg-secondary text-white absolute rounded-full w-5 h-5",
      style: {
        top: -4,
        right: -12
      }
    }, totalFavoritesCount));
  };
  var renderDesktop = function renderDesktop() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
      className: "relative fal fa-heart text-secondary cursor-pointer text-14",
      style: {
        bottom: 6
      }
    }), hasWindow() && totalFavoritesCount > 0 && /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center text-xs bg-secondary text-white absolute rounded-full w-4 h-4",
      style: {
        top: -4,
        right: -12
      }
    }, totalFavoritesCount));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "relative",
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "block md3:hidden"
  }, renderMobile()), /*#__PURE__*/React.createElement("div", {
    className: "hidden md3:block"
  }, renderDesktop()));
};
var FavoriteBtnWithCounter$1 = baseMenuFavoritesBtn(FavoriteBtnWithCounter);

var LanguagePicker = function LanguagePicker(_ref) {
  var availableLanguages = _ref.availableLanguages,
    currentLanguage = _ref.currentLanguage,
    onLanguageChanged = _ref.onLanguageChanged;
  var _useState = useState(false),
    dropdownVisible = _useState[0],
    setDropdownVisible = _useState[1];
  if (availableLanguages.length <= 1) {
    return /*#__PURE__*/React.createElement("div", {
      className: "hidden"
    });
  }
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "hidden md3:block relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-light text-secondary transition-all hover:text-primary leading-0.875 cursor-pointer",
    onClick: function onClick() {
      return setDropdownVisible(!dropdownVisible);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "uppercase"
  }, currentLanguage)), dropdownVisible && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col space-y-2 absolute px-4 py-2 shadow-xs border border-gray-100 right-0 top-5 bg-white z-50"
  }, map(filter(availableLanguages, function (l) {
    return l.code !== currentLanguage;
  }), function (lng, index) {
    return /*#__PURE__*/React.createElement("span", {
      key: index,
      className: "cursor-pointer uppercase hover:text-secondary",
      onClick: function onClick() {
        return onLanguageChanged(lng.code);
      }
    }, lng.code);
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex md3:hidden text-white text-20 leading-none font-light space-x-4 mt-7"
  }, map(availableLanguages, function (lng, index) {
    var isActive = currentLanguage === lng.code;
    return /*#__PURE__*/React.createElement("span", {
      key: index,
      className: "cursor-pointer uppercase " + (isActive ? 'underline' : ''),
      onClick: function onClick() {
        return onLanguageChanged(lng.code);
      }
    }, lng.code);
  })));
};
var LanguagePicker$1 = baseLanguagePicker(LanguagePicker, true);

var TopBar = function TopBar(_ref) {
  var context = _ref.context,
    top_menu = _ref.top_menu;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex w-full justify-end mb-1.0625rem space-x-1.5625rem relative"
  }, map(top_menu, function (menuItem) {
    return /*#__PURE__*/React.createElement(ActionLink, {
      key: menuItem.id,
      action: menuItem,
      context: context,
      className: "whitespace-nowrap font-light text-secondary transition-all hover:text-primary leading-0.875"
    });
  }), context.favorites && /*#__PURE__*/React.createElement(FavoriteBtnWithCounter$1, {
    context: context
  }), /*#__PURE__*/React.createElement(LanguagePicker$1, {
    context: context
  }));
};

var SubMenu = function SubMenu(_ref) {
  var actions = _ref.actions,
    isOpen = _ref.isOpen,
    isLast = _ref.isLast,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "z-20 absolute bg-white border-l border-r border-b border-secondary-two px-6 py-1.125rem shadow-sm transform w-max " + (isOpen ? 'visible translate-y-0 opacity-100' : 'invisible translate-y-4 opacity-0') + " " + (isLast ? 'right-0' : '') + " transition"
  }, map(actions, function (action, i) {
    var isLast = i === actions.length - 1;
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "text-secondary hover:text-primary transition-colors"
    }, /*#__PURE__*/React.createElement(ActionLink, {
      action: action,
      context: context,
      className: "text-18 leading-none p-0.3125rem font-light",
      style: {
        marginBottom: isLast ? 0 : '0.625rem'
      }
    }));
  }));
};
var mapMenu = function mapMenu(width, menu) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var totalToCut = 0;
  if (width > 0 && width < 1159) totalToCut = 1;
  if (width > 0 && width < 1094) totalToCut = 2;
  if (width > 0 && width < 959) totalToCut = 3;
  if (totalToCut > 0) {
    var slicedActions = slice(menu, menu.length - totalToCut, menu.length);
    var subActions = [];
    map(slicedActions, function (action) {
      var _action$subActions;
      var subActionsTemp = [].concat(subActions, [{
        action: action.action
      }]);
      if (((_action$subActions = action.subActions) === null || _action$subActions === void 0 ? void 0 : _action$subActions.length) > 0) {
        subActions = [].concat(subActionsTemp, map(action.subActions, function (subAction) {
          return {
            action: subAction
          };
        }));
      } else {
        subActions = [].concat(subActionsTemp);
      }
    });
    var otherActions = slice(menu, 0, menu.length - totalToCut);
    var moreActions = _extends({}, DefaultActionWithSubActions, {
      action: _extends({}, DefaultActionWithSubActions.action, {
        title: t('More')
      }),
      subActions: subActions
    });
    return [].concat(otherActions, [moreActions]);
  }
  return menu;
};
var isActivePage = function isActivePage(context, url) {
  var isActive = false;
  var page = find(context.allPagesData, function (page) {
    return page.url === url && page.language === context.culture;
  });
  if (page && page.key === 'index') {
    isActive = true;
  }
  if (hasWindow()) {
    var location = window.location;
    if ((location === null || location === void 0 ? void 0 : location.pathname) === "/" + context.culture + url) {
      isActive = true;
    }
  }
  return isActive;
};
var MenuBar = function MenuBar(_ref2) {
  var context = _ref2.context,
    menu = _ref2.menu;
  var _useState = useState(null),
    activeSubmenu = _useState[0],
    setActiveSubmenu = _useState[1];
  var _useWindowDimensions = useWindowDimensions(),
    width = _useWindowDimensions.width;
  var mappedMenu = mapMenu(width, menu);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex w-full h-full items-center justify-end border-t border-secondary-two space-x-12"
  }, map(mappedMenu, function (menuItem, i) {
    var action = menuItem.action,
      subActions = menuItem.subActions;
    var hasSubitems = (subActions === null || subActions === void 0 ? void 0 : subActions.length) > 0;
    var isOpen = action.title + "-" + i === activeSubmenu;
    var isLast = (mappedMenu === null || mappedMenu === void 0 ? void 0 : mappedMenu.length) - 1 === i;
    var isActive = isActivePage(context, action.url);
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      onMouseEnter: function onMouseEnter() {
        return setActiveSubmenu(action.title + "-" + i);
      },
      onMouseLeave: function onMouseLeave() {
        return setActiveSubmenu(null);
      },
      className: "h-full relative"
    }, /*#__PURE__*/React.createElement(ActionLink, {
      key: action.id,
      action: action,
      context: context,
      className: "flex h-full items-center relative font-bold transition-all hover:text-primary text-22 " + (isActive ? 'text-primary' : 'text-secondary')
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "whitespace-nowrap"
    }, action.title), hasSubitems && /*#__PURE__*/React.createElement("div", {
      className: "flex items-start relative"
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-angle-down transform transition-transform " + (isOpen ? 'rotate-180' : 'rotate-0') + " text-primary",
      style: {
        fontSize: 13,
        paddingTop: 0,
        left: 2,
        marginLeft: '0.55rem'
      }
    })))), !!hasSubitems && /*#__PURE__*/React.createElement(SubMenu, {
      actions: subActions,
      isOpen: isOpen,
      isLast: isLast,
      context: context
    }));
  }));
};

var HeaderDesktop = function HeaderDesktop(_ref) {
  var _logo$image, _logo$image2, _logo$image3, _logo$image4, _logo$image5;
  var logo = _ref.logo,
    menu = _ref.menu,
    top_menu = _ref.top_menu,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex sticky-header md3:h-113px lg3:h-116px"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex w-25 md3:w-35 lg3:w-55 mr-0 md3:mr-10 lg3:mr-5 py-5"
  }, /*#__PURE__*/React.createElement(ActionLink, {
    action: logo.action,
    context: context,
    className: "flex items-end justify-end desktop-logo"
  }, /*#__PURE__*/React.createElement("img", {
    srcSet: (logo === null || logo === void 0 ? void 0 : (_logo$image = logo.image) === null || _logo$image === void 0 ? void 0 : _logo$image.mobile) + " 300w, " + (logo === null || logo === void 0 ? void 0 : (_logo$image2 = logo.image) === null || _logo$image2 === void 0 ? void 0 : _logo$image2.tablet) + " 768w, " + (logo === null || logo === void 0 ? void 0 : (_logo$image3 = logo.image) === null || _logo$image3 === void 0 ? void 0 : _logo$image3.desktop) + " 1280w",
    src: logo === null || logo === void 0 ? void 0 : (_logo$image4 = logo.image) === null || _logo$image4 === void 0 ? void 0 : _logo$image4.mobile,
    alt: logo === null || logo === void 0 ? void 0 : (_logo$image5 = logo.image) === null || _logo$image5 === void 0 ? void 0 : _logo$image5.alt,
    className: "cursor-pointer lg3:h-full",
    style: {
      objectFit: 'contain',
      objectPosition: 'center'
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 flex-col pt-5 w-full"
  }, /*#__PURE__*/React.createElement(TopBar, {
    context: context,
    top_menu: top_menu
  }), /*#__PURE__*/React.createElement(MenuBar, {
    context: context,
    menu: menu
  })));
};

var SubMenu$1 = function SubMenu(_ref) {
  var actions = _ref.actions,
    isOpen = _ref.isOpen,
    context = _ref.context;
  var inactiveClasses = 'opacity-0 -z-10 h-0';
  var activeClasses = 'opacity-100 z-10 h-full mt-0.9375rem';
  return /*#__PURE__*/React.createElement("div", {
    className: "transition-all transform space-y-2.5 \n                          " + (isOpen ? activeClasses : inactiveClasses)
  }, map(actions, function (action, index) {
    return /*#__PURE__*/React.createElement(ActionLink, {
      key: index,
      action: action,
      context: context,
      className: "flex items-center text-white text-20 leading-none py-2 font-light"
    }, action.title);
  }));
};
var SideMenu = function SideMenu(_ref2) {
  var context = _ref2.context,
    isOpen = _ref2.isOpen,
    menu = _ref2.menu,
    top_menu = _ref2.top_menu,
    onClose = _ref2.onClose;
  var _useState = useState(null),
    activeSubmenu = _useState[0],
    setActiveSubmenu = _useState[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "transition-all duration-700 fixed bg-black inset-y-0 right-0 px-6 py-5 overflow-y-auto h-screen " + (isOpen ? 'left-0 opacity-100' : 'left-full opacity-0')
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex w-full justify-end items-end mb-5 pr-1 sticky top-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-10 h-10 -mt-0.5",
    onClick: onClose
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-times text-white text-26 font-light"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "space-y-7",
    style: {
      marginTop: 22
    }
  }, map(menu, function (menuItem, i) {
    var action = menuItem.action,
      subActions = menuItem.subActions;
    var hasSubitems = (subActions === null || subActions === void 0 ? void 0 : subActions.length) > 0;
    var isOpen = action.id === activeSubmenu;
    var isActive = isCurrentPage(context, action.url);
    return /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        return setActiveSubmenu(activeSubmenu ? null : action.id);
      },
      key: "menu-" + action.id + "-" + i
    }, /*#__PURE__*/React.createElement(ActionLink, {
      action: action,
      context: context,
      className: "flex items-center relative font-normal transition-all text-white leading-none " + (isActive ? 'underline' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "whitespace-nowrap text-32"
    }, action.title), hasSubitems && /*#__PURE__*/React.createElement("div", {
      className: "flex items-start relative"
    }, /*#__PURE__*/React.createElement("i", {
      className: "far " + (isOpen ? 'fa-angle-up' : 'fa-angle-down') + "  relative",
      style: {
        fontSize: 13,
        paddingTop: 0,
        left: 2,
        marginLeft: '0.55rem'
      }
    })))), hasSubitems && /*#__PURE__*/React.createElement(SubMenu$1, {
      actions: subActions,
      isOpen: isOpen,
      context: context
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "space-y-7 my-7"
  }, map(top_menu, function (action, i) {
    return /*#__PURE__*/React.createElement(ActionLink, {
      key: "top-menu-" + action.id,
      action: action,
      context: context,
      className: "flex items-center text-white text-20 leading-none font-light"
    }, action.title);
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-12"
  }, /*#__PURE__*/React.createElement(LanguagePicker$1, {
    context: context
  })));
};

var HeaderMobile = function HeaderMobile(_ref) {
  var _logo$image, _logo$image2, _logo$image3, _logo$image4, _logo$image5;
  var logo = _ref.logo,
    menu = _ref.menu,
    top_menu = _ref.top_menu,
    context = _ref.context;
  var _useState = useState(false),
    menuOpen = _useState[0],
    setMenuOpen = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between sticky-header py-5",
    style: {
      height: 81
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1",
    style: {
      width: 100,
      height: 40
    }
  }, /*#__PURE__*/React.createElement(ActionLink, {
    action: logo.action,
    context: context,
    className: "h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center",
    style: {
      height: 40
    }
  }, /*#__PURE__*/React.createElement("img", {
    srcSet: (logo === null || logo === void 0 ? void 0 : (_logo$image = logo.image) === null || _logo$image === void 0 ? void 0 : _logo$image.mobile) + " 300w, " + (logo === null || logo === void 0 ? void 0 : (_logo$image2 = logo.image) === null || _logo$image2 === void 0 ? void 0 : _logo$image2.tablet) + " 768w, " + (logo === null || logo === void 0 ? void 0 : (_logo$image3 = logo.image) === null || _logo$image3 === void 0 ? void 0 : _logo$image3.desktop) + " 1280w",
    src: logo === null || logo === void 0 ? void 0 : (_logo$image4 = logo.image) === null || _logo$image4 === void 0 ? void 0 : _logo$image4.mobile,
    alt: logo === null || logo === void 0 ? void 0 : (_logo$image5 = logo.image) === null || _logo$image5 === void 0 ? void 0 : _logo$image5.alt,
    className: "cursor-pointer lg3:h-full",
    style: {
      objectFit: 'cover',
      objectPosition: 'center',
      maxHeight: 40,
      minHeight: 25
    }
  })))), context.favorites && /*#__PURE__*/React.createElement("div", {
    className: "mr-6"
  }, /*#__PURE__*/React.createElement(FavoriteBtnWithCounter$1, {
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col justify-center items-center text-16",
    onClick: function onClick() {
      return setMenuOpen(true);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-bars text-secondary"
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-0.5 leading-none font-bold text-secondary"
  }, t('Menu'))), /*#__PURE__*/React.createElement(SideMenu, {
    context: context,
    isOpen: menuOpen,
    onClose: function onClose() {
      return setMenuOpen(false);
    },
    menu: menu,
    top_menu: top_menu
  }));
};

var HeaderLogoMenuWithSubsTopMenu = function HeaderLogoMenuWithSubsTopMenu(_ref) {
  var logo = _ref.logo,
    menu = _ref.menu,
    top_menu = _ref.top_menu,
    context = _ref.context;
  useEffect(function () {
    var el = document.getElementById('header-wrapper').parentNode;
    if (el) {
      el.classList.add('header-parent');
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    id: "header-wrapper",
    className: "flex border-b border-secondary-two sticky bg-white w-full top-0 z-50"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start justify-start container w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden md3:block w-full"
  }, /*#__PURE__*/React.createElement(HeaderDesktop, {
    logo: logo,
    menu: menu,
    top_menu: top_menu,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "block md3:hidden w-full"
  }, /*#__PURE__*/React.createElement(HeaderMobile, {
    logo: logo,
    menu: menu,
    top_menu: top_menu,
    context: context
  }))));
};
HeaderLogoMenuWithSubsTopMenu.defaultProps = {
  logo: DefaultImageAction,
  menu: DefaultActionWithSubActionsList,
  top_menu: DefaultActionList
};
HeaderLogoMenuWithSubsTopMenu.human = {
  nl: 'Header',
  fr: 'Header',
  en: 'Header'
};
HeaderLogoMenuWithSubsTopMenu.preview = function () {
  return /*#__PURE__*/React.createElement("div", null, "HEADER");
};

var PageNotFound = function PageNotFound() {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, "Page not found"));
};
PageNotFound.defaultProps = {};
PageNotFound.human = {
  nl: '404',
  fr: '404',
  en: '404'
};

var Paragraph = function Paragraph(_ref) {
  var text = _ref.text,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container mb-5 md:mb-12",
    style: {
      minHeight: 30
    }
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: text,
    context: context,
    data: {
      dealerGroup: context.dealerGroup ? context.dealerGroup : undefined
    }
  }));
};
Paragraph.human = {
  nl: 'Paragraph',
  fr: 'Paragraph',
  en: 'Paragraph'
};
Paragraph.preview = Paragraph;

var Separator = function Separator() {
  return /*#__PURE__*/React.createElement("div", {
    className: "container h-8 md:h-12"
  });
};
Separator.human = {
  nl: '',
  fr: '',
  en: ''
};
Separator.preview = Separator;

var CookieBanner = function CookieBanner(_ref) {
  var _useTranslation = useTranslation();
  return /*#__PURE__*/React.createElement("div", null, " TODO COOKIE BANNER ");
};
var CookieBanner$1 = baseCookieBanner(CookieBanner);

var FinanceBanner = function FinanceBanner(_ref) {
  var Content = _ref.Content,
    onAcceptLegal = _ref.onAcceptLegal,
    visible = _ref.visible,
    location = _ref.location,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAnalytics = useAnalytics(context),
    _useAnalytics$notific = _useAnalytics.notificationClickEventAnalytics,
    notificationClickEventAnalytics = _useAnalytics$notific === void 0 ? function (data) {
      return null;
    } : _useAnalytics$notific,
    _useAnalytics$notific2 = _useAnalytics.notificationImpressionEventAnalytics,
    notificationImpressionEventAnalytics = _useAnalytics$notific2 === void 0 ? function (data) {
      return null;
    } : _useAnalytics$notific2;
  var _useWindowDimensions = useWindowDimensions(),
    width = _useWindowDimensions.width;
  var handleClickAccept = function handleClickAccept(e) {
    onAcceptLegal();
    enableBodyScroll();
    notificationClickEventAnalytics({
      notificationType: 'banner',
      notificationCategory: 'financial',
      notificationName: 'financial-disclaimer',
      notificationOption: t('Accept')
    });
  };
  var enableBodyScroll = function enableBodyScroll() {
    toggleBodyScroll('scroll');
  };
  var toggleBodyScroll = function toggleBodyScroll(type) {
    if (document && width > 0 && width <= 768) {
      document.body.style.overflow = type;
    }
  };
  useEffect(function () {
    if (width > 0 && width <= 768) {
      toggleBodyScroll(visible ? 'hidden' : 'auto');
    }
  }, [visible, width]);
  useEffect(function () {
    if (visible) {
      notificationImpressionEventAnalytics({
        notificationType: 'banner',
        notificationCategory: 'financial',
        notificationName: 'financial-disclaimer',
        notificationOption: ''
      });
    }
  }, [visible]);
  return /*#__PURE__*/React.createElement(Fade, {
    bottom: true,
    when: visible,
    innerZ: 15,
    duration: 500,
    collapse: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row items-center justify-center text-white py-10 px-5 md:px-0 fixed left-0 right-0 " + location + "-0",
    style: {
      zIndex: 99999,
      backgroundColor: 'rgba(0, 0, 0, 0.9)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-80 overflow-y-auto md:h-auto px-5"
  }, Content), /*#__PURE__*/React.createElement("div", {
    className: "flex items-end justify-end px-5 mt-5 md:mt-0 self-end md:self-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row items-center md:flex-col "
  }, /*#__PURE__*/React.createElement("button", {
    className: "button primary-button",
    onClick: handleClickAccept
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-check mr-2"
  }), t('Accept'))))));
};
var FinanceBanner$1 = baseFinancingBanner(FinanceBanner);

var LoadingIndicator = function LoadingIndicator(_ref) {
  var color = _ref.color,
    small = _ref.small,
    extraSmall = _ref.extraSmall;
  var classes = small ? 'small-loader' : 'loader';
  classes = extraSmall ? 'extra-small' : classes;
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner one " + (color === null ? 'border-primary' : ''),
    style: {
      borderColor: color !== null ? color : ''
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "inner two " + (color === null ? 'border-primary' : ''),
    style: {
      borderColor: color !== null ? color : ''
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "inner three " + (color === null ? 'border-primary' : ''),
    style: {
      borderColor: color !== null ? color : ''
    }
  }));
};
LoadingIndicator.defaultProps = {
  color: null,
  small: false,
  extraSmall: false
};

var FinancingTextBlock = function FinancingTextBlock(_ref) {
  var Content = _ref.Content,
    loading = _ref.loading;
  if (loading) {
    return /*#__PURE__*/React.createElement(LoadingIndicator, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute top-0 -left-2"
  }, "*"), Content);
};
var FinancingTextBlock$1 = baseFinancingContent(FinancingTextBlock);

var VehicleCardSkeleton = function VehicleCardSkeleton(_ref) {
  var options = _ref.options;
  var defaultOptions = {
    width: hasWindow() ? window.innerWidth < 768 ? window.innerWidth - 60 : 330 : 300,
    height: 536
  };
  var opt = _extends({}, defaultOptions, options);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: opt.width,
      height: opt.height
    },
    className: "animate-pulse overflow-hidden border border-secondary-lightest relative shadow rounded-4"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: 246
    },
    className: "relative bg-gray-200 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute w-10 h-10 rounded-full bg-white",
    style: {
      top: 15,
      right: 15
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "px-4 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-6 bg-gray-200 mb-2 w-2/3"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 bg-gray-200 w-full"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex px-4 space-x-2 my-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-1/2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-6 bg-gray-200 mb-2 w-3/4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 bg-gray-200 w-1/3"
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-1/2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-6 bg-gray-200 mb-2 w-3/4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 bg-gray-200 w-1/3"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 px-4 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-4 h-4 bg-gray-200 mr-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 bg-gray-200 w-2/5"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-4 h-4 bg-gray-200 mr-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 bg-gray-200 w-2/5"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start "
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-4 h-4 bg-gray-200 mr-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 bg-gray-200 w-2/5"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-4 h-4 bg-gray-200 mr-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 bg-gray-200 w-2/5"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between w-full mt-2 px-4 border-t border-secondary-five"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-1/2  flex flex-row items-center py-6 border-r border-secondary-five pr-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-4 bg-gray-200 w-full"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center w-1/2 py-6 pl-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-4 bg-gray-200 w-full"
  }))));
};
VehicleCardSkeleton.defaultProps = {
  options: {}
};

var VehicleFavoriteBtn = function VehicleFavoriteBtn(_ref) {
  var isFavorite = _ref.isFavorite,
    updateFavorite = _ref.updateFavorite;
  var handleClick = function handleClick(e) {
    e.stopPropagation();
    e.preventDefault();
    updateFavorite();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center absolute cursor-pointer rounded-full bg-white opacity-75",
    onClick: handleClick,
    style: {
      width: 36,
      height: 36
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "text-lma " + (isFavorite ? 'fas fa-heart' : 'fal fa-heart'),
    style: {
      fontSize: 17
    }
  }));
};
var VehicleFavoriteBtn$1 = baseFavoriteBtn(VehicleFavoriteBtn);

var Checkbox = function Checkbox(_ref) {
  var _onClick = _ref.onClick,
    checked = _ref.checked,
    label = _ref.label,
    labelClassName = _ref.labelClassName;
  var _useState = useState(checked),
    isChecked = _useState[0],
    setIsChecked = _useState[1];
  useEffect(function () {
    setIsChecked(checked);
  }, [checked]);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center cursor-pointer",
    onClick: function onClick(e) {
      return _onClick(!isChecked, e);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-6 h-6 p-1 border-2 border-gray-200 bg-white"
  }, isChecked && /*#__PURE__*/React.createElement("div", {
    className: "w-full h-full bg-lma"
  })), label && /*#__PURE__*/React.createElement("div", {
    className: labelClassName + " ml-2"
  }, typeof label === 'function' ? label() : label));
};
Checkbox.defaultProps = {
  checked: false,
  label: '',
  onClick: undefined,
  labelClassName: 'flex flex-1 text-16 leading-19px text-secondary font-light'
};

var VehicleCompareBtn = function VehicleCompareBtn(_ref) {
  var isInCompare = _ref.isInCompare,
    updateCompare = _ref.updateCompare;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleClickCheckbox = function handleClickCheckbox(value, e) {
    e.preventDefault();
    e.stopPropagation();
    updateCompare();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    label: t('Compare'),
    onClick: handleClickCheckbox,
    checked: isInCompare,
    labelClassName: "text-14 leading-19px text-secondary font-normal"
  }));
};
var VehicleCompareBtn$1 = baseCompareBtn(VehicleCompareBtn);

var imgLock = "lock~lxTiJPSA.png";

var imgDefaultVehicleCard = "vehicle-card-default-photo~JzylAAlB.jpg";

var Warranty = function Warranty(_ref) {
  var warranty = _ref.warranty,
    labels = _ref.labels,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (!warranty) {
    return /*#__PURE__*/React.createElement("div", {
      className: "hidden"
    });
  }
  var warrantyDuration = parseInt(warranty);
  var renderLogo = function renderLogo() {
    if (isMyWayLabel(labels)) {
      return /*#__PURE__*/React.createElement("img", {
        src: useAsset(myWayLogoBig),
        alt: "MyWay",
        style: {
          maxHeight: 22
        }
      });
    } else if (isAapLabel(labels)) {
      return /*#__PURE__*/React.createElement("img", {
        src: useAsset(context.culture === 'fr' ? aapLogoFr : aapLogoNl),
        alt: "Audi approved plus",
        style: {
          maxHeight: 22
        }
      });
    }
  };
  var renderWarrantyLabel = function renderWarrantyLabel() {
    if (context.culture === 'fr') {
      if (warrantyDuration < 2) {
        return "garantie " + warrantyDuration + " an";
      }
      return "garantie " + warrantyDuration + " ans";
    }
    if (context.culture === 'nl') {
      if (warrantyDuration < 2) {
        return warrantyDuration + " jaar garantie";
      }
      return warrantyDuration + " jaar garantie";
    }
    if (warrantyDuration < 2) {
      return warrantyDuration + " " + t('year warranty');
    }
    return warrantyDuration + " " + t('years warranty');
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 items-center justify-end text-12 text-lma-darkgray leading-17px font-semibold"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mr-1 whitespace-nowrap"
  }, renderWarrantyLabel()), /*#__PURE__*/React.createElement("div", null, renderLogo()));
};

var TotalPrice = function TotalPrice(_ref) {
  var label = _ref.label,
    price = _ref.price;
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full",
    style: {
      minHeight: 88
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-10 leading-20px text-lma-darkgray mb-0.5"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "w-full p-1.5",
    style: {
      minHeight: 71
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-24 font-bold leading-28px text-secondary"
  }, price ? formatPrice(price) : '')));
};
var BothPrices = function BothPrices(_ref2) {
  var labelTotal = _ref2.labelTotal,
    labelMonthly = _ref2.labelMonthly,
    monthlyPriceType = _ref2.monthlyPriceType,
    monthlyLastPayment = _ref2.monthlyLastPayment,
    monthlyPrice = _ref2.monthlyPrice,
    totalPrice = _ref2.totalPrice,
    context = _ref2.context,
    vehicle = _ref2.vehicle;
  var _useState = useState(false),
    isHovered = _useState[0],
    setIsHovered = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var getUrl = function getUrl() {
    var page = find(context.allPagesData, function (page) {
      return page.key === 'vehicle';
    });
    if (page && vehicle) {
      var url = page.url.replace(':make', vehicle.make).replace(':model', vehicle.model).replace(':reference', vehicle.reference);
      return url + "#" + vehicle.identification;
    }
    return undefined;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex w-full",
    style: {
      minHeight: 88
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "mr-2 text-secondary with-financing"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cursor-pointer",
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    },
    onClick: function onClick() {
      return navigateInternalUrl(getUrl());
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center text-10 leading-20px text-lma-darkgray mb-0.5"
  }, /*#__PURE__*/React.createElement("span", {
    className: "" + (isHovered ? 'underline' : '')
  }, labelMonthly), /*#__PURE__*/React.createElement("i", {
    className: "fal fa-info-circle text-10 ml-1"
  })), /*#__PURE__*/React.createElement("div", {
    className: "monthly-price-box flex flex-col w-full border-2 border-gray-100 bg-gray-100 p-1.5 rounded-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row items-end lg2:flex-col lg2:items-start lg3:flex-row lg3:items-end"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-24 font-bold leading-28px text-secondary"
  }, "\u20AC", monthlyPrice ? formatNumber(monthlyPrice, 2, 2) : ''), /*#__PURE__*/React.createElement("div", {
    className: "text-12 font-semibold text-secondary ml-1 mb-1 monthly-price-label"
  }, "/ ", t('month'))), monthlyPriceType === 'balloon' && monthlyLastPayment && /*#__PURE__*/React.createElement("div", {
    className: "text-10 leading-18px text-secondary"
  }, t('Last monthly payment'), " \u20AC", formatNumber(monthlyLastPayment, 2, 2))))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-10 leading-20px text-lma-darkgray mb-0.5"
  }, labelTotal), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 w-full p-1.5",
    style: {
      minHeight: 71
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-18 font-bold leading-28px text-secondary"
  }, totalPrice ? formatPrice(totalPrice) : ''))));
};
var ProfessionalPriceBlock = function ProfessionalPriceBlock(_ref3) {
  var vehicle = _ref3.vehicle,
    context = _ref3.context,
    financingEnabled = _ref3.financingEnabled;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings;
  var hasMonthlyPrice = vehicle.monthlyPriceProf > 0;
  var price,
    priceLabel,
    monthlyPrice,
    monthlyPriceLabel = '';
  if (!vehicle.vatRegime) {
    price = vehicle.price;
    priceLabel = t('Price (incl. VAT)');
    if (financingEnabled && hasMonthlyPrice) {
      monthlyPrice = increasedForVAT(vehicle.monthlyPriceProf);
      monthlyPriceLabel = t('Monthly price (incl. VAT)');
    }
  } else {
    price = (clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isInclVat) === true ? vehicle.price : vehicle.priceExcl;
    priceLabel = (clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isInclVat) === true ? t('Price (incl. VAT)') : t('Price (excl. VAT)');
    if (financingEnabled && hasMonthlyPrice) {
      monthlyPrice = (clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isInclVat) === true ? increasedForVAT(vehicle.monthlyPriceProf) : vehicle.monthlyPriceProf;
      monthlyPriceLabel = (clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isInclVat) === true ? t('Monthly price (incl. VAT)') : t('Monthly price (excl. VAT)');
    }
  }
  if (!financingEnabled || !hasMonthlyPrice) {
    return /*#__PURE__*/React.createElement(TotalPrice, {
      label: priceLabel,
      price: price,
      context: context
    });
  }
  return /*#__PURE__*/React.createElement(BothPrices, {
    labelTotal: priceLabel,
    labelMonthly: monthlyPriceLabel,
    monthlyPriceType: vehicle.monthlyPriceTypeProf,
    monthlyPrice: monthlyPrice,
    totalPrice: price,
    context: context
  });
};
var PrivatePriceBlock = function PrivatePriceBlock(_ref4) {
  var vehicle = _ref4.vehicle,
    financingEnabled = _ref4.financingEnabled,
    context = _ref4.context;
  var _useTranslation3 = useTranslation(),
    t = _useTranslation3.t;
  var hasMonthlyPrice = vehicle.monthlyPrice > 0;
  if (!financingEnabled || !hasMonthlyPrice) {
    return /*#__PURE__*/React.createElement(TotalPrice, {
      label: t('Price (incl. VAT)'),
      price: vehicle.price,
      context: context
    });
  }
  return /*#__PURE__*/React.createElement(BothPrices, {
    labelTotal: t('Price (incl. VAT)'),
    labelMonthly: t('Monthly price (incl. VAT)'),
    monthlyPriceType: vehicle.monthlyPriceType,
    monthlyLastPayment: vehicle.monthlyLastPayment,
    monthlyPrice: vehicle.monthlyPrice,
    totalPrice: vehicle.price,
    context: context,
    vehicle: vehicle
  });
};
var PriceBlock = function PriceBlock(_ref5) {
  var vehicle = _ref5.vehicle,
    isProfessional = _ref5.isProfessional,
    context = _ref5.context;
  var financingEnabled = context.financing;
  if (isProfessional) {
    return /*#__PURE__*/React.createElement(ProfessionalPriceBlock, {
      context: context,
      vehicle: vehicle,
      financingEnabled: financingEnabled
    });
  }
  return /*#__PURE__*/React.createElement(PrivatePriceBlock, {
    context: context,
    vehicle: vehicle,
    financingEnabled: financingEnabled
  });
};

var overlayTypes = {
  sold: 'sold',
  reserved: 'reserved'
};
var mapVehicleImagesForViewer = function mapVehicleImagesForViewer(images) {
  var isArray = images instanceof Array;
  return isArray ? images.map(function (img) {
    return img.uri + "?width=800";
  }) : [images.uri + "?width=800"];
};
var VehicleCard = function VehicleCard(_ref) {
  var vehicle = _ref.vehicle,
    context = _ref.context,
    onClick = _ref.onClick,
    cardClass = _ref.cardClass,
    styles = _ref.styles,
    eventName = _ref.eventName;
  var _useState = useState(260),
    setImageViewerHeight = _useState[1];
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAnalytics = useAnalytics(context),
    _useAnalytics$buttonC = _useAnalytics.buttonClickEventAnalytics,
    buttonClickEventAnalytics = _useAnalytics$buttonC === void 0 ? function (data) {
      return null;
    } : _useAnalytics$buttonC;
  var isSold = vehicle.sold;
  var isReserved = vehicle.reserved;
  var isNew = vehicle.categoryKey === 'new';
  var image = head(mapVehicleImagesForViewer(vehicle.images));
  var calculateHeight = function calculateHeight() {
    var newHeight = window.innerWidth < 768 ? 220 : 260;
    setImageViewerHeight(newHeight);
  };
  useEffect(function () {
    calculateHeight();
    function handleResize() {
      calculateHeight();
    }
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  var renderOverlay = function renderOverlay(type) {
    var title = type === overlayTypes.reserved ? t('Reserved') : t('Sold');
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-center justify-center absolute right-0 left-0 top-0 bottom-0 z-20",
      style: {
        background: 'rgba(0, 0, 0, 0.5)'
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: useAsset(imgLock),
      alt: t('Not available'),
      style: {
        height: 40
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "paragraph-large font-semibold text-white uppercase mt-3"
    }, title));
  };
  var handleClick = function handleClick() {
    {
      if (eventName == 'deals') {
        buttonClickEventAnalytics({
          analyticsButtonName: 'to-deals',
          url: vehicle.url
        });
      }
      if (eventName == 'similar') {
        buttonClickEventAnalytics({
          analyticsButtonName: 'to-similar-vehicle',
          analyticsButtonType: 'recommendation',
          url: vehicle.url
        });
      }
      if (onClick) onClick(vehicle);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    key: vehicle.reference,
    className: cardClass + " shadow-inner overflow-hidden border border-secondary-lightest relative",
    style: _extends({}, styles, {
      outline: 'none !important'
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col rounded-4 flex-1 h-full "
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative rounded-tl-4 rounded-tr-4"
  }, isSold && renderOverlay(overlayTypes.sold), isReserved && renderOverlay(overlayTypes.reserved), /*#__PURE__*/React.createElement("div", {
    className: "relative h-full " + ( 'cursor-pointer' ),
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("img", {
    src: image ? image : useAsset(imgDefaultVehicleCard),
    alt: vehicle.make,
    className: "w-full object-cover",
    style: {
      minHeight: 220
    }
  })), context.favorites && /*#__PURE__*/React.createElement("div", {
    className: "absolute",
    style: {
      top: 15,
      right: 50
    }
  }, /*#__PURE__*/React.createElement(VehicleFavoriteBtn$1, {
    reference: vehicle.reference,
    vehicle: vehicle,
    context: context
  })), isNew && /*#__PURE__*/React.createElement("div", {
    className: "absolute paragraph-xsmall uppercase text-white px-2.5 py-1.5 gradient-left-right rounded-4",
    style: {
      top: 15,
      left: 20
    }
  }, t('New'))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 p-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col text-left " + ( 'cursor-pointer' ),
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "truncate font-bold text-secondary text-16 leading-28px"
  }, vehicle.make), /*#__PURE__*/React.createElement("div", {
    className: "text-24 font-bold text-secondary text-secondary truncate leading-28px"
  }, ' ', vehicle.model), /*#__PURE__*/React.createElement("div", {
    className: "text-14 font-medium text-secondary truncate leading-28px",
    style: {
      minHeight: 21,
      height: 21
    }
  }, ' ', vehicle === null || vehicle === void 0 ? void 0 : vehicle.version)), /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-2 mt-1 mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-2 py-1 text-12 text-white rounded-3 whitespace-nowrap bg-lma-darkgray"
  }, vehicle.firstRegistrationYear), /*#__PURE__*/React.createElement("div", {
    className: "px-2 py-1 text-12 text-white rounded-3 whitespace-nowrap bg-lma-darkgray"
  }, formatNumber(vehicle.mileage), " ", t('km')), /*#__PURE__*/React.createElement("div", {
    className: "px-2 py-1 text-12 text-white rounded-3 whitespace-nowrap bg-lma-darkgray truncate"
  }, vehicle.fuel)), /*#__PURE__*/React.createElement(PriceBlock, {
    context: context,
    isProfessional: clientSettings.isProfessional,
    vehicle: vehicle
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row flex-wrap my-3 space-x-2"
  }, context.vehicleCompare && /*#__PURE__*/React.createElement(VehicleCompareBtn$1, {
    reference: vehicle.reference,
    vehicle: vehicle,
    context: context
  }), vehicle.warranty && (isMyWayLabel(vehicle.labelsV2) || isAapLabel(vehicle.labelsV2)) && /*#__PURE__*/React.createElement(Warranty, {
    warranty: vehicle.warranty,
    labels: vehicle.labelsV2,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "button bg-secondary hover:opacity-95 transition text-white font-bold rounded-3 " + ( '' ),
    onClick: handleClick
  }, t('Go to details')))));
};
VehicleCard.defaultProps = {
  cardClass: 'vehicle-card',
  styles: {}
};
var VehicleCard$1 = baseVehicleCard(VehicleCard);

var FavoriteVehiclesOverview = function FavoriteVehiclesOverview(_ref) {
  var vehicles = _ref.vehicles,
    loading = _ref.loading,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var totalSkeletons = 3;
  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 py-4"
    }, times(totalSkeletons, function (item) {
      return /*#__PURE__*/React.createElement(VehicleCardSkeleton, {
        key: "skeleton-favorite-" + item
      });
    }));
  }
  if (!loading && vehicles.length < 1) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col mb-5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "inline-block md:flex items-center",
      style: {
        lineHeight: 2
      }
    }, t('Look for your favorite cars within our assortment'), /*#__PURE__*/React.createElement("span", {
      className: "bg-gray-50 mx-1 rounded-full px-2 py-1"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fal fa-heart"
    })), t('and keep them in this list.')), /*#__PURE__*/React.createElement("div", {
      className: "inline-block"
    }, /*#__PURE__*/React.createElement(InternalLink, {
      page: context.defaultPageNames.vehicles,
      className: "button primary-button inline-block mt-5",
      context: context
    }, t('Assortment of second-hand cars.'))));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 gap-4"
  }, map(vehicles, function (vehicle) {
    return /*#__PURE__*/React.createElement(VehicleCard$1, {
      key: "vehicle-desktop-" + (vehicle === null || vehicle === void 0 ? void 0 : vehicle.reference),
      vehicle: vehicle,
      context: context
    });
  })));
};
var FavoriteVehiclesOverview$1 = baseFavoriteVehicles(FavoriteVehiclesOverview);

var FavoriteVehicles = function FavoriteVehicles(_ref) {
  var context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (context.builder) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        height: 50
      }
    }, "Favorite vehicles");
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "container py-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-5 text-24 md:text-32 text-secondary font-bold"
  }, t('Your favorite vehicles')), /*#__PURE__*/React.createElement(FavoriteVehiclesOverview$1, {
    context: context
  }));
};
FavoriteVehicles.defaultProps = {};
FavoriteVehicles.human = {
  nl: 'Favorite vehicles',
  fr: 'Favorite vehicles',
  en: 'Favorite vehicles'
};
FavoriteVehicles.preview = function () {
  return /*#__PURE__*/React.createElement("div", null, "FavoriteVehicles");
};

var NoResultsBanner = function NoResultsBanner() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "container mx-auto w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex self-center bg-orange-100 w-1/2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-16 bg-orange-200 flex items-center justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fad fa-info"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-auto text-gray-800 text-lg items-center p-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "leading-tight"
  }, t('You have no any vehicles to compare.'))))));
};

var CompareArrows = function CompareArrows(_ref) {
  var hasPrev = _ref.hasPrev,
    hasNext = _ref.hasNext,
    onNext = _ref.onNext,
    onPrev = _ref.onPrev;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, hasPrev && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center rounded-full absolute -left-5 text-white bg-secondary h-10 w-10 vAlign cursor-pointer z-10",
    onClick: onPrev
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-chevron-left text-white"
  })), hasNext && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center rounded-full absolute -right-5 text-white bg-secondary h-10 w-10 vAlign cursor-pointer",
    onClick: onNext,
    style: {
      zIndex: 2
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-chevron-right text-white"
  })));
};

var CompareCard = function CompareCard(_ref) {
  var vehicle = _ref.vehicle,
    compareRemoveVehicle = _ref.compareRemoveVehicle,
    onClick = _ref.onClick,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings;
  var coverImage = head(vehicle.images);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 flex-col cursor-pointer pr-4",
    key: vehicle.reference
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement("img", {
    src: coverImage ? coverImage.uri : useAsset(imgDefaultVehicleCard),
    alt: vehicle.make,
    style: {
      maxHeight: 192
    },
    className: "w-full object-cover",
    onClick: onClick
  }), /*#__PURE__*/React.createElement("div", {
    className: "absolute md:hidden z-10",
    style: {
      top: 10,
      right: 35
    },
    onClick: function onClick() {
      return compareRemoveVehicle(vehicle.reference);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-times text-secondary text-20"
  })), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block absolute cursor-pointer z-10 -top-5 -right-1",
    onClick: function onClick() {
      return compareRemoveVehicle(vehicle.reference);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-times text-secondary text-20"
  })), context.favorites && /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block absolute z-10",
    style: {
      top: 15,
      right: 50
    }
  }, /*#__PURE__*/React.createElement(VehicleFavoriteBtn$1, {
    reference: vehicle.reference,
    vehicle: vehicle,
    context: context
  }))), /*#__PURE__*/React.createElement("div", {
    className: " flex flex-col text-left cursor-pointer py-3",
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "truncate font-bold text-secondary text-16 leading-28px"
  }, vehicle.make), /*#__PURE__*/React.createElement("div", {
    className: "text-24 font-bold text-secondary truncate leading-28px"
  }, ' ', vehicle.model)), /*#__PURE__*/React.createElement("div", {
    className: "compare-card-price-box"
  }, clientSettings.isProfessional && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col sm:flex-row"
  }, (context === null || context === void 0 ? void 0 : context.financing) && (vehicle === null || vehicle === void 0 ? void 0 : vehicle.monthlyPrice) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "text-secondary bg-gray-100 p-3 w-full sm:w-1/2 mr-0 sm:mr-2 leading-none",
    style: {
      minHeight: 71
    }
  }, vehicle !== null && vehicle !== void 0 && vehicle.monthlyPriceProf ? /*#__PURE__*/React.createElement("p", {
    className: "font-bold text-20"
  }, formatPrice(vehicle.monthlyPriceProf), ' ') : /*#__PURE__*/React.createElement("p", {
    className: "font-bold text-20"
  }, formatPrice(vehicle.monthlyPrice), ' '), /*#__PURE__*/React.createElement("p", {
    className: "font-normal text-12"
  }, "/ ", t('month'))), /*#__PURE__*/React.createElement("div", {
    className: "text-secondary py-3 px-3 sm:px-0 w-full sm:w-1/2 leading-none"
  }, !(vehicle !== null && vehicle !== void 0 && vehicle.vatRegime) ? /*#__PURE__*/React.createElement("p", {
    className: "text-20 font-bold"
  }, formatPrice(vehicle === null || vehicle === void 0 ? void 0 : vehicle.price)) : clientSettings !== null && clientSettings !== void 0 && clientSettings.isInclVat ? /*#__PURE__*/React.createElement("p", {
    className: "text-20 font-bold"
  }, formatPrice(vehicle === null || vehicle === void 0 ? void 0 : vehicle.price)) : /*#__PURE__*/React.createElement("p", {
    className: "text-20 font-bold"
  }, formatPrice(vehicle.priceExcl), ' '))), !clientSettings.isProfessional && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col sm:flex-row"
  }, (context === null || context === void 0 ? void 0 : context.financing) && (vehicle === null || vehicle === void 0 ? void 0 : vehicle.monthlyPrice) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "text-secondary bg-gray-100 p-3 w-full sm:w-1/2 mr-0 sm:mr-2 leading-none",
    style: {
      minHeight: 71
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-bold text-20"
  }, formatPrice(vehicle.monthlyPrice), ' '), /*#__PURE__*/React.createElement("p", {
    className: "font-normal text-12"
  }, "/ ", t('month'))), /*#__PURE__*/React.createElement("div", {
    className: "text-secondary py-3 px-3 sm:px-0 w-full sm:w-1/2 leading-none"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-20 font-bold"
  }, formatPrice(vehicle === null || vehicle === void 0 ? void 0 : vehicle.price))))));
};

var CompareSpecs = function CompareSpecs(_ref) {
  var vehicles = _ref.vehicles,
    compareGroups = _ref.compareGroups,
    compareFields = _ref.compareFields,
    context = _ref.context;
  var _useTranslation = useTranslation();
  var general = find(compareGroups, function (cg) {
    return cg.key === 'general';
  });
  var other = filter(compareGroups, function (cg) {
    return cg.key !== 'general';
  });
  var orderedGroups = general ? [general].concat(other) : compareGroups;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:flex flex-1 flex-col"
  }, map(orderedGroups, function (item) {
    var options = filter(compareFields, function (cf) {
      return cf.group === item.key;
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "paragraph-default text-secondary font-bold text-18  py-6"
    }, item.label(context.culture)), map(options, function (option) {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex py-2 paragraph-default font-semibold text-primary border-b border-r border-secondary-five truncate"
      }, /*#__PURE__*/React.createElement("div", {
        className: "w-full truncate mr-2 capitalize"
      }, option.label(context.culture)));
    }));
  })), map(vehicles, function (vehicle, i) {
    var isFirstCol = i === 0;
    return /*#__PURE__*/React.createElement(Fade, null, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 flex-col",
      key: vehicle.reference + "-specs"
    }, map(orderedGroups, function (item, i) {
      var options = filter(compareFields, function (cf) {
        return cf.group === item.key;
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col"
      }, /*#__PURE__*/React.createElement("div", {
        className: "paragraph-default text-secondary font-bold text-18 py-6"
      }, /*#__PURE__*/React.createElement("span", {
        className: (isFirstCol ? 'opacity-100 lg:opacity-0' : 'opacity-0') + " "
      }, item.label(context.culture))), map(options, function (option) {
        return /*#__PURE__*/React.createElement("div", {
          className: "paragraph-default text-secondary-four py-2 pr-4 pl-0 lg:pr-4 lg:pl-4 border-b border-secondary-five truncate"
        }, /*#__PURE__*/React.createElement("div", {
          className: "block lg:hidden truncate paragraph-default font-semibold text-primary mb-1 " + (isFirstCol ? 'opacity-100' : 'opacity-0') + " lg:opacity-0"
        }, option.label(context.culture)), option.value(vehicle));
      }));
    })));
  }));
};

var CompareBar = function CompareBar(_ref) {
  var displayBar = _ref.displayBar,
    gridColsClass = _ref.gridColsClass,
    vehicles = _ref.vehicles,
    context = _ref.context;
  var getFirstImageUri = function getFirstImageUri(images) {
    var _images$;
    return images instanceof Array ? (_images$ = images[0]) === null || _images$ === void 0 ? void 0 : _images$.uri : images === null || images === void 0 ? void 0 : images.uri;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "fixed w-full left-0 bg-white border-b border-secondary-four z-10 transition transform " + (displayBar ? 'translate-y-0' : '-translate-y-full'),
    style: {
      top: getStickiesOffset()
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container px-5 md:px-10 grid " + gridColsClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:block"
  }), map(vehicles, function (vehicle, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: "compare-bar-vehicle-" + index,
      className: "flex items-center py-2 cursor-pointer",
      onClick: function onClick() {
        return navigateInternalPage(context, context.defaultPageNames.vehicleDetail, "reference=" + (vehicle === null || vehicle === void 0 ? void 0 : vehicle.reference));
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: getFirstImageUri(vehicle.images),
      alt: vehicle.make + " " + vehicle.model,
      className: "hidden md:block h-10"
    }), /*#__PURE__*/React.createElement("div", {
      className: "truncate md:px-3"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "truncate text-lg font-bold"
    }, vehicle.make + ' ' + vehicle.model)));
  })));
};

var CompareSkeleton = function CompareSkeleton(_ref) {
  var grid = _ref.grid;
  var _useState = useState(0),
    cols = _useState[0],
    setCols = _useState[1];
  var _useState2 = useState(375),
    headerCardHeight = _useState2[0],
    setHeaderCardHeight = _useState2[1];
  var _useWindowDimensions = useWindowDimensions(),
    width = _useWindowDimensions.width;
  useEffect(function () {
    if (width > 0) {
      if (width >= 768 && width < 1280) {
        setCols(3);
        setHeaderCardHeight(365);
      } else if (width >= 1280) {
        setCols(4);
        setHeaderCardHeight(375);
      } else {
        setCols(2);
        setHeaderCardHeight(365);
      }
    }
  }, [width]);
  var groups = 2;
  var fields = 10;
  if (cols === 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "hidden"
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: grid + " gap-4 relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:flex items-center justify-end w-full h-full",
    style: {
      height: headerCardHeight
    }
  }), times(cols, function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item,
      className: "bg-gray-200 animate-pulse",
      style: {
        height: headerCardHeight
      }
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full mt-6"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: 2
    },
    className: "bg-secondary-five w-full"
  })), /*#__PURE__*/React.createElement("div", {
    className: "" + grid
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:flex flex-1 flex-col"
  }, times(groups, function (item) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "py-6"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-gray-200 animate-pulse h-5"
    })), times(fields, function (option) {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex py-2 border-b border-r border-secondary-five"
      }, /*#__PURE__*/React.createElement("div", {
        className: "w-full mr-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "bg-gray-200 animate-pulse h-2 w-1/3"
      })));
    }));
  })), times(cols, function (item) {
    var isFirstCol = item === 0;
    return /*#__PURE__*/React.createElement(Fade, null, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 flex-col"
    }, times(groups, function (group) {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col"
      }, /*#__PURE__*/React.createElement("div", {
        className: "py-6"
      }, /*#__PURE__*/React.createElement("div", {
        className: (isFirstCol ? 'opacity-100 lg:opacity-0' : 'opacity-0') + " "
      }, /*#__PURE__*/React.createElement("div", {
        className: "bg-gray-200 animate-pulse h-5"
      }))), times(fields, function (option) {
        return /*#__PURE__*/React.createElement("div", {
          className: "py-2 pr-4 pl-0 lg:pr-4 lg:pl-4 border-b border-secondary-five"
        }, /*#__PURE__*/React.createElement("div", {
          className: "block lg:hidden mb-1 " + (isFirstCol ? 'opacity-100' : 'opacity-0') + " lg:opacity-0"
        }, /*#__PURE__*/React.createElement("div", {
          className: "bg-gray-200 animate-pulse h-5"
        })), /*#__PURE__*/React.createElement("div", {
          className: "bg-gray-200 animate-pulse h-2 w-1/3"
        }));
      }));
    })));
  })));
};

var Compare = function Compare(_ref) {
  var vehicles = _ref.vehicles,
    loading = _ref.loading,
    compareFields = _ref.compareFields,
    compareGroups = _ref.compareGroups,
    hasNext = _ref.hasNext,
    hasPrev = _ref.hasPrev,
    onNext = _ref.onNext,
    onPrev = _ref.onPrev,
    context = _ref.context,
    compareRemoveVehicle = _ref.compareRemoveVehicle;
  var _useScrollPosition = useScrollPosition(),
    scrollPosition = _useScrollPosition.scrollPosition;
  var _useState = useState(false),
    displayBar = _useState[0],
    setDisplayBar = _useState[1];
  var horizontalLineRef = useRef();
  var grid = 'grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 lg2:grid-cols-5';
  useEffect(function () {
    var _horizontalLineRef$cu;
    setDisplayBar(scrollPosition > (horizontalLineRef === null || horizontalLineRef === void 0 ? void 0 : (_horizontalLineRef$cu = horizontalLineRef.current) === null || _horizontalLineRef$cu === void 0 ? void 0 : _horizontalLineRef$cu.offsetTop) - getStickiesOffset());
  }, [scrollPosition]);
  if (loading) {
    return /*#__PURE__*/React.createElement(CompareSkeleton, {
      grid: grid
    });
  }
  if ((vehicles === null || vehicles === void 0 ? void 0 : vehicles.length) === 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-screen"
    }, /*#__PURE__*/React.createElement(NoResultsBanner, null));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CompareBar, {
    vehicles: vehicles,
    displayBar: displayBar,
    gridColsClass: grid,
    context: context
  }), /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement(CompareArrows, {
    hasPrev: hasPrev,
    hasNext: hasNext,
    onNext: onNext,
    onPrev: onPrev
  }), /*#__PURE__*/React.createElement("div", {
    className: "" + grid
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:block"
  }), map(vehicles, function (vehicle) {
    return /*#__PURE__*/React.createElement("div", {
      key: vehicle.reference
    }, /*#__PURE__*/React.createElement(CompareCard, {
      key: vehicle.reference,
      vehicle: vehicle,
      context: context,
      onClick: function onClick() {
        return navigateInternalUrl(context, vehicle.url);
      },
      compareRemoveVehicle: compareRemoveVehicle
    }));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-full mt-6",
    ref: horizontalLineRef
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: 2
    },
    className: "bg-secondary-five w-full"
  })), /*#__PURE__*/React.createElement("div", {
    className: "" + grid
  }, /*#__PURE__*/React.createElement(CompareSpecs, {
    vehicles: vehicles,
    grid: grid,
    compareGroups: compareGroups,
    compareFields: compareFields,
    context: context
  })));
};
var Compare$1 = baseCompare(Compare);

var VehicleCompare = function VehicleCompare(_ref) {
  var references = _ref.references,
    onDelete = _ref.onDelete,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-32 text-secondary font-bold py-7"
  }, t('Vehicles compare')), /*#__PURE__*/React.createElement(Compare$1, {
    context: context,
    references: references,
    onDelete: onDelete
  })));
};
VehicleCompare.defaultProps = {};
VehicleCompare.human = {
  nl: "Auto's Vergelijken",
  fr: 'Comparer des véhicules',
  en: 'Compare vehicles'
};

var VehicleCompareBanner = function VehicleCompareBanner(_ref) {
  var totalVehiclesInCompare = _ref.totalVehiclesInCompare,
    navigateCompare = _ref.navigateCompare,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAnalytics = useAnalytics(context),
    analyticsTracker = _useAnalytics.analyticsTracker,
    _useAnalytics$notific = _useAnalytics.notificationClickEventAnalytics,
    notificationClickEventAnalytics = _useAnalytics$notific === void 0 ? function (data) {
      return null;
    } : _useAnalytics$notific,
    _useAnalytics$notific2 = _useAnalytics.notificationImpressionEventAnalytics,
    notificationImpressionEventAnalytics = _useAnalytics$notific2 === void 0 ? function (data) {
      return null;
    } : _useAnalytics$notific2;
  var handleClickCompare = function handleClickCompare(e) {
    notificationClickEventAnalytics({
      notificationType: 'banner',
      notificationCategory: 'product',
      notificationName: 'myway-comparison',
      notificationOption: t('Compare vehicles') + " (" + totalVehiclesInCompare + ")"
    });
    navigateCompare(e);
  };
  useEffect(function () {
    notificationImpressionEventAnalytics({
      notificationType: 'banner',
      notificationCategory: 'product',
      notificationName: 'myway-comparison',
      notificationOption: ''
    });
  }, [analyticsTracker]);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center fixed left-0 right-0 bottom-0",
    style: {
      zIndex: 99999
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "block w-full flex shadow-xl bg-lma text-white"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center font-primary font-normal text-16 leading-6 px-4 py-3  cursor-pointer p-2 w-full text-18 relative rounded-none h-49px md:h-56px",
    onClick: handleClickCompare
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4 flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mr-4"
  }, t('Compare vehicles'), " (", totalVehiclesInCompare, ")"), /*#__PURE__*/React.createElement("i", {
    className: "far fa-arrow-right mt-1 md:mt-0.5"
  })))));
};
var VehicleCompareBanner$1 = baseCompareBanner(VehicleCompareBanner);

var getColorByBranding = function getColorByBranding(branding) {
  if (branding === BRANDING.myway) return 'text-white';
  return 'text-lma-darkgray';
};
var BreadcrumbsDetailMobile = function BreadcrumbsDetailMobile(_ref) {
  var _context$defaultPageN;
  var branding = _ref.branding,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: getColorByBranding(branding) + " container py-6"
  }, /*#__PURE__*/React.createElement(InternalLink, {
    page: context === null || context === void 0 ? void 0 : (_context$defaultPageN = context.defaultPageNames) === null || _context$defaultPageN === void 0 ? void 0 : _context$defaultPageN.vehicles,
    context: context
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-long-arrow-left mr-2"
  }), t('Used car vehicles')));
};

var getColorByBranding$1 = function getColorByBranding(branding) {
  if (branding === BRANDING.myway) return 'text-white';
  if (branding === BRANDING.aap) return 'text-aap';
  return 'text-primary';
};
var BreadcrumbsDetailDesktop = function BreadcrumbsDetailDesktop(_ref) {
  var _context$defaultPageN, _context$defaultPageN2;
  var branding = _ref.branding,
    make = _ref.make,
    model = _ref.model,
    version = _ref.version,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "container pt-6 pb-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: getColorByBranding$1(branding) + " flex"
  }, context !== null && context !== void 0 && context.lmaHomePage ? /*#__PURE__*/React.createElement(ExternalLink, {
    url: context === null || context === void 0 ? void 0 : context.lmaHomePage,
    target: "_self",
    className: getColorByBranding$1(branding) + " font-semibold underline flex-none",
    context: context
  }, t('Home')) : /*#__PURE__*/React.createElement(InternalLink, {
    page: context === null || context === void 0 ? void 0 : (_context$defaultPageN = context.defaultPageNames) === null || _context$defaultPageN === void 0 ? void 0 : _context$defaultPageN.home,
    className: getColorByBranding$1(branding) + " font-semibold underline flex-none",
    context: context
  }, t('Home')), /*#__PURE__*/React.createElement("span", {
    className: " mx-2"
  }, "-"), /*#__PURE__*/React.createElement(InternalLink, {
    page: context === null || context === void 0 ? void 0 : (_context$defaultPageN2 = context.defaultPageNames) === null || _context$defaultPageN2 === void 0 ? void 0 : _context$defaultPageN2.vehicles,
    className: getColorByBranding$1(branding) + " font-semibold underline flex-none",
    context: context
  }, t('Used car vehicles')), /*#__PURE__*/React.createElement("span", {
    className: "mx-2"
  }, "-"), /*#__PURE__*/React.createElement("p", {
    className: "truncate"
  }, make, " ", model, " ", version)));
};

var TitleDetail = function TitleDetail(_ref) {
  var make = _ref.make,
    model = _ref.model,
    version = _ref.version,
    identification = _ref.identification;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", {
    className: "font-bold text-3xl truncate"
  }, make, " ", model), /*#__PURE__*/React.createElement("h2", {
    className: "font-light text-2xl truncate"
  }, version), /*#__PURE__*/React.createElement("p", {
    className: "text-12 font-semibold"
  }, t('Reference'), ": ", identification));
};

var ClientTypeSwitch = function ClientTypeSwitch() {
  var _useClientSettings = useClientSettings(),
    clientSettings = _useClientSettings.clientSettings,
    setClientSetting = _useClientSettings.setClientSetting;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "rounded-full inline-flex py-1 relative",
    style: {
      background: '#f2f2f2'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute top-0 w-32 " + ((clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isProfessional) === false ? 'transform translate-x-0' : 'transform translate-x-32') + " bg-secondary rounded-full shadow-xl py-5 -mt-1 transition-transform",
    style: {
      zIndex: 1
    }
  }), /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      if ((clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isProfessional) === true) {
        setClientSetting('isProfessional', false);
      }
    },
    className: "flex-none text-center w-32 cursor-pointer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative transition-colors truncate px-3\n              " + ((clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isProfessional) === false ? 'text-white' : 'text-secondary') + "\n            ",
    style: {
      zIndex: 2
    }
  }, t('Private'))), /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      if ((clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isProfessional) === false) {
        setClientSetting('isProfessional', true);
      }
    },
    className: "flex-none text-center w-32 cursor-pointer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative transition-colors truncate px-3\n              " + ((clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isProfessional) === true ? 'text-white' : 'text-secondary') + "\n            ",
    style: {
      zIndex: 2
    }
  }, t('Professional'))));
};

var Guarantees = function Guarantees(_ref) {
  var label = _ref.label,
    warranty = _ref.warranty,
    availability = _ref.availability,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var getLogoByLabel = function getLogoByLabel(label) {
    if (label === 'myway') {
      return /*#__PURE__*/React.createElement("img", {
        src: IMAGES['myway-dark-text-logo-nl'],
        className: "object-contain",
        style: {
          maxWidth: 120,
          maxHeight: 25
        },
        alt: "My Way logo"
      });
    }
    if (label === 'aap') {
      return /*#__PURE__*/React.createElement("img", {
        src: IMAGES["aap-red-logo-" + context.culture.toLowerCase()],
        className: "object-contain",
        style: {
          maxWidth: 120,
          maxHeight: 25
        },
        alt: "Audi approved plus"
      });
    }
  };
  var legalWarranty = 1;
  var commercialWarranty = warranty - 1;
  return /*#__PURE__*/React.createElement(React.Fragment, null, warranty && /*#__PURE__*/React.createElement("div", {
    className: "text-13 font-regular mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start"
  }, /*#__PURE__*/React.createElement("p", {
    className: "flex-none"
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-check mr-2"
  }), warranty, " ", warranty === 1 ? t('year legal warranty') : t('years warranty')), label && /*#__PURE__*/React.createElement("div", {
    className: "ml-5"
  }, getLogoByLabel(label))), warranty > 1 && /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-1 mt-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-gray-darker"
  }, "(", legalWarranty, " ", t('year legal')), commercialWarranty > 0 && /*#__PURE__*/React.createElement("div", {
    className: "text-gray-darker"
  }, t('and'), " ", commercialWarranty, " ", commercialWarranty === 1 ? t('year commercial') : t('years commercial'), ")"))), availability && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("i", {
    className: "far fa-check mr-2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "font-bold"
  }, t('Available from')), ' ', formatDate(availability))));
};

var BtnBasic = function BtnBasic(_ref) {
  var onClick = _ref.onClick,
    className = _ref.className,
    text = _ref.text,
    label = _ref.label,
    type = _ref.type,
    disabled = _ref.disabled;
  var getButtonClassesByLabel = function getButtonClassesByLabel(label) {
    if (label === 'myway') return 'rounded bg-gradient-to-r from-myway-light to-myway-dark text-white font-semibold';
    if (label === 'aap') return 'bg-aap text-white font-semibold';
    return 'rounded-full bg-primary text-white font-semibold';
  };
  return /*#__PURE__*/React.createElement("button", {
    type: type,
    disabled: disabled,
    className: getButtonClassesByLabel(label) + " " + className + " py-3 px-4",
    onClick: onClick
  }, text);
};
BtnBasic.defaultProps = {
  onClick: null,
  className: '',
  text: 'Button',
  label: '',
  type: 'button',
  disabled: false,
  loading: false
};

var ActionButtons = function ActionButtons(_ref) {
  var label = _ref.label,
    onAppointment = _ref.onAppointment,
    onTestDrive = _ref.onTestDrive,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAnalytics = useAnalytics(context),
    buttonClickEventAnalytics = _useAnalytics.buttonClickEventAnalytics;
  var analyticsButtonEventTrigger = function analyticsButtonEventTrigger(_buttonData) {
    var buttonData = _extends({
      analyticsButtonCategory: 'interaction',
      analyticsButtonType: 'button'
    }, _buttonData ? _buttonData : {});
    buttonClickEventAnalytics(buttonData);
  };
  var handleClickAppointment = function handleClickAppointment(e) {
    analyticsButtonEventTrigger({
      analyticsButtonName: 'to-dealersite-contact-dealer',
      analyticsButtonText: t('Make an appointment')
    });
    onAppointment(e);
  };
  var handleClickTestDrive = function handleClickTestDrive(e) {
    analyticsButtonEventTrigger({
      analyticsButtonName: 'to-dealersite-test-drive',
      analyticsButtonText: t('Plan a test drive')
    });
    onTestDrive(e);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start justify-between flex-wrap lg:flex-row"
  }, /*#__PURE__*/React.createElement(BtnBasic, {
    onClick: handleClickAppointment,
    className: 'mb-2 lg:mb-5 mr-4',
    text: t('Make an appointment'),
    label: label
  }), /*#__PURE__*/React.createElement(BtnBasic, {
    onClick: handleClickTestDrive,
    className: 'mb-2 lg:mb-5',
    text: t('Plan a test drive'),
    label: label
  }));
};

var SuccessIndicator = function SuccessIndicator(_ref) {
  var success = _ref.success,
    icon = _ref.icon;
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-green-200 flex items-center rounded"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-16 bg-green-300 flex items-center justify-center rounded-l",
    style: {
      minWidth: '4rem'
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: icon + " text-2xl text-green-900"
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-auto text-black opacity-75 items-center px-4 py-4 flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leading-tight list-none"
  }, success))));
};
SuccessIndicator.defaultProps = {
  success: 'Success!',
  icon: 'fad fa-check'
};

var TextAreaField = function TextAreaField(_ref) {
  var containerClass = _ref.containerClass,
    label = _ref.label,
    placeholder = _ref.placeholder,
    value = _ref.value,
    _onChange = _ref.onChange,
    errorText = _ref.errorText,
    required = _ref.required,
    heightClass = _ref.heightClass,
    inputClass = _ref.inputClass;
  var hasError = errorText !== undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: containerClass
  }, label && /*#__PURE__*/React.createElement("label", {
    className: "block tracking-wide " + (hasError ? 'text-red-400' : 'text-gray-700') + " mb-2"
  }, label, " ", required ? '(*)' : ''), /*#__PURE__*/React.createElement("textarea", {
    className: "appearance-none block w-full " + (hasError ? 'bg-red-100 border-red-400' : 'bg-white border-gray-400') + " text-gray-700 border rounded py-3 px-4 mb-1 " + heightClass + " focus:outline-none focus:border-primary " + inputClass,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    value: value,
    placeholder: placeholder
  }), hasError && /*#__PURE__*/React.createElement("div", {
    className: "text-red-400 text-xs"
  }, errorText));
};
TextAreaField.defaultProps = {
  containerClass: 'text-xs font-bold',
  required: false,
  heightClass: 'h-48',
  inputClass: ''
};

var InputField = function InputField(_ref) {
  var containerClass = _ref.containerClass,
    label = _ref.label,
    placeholder = _ref.placeholder,
    value = _ref.value,
    _onChange = _ref.onChange,
    errorText = _ref.errorText,
    required = _ref.required,
    type = _ref.type,
    withIcon = _ref.withIcon,
    icon = _ref.icon,
    errorClass = _ref.errorClass,
    inputClass = _ref.inputClass,
    onlyNumbers = _ref.onlyNumbers,
    lightForm = _ref.lightForm,
    inputRef = _ref.inputRef,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function (e) {
      return null;
    } : _ref$onClick;
  var hasError = errorText !== undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: containerClass
  }, label && /*#__PURE__*/React.createElement("label", {
    className: "block tracking-wide " + (hasError ? 'text-red-400' : lightForm ? 'text-white' : 'text-gray-700') + " mb-2"
  }, label, " ", required ? '(*)' : ''), /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, withIcon && /*#__PURE__*/React.createElement("div", {
    className: "flex -mr-px"
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex items-center leading-normal rounded rounded-r-none " + (lightForm ? 'text-white' : 'text-gray-700  border') + " border-r-0 " + (hasError ? 'bg-red-100 border-red-400' : lightForm ? 'bg-transparent border-b border-white' : 'bg-gray-100 border-gray-400') + " px-3 whitespace-nowrap text-sm"
  }, /*#__PURE__*/React.createElement("i", {
    className: "" + icon
  }))), /*#__PURE__*/React.createElement("input", {
    ref: inputRef,
    className: "appearance-none block w-full " + (lightForm ? 'text-white focus:border-gray-400 rounded-none px-0' : 'text-gray-700 border focus:border-primary px-4') + " " + (hasError ? 'bg-red-100 border-red-400' : lightForm ? 'bg-transparent border-b border-white' : 'bg-white border-gray-400') + "  " + (withIcon && 'rounded-l-none') + " py-3 focus:outline-none " + inputClass,
    type: type,
    placeholder: placeholder,
    value: value,
    onChange: function onChange(e) {
      if (onlyNumbers) {
        var re = /^[0-9\b]+$/;
        if (re.test(e.target.value)) {
          _onChange(e.target.value, e);
        }
      } else {
        _onChange(e.target.value, e);
      }
    },
    onClick: onClick
  })), hasError && errorText !== '' && /*#__PURE__*/React.createElement("div", {
    className: "text-red-400 text-xs mt-1 " + errorClass
  }, errorText));
};
InputField.defaultProps = {
  containerClass: 'text-sm font-bold',
  type: 'text',
  required: false,
  withIcon: false,
  icon: '',
  errorClass: '',
  inputClass: 'rounded',
  onlyNumbers: false,
  lightForm: false
};

var RadioInput = function RadioInput(_ref) {
  var orientation = _ref.orientation,
    options = _ref.options,
    value = _ref.value,
    label = _ref.label,
    required = _ref.required,
    onChange = _ref.onChange,
    errorText = _ref.errorText;
  var _useState = useState(null),
    val = _useState[0],
    setVal = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    setVal(value);
  }, [value]);
  var hasError = errorText && errorText !== '';
  var handleChange = function handleChange(val) {
    setVal(val);
    onChange(val);
  };
  if (!options || options.length < 1) {
    return /*#__PURE__*/React.createElement("div", {
      className: "bg-yellow-50 border-l-4 border-yellow-400 p-4"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-sm text-yellow-700"
    }, t('Please provide some options.')));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full"
  }, label && /*#__PURE__*/React.createElement("label", {
    className: "tracking-wide " + (hasError ? 'text-red-400' : 'text-gray-700') + " mb-2"
  }, t('Title'), " ", required && /*#__PURE__*/React.createElement("span", null, "(*)")), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col " + (orientation === 'horizontal' ? 'md:flex-row' : 'md:flex-col') + " " + (hasError ? 'text-red-500' : 'text-gray-700')
  }, map(options, function (option, i) {
    var isSelected = val === option.value;
    return /*#__PURE__*/React.createElement("div", {
      key: option + "-" + i,
      className: "flex items-center cursor-pointer mr-5",
      onClick: function onClick() {
        return handleChange(option.value);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-6 h-6 rounded-full p-1 mr-3 border " + (hasError ? 'border-red-500' : 'border-gray-500')
    }, isSelected && /*#__PURE__*/React.createElement("div", {
      className: "bg-primary h-full w-full rounded-full"
    })), option.label);
  })), hasError && /*#__PURE__*/React.createElement("div", {
    className: "text-red-400 text-xs mt-1"
  }, errorText));
};
RadioInput.defaultProps = {
  orientation: 'horizontal',
  options: [],
  label: 'Choose an option',
  required: false
};

var Dealership = function Dealership(_ref) {
  var name = _ref.name,
    address = _ref.address,
    postal = _ref.postal,
    city = _ref.city,
    tel = _ref.tel,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      color: '#8b8b8b'
    }
  }, name && /*#__PURE__*/React.createElement("div", {
    className: "text-secondary text-20 mb-3"
  }, /*#__PURE__*/React.createElement("p", null, t('This car is availaible at')), /*#__PURE__*/React.createElement("p", {
    className: "uppercase"
  }, name)), /*#__PURE__*/React.createElement("div", null, address && /*#__PURE__*/React.createElement("div", {
    className: "font-bold mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-map-marker-alt mr-3",
    style: {
      width: 16
    }
  }), /*#__PURE__*/React.createElement("p", null, address)), /*#__PURE__*/React.createElement("p", {
    style: {
      marginLeft: 28
    }
  }, postal && /*#__PURE__*/React.createElement("span", null, postal, " "), city && /*#__PURE__*/React.createElement("span", null, city))), tel && /*#__PURE__*/React.createElement(ExternalLink, {
    url: 'tel:' + tel,
    context: context
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center font-bold"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-phone mr-3",
    style: {
      width: 16
    }
  }), /*#__PURE__*/React.createElement("p", null, tel)))));
};

var Disclosure = function Disclosure(_ref) {
  var placeholder = _ref.placeholder,
    dropdownPosition = _ref.dropdownPosition,
    renderButton = _ref.renderButton,
    renderDropdown = _ref.renderDropdown,
    onToggleDropDown = _ref.onToggleDropDown,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? 0 : _ref$gap,
    isLocked = _ref.isLocked;
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var wrapperRef = useOuterClick(function (ev) {
    setIsOpen(false);
  });
  useEffect(function () {
    if (onToggleDropDown && typeof onToggleDropDown === 'function') {
      onToggleDropDown(isOpen);
    }
  }, [isOpen]);
  var getDropdownPositionStyle = function getDropdownPositionStyle() {
    var style = {};
    if (dropdownPosition.includes('bottom')) style.bottom = "calc(100% + " + gap + "px)";else style.top = "calc(100% + " + gap + "px)";
    if (dropdownPosition.includes('left')) style.left = 0;else style.right = 0;
    return style;
  };
  var close = function close() {
    setIsOpen(false);
  };
  var button = function button() {
    if (renderButton) {
      return renderButton(isOpen, function () {
        return setIsOpen(!isOpen);
      }, function () {
        return setIsOpen(true);
      }, function () {
        return setIsOpen(false);
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "relative flex items-center justify-between rounded-4 text-gray-darkest hover:text-white bg-gray-lightest2 border border-gray-lightest2 hover:bg-green-dark2 hover:border-green-dark2 focus:border-green-dark2 px-4 h-10"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-12 whitespace-nowrap"
    }, placeholder), /*#__PURE__*/React.createElement("i", {
      className: "far fa-angle-down ml-2.5 text-14 pt-0.5 transform transition duration-150 ease-in-out " + (isOpen ? 'rotate-180' : '')
    }));
  };
  var dropdown = function dropdown() {
    if (renderDropdown) {
      return renderDropdown(close, isOpen);
    }
    return /*#__PURE__*/React.createElement("div", null, t('No content to show.'));
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: wrapperRef,
    className: "relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "" + (isLocked ? 'pointer-events-none cursor-default' : ''),
    onClick: function onClick() {
      return isLocked ? undefined : setIsOpen(!isOpen);
    }
  }, button()), /*#__PURE__*/React.createElement(Fade, {
    when: isOpen && !isLocked,
    collapse: !isOpen || isLocked,
    duration: 500
  }, /*#__PURE__*/React.createElement("div", {
    className: "select-field-dropdown absolute w-max " + (isOpen && !isLocked ? 'opacity-100 z-50' : 'opacity-0 -z-1'),
    style: getDropdownPositionStyle()
  }, dropdown())));
};
Disclosure.defaultProps = {
  placeholder: 'Select',
  dropdownPosition: 'right',
  dropdownVerticalPosition: 'bottom',
  renderDropdown: undefined,
  renderButton: undefined,
  onToggleDropDown: undefined,
  loading: false
};

var defaultCountry = 'BE';
var COUNTRIES_QUERY = "query Countries {\n  countries {\n    id\n    alpha2Code\n    alpha3Code\n    name\n    flag\n    flagUtf\n    callingCode\n  }\n}";
var PhoneInputField = function PhoneInputField(_ref) {
  var _data$countries;
  var containerClass = _ref.containerClass,
    label = _ref.label,
    value = _ref.value,
    _onChange = _ref.onChange,
    errorText = _ref.errorText,
    required = _ref.required,
    errorClass = _ref.errorClass,
    inputClass = _ref.inputClass,
    context = _ref.context;
  var _useQuery = useQuery(context),
    data = _useQuery.data,
    fetchData = _useQuery.fetchData,
    loading = _useQuery.loading,
    fetchError = _useQuery.error;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(defaultCountry),
    selectedCountry = _useState[0],
    setSelectedCountry = _useState[1];
  var selectedCountryDb = data === null || data === void 0 ? void 0 : (_data$countries = data.countries) === null || _data$countries === void 0 ? void 0 : _data$countries.find(function (c) {
    return c.alpha2Code === selectedCountry;
  });
  var getMask = function getMask(selectedCountry) {
    var country = countriesListWithMask.find(function (c) {
      return c.locale === selectedCountry;
    });
    if (country) {
      return country.phoneMask;
    }
    return null;
  };
  var getCode = function getCode(selectedCountry) {
    var country = countriesListWithMask.find(function (c) {
      return c.locale === selectedCountry;
    });
    if (country) {
      return country.code;
    }
    return null;
  };
  useEffect(function () {
    fetchData(COUNTRIES_QUERY, undefined);
  }, []);
  var renderCountryButton = function renderCountryButton() {
    return /*#__PURE__*/React.createElement("div", {
      className: "h-4 w-6"
    }, loading && /*#__PURE__*/React.createElement("svg", {
      className: "animate-spin h-4 w-4 text-primary",
      viewBox: "0 0 24 24"
    }, /*#__PURE__*/React.createElement("circle", {
      "class": "opacity-25",
      cx: "12",
      cy: "12",
      r: "10",
      stroke: "currentColor",
      "stroke-width": "4",
      fillOpacity: 0
    }), /*#__PURE__*/React.createElement("path", {
      "class": "opacity-75",
      fill: "currentColor",
      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    })), !loading && /*#__PURE__*/React.createElement("img", {
      src: selectedCountryDb === null || selectedCountryDb === void 0 ? void 0 : selectedCountryDb.flag,
      className: "h-4 w-6",
      alt: selectedCountryDb === null || selectedCountryDb === void 0 ? void 0 : selectedCountryDb.name
    }));
  };
  var renderCountryDropdown = function renderCountryDropdown(close) {
    var _data$countries2;
    var hasCountries = !loading && !fetchError && (data === null || data === void 0 ? void 0 : (_data$countries2 = data.countries) === null || _data$countries2 === void 0 ? void 0 : _data$countries2.length) > 0;
    var renderCountry = function renderCountry(country, index) {
      var handleClickCountry = function handleClickCountry(e) {
        setSelectedCountry(country.alpha2Code);
        close();
      };
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "flex text-15 text-gray-darkest font-regular cursor-pointer px-2 py-1 first:pt-2 last:pb-2",
        onClick: handleClickCountry
      }, /*#__PURE__*/React.createElement("img", {
        src: country.flag,
        alt: country.name,
        className: "w-6 h-4"
      }), /*#__PURE__*/React.createElement("span", {
        className: "ml-3 mr-0.5"
      }, t(country.name)), /*#__PURE__*/React.createElement("span", null, "(", getCode(country.alpha2Code), ")"));
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "bg-white border border-gray-200 rounded"
    }, !hasCountries && /*#__PURE__*/React.createElement("div", {
      className: "text-14 px-2 min-w-25"
    }, t('No countries to show.')), hasCountries && /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col"
    }, data.countries.map(renderCountry)));
  };
  var hasError = errorText !== undefined;
  var mask = getMask(selectedCountry);
  return /*#__PURE__*/React.createElement("div", {
    className: "" + containerClass
  }, label && /*#__PURE__*/React.createElement("label", {
    className: "block tracking-wide " + (hasError ? 'text-red-400' : 'text-gray-700') + " mb-2"
  }, label, " ", required ? '(*)' : ''), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row items-center gap-4 py-3 text-gray-700 border bg-white border-gray-400 focus-within:border-primary px-4 " + inputClass
  }, /*#__PURE__*/React.createElement(Disclosure, {
    context: context,
    dropdownPosition: "left",
    renderButton: renderCountryButton,
    renderDropdown: renderCountryDropdown,
    gap: 10,
    isLocked: loading
  }), /*#__PURE__*/React.createElement(ReactInputMask, {
    mask: mask,
    maskPlaceholder: '_',
    placeholder: "+32 486 12 34 56",
    type: "tel",
    className: "w-full h-full bg-transparent focus:outline-none",
    value: value,
    onChange: function onChange(e) {
      _onChange(e.target.value, e);
    }
  })), hasError && errorText !== '' && /*#__PURE__*/React.createElement("div", {
    className: "text-red-400 text-xs mt-1 " + errorClass
  }, errorText));
};

var _initialFormData;
var FormFields = {
  title: 'title',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  message: 'message',
  privacy: 'privacy'
};
var initialFormData = (_initialFormData = {}, _initialFormData[FormFields.title] = '', _initialFormData[FormFields.firstName] = '', _initialFormData[FormFields.lastName] = '', _initialFormData[FormFields.email] = '', _initialFormData[FormFields.phone] = '', _initialFormData[FormFields.message] = '', _initialFormData[FormFields.privacy] = false, _initialFormData);
var validator = function validator(data, t) {
  var errors = {};
  if (!hasValue(data.title)) {
    errors[FormFields.title] = t('Gender is required.');
  }
  if (!hasValue(data.firstName)) {
    errors[FormFields.firstName] = t('First name is required.');
  }
  if (!hasValue(data.lastName)) {
    errors[FormFields.lastName] = t('Last name is required.');
  }
  if (!hasValue(data.email)) {
    errors[FormFields.email] = t('Email address is required.');
  } else if (!isValidEmail(data.email)) {
    errors[FormFields.email] = t('Email address is not valid.');
  }
  if (!hasValue(data.phone)) {
    errors[FormFields.phone] = t('Phone is required.');
  }
  if (data.privacy === false) {
    errors[FormFields.privacy] = '';
  }
  return errors;
};
var submitDataMapper = function submitDataMapper(formData, additionalData, context) {
  return {
    title: formData.title,
    first_name: formData.firstName,
    last_name: formData.lastName,
    email: formData.email,
    phone: formData.phone,
    message: formData.message,
    privacy: formData.privacy,
    vehicle: {
      id: additionalData === null || additionalData === void 0 ? void 0 : additionalData.vehicle.id,
      reference: additionalData === null || additionalData === void 0 ? void 0 : additionalData.vehicle.reference,
      identification: additionalData === null || additionalData === void 0 ? void 0 : additionalData.vehicle.identification,
      vehicleUrl: window.location.href
    },
    financial: additionalData !== null && additionalData !== void 0 && additionalData.financialData ? {
      price: additionalData === null || additionalData === void 0 ? void 0 : additionalData.financialData.price,
      deposit: additionalData === null || additionalData === void 0 ? void 0 : additionalData.financialData.deposit,
      months: additionalData === null || additionalData === void 0 ? void 0 : additionalData.financialData.months,
      financePrice: additionalData === null || additionalData === void 0 ? void 0 : additionalData.financialData.financePrice
    } : {}
  };
};
var AppointmentForm = function AppointmentForm(_ref) {
  var _additionalData$vehic;
  var additionalData = _ref.additionalData,
    formData = _ref.formData,
    label = _ref.label,
    submit = _ref.submit,
    submitting = _ref.submitting,
    submitSuccess = _ref.submitSuccess,
    submitError = _ref.submitError,
    validationErrors = _ref.validationErrors,
    setFormValue = _ref.setFormValue,
    onClose = _ref.onClose,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAnalytics = useAnalytics(context),
    toolCompleteEventAnalytics = _useAnalytics.toolCompleteEventAnalytics;
  var dealer = additionalData === null || additionalData === void 0 ? void 0 : (_additionalData$vehic = additionalData.vehicle) === null || _additionalData$vehic === void 0 ? void 0 : _additionalData$vehic.dealer;
  useEffect(function () {
    if (hasDocument()) {
      var el = document.getElementById('appointment-form');
      scrollToTargetV2(el, getStickiesOffset(), 'instant');
    }
    setMessageValue();
  }, []);
  useEffect(function () {
    if (submitSuccess || submitError) {
      if (hasDocument()) {
        var el = document.getElementById('appointment-form');
        scrollToTargetV2(el, getStickiesOffset());
      }
      if (submitSuccess) {
        toolCompleteEventAnalytics({
          toolType: additionalData === null || additionalData === void 0 ? void 0 : additionalData.toolType,
          toolName: additionalData === null || additionalData === void 0 ? void 0 : additionalData.toolName,
          toolStep: 'thank-you',
          toolStepOption: additionalData === null || additionalData === void 0 ? void 0 : additionalData.toolStepOption,
          toolStepNumber: '2',
          requestType: additionalData === null || additionalData === void 0 ? void 0 : additionalData.requestType,
          vehicle: additionalData.vehicle
        });
      }
    }
  }, [submitSuccess, submitError]);
  useEffect(function () {
    if (!isEmpty(validationErrors)) {
      if (hasDocument()) {
        var el = document.getElementById('appointment-form-content');
        scrollToTargetV2(el, getStickiesOffset());
      }
    }
  }, [validationErrors]);
  var setMessageValue = function setMessageValue() {
    var initMessage = initialMessage(context.culture);
    setFormValue(FormFields.message, initMessage);
  };
  return /*#__PURE__*/React.createElement("form", {
    id: "appointment-form",
    action: "",
    onSubmit: submit,
    className: "relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center mb-2"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-secondary font-bold text-2xl"
  }, t('Make an appointment')), /*#__PURE__*/React.createElement("i", {
    className: "fal fa-times text-xl cursor-pointer",
    onClick: onClose
  })), /*#__PURE__*/React.createElement("p", {
    className: "mb-10"
  }, t('Send us your details and we will contact you.')), dealer && /*#__PURE__*/React.createElement("div", {
    className: "w-full mb-8 border-b border-gray-200 pb-4"
  }, /*#__PURE__*/React.createElement(Dealership, {
    context: context,
    name: dealer === null || dealer === void 0 ? void 0 : dealer.name,
    address: dealer === null || dealer === void 0 ? void 0 : dealer.address,
    postal: dealer === null || dealer === void 0 ? void 0 : dealer.postalCode,
    city: dealer === null || dealer === void 0 ? void 0 : dealer.city,
    tel: dealer === null || dealer === void 0 ? void 0 : dealer.tel
  })), validationErrors && validationErrors['result'] && /*#__PURE__*/React.createElement("div", {
    className: "mb-4",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: validationErrors['result']
  })), submitError && submitError !== '' && /*#__PURE__*/React.createElement("div", {
    className: "mb-4",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: submitError
  })), submitSuccess && /*#__PURE__*/React.createElement("div", {
    className: "px-0 md:px-5 lg:px-12 left-0 right-0 absolute",
    style: {
      top: 40
    }
  }, /*#__PURE__*/React.createElement(SuccessIndicator, {
    success: t('Your request has been sent!')
  })), /*#__PURE__*/React.createElement("div", {
    id: "appointment-form-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(RadioInput, {
    options: genderOptions(t),
    label: t('Title'),
    errorText: validationErrors[FormFields.title],
    value: formData.title,
    onChange: function onChange(value) {
      return setFormValue(FormFields.title, value);
    },
    required: true,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 md:mb-0 mr-1",
    inputClass: "rounded",
    label: t('First name'),
    placeholder: "John",
    value: formData.firstName,
    onChange: function onChange(value) {
      return setFormValue(FormFields.firstName, value);
    },
    errorText: validationErrors[FormFields.firstName],
    required: true
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 md:mb-0 ml-1",
    inputClass: "rounded",
    label: t('Last name'),
    placeholder: "Doe",
    value: formData.lastName,
    onChange: function onChange(value) {
      return setFormValue(FormFields.lastName, value);
    },
    errorText: validationErrors[FormFields.lastName],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: " mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full mb-2 md:mb-0",
    inputClass: "rounded",
    label: t('Email address'),
    placeholder: "john.doe@gmail.com",
    value: formData.email,
    onChange: function onChange(value) {
      return setFormValue(FormFields.email, value);
    },
    errorText: validationErrors[FormFields.email],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(PhoneInputField, {
    containerClass: "w-full mb-2 md:mb-0",
    inputClass: "rounded",
    label: t('Phone'),
    value: formData.phone,
    onChange: function onChange(value) {
      return setFormValue(FormFields.phone, value);
    },
    errorText: validationErrors[FormFields.phone],
    required: true,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(TextAreaField, {
    containerClass: "md:w-full md:mb-0",
    inputClass: "rounded",
    label: t('Message'),
    placeholder: t('I want to make an appointment to see this vehicle'),
    value: formData.message,
    heightClass: "h-30",
    onChange: function onChange(value) {
      return setFormValue(FormFields.message, value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex mt-3 mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center border-2 p-1 mr-2 w-6 h-6 cursor-pointer " + (validationErrors['privacy'] !== undefined ? 'border-red-400' : 'border-gray-200'),
    onClick: function onClick() {
      return setFormValue(FormFields.privacy, !formData.privacy);
    }
  }, formData.privacy && /*#__PURE__*/React.createElement("div", {
    className: "h-full w-full bg-primary"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex " + (validationErrors['privacy'] !== undefined ? 'text-red-400' : 'text-secondary')
  }, /*#__PURE__*/React.createElement("div", {
    className: "mr-2"
  }, t('I agree to the')), /*#__PURE__*/React.createElement(ExternalLink, {
    url: privacyUrl(context),
    className: "underline",
    context: context
  }, t('privacy terms'), ".")))), /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement(BtnBasic, {
    label: label,
    type: "submit",
    disabled: submitting,
    text: submitting ? t('Sending...') : t('Send'),
    className: ''
  }))));
};
var AppointmentForm$1 = baseDealerContactForm(DealerContactTypes.vehicleInformation, initialFormData, validator, submitDataMapper, AppointmentForm);

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'minder dan een seconde',
    other: 'minder dan {{count}} seconden'
  },
  xSeconds: {
    one: '1 seconde',
    other: '{{count}} seconden'
  },
  halfAMinute: 'een halve minuut',
  lessThanXMinutes: {
    one: 'minder dan een minuut',
    other: 'minder dan {{count}} minuten'
  },
  xMinutes: {
    one: 'een minuut',
    other: '{{count}} minuten'
  },
  aboutXHours: {
    one: 'ongeveer 1 uur',
    other: 'ongeveer {{count}} uur'
  },
  xHours: {
    one: '1 uur',
    other: '{{count}} uur'
  },
  xDays: {
    one: '1 dag',
    other: '{{count}} dagen'
  },
  aboutXWeeks: {
    one: 'ongeveer 1 week',
    other: 'ongeveer {{count}} weken'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weken'
  },
  aboutXMonths: {
    one: 'ongeveer 1 maand',
    other: 'ongeveer {{count}} maanden'
  },
  xMonths: {
    one: '1 maand',
    other: '{{count}} maanden'
  },
  aboutXYears: {
    one: 'ongeveer 1 jaar',
    other: 'ongeveer {{count}} jaar'
  },
  xYears: {
    one: '1 jaar',
    other: '{{count}} jaar'
  },
  overXYears: {
    one: 'meer dan 1 jaar',
    other: 'meer dan {{count}} jaar'
  },
  almostXYears: {
    one: 'bijna 1 jaar',
    other: 'bijna {{count}} jaar'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'over ' + result;
    } else {
      return result + ' geleden';
    }
  }
  return result;
};

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'dd.MM.y'
};
var timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'vorige' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['v.C.', 'n.C.'],
  abbreviated: ['v.Chr.', 'n.Chr.'],
  wide: ['voor Christus', 'na Christus']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['K1', 'K2', 'K3', 'K4'],
  wide: ['1e kwartaal', '2e kwartaal', '3e kwartaal', '4e kwartaal']
};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['jan.', 'feb.', 'mrt.', 'apr.', 'mei', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
  wide: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december']
};
var dayValues = {
  narrow: ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'],
  short: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
  abbreviated: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
  wide: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag']
};
var dayPeriodValues = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middag',
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middag',
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middag',
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts"
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + 'e';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide'
  })
};

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)e?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
};
var parseEraPatterns = {
  any: [/^v/, /^n/]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
};
var matchDayPatterns = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var parseDayPatterns = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
};
var matchDayPeriodPatterns = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
 */
var locale = {
  code: 'nl-BE',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4
  }
};

var formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: 'moins d’une seconde',
    other: 'moins de {{count}} secondes'
  },
  xSeconds: {
    one: '1 seconde',
    other: '{{count}} secondes'
  },
  halfAMinute: '30 secondes',
  lessThanXMinutes: {
    one: 'moins d’une minute',
    other: 'moins de {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'environ 1 heure',
    other: 'environ {{count}} heures'
  },
  xHours: {
    one: '1 heure',
    other: '{{count}} heures'
  },
  xDays: {
    one: '1 jour',
    other: '{{count}} jours'
  },
  aboutXWeeks: {
    one: 'environ 1 semaine',
    other: 'environ {{count}} semaines'
  },
  xWeeks: {
    one: '1 semaine',
    other: '{{count}} semaines'
  },
  aboutXMonths: {
    one: 'environ 1 mois',
    other: 'environ {{count}} mois'
  },
  xMonths: {
    one: '1 mois',
    other: '{{count}} mois'
  },
  aboutXYears: {
    one: 'environ 1 an',
    other: 'environ {{count}} ans'
  },
  xYears: {
    one: '1 an',
    other: '{{count}} ans'
  },
  overXYears: {
    one: 'plus d’un an',
    other: 'plus de {{count}} ans'
  },
  almostXYears: {
    one: 'presqu’un an',
    other: 'presque {{count}} ans'
  }
};
var formatDistance$1 = function formatDistance(token, count, options) {
  var result;
  var form = formatDistanceLocale$1[token];
  if (typeof form === 'string') {
    result = form;
  } else if (count === 1) {
    result = form.one;
  } else {
    result = form.other.replace('{{count}}', String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'dans ' + result;
    } else {
      return 'il y a ' + result;
    }
  }
  return result;
};

var dateFormats$1 = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'dd/MM/y'
};
var timeFormats$1 = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$1 = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$1 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale$1 = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: 'P'
};
var formatRelative$1 = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale$1[token];
};

var eraValues$1 = {
  narrow: ['av. J.-C', 'ap. J.-C'],
  abbreviated: ['av. J.-C', 'ap. J.-C'],
  wide: ['avant Jésus-Christ', 'après Jésus-Christ']
};
var quarterValues$1 = {
  narrow: ['T1', 'T2', 'T3', 'T4'],
  abbreviated: ['1er trim.', '2ème trim.', '3ème trim.', '4ème trim.'],
  wide: ['1er trimestre', '2ème trimestre', '3ème trimestre', '4ème trimestre']
};
var monthValues$1 = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
  wide: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
};
var dayValues$1 = {
  narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
  short: ['di', 'lu', 'ma', 'me', 'je', 've', 'sa'],
  abbreviated: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
  wide: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
};
var dayPeriodValues$1 = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'minuit',
    noon: 'midi',
    morning: 'mat.',
    afternoon: 'ap.m.',
    evening: 'soir',
    night: 'mat.'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'minuit',
    noon: 'midi',
    morning: 'matin',
    afternoon: 'après-midi',
    evening: 'soir',
    night: 'matin'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'minuit',
    noon: 'midi',
    morning: 'du matin',
    afternoon: 'de l’après-midi',
    evening: 'du soir',
    night: 'du matin'
  }
};
var ordinalNumber$1 = function ordinalNumber(dirtyNumber, options) {
  var number = Number(dirtyNumber);
  var unit = options === null || options === void 0 ? void 0 : options.unit;
  if (number === 0) return '0';
  var feminineUnits = ['year', 'week', 'hour', 'minute', 'second'];
  var suffix;
  if (number === 1) {
    suffix = unit && feminineUnits.includes(unit) ? 'ère' : 'er';
  } else {
    suffix = 'ème';
  }
  return number + suffix;
};
var localize$1 = {
  ordinalNumber: ordinalNumber$1,
  era: buildLocalizeFn({
    values: eraValues$1,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: 'wide'
  })
};

var matchOrdinalNumberPattern$1 = /^(\d+)(ième|ère|ème|er|e)?/i;
var parseOrdinalNumberPattern$1 = /\d+/i;
var matchEraPatterns$1 = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var parseEraPatterns$1 = {
  any: [/^av/i, /^ap/i]
};
var matchQuarterPatterns$1 = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
};
var parseQuarterPatterns$1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$1 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var parseMonthPatterns$1 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$1 = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var parseDayPatterns$1 = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
};
var matchDayPeriodPatterns$1 = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var parseDayPeriodPatterns$1 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
};
var match$1 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: function valueCallback(value) {
      return parseInt(value);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */
var locale$1 = {
  code: 'fr',
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4
  }
};

registerLocale('nl-NL', locale);
registerLocale('fr-FR', locale$1);
var DatePickerField = function DatePickerField(_ref) {
  var label = _ref.label,
    _onChange = _ref.onChange,
    value = _ref.value,
    errorText = _ref.errorText,
    noPast = _ref.noPast,
    noFuture = _ref.noFuture,
    required = _ref.required,
    containerClass = _ref.containerClass,
    inputClass = _ref.inputClass,
    context = _ref.context;
  var _useState = useState(false),
    viewMonths = _useState[0],
    setViewMonths = _useState[1];
  var _useState2 = useState(false),
    viewYears = _useState2[0],
    setViewYears = _useState2[1];
  var getDate = function getDate(date) {
    return date === null || date === void 0 ? void 0 : date.getDate();
  };
  var getYear = function getYear(date) {
    return date === null || date === void 0 ? void 0 : date.getFullYear();
  };
  var getMonth = function getMonth(date) {
    return date === null || date === void 0 ? void 0 : date.getMonth();
  };
  var months = monthsForLocale(datePickerLocale(context.culture));
  var monthsShort = monthsForLocale(datePickerLocale(context.culture), 'short');
  var getYearOptions = function getYearOptions() {
    var years = range(getYear(new Date()) - 5, getYear(new Date()) + 5, 1);
    if (noPast && noFuture) years = [getYear(new Date())];else if (noPast) years = range(getYear(new Date()), getYear(new Date()) + 10, 1);else if (noFuture) years = range(getYear(new Date()) - 10, getYear(new Date()) + 1, 1);
    return years;
  };
  var years = getYearOptions();
  var renderCustomHeader = function renderCustomHeader(_ref2) {
    var date = _ref2.date,
      changeYear = _ref2.changeYear,
      changeMonth = _ref2.changeMonth,
      decreaseMonth = _ref2.decreaseMonth,
      increaseMonth = _ref2.increaseMonth,
      prevMonthButtonDisabled = _ref2.prevMonthButtonDisabled,
      nextMonthButtonDisabled = _ref2.nextMonthButtonDisabled,
      decreaseYear = _ref2.decreaseYear,
      increaseYear = _ref2.increaseYear,
      prevYearButtonDisabled = _ref2.prevYearButtonDisabled,
      nextYearButtonDisabled = _ref2.nextYearButtonDisabled;
    var currentMonthIndex = getMonth(date);
    var currentMonth = months[currentMonthIndex];
    var currentYear = getYear(date);
    var renderIconButton = function renderIconButton(icon, onClick, disabled) {
      return /*#__PURE__*/React.createElement("button", {
        onClick: onClick,
        type: "button",
        disabled: disabled,
        className: "w-10 h-10 flex items-center justify-center disabled:opacity-20"
      }, /*#__PURE__*/React.createElement("i", {
        className: icon + " text-24 w-6"
      }));
    };
    var renderMonthsView = function renderMonthsView() {
      return /*#__PURE__*/React.createElement("div", {
        className: "absolute inset-0  rounded bg-common-content-background-light flex flex-col"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex flex-row justify-between items-center font-primary h-16 px-14 border-b border-common-content-border"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex flex-row gap-2 items-center cursor-pointer",
        onClick: function onClick() {
          return setViewMonths(false);
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-14 leading-5 tracking-wide font-normal capitalize"
      }, monthsShort[getMonth(date)]), /*#__PURE__*/React.createElement("i", {
        className: "fa fa-caret-down text-14 w-4 h-4 flex items-center justify-center"
      })), /*#__PURE__*/React.createElement("div", {
        className: "flex flex-row gap-2 items-center opacity-20"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-14 leading-5 tracking-wide"
      }, getYear(date)))), /*#__PURE__*/React.createElement("div", {
        className: "overflow-y-scroll flex flex-col flex-1"
      }, months.map(function (month, index) {
        var disabled = prevMonthButtonDisabled && index < currentMonthIndex || nextMonthButtonDisabled && index > currentMonthIndex;
        var isSelected = month == currentMonth;
        var handleClickMonth = function handleClickMonth(e) {
          if (disabled) return;
          changeMonth(months.indexOf(month));
          setViewMonths(false);
        };
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: "flex flex-row gap-4 pl-4 pr-6 min-h-12 items-center cursor-pointer " + (isSelected ? 'bg-common-content-background-dark bg-opacity-10' : '') + " " + (disabled ? 'opacity-30' : ''),
          onClick: handleClickMonth
        }, isSelected && /*#__PURE__*/React.createElement("i", {
          className: "fal fa-check w-6 h-6 text-16 flex items-center justify-center"
        }), !isSelected && /*#__PURE__*/React.createElement("div", {
          className: "w-6 h-6"
        }), /*#__PURE__*/React.createElement("span", {
          className: "text-16 font-regular leading-normal tracking-wide capitalize"
        }, month));
      })));
    };
    var renderYearView = function renderYearView() {
      return /*#__PURE__*/React.createElement("div", {
        className: "absolute inset-0  rounded bg-common-content-background-light flex flex-col"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex flex-row justify-between items-center font-primary h-16 px-14 border-b border-common-content-border"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex flex-row gap-2 items-center opacity-20"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-14 leading-5 tracking-wide font-normal capitalize"
      }, monthsShort[getMonth(date)]), /*#__PURE__*/React.createElement("i", {
        className: "fa fa-caret-down text-14 w-4 h-4 flex items-center justify-center"
      })), /*#__PURE__*/React.createElement("div", {
        className: "flex flex-row gap-2 items-center  cursor-pointer",
        onClick: function onClick() {
          return setViewYears(false);
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-14 leading-5 tracking-wide"
      }, getYear(date)))), /*#__PURE__*/React.createElement("div", {
        className: "overflow-y-scroll flex flex-col flex-1"
      }, years.map(function (year, index) {
        var disabled = prevYearButtonDisabled && year < currentYear || nextYearButtonDisabled && year > currentYear;
        var isSelected = year == currentYear;
        var handleClickYear = function handleClickYear(e) {
          if (disabled) return;
          changeYear(year);
          setViewYears(false);
        };
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: "flex flex-row gap-4 pl-4 pr-6 min-h-12 items-center cursor-pointer " + (isSelected ? 'bg-common-content-background-dark bg-opacity-10' : '') + " " + (disabled ? 'opacity-30' : ''),
          onClick: handleClickYear
        }, isSelected && /*#__PURE__*/React.createElement("i", {
          className: "fal fa-check w-6 h-6 text-16 flex items-center justify-center"
        }), !isSelected && /*#__PURE__*/React.createElement("div", {
          className: "w-6 h-6"
        }), /*#__PURE__*/React.createElement("span", {
          className: "text-16 font-regular leading-normal tracking-wide capitalize"
        }, year));
      })));
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row justify-between font-primary items-center h-16"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row items-center h-12"
    }, renderIconButton('fal fa-angle-left', decreaseMonth, prevMonthButtonDisabled), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row gap-2 items-center cursor-pointer",
      onClick: function onClick() {
        return setViewMonths(true);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-14 leading-5 tracking-wide font-normal capitalize"
    }, monthsShort[getMonth(date)]), /*#__PURE__*/React.createElement("i", {
      className: "fa fa-caret-down text-14 w-4 h-4 flex items-center justify-center"
    })), renderIconButton('fal fa-angle-right', increaseMonth, nextMonthButtonDisabled)), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row items-center h-12"
    }, renderIconButton('fal fa-angle-left', decreaseYear, prevYearButtonDisabled), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row gap-2 items-center cursor-pointer",
      onClick: function onClick() {
        return setViewYears(true);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-14 leading-5 tracking-wide"
    }, getYear(date)), /*#__PURE__*/React.createElement("i", {
      className: "fa fa-caret-down text-14 w-4 h-4 flex items-center justify-center"
    })), renderIconButton('fal fa-angle-right', increaseYear, nextYearButtonDisabled)), viewMonths && renderMonthsView(), viewYears && renderYearView());
  };
  var renderDayContents = function renderDayContents(day, date) {
    return /*#__PURE__*/React.createElement("div", {
      className: "w-full h-full flex items-center justify-center"
    }, getDate(date));
  };
  var InputFieldDatePicker = forwardRef(function (_ref3, ref) {
    var value = _ref3.value,
      onClick = _ref3.onClick,
      onChange = _ref3.onChange;
    var handleChange = function handleChange(_, e) {
      onChange(e);
    };
    return /*#__PURE__*/React.createElement(InputField, {
      inputRef: ref,
      label: label,
      value: value,
      containerClass: containerClass,
      inputClass: inputClass,
      errorText: errorText,
      required: required,
      onChange: handleChange,
      onClick: onClick
    });
  });
  return /*#__PURE__*/React.createElement(DatePicker, {
    className: "z-2 relative w-full",
    onChange: function onChange(date) {
      return _onChange(date);
    },
    selected: value,
    placeholderText: "--/--/----",
    dateFormat: ['dd/MM/yyyy', 'ddMMyyyy'],
    minDate: noPast ? new Date() : '',
    maxDate: noFuture ? new Date() : '',
    locale: datePickerLocale(context.culture),
    renderCustomHeader: renderCustomHeader,
    dayClassName: function dayClassName(date) {
      return "font-primary text-16 w-7 h-7 leading-normal tracking-wide font-regular";
    },
    weekDayClassName: function weekDayClassName() {
      return "font-primary text-16 w-7 leading-normal tracking-wide font-regular";
    },
    renderDayContents: renderDayContents,
    calendarClassName: "bg-white border rounded border-common-content-border",
    useWeekdaysShort: false,
    formatWeekDay: function formatWeekDay(day) {
      return day.substring(0, 1);
    },
    showPopperArrow: false,
    customInput: /*#__PURE__*/React.createElement(InputFieldDatePicker, null),
    wrapperClassName: "w-full"
  });
};
DatePickerField.defaultProps = {
  noPast: false,
  noFuture: false,
  required: false
};

var _initialFormData$1;
var FormFields$1 = {
  title: 'title',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  date: 'date',
  message: 'message',
  privacy: 'privacy'
};
var initialFormData$1 = (_initialFormData$1 = {}, _initialFormData$1[FormFields$1.title] = '', _initialFormData$1[FormFields$1.firstName] = '', _initialFormData$1[FormFields$1.lastName] = '', _initialFormData$1[FormFields$1.email] = '', _initialFormData$1[FormFields$1.phone] = '', _initialFormData$1[FormFields$1.date] = null, _initialFormData$1[FormFields$1.message] = '', _initialFormData$1[FormFields$1.privacy] = false, _initialFormData$1);
var validator$1 = function validator(data, t) {
  var errors = {};
  if (!hasValue(data.title)) {
    errors[FormFields$1.title] = t('Gender is required.');
  }
  if (!hasValue(data.firstName)) {
    errors[FormFields$1.firstName] = t('First name is required.');
  }
  if (!hasValue(data.lastName)) {
    errors[FormFields$1.lastName] = t('Last name is required.');
  }
  if (!hasValue(data.email)) {
    errors[FormFields$1.email] = t('Email address is required.');
  } else if (!isValidEmail(data.email)) {
    errors[FormFields$1.email] = t('Email address is not valid.');
  }
  if (!hasValue(data.phone)) {
    errors[FormFields$1.phone] = t('Phone is required.');
  }
  if (data.privacy === false) {
    errors[FormFields$1.privacy] = '';
  }
  return errors;
};
var submitDataMapper$1 = function submitDataMapper(formData, additionalData, context) {
  return {
    title: formData.title,
    first_name: formData.firstName,
    last_name: formData.lastName,
    email: formData.email,
    phone: formData.phone,
    date: formData.date ? formData.date.toLocaleDateString() : null,
    message: formData.message,
    privacy: formData.privacy,
    vehicle: {
      id: additionalData === null || additionalData === void 0 ? void 0 : additionalData.vehicle.id,
      reference: additionalData === null || additionalData === void 0 ? void 0 : additionalData.vehicle.reference,
      identification: additionalData === null || additionalData === void 0 ? void 0 : additionalData.vehicle.identification,
      vehicleUrl: window.location.href
    },
    financial: {}
  };
};
var TestDriveForm = function TestDriveForm(_ref) {
  var _additionalData$vehic;
  var additionalData = _ref.additionalData,
    formData = _ref.formData,
    label = _ref.label,
    submit = _ref.submit,
    submitting = _ref.submitting,
    submitSuccess = _ref.submitSuccess,
    submitError = _ref.submitError,
    validationErrors = _ref.validationErrors,
    setFormValue = _ref.setFormValue,
    onClose = _ref.onClose,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var dealer = additionalData === null || additionalData === void 0 ? void 0 : (_additionalData$vehic = additionalData.vehicle) === null || _additionalData$vehic === void 0 ? void 0 : _additionalData$vehic.dealer;
  var _useAnalytics = useAnalytics(context),
    toolCompleteEventAnalytics = _useAnalytics.toolCompleteEventAnalytics;
  useEffect(function () {
    if (hasDocument()) {
      var el = document.getElementById('test-drive-form');
      scrollToTargetV2(el, getStickiesOffset(), 'instant');
    }
    setMessageValue();
  }, []);
  useEffect(function () {
    if (submitSuccess || submitError) {
      if (hasDocument()) {
        var el = document.getElementById('test-drive-form');
        scrollToTargetV2(el, getStickiesOffset());
      }
    }
    if (submitSuccess) {
      toolCompleteEventAnalytics({
        toolType: additionalData === null || additionalData === void 0 ? void 0 : additionalData.toolType,
        toolName: additionalData === null || additionalData === void 0 ? void 0 : additionalData.toolName,
        toolStep: 'thank-you',
        toolStepOption: additionalData === null || additionalData === void 0 ? void 0 : additionalData.toolStepOption,
        toolStepNumber: '2',
        requestType: additionalData === null || additionalData === void 0 ? void 0 : additionalData.requestType,
        vehicle: additionalData === null || additionalData === void 0 ? void 0 : additionalData.vehicle
      });
    }
  }, [submitSuccess, submitError]);
  useEffect(function () {
    if (!isEmpty(validationErrors)) {
      if (hasDocument()) {
        var el = document.getElementById('test-drive-form-content');
        scrollToTargetV2(el, getStickiesOffset());
      }
    }
  }, [validationErrors]);
  var setMessageValue = function setMessageValue() {
    var initMessage = initialMessage(context.culture);
    setFormValue(FormFields$1.message, initMessage);
  };
  return /*#__PURE__*/React.createElement("form", {
    id: "test-drive-form",
    action: "",
    onSubmit: submit,
    className: "relative pb-10 md:py-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center mb-2"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-secondary font-bold text-2xl"
  }, t('Test drive')), /*#__PURE__*/React.createElement("i", {
    className: "fal fa-times text-xl cursor-pointer",
    onClick: onClose
  })), /*#__PURE__*/React.createElement("p", {
    className: "mb-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-1"
  }, t('Indicate when you want to take a test drive with this vehicle. We will then confirm your booking.')), /*#__PURE__*/React.createElement("div", null, t('This car can only be viewed by appointment.'))), dealer && /*#__PURE__*/React.createElement("div", {
    className: "w-full mb-8 border-b border-gray-200 pb-4"
  }, /*#__PURE__*/React.createElement(Dealership, {
    context: context,
    name: dealer === null || dealer === void 0 ? void 0 : dealer.name,
    address: dealer === null || dealer === void 0 ? void 0 : dealer.address,
    postal: dealer === null || dealer === void 0 ? void 0 : dealer.postalCode,
    city: dealer === null || dealer === void 0 ? void 0 : dealer.city,
    tel: dealer === null || dealer === void 0 ? void 0 : dealer.tel
  })), validationErrors && validationErrors['result'] && /*#__PURE__*/React.createElement("div", {
    className: "mb-4",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: validationErrors['result']
  })), submitError && submitError !== '' && /*#__PURE__*/React.createElement("div", {
    className: "mb-4",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: submitError
  })), submitSuccess && /*#__PURE__*/React.createElement("div", {
    className: "px-0 md:px-5 lg:px-12 left-0 right-0 absolute",
    style: {
      top: 40
    }
  }, /*#__PURE__*/React.createElement(SuccessIndicator, {
    success: t('Your request has been sent!')
  })), /*#__PURE__*/React.createElement("div", {
    id: "test-drive-form-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(RadioInput, {
    options: genderOptions(t),
    label: t('Title'),
    errorText: validationErrors[FormFields$1.title],
    value: formData.title,
    onChange: function onChange(value) {
      return setFormValue(FormFields$1.title, value);
    },
    required: true,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 mb-5 md:mb-0 mr-0 md:mr-1",
    inputClass: "rounded",
    label: t('First name'),
    placeholder: "John",
    value: formData.firstName,
    onChange: function onChange(value) {
      return setFormValue(FormFields$1.firstName, value);
    },
    errorText: validationErrors[FormFields$1.firstName],
    required: true
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 md:mb-0 ml-0 md:ml-1",
    inputClass: "rounded",
    label: t('Last name'),
    placeholder: "Doe",
    value: formData.lastName,
    onChange: function onChange(value) {
      return setFormValue(FormFields$1.lastName, value);
    },
    errorText: validationErrors[FormFields$1.lastName],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full mb-2 md:mb-0",
    inputClass: "rounded",
    label: t('Email address'),
    placeholder: "john.doe@gmail.com",
    value: formData.email,
    onChange: function onChange(value) {
      return setFormValue(FormFields$1.email, value);
    },
    errorText: validationErrors[FormFields$1.email],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(PhoneInputField, {
    containerClass: "w-full mb-2 md:mb-0",
    inputClass: "rounded",
    label: t('Phone'),
    value: formData.phone,
    onChange: function onChange(value) {
      return setFormValue(FormFields$1.phone, value);
    },
    errorText: validationErrors[FormFields$1.phone],
    required: true,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(DatePickerField, {
    containerClass: "w-full mb-2 md:mb-0",
    inputClass: "rounded",
    onChange: function onChange(date) {
      var isDate = date instanceof Date;
      if (isDate) {
        setFormValue(FormFields$1.date, date);
      }
    },
    label: t('Date'),
    value: formData.date,
    noPast: true,
    errorText: validationErrors[FormFields$1.date],
    context: context
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextAreaField, {
    containerClass: "md:w-full md:mb-0",
    inputClass: "rounded-4",
    label: t('Message'),
    placeholder: t('I am interested in purchasing this car and would like to know if it is still available?'),
    value: formData.message,
    heightClass: "h-30",
    onChange: function onChange(value) {
      return setFormValue(FormFields$1.message, value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex mt-3 mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center border-2 p-1 mr-2 w-6 h-6 cursor-pointer " + (validationErrors['privacy'] !== undefined ? 'border-red-400' : 'border-gray-200'),
    onClick: function onClick() {
      return setFormValue(FormFields$1.privacy, !formData.privacy);
    }
  }, formData.privacy && /*#__PURE__*/React.createElement("div", {
    className: "h-full w-full bg-primary"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex " + (validationErrors['privacy'] !== undefined ? 'text-red-400' : 'text-secondary')
  }, /*#__PURE__*/React.createElement("div", {
    className: "mr-2"
  }, t('I agree to the')), /*#__PURE__*/React.createElement(ExternalLink, {
    url: privacyUrl(context),
    className: "underline",
    context: context
  }, t('privacy terms'), ".")))), /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement(BtnBasic, {
    label: label,
    type: "submit",
    disabled: submitting,
    text: submitting ? t('Sending...') : t('Send'),
    className: ''
  }))));
};
var TestDriveForm$1 = baseDealerContactForm(DealerContactTypes.vehicleTestDrive, initialFormData$1, validator$1, submitDataMapper$1, TestDriveForm);

var Prices = function Prices(_ref) {
  var vehicle = _ref.vehicle,
    activeRate = _ref.activeRate,
    activeFinancingType = _ref.activeFinancingType,
    context = _ref.context,
    deliveryCost = _ref.deliveryCost;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useClientSettings = useClientSettings(),
    clientSettings = _useClientSettings.clientSettings;
  var isProfessional = (clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isProfessional) === true;
  var goToFinanceBlock = function goToFinanceBlock(behavior) {
    if (hasDocument()) {
      var el = getElementByClassName("finance-id-" + vehicle.identification);
      if (el) {
        var stickiesOffset = getStickiesOffset() + getStickiesOffset('content-base-header');
        scrollToTargetV2(el, stickiesOffset);
      }
    }
  };
  var renderProfessional = function renderProfessional() {
    var isInclVat = (clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isInclVat) === true;
    var price,
      priceLabel,
      monthlyPrice,
      monthlyPriceLabel = null;
    if (!vehicle.vatRegime) {
      price = vehicle === null || vehicle === void 0 ? void 0 : vehicle.price;
      priceLabel = t('Price (incl. VAT)');
      if (context.financing && activeRate !== null && activeRate !== void 0 && activeRate.price) {
        monthlyPrice = activeRate.priceIncl;
        monthlyPriceLabel = t('Per month') + " (" + t('incl. VAT') + ")";
      }
    } else {
      price = isInclVat ? vehicle === null || vehicle === void 0 ? void 0 : vehicle.price : vehicle === null || vehicle === void 0 ? void 0 : vehicle.priceExcl;
      priceLabel = isInclVat ? t('Price (incl. VAT)') : t('Price (excl. VAT)');
      if (context.financing && activeRate !== null && activeRate !== void 0 && activeRate.price) {
        monthlyPrice = isInclVat ? activeRate.priceIncl : activeRate.price;
        monthlyPriceLabel = isInclVat ? t('Per month') + " (" + t('incl. VAT') + ")" : t('Per month') + " (" + t('excl. VAT') + ")";
      }
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, price && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
      className: "text-sm"
    }, priceLabel), /*#__PURE__*/React.createElement("p", {
      className: "flex items-start text-28"
    }, "\u20AC ", formatNumber(price), deliveryCost && /*#__PURE__*/React.createElement("i", {
      className: "fas fa-star-of-life ml-1",
      style: {
        fontSize: 8,
        marginTop: 8
      }
    }))), monthlyPrice && monthlyPriceLabel && /*#__PURE__*/React.createElement("div", {
      className: "cursor-pointer",
      onClick: function onClick() {
        return goToFinanceBlock();
      }
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-sm"
    }, monthlyPriceLabel), /*#__PURE__*/React.createElement("p", {
      className: "flex items-start text-28 text-right"
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-info-circle text-18 mr-2 mt-2"
    }), "\u20AC ", formatNumberToMin2Digits(monthlyPrice), deliveryCost && /*#__PURE__*/React.createElement("i", {
      className: "fas fa-star-of-life ml-1",
      style: {
        fontSize: 8,
        marginTop: 8
      }
    }))));
  };
  var renderPrivate = function renderPrivate() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, (vehicle === null || vehicle === void 0 ? void 0 : vehicle.price) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
      className: "text-sm"
    }, t('Price'), " (", t('incl. VAT'), ")"), /*#__PURE__*/React.createElement("p", {
      className: "flex items-start text-28"
    }, "\u20AC ", formatNumber(vehicle.price), deliveryCost && /*#__PURE__*/React.createElement("i", {
      className: "fas fa-star-of-life ml-1",
      style: {
        fontSize: 8,
        marginTop: 8
      }
    }))), context.financing && (activeRate === null || activeRate === void 0 ? void 0 : activeRate.monthlyPrice) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "cursor-pointer",
      onClick: function onClick() {
        return goToFinanceBlock();
      }
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-sm cursor"
    }, t('Per month'), " (", t('incl. VAT'), ")"), /*#__PURE__*/React.createElement("p", {
      className: "flex items-start text-28 text-right"
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-info-circle text-18 mr-2 mt-2"
    }), "\u20AC ", formatNumberToMin2Digits(activeRate.monthlyPrice), deliveryCost && /*#__PURE__*/React.createElement("i", {
      className: "fas fa-star-of-life ml-1",
      style: {
        fontSize: 8,
        marginTop: 8
      }
    }))), (activeFinancingType === null || activeFinancingType === void 0 ? void 0 : activeFinancingType.key) === FINANCING_TYPE_KEYS.BALLOON && (vehicle === null || vehicle === void 0 ? void 0 : vehicle.monthlyLastPayment) && /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col w-full text-secondary font-semibold text-12"
    }, /*#__PURE__*/React.createElement("div", null, t('last monthly payment'), ":"), /*#__PURE__*/React.createElement("div", null, "\u20AC ", formatNumberToMin2Digits(vehicle === null || vehicle === void 0 ? void 0 : vehicle.monthlyLastPayment)))));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, isProfessional ? renderProfessional() : renderPrivate());
};

var VatTypeSwitch = function VatTypeSwitch(_ref) {
  var context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings,
    setClientSetting = _useClientSettings.setClientSetting;
  var isInclVat = (clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isInclVat) === true;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col text-gray-900"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row cursor-pointer",
    onClick: function onClick() {
      return setClientSetting('isInclVat', !isInclVat, true);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center border-2 border-gray-200 p-1 mr-2 w-6 h-6"
  }, isInclVat && /*#__PURE__*/React.createElement("div", {
    className: "h-full w-full bg-lma"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 text-16 leading-19px text-secondary font-light"
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, t('Show prices incl. VAT')))));
};

var PriceCard = function PriceCard(_ref) {
  var _vehicle$dealer3, _vehicle$dealer4, _vehicle$dealer5, _vehicle$dealer6, _vehicle$dealer7;
  var vehicle = _ref.vehicle,
    label = _ref.label,
    activeRate = _ref.activeRate,
    activeFinancingType = _ref.activeFinancingType,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings;
  var isProfessional = (clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isProfessional) === true;
  var isInclVat = (clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isInclVat) === true;
  var _useState = useState(null),
    activeForm = _useState[0],
    setActiveForm = _useState[1];
  var CarDealerRef = useRef();
  useContentBlockImpressionWhenInViewport(CarDealerRef, 'dealer', context);
  if (activeForm === 'appointment') {
    var _vehicle$dealer;
    return /*#__PURE__*/React.createElement("div", {
      className: "bg-white p-0 lg:p-10 border-0 lg:border",
      style: {
        borderColor: '#dfe7f5'
      }
    }, /*#__PURE__*/React.createElement(AppointmentForm$1, {
      additionalData: {
        vehicle: vehicle,
        toolType: 'request-form',
        toolName: 'dealersite-contact-dealer',
        toolStepStart: 'personal-info',
        toolStepComplete: 'thank-you',
        toolStepError: 'personal-info',
        toolStepOption: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$dealer = vehicle.dealer) === null || _vehicle$dealer === void 0 ? void 0 : _vehicle$dealer.name,
        requestType: 'contact-dealer'
      },
      label: label,
      onClose: function onClose() {
        return setActiveForm(null);
      },
      context: context
    }));
  }
  if (activeForm === 'test_drive') {
    var _vehicle$dealer2;
    return /*#__PURE__*/React.createElement("div", {
      className: "bg-white p-0 lg:p-10 border-0 lg:border",
      style: {
        borderColor: '#dfe7f5'
      }
    }, /*#__PURE__*/React.createElement(TestDriveForm$1, {
      additionalData: {
        vehicle: vehicle,
        toolType: 'request-form',
        toolName: 'dealersite-test-drive',
        toolStepStart: 'personal-info',
        toolStepComplete: 'thank-you',
        toolStepError: 'personal-info',
        toolStepOption: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$dealer2 = vehicle.dealer) === null || _vehicle$dealer2 === void 0 ? void 0 : _vehicle$dealer2.name,
        requestType: 'test-drive'
      },
      label: label,
      onClose: function onClose() {
        return setActiveForm(null);
      },
      context: context
    }));
  }
  var deliveryCost = resolveDeliveryCost(vehicle === null || vehicle === void 0 ? void 0 : vehicle.productsAndServices);
  var resolveDeliveryCostText = function resolveDeliveryCostText() {
    if (isProfessional && !isInclVat) {
      return t('Exclusive delivery cost') + " " + formatPriceByCulture(deliveryCost === null || deliveryCost === void 0 ? void 0 : deliveryCost.priceExcl, {
        culture: context.culture
      }) + " " + t('VAT excl.');
    }
    return t('Exclusive delivery cost') + " " + formatPriceByCulture(deliveryCost === null || deliveryCost === void 0 ? void 0 : deliveryCost.priceIncl, {
      culture: context.culture
    }) + " " + t('VAT incl.');
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-white p-0 lg:p-10 border-0 lg:border",
    style: {
      borderColor: '#dfe7f5'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block mb-6"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-xl font-bold text-secondary truncate"
  }, vehicle === null || vehicle === void 0 ? void 0 : vehicle.make, " ", vehicle === null || vehicle === void 0 ? void 0 : vehicle.model), /*#__PURE__*/React.createElement("h2", {
    className: "text-base font-light truncate"
  }, vehicle === null || vehicle === void 0 ? void 0 : vehicle.version), /*#__PURE__*/React.createElement("p", {
    className: "text-12 font-semibold text-lma-darkgray"
  }, t('Reference'), ": ", vehicle === null || vehicle === void 0 ? void 0 : vehicle.identification)), /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(ClientTypeSwitch, {
    context: context
  })), isProfessional && vehicle.vatRegime && /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(VatTypeSwitch, {
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between font-bold mb-5 text-secondary"
  }, /*#__PURE__*/React.createElement(Prices, {
    activeRate: activeRate,
    activeFinancingType: activeFinancingType,
    vehicle: vehicle,
    context: context,
    deliveryCost: deliveryCost
  })), deliveryCost && /*#__PURE__*/React.createElement("div", {
    className: "flex items-start gap-1 mb-5"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-star-of-life",
    style: {
      fontSize: 8,
      marginTop: 2
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-gray-900 text-12 leading-18 font-regular"
  }, resolveDeliveryCostText())), /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(AdvertiseComponent$1, {
    groupName: "vehicle-detail-price-card",
    vehicleReference: vehicle.reference,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-secondary mb-5"
  }, /*#__PURE__*/React.createElement(Guarantees, {
    label: label,
    warranty: vehicle === null || vehicle === void 0 ? void 0 : vehicle.warranty,
    availability: vehicle === null || vehicle === void 0 ? void 0 : vehicle.availability,
    context: context
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ActionButtons, {
    label: label,
    onAppointment: function onAppointment() {
      return setActiveForm('appointment');
    },
    onTestDrive: function onTestDrive() {
      return setActiveForm('test_drive');
    },
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:block",
    ref: CarDealerRef
  }, /*#__PURE__*/React.createElement(Dealership, {
    name: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$dealer3 = vehicle.dealer) === null || _vehicle$dealer3 === void 0 ? void 0 : _vehicle$dealer3.name,
    address: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$dealer4 = vehicle.dealer) === null || _vehicle$dealer4 === void 0 ? void 0 : _vehicle$dealer4.address,
    postal: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$dealer5 = vehicle.dealer) === null || _vehicle$dealer5 === void 0 ? void 0 : _vehicle$dealer5.postal,
    city: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$dealer6 = vehicle.dealer) === null || _vehicle$dealer6 === void 0 ? void 0 : _vehicle$dealer6.city,
    tel: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$dealer7 = vehicle.dealer) === null || _vehicle$dealer7 === void 0 ? void 0 : _vehicle$dealer7.tel,
    context: context
  })));
};

var ContentHeader = function ContentHeader(_ref) {
  var headerTabs = _ref.headerTabs,
    currentTab = _ref.currentTab,
    changeTab = _ref.changeTab;
  var _useState = useState(''),
    hoveredItem = _useState[0],
    setHoveredItem = _useState[1];
  var renderMobile = function renderMobile() {
    return /*#__PURE__*/React.createElement("div", {
      className: "overflow-x-scroll w-full no-scrollbar bg-white"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-nowrap relative left-0 space-x-2.5",
      style: {
        width: 'fit-content'
      }
    }, map(headerTabs, function (item, i) {
      var isActive = item.key === currentTab || item.key === hoveredItem;
      return /*#__PURE__*/React.createElement("div", {
        key: "header-tab-" + i,
        className: "flex-none text-14 font-bold leading-25 text-center relative pb-6 cursor-pointer " + (isActive ? 'text-secondary' : 'text-gray-500'),
        onClick: function onClick() {
          return changeTab(item.key);
        },
        onMouseEnter: function onMouseEnter() {
          return setHoveredItem(item.key);
        },
        onMouseLeave: function onMouseLeave() {
          return setHoveredItem('');
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "px-2.5 "
      }, item.label), /*#__PURE__*/React.createElement("div", {
        className: "transition absolute inset-x-0 bottom-0 " + (isActive ? 'bg-lma' : 'bg-gray-100'),
        style: {
          height: 6
        }
      }));
    })));
  };
  var renderDesktop = function renderDesktop() {
    return /*#__PURE__*/React.createElement(Sticky, {
      top: getStickiesOffset(),
      activeClass: "bg-white w-full",
      innerZ: 22,
      bottomBoundary: ".details-page-bottom"
    }, function (_ref2) {
      var status = _ref2.status;
      return /*#__PURE__*/React.createElement("div", {
        className: "grid grid-cols-4 gap-5 w-full bg-white " + (status === STICKY_STATUS.STATUS_FIXED ? 'py-6' : '')
      }, map(headerTabs, function (item, i) {
        var isActive = item.key === currentTab || item.key === hoveredItem;
        return /*#__PURE__*/React.createElement("div", {
          key: "header-tab-" + i,
          className: "flex-none text-18 font-bold leading-25 text-center relative pb-6 cursor-pointer " + (isActive ? 'text-secondary' : 'text-gray-500'),
          onClick: function onClick() {
            return changeTab(item.key);
          },
          onMouseEnter: function onMouseEnter() {
            return setHoveredItem(item.key);
          },
          onMouseLeave: function onMouseLeave() {
            return setHoveredItem('');
          }
        }, /*#__PURE__*/React.createElement("div", null, item.label), /*#__PURE__*/React.createElement("div", {
          className: "transition absolute inset-x-0 bottom-0 " + (isActive ? 'bg-lma' : 'bg-gray-100'),
          style: {
            height: 6
          }
        }));
      }));
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "content-base-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "block md:hidden"
  }, renderMobile()), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block"
  }, renderDesktop()));
};

var Specifications = function Specifications(_ref) {
  var vehicle = _ref.vehicle;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var specs = [{
    label: t('First registration'),
    value: vehicle !== null && vehicle !== void 0 && vehicle.firstRegistrationMonth && vehicle !== null && vehicle !== void 0 && vehicle.firstRegistrationYear ? (vehicle === null || vehicle === void 0 ? void 0 : vehicle.firstRegistrationMonth) + "/" + (vehicle === null || vehicle === void 0 ? void 0 : vehicle.firstRegistrationYear) : null
  }, {
    label: t('Mileage'),
    value: vehicle.mileage ? formatNumber(vehicle.mileage) + " km" : null
  }, {
    label: t('Fuel type'),
    value: vehicle === null || vehicle === void 0 ? void 0 : vehicle.fuel
  }, {
    label: t('Transmission'),
    value: vehicle === null || vehicle === void 0 ? void 0 : vehicle.gearbox
  }, {
    label: t('PK'),
    value: vehicle.hp ? vehicle.hp + " pk" : null
  }, {
    label: t('CO2 (g/km)'),
    value: vehicle.co2 ? vehicle.co2 + " g/km" : null
  }, {
    label: t('Body type'),
    value: vehicle === null || vehicle === void 0 ? void 0 : vehicle.body
  }, {
    label: t('Seats'),
    value: vehicle === null || vehicle === void 0 ? void 0 : vehicle.seats
  }, {
    label: t('Doors'),
    value: vehicle === null || vehicle === void 0 ? void 0 : vehicle.doors
  }, {
    label: t('Exterior color'),
    value: vehicle === null || vehicle === void 0 ? void 0 : vehicle.exteriorColor
  }, {
    label: t('Interior color'),
    value: vehicle === null || vehicle === void 0 ? void 0 : vehicle.interiorColor
  }, {
    label: t('Reference'),
    value: vehicle === null || vehicle === void 0 ? void 0 : vehicle.identification
  }];
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "text-32 text-secondary font-bold leading-25 mb-8"
  }, t('Specifications')), /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, map(specs, function (item, i) {
    var isLast = i === specs.length - 1;
    return /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 py-0 md:py-3 text-secondary border-gray-100 " + (isLast ? 'border-none' : 'border-none md:border-b '),
      key: "spec-" + i
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-start text-16 md:text-18 font-light leading-25 "
    }, item.label), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-end font-bold"
    }, item.value));
  })));
};

var logoCarPass = "carpass_green~PIRedrvg.png";

var Tracking = function Tracking(_ref) {
  var context = _ref.context,
    vehicle = _ref.vehicle;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var CarPassRef = useRef();
  useContentBlockImpressionWhenInViewport(CarPassRef, 'carpass', context);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "text-32 text-secondary font-bold leading-25 mb-8"
  }, t('Vehicle tracking')), /*#__PURE__*/React.createElement("div", {
    className: "w-full",
    ref: CarPassRef
  }, vehicle.carpass && vehicle.carpass !== '' && /*#__PURE__*/React.createElement("a", {
    href: vehicle.carpass,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    className: "cursor-hand",
    src: useAsset(logoCarPass),
    style: {
      height: 47
    },
    alt: "carpass"
  }))));
};

var OptionsDesktop = function OptionsDesktop(_ref) {
  var equipments = _ref.equipments,
    equipmentGroups = _ref.equipmentGroups,
    expanded = _ref.expanded,
    toggleGroupsExpand = _ref.toggleGroupsExpand,
    refs = _ref.refs,
    maxHeights = _ref.maxHeights,
    maxHeightDefault = _ref.maxHeightDefault;
  var renderContent = function renderContent(groups, group) {
    var _find;
    var maxHeight = (_find = find(maxHeights, function (mh) {
      return parseInt(mh.group) === parseInt(group);
    })) === null || _find === void 0 ? void 0 : _find.maxHeight;
    return /*#__PURE__*/React.createElement("div", {
      className: "w-full"
    }, /*#__PURE__*/React.createElement("div", {
      ref: function ref(element) {
        return refs.current[group] = element;
      },
      id: group,
      className: "vehicle-options grid grid-cols-2 gap-x-4 gap-y-8 relative overflow-hidden cursor-pointer transform transition-all duration-1000",
      style: {
        height: expanded ? maxHeight : maxHeightDefault
      },
      onClick: function onClick() {
        return toggleGroupsExpand();
      }
    }, map(groups, function (groupKey, index) {
      var _find2;
      var options = map(filter(equipments, function (eq) {
        return eq.group_key === groupKey;
      }), function (opt) {
        return opt.value;
      });
      var groupLabel = (_find2 = find(equipments, function (eq) {
        return eq.group_key === groupKey;
      })) === null || _find2 === void 0 ? void 0 : _find2.group;
      var groupName = groupLabel ? groupLabel : groupKey;
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "flex flex-col flex-1"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-18 leading-25 text-secondary font-bold mb-2"
      }, groupName), /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col"
      }, map(options.sort(), function (option, i) {
        var isLast = options.length - 1 === i;
        return /*#__PURE__*/React.createElement("div", {
          key: "option-" + i,
          className: "flex flex-nowrap items-start text-18 leading-32 font-light capitalize text-secondary " + (isLast ? '' : 'mb-0.5 md:mb-0.5')
        }, /*#__PURE__*/React.createElement("i", {
          className: "fal fa-check mr-2",
          style: {
            marginTop: 8
          }
        }), " ", option);
      })));
    }), !expanded && /*#__PURE__*/React.createElement("div", {
      className: "absolute bottom-0 left-0 right-0",
      style: {
        height: 58,
        background: 'transparent linear-gradient(180deg, #FFFFFF00 0%, #FFFFFF 100%) 0% 0% no-repeat padding-box'
      }
    })));
  };
  var GROUPS = [{
    id: 1,
    groups: equipmentGroups.slice(0, 2)
  }, {
    id: 2,
    groups: equipmentGroups.slice(2, 4)
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col relative flex flex-col relative w-full"
  }, map(GROUPS, function (gr) {
    return /*#__PURE__*/React.createElement("div", {
      key: "group-" + gr.id,
      className: "relative mb-10"
    }, renderContent(gr.groups, gr.id));
  }));
};

var OptionsMobile = function OptionsMobile(_ref) {
  var equipments = _ref.equipments,
    equipmentGroups = _ref.equipmentGroups,
    expanded = _ref.expanded,
    toggleGroupsExpand = _ref.toggleGroupsExpand,
    refs = _ref.refs,
    maxHeights = _ref.maxHeights,
    maxHeightDefault = _ref.maxHeightDefault;
  var renderContent = function renderContent(groups, group) {
    var _find;
    var maxHeight = (_find = find(maxHeights, function (mh) {
      return parseInt(mh.group) === parseInt(group);
    })) === null || _find === void 0 ? void 0 : _find.maxHeight;
    return /*#__PURE__*/React.createElement("div", {
      className: "container mx-auto px-0"
    }, /*#__PURE__*/React.createElement("div", {
      ref: function ref(element) {
        return refs.current[group] = element;
      },
      id: group,
      className: "vehicle-options grid grid-cols-1 gap-x-4 gap-y-8 relative overflow-hidden cursor-pointer transform transition-all",
      style: {
        height: expanded ? maxHeight : maxHeightDefault
      },
      onClick: function onClick() {
        return toggleGroupsExpand();
      }
    }, map(groups, function (groupKey, index) {
      var _find2;
      var options = map(filter(equipments, function (eq) {
        return eq.group_key === groupKey;
      }), function (opt) {
        return opt.value;
      });
      var groupLabel = (_find2 = find(equipments, function (eq) {
        return eq.group_key === groupKey;
      })) === null || _find2 === void 0 ? void 0 : _find2.group;
      var groupName = groupLabel ? groupLabel : groupKey;
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "flex flex-col flex-1 w-full"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-16 leading-29 font-bold text-secondary"
      }, groupName), /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col"
      }, map(options.sort(), function (option, i) {
        return /*#__PURE__*/React.createElement("div", {
          key: "option-" + i,
          className: "text-16 leading-29 font-light capitalize text-secondary flex-nowrap"
        }, /*#__PURE__*/React.createElement("i", {
          className: "fal fa-check mr-2"
        }), " ", option);
      })));
    }), !expanded && /*#__PURE__*/React.createElement("div", {
      className: "absolute bottom-0 left-0 right-0",
      style: {
        height: 58,
        background: 'transparent linear-gradient(180deg, #FFFFFF00 0%, #FFFFFF 100%) 0% 0% no-repeat padding-box'
      }
    })));
  };
  var GROUPS = [{
    id: 1,
    groups: equipmentGroups.slice(0, 1)
  }, {
    id: 2,
    groups: equipmentGroups.slice(1, 2)
  }, {
    id: 3,
    groups: equipmentGroups.slice(2, 3)
  }, {
    id: 4,
    groups: equipmentGroups.slice(3, 4)
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col relative flex flex-col relative w-full"
  }, map(GROUPS, function (gr) {
    return /*#__PURE__*/React.createElement("div", {
      key: "group-" + gr.id,
      className: "relative mb-5 md:mb-10"
    }, renderContent(gr.groups, gr.id));
  }));
};

var MAX_HEIGHT_DEFAULT = 150;
var Options = function Options(_ref) {
  var context = _ref.context,
    vehicle = _ref.vehicle;
  var _useState = useState([]),
    maxHeights = _useState[0],
    setMaxHeights = _useState[1];
  var _useState2 = useState(false),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var desktopRefs = useRef([]);
  var mobileRefs = useRef([]);
  var getMaxHeights = function getMaxHeights(refs) {
    if (refs.current) {
      var groupHeights = [];
      forEach(filter(refs.current, function (ref) {
        return ref;
      }), function (ref) {
        groupHeights.push({
          group: ref.id,
          maxHeight: ref.scrollHeight
        });
      });
      setMaxHeights(groupHeights);
    }
  };
  useEffect(function () {
    if (vehicle.equipments) {
      if (hasWindow()) {
        if (window.innerWidth < 768) {
          if (mobileRefs.current) {
            getMaxHeights(mobileRefs);
          }
        } else {
          if (desktopRefs.current) {
            getMaxHeights(desktopRefs);
          }
        }
      }
    }
  }, [vehicle]);
  var equipments = vehicle !== null && vehicle !== void 0 && vehicle.equipments ? vehicle === null || vehicle === void 0 ? void 0 : vehicle.equipments : [];
  var toggleGroupsExpand = function toggleGroupsExpand() {
    if (expanded) scrollToTarget('equipments-title', getStickiesOffset());
    setExpanded(!expanded);
  };
  var renderExpandButton = function renderExpandButton() {
    var showExpandButton = some(maxHeights, function (mh) {
      return parseInt(mh.maxHeight) > MAX_HEIGHT_DEFAULT;
    });
    if (showExpandButton) {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex justify-start cursor-pointer text-16 md:text-18 font-bold text-secondary leading-25",
        onClick: function onClick() {
          return toggleGroupsExpand();
        }
      }, !expanded && /*#__PURE__*/React.createElement("div", null, t('More equipment'), " ", /*#__PURE__*/React.createElement("i", {
        className: "fal fa-arrow-down ml-2"
      })), expanded && /*#__PURE__*/React.createElement("div", null, t('Less equipment'), " ", /*#__PURE__*/React.createElement("i", {
        className: "fal fa-arrow-up ml-2"
      })));
    }
  };
  var equipmentGroups = uniq(map(filter(equipments, function (eq) {
    return eq.group_key !== 'Cons';
  }), function (eq) {
    return eq.group_key;
  }));
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    id: "equipments-title",
    className: "text-24 md:text-32 text-secondary font-bold leading-25 mb-5 md:mb-8"
  }, t('Options and equipment')), /*#__PURE__*/React.createElement("div", {
    className: "block md:hidden"
  }, /*#__PURE__*/React.createElement(OptionsMobile, {
    vehicle: vehicle,
    expanded: expanded,
    refs: mobileRefs,
    maxHeights: maxHeights,
    maxHeightDefault: MAX_HEIGHT_DEFAULT,
    toggleGroupsExpand: toggleGroupsExpand,
    equipments: equipments,
    equipmentGroups: equipmentGroups,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block"
  }, /*#__PURE__*/React.createElement(OptionsDesktop, {
    vehicle: vehicle,
    expanded: expanded,
    refs: desktopRefs,
    maxHeights: maxHeights,
    maxHeightDefault: MAX_HEIGHT_DEFAULT,
    toggleGroupsExpand: toggleGroupsExpand,
    equipments: equipments,
    equipmentGroups: equipmentGroups,
    context: context
  })), renderExpandButton());
};

var SelectBox = function SelectBox(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    options = _ref.options,
    isDisabled = _ref.isDisabled,
    className = _ref.className,
    placeholder = _ref.placeholder,
    isLoading = _ref.isLoading,
    isMulti = _ref.isMulti,
    customComponents = _ref.customComponents,
    closeMenuOnSelect = _ref.closeMenuOnSelect,
    errorText = _ref.errorText,
    containerClass = _ref.containerClass,
    label = _ref.label,
    required = _ref.required,
    lightForm = _ref.lightForm,
    errorClass = _ref.errorClass,
    isSearchable = _ref.isSearchable;
  var refSelectContainer = useRef();
  var hasError = errorText !== undefined;
  var DropdownIndicator = function DropdownIndicator(props) {
    return components.DropdownIndicator && /*#__PURE__*/React.createElement(components.DropdownIndicator, props, /*#__PURE__*/React.createElement("i", {
      className: (props.selectProps.menuIsOpen ? 'fas fa-angle-up' : 'fas fa-angle-down') + " text-secondary-two"
    }));
  };
  var formatGroupLabel = function formatGroupLabel(data) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: "font-secondary font-semibold text-primary text-12"
    }, "- ", data.label));
  };
  var Components = customComponents ? _extends({
    DropdownIndicator: DropdownIndicator
  }, customComponents) : {
    DropdownIndicator: DropdownIndicator
  };
  return /*#__PURE__*/React.createElement("div", {
    className: containerClass
  }, label && /*#__PURE__*/React.createElement("label", {
    className: "block tracking-wide " + (hasError ? 'text-red-400' : lightForm ? 'text-white' : 'text-gray-700') + " mb-2"
  }, label, " ", required ? '(*)' : ''), /*#__PURE__*/React.createElement(Select, {
    value: value,
    onChange: onChange,
    options: options,
    classNamePrefix: "custom-select",
    className: "text-14 font-primary text-secondary cursor-pointer " + (hasError ? 'error' : '') + " " + className,
    components: Components,
    formatGroupLabel: formatGroupLabel,
    isDisabled: isDisabled,
    placeholder: placeholder,
    isLoading: isLoading,
    closeMenuOnSelect: closeMenuOnSelect,
    isMulti: isMulti,
    isSearchable: isSearchable,
    styles: {
      indicatorSeparator: function indicatorSeparator(styles) {
        return {
          display: 'none'
        };
      },
      indicatorContainer: function indicatorContainer(styles) {
        return {
          marginTop: '1px'
        };
      }
    }
  }), hasError && errorText !== '' && /*#__PURE__*/React.createElement("div", {
    className: "text-red-400 text-xs mt-1 " + errorClass
  }, errorText));
};
SelectBox.defaultProps = {
  containerClass: '',
  errorClass: '',
  label: '',
  value: null,
  required: false,
  options: [],
  isDisabled: false,
  className: '',
  placeholder: 'Select...',
  isLoading: false,
  customComponents: null,
  isMulti: false,
  closeMenuOnSelect: true,
  lightForm: false,
  isSearchable: true
};

var GenericSelect = function GenericSelect(_ref) {
  var placeHolder = _ref.placeHolder,
    items = _ref.items,
    values = _ref.values,
    isSearchable = _ref.isSearchable,
    handleFilterChanged = _ref.handleFilterChanged;
  var options = orderBy(map(items, function (item) {
    return {
      value: item.key,
      label: item.text
    };
  }), ['label']);
  var valuesLabels = map(filter(options, function (option) {
    return includes(values, option.value);
  }), function (item) {
    return item.label;
  });
  var valueLabel = valuesLabels.length > 0 ? {
    label: valuesLabels.join(', ')
  } : '';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectBox, {
    value: valueLabel,
    options: options,
    placeholder: placeHolder,
    closeMenuOnSelect: false,
    isSearchable: isSearchable,
    customComponents: {
      Option: function Option(_ref2) {
        var innerProps = _ref2.innerProps,
          isDisabled = _ref2.isDisabled,
          data = _ref2.data;
        var isSelected = includes(values, data.value);
        return !isDisabled ? /*#__PURE__*/React.createElement("div", innerProps, /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row py-1 px-3 hover:bg-secondary-five cursor-pointer hover:text-primary",
          onClick: function onClick() {
            return handleFilterChanged(data);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center"
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center justify-center border-2 border-gray-200 p-1 mr-2 w-6 h-6"
        }, isSelected && /*#__PURE__*/React.createElement("div", {
          className: "h-full w-full bg-primary"
        }))), /*#__PURE__*/React.createElement("div", {
          className: "flex flex-1 text-16 font-light text-secondary font-semibold"
        }, /*#__PURE__*/React.createElement("div", {
          className: "capitalize"
        }, data.label)))) : null;
      }
    },
    isLoading: false
  }));
};

var FinancingTypes = function FinancingTypes(_ref) {
  var financingTypes = _ref.financingTypes,
    activeFinancingType = _ref.activeFinancingType,
    onFinancingTypeChange = _ref.onFinancingTypeChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useClientSettings = useClientSettings(),
    clientSettings = _useClientSettings.clientSettings;
  return /*#__PURE__*/React.createElement(Fade, {
    duration: 300,
    spy: clientSettings.isProfessional
  }, /*#__PURE__*/React.createElement("div", {
    className: "block md:hidden"
  }, /*#__PURE__*/React.createElement(GenericSelect, {
    placeHolder: t('Financing type'),
    items: map(filter(financingTypes, function (ft) {
      var _ft$rates;
      return ((_ft$rates = ft.rates) === null || _ft$rates === void 0 ? void 0 : _ft$rates.length) > 0 || ft.key === FINANCING_TYPE_KEYS.LONG_TERM_RENTAL;
    }), function (type) {
      return {
        key: type.key,
        text: type.title
      };
    }),
    values: {
      value: activeFinancingType === null || activeFinancingType === void 0 ? void 0 : activeFinancingType.key,
      label: activeFinancingType === null || activeFinancingType === void 0 ? void 0 : activeFinancingType.title
    },
    isSearchable: false,
    handleFilterChanged: function handleFilterChanged(type) {
      onFinancingTypeChange(type.value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex space-x-8"
  }, map(financingTypes, function (type) {
    var _type$rates;
    var isLongTermRental = type.key === FINANCING_TYPE_KEYS.LONG_TERM_RENTAL;
    if (!isLongTermRental && ((_type$rates = type.rates) === null || _type$rates === void 0 ? void 0 : _type$rates.length) <= 0) return;
    return /*#__PURE__*/React.createElement("div", {
      key: type.key,
      className: "flex cursor-pointer",
      onClick: function onClick() {
        onFinancingTypeChange(type.key);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-none justify-center items-center w-6 h-6 rounded-full border border-secondary mr-2"
    }, (activeFinancingType === null || activeFinancingType === void 0 ? void 0 : activeFinancingType.key) === type.key && /*#__PURE__*/React.createElement("div", {
      className: "flex-none w-4 h-4 rounded-full bg-secondary"
    })), /*#__PURE__*/React.createElement("p", null, type.title, type.disclaimer && /*#__PURE__*/React.createElement("sup", {
      className: "ml-1 text-gray-500 text-10"
    }, "(", type.disclaimer, ")")));
  })));
};

var LongTermRental = function LongTermRental(_ref) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, t('The Long Term Rental offers you a complete service and lighter administrative management. You will receive an invoice every month with the rental of your vehicle and all associated services (insurance, maintenance & setup, roadside assistance, etc.). At the end of the contract, you simply return the car.')));
};

var FinancingAmounts = function FinancingAmounts(_ref) {
  var vehicle = _ref.vehicle,
    rates = _ref.rates,
    defaultRate = _ref.defaultRate,
    depositAmount = _ref.depositAmount,
    monthsAmount = _ref.monthsAmount,
    onDepositChange = _ref.onDepositChange,
    onMonthsChange = _ref.onMonthsChange,
    activeRate = _ref.activeRate,
    activeFinancingType = _ref.activeFinancingType,
    label = _ref.label,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useClientSettings = useClientSettings(),
    clientSettings = _useClientSettings.clientSettings;
  useEffect(function () {
    onDepositChange(defaultRate === null || defaultRate === void 0 ? void 0 : defaultRate.deposit);
    onMonthsChange(defaultRate === null || defaultRate === void 0 ? void 0 : defaultRate.months);
  }, [defaultRate]);
  var deposits = sortBy(rates === null || rates === void 0 ? void 0 : rates.map(function (fr) {
    return parseInt(fr.deposit);
  }).filter(function (value, index, self) {
    return self.indexOf(value) === index;
  }));
  var availableMonths = sortBy(rates === null || rates === void 0 ? void 0 : rates.map(function (fr) {
    return parseInt(fr.months);
  }).filter(function (value, index, self) {
    return self.indexOf(value) === index;
  }));
  var depositMarks = mapValues(keyBy(deposits), function () {
    return '';
  });
  var monthMarks = mapValues(keyBy(availableMonths), function () {
    return '';
  });
  var getDepositTotal = function getDepositTotal(deposit) {
    var depositTotal = deposit / 100 * vehicle.price;
    return formatNumber(depositTotal);
  };
  var renderLegalInfo = function renderLegalInfo() {
    if (!activeRate.legal) {
      return /*#__PURE__*/React.createElement("div", {
        className: "hidden"
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "mt-6",
      dangerouslySetInnerHTML: {
        __html: b64DecodeUnicode(activeRate === null || activeRate === void 0 ? void 0 : activeRate.legal)
      }
    });
  };
  var renderProfessionalBox = function renderProfessionalBox() {
    if (activeFinancingType.key === FINANCING_TYPE_KEYS.LONG_TERM_RENTAL) {
      return /*#__PURE__*/React.createElement(LongTermRental, {
        context: context,
        label: label
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "w-full professional-amounts"
    }, vehicle.vatRegime && /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center bg-lma-gray py-4 mb-4"
    }, /*#__PURE__*/React.createElement("p", {
      className: "flex flex-1 truncate px-4"
    }, t('Rental price (excl. VAT)')), /*#__PURE__*/React.createElement("p", {
      className: "pr-4 text-right"
    }, "\u20AC", ' ', activeRate !== null && activeRate !== void 0 && activeRate.price ? formatNumberToMin2Digits(activeRate.price) : '')), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center bg-lma-gray py-4 mb-4"
    }, /*#__PURE__*/React.createElement("p", {
      className: "flex flex-1 truncate px-4"
    }, t('Rental price (incl. VAT)')), /*#__PURE__*/React.createElement("p", {
      className: "flex-none pr-4 text-right"
    }, "\u20AC ", activeRate !== null && activeRate !== void 0 && activeRate.priceIncl ? formatNumber(activeRate.priceIncl) : '')), /*#__PURE__*/React.createElement("div", {
      className: "bg-lma-gray py-4 mb-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center mb-2"
    }, /*#__PURE__*/React.createElement("p", {
      className: "flex flex-1 truncate px-4"
    }, t('Deposit'), " (", activeRate === null || activeRate === void 0 ? void 0 : activeRate.deposit, "%)"), /*#__PURE__*/React.createElement("p", {
      className: "flex-none pr-4 text-right"
    }, "\u20AC", ' ', activeRate !== null && activeRate !== void 0 && activeRate.depositAmount ? getDepositTotal(activeRate.deposit) : '')), /*#__PURE__*/React.createElement("div", {
      className: "px-4 w-full md:w-72"
    }, /*#__PURE__*/React.createElement(Slider, {
      min: parseInt(min(deposits)),
      max: parseInt(max(deposits)),
      defaultValue: parseInt(activeRate === null || activeRate === void 0 ? void 0 : activeRate.deposit),
      step: null,
      marks: depositMarks,
      dotStyle: {
        display: 'none'
      },
      value: depositAmount,
      onChange: function onChange(deposit) {
        onDepositChange(deposit);
      }
    }))), /*#__PURE__*/React.createElement("div", {
      className: "bg-lma-gray py-4 mb-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center"
    }, /*#__PURE__*/React.createElement("p", {
      className: "flex flex-1 truncate px-4 mb-2"
    }, t('Contract duration')), /*#__PURE__*/React.createElement("p", {
      className: "flex-none pr-4 text-right"
    }, (activeRate === null || activeRate === void 0 ? void 0 : activeRate.months) + ' ' + t('months'))), /*#__PURE__*/React.createElement("div", {
      className: "px-4 w-full md:w-72"
    }, /*#__PURE__*/React.createElement(Slider, {
      min: parseInt(min(availableMonths)),
      max: parseInt(max(availableMonths)),
      step: null,
      marks: monthMarks,
      dotStyle: {
        display: 'none'
      },
      value: monthsAmount,
      onChange: function onChange(months) {
        onMonthsChange(months);
      }
    }))), vehicle.vatRegime && /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center bg-lma-gray py-4 mb-4"
    }, /*#__PURE__*/React.createElement("p", {
      className: "flex flex-1 truncate px-4"
    }, t('First increased rental price (excl. VAT)')), /*#__PURE__*/React.createElement("p", {
      className: "flex-none pr-4 text-right"
    }, "\u20AC", ' ', activeRate !== null && activeRate !== void 0 && activeRate.depositAmount ? formatNumber(activeRate.depositAmount) : '')), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center bg-lma-gray py-4 mb-4"
    }, /*#__PURE__*/React.createElement("p", {
      className: "flex flex-1 truncate px-4"
    }, t('Purchase option')), /*#__PURE__*/React.createElement("p", {
      className: "flex-none pr-4 text-right"
    }, activeRate !== null && activeRate !== void 0 && activeRate.purchase ? formatNumber(activeRate.purchase) : '', " %")));
  };
  var renderPrivateBox = function renderPrivateBox() {
    return /*#__PURE__*/React.createElement("div", {
      className: "w-full private-amounts"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center bg-lma-gray py-4 mb-4"
    }, /*#__PURE__*/React.createElement("p", {
      className: "flex flex-1 truncate px-4"
    }, t('Monthly payment')), /*#__PURE__*/React.createElement("p", {
      className: "pr-4 text-right"
    }, "\u20AC", ' ', activeRate !== null && activeRate !== void 0 && activeRate.monthlyPrice ? formatNumberToMin2Digits(activeRate.monthlyPrice) : '')), /*#__PURE__*/React.createElement("div", {
      className: "bg-lma-gray py-4 mb-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center mb-2"
    }, /*#__PURE__*/React.createElement("p", {
      className: "flex flex-1 truncate px-4"
    }, t('Deposit'), " ", depositAmount, "%"), /*#__PURE__*/React.createElement("p", {
      className: "flex-none pr-4 text-right"
    }, "\u20AC ", formatNumber(activeRate === null || activeRate === void 0 ? void 0 : activeRate.depositAmount))), /*#__PURE__*/React.createElement("div", {
      className: "px-4 w-full md:w-72"
    }, /*#__PURE__*/React.createElement(Slider, {
      min: parseInt(min(deposits)),
      max: parseInt(max(deposits)),
      step: null,
      marks: depositMarks,
      dotStyle: {
        display: 'none'
      },
      value: depositAmount,
      onChange: function onChange(deposit) {
        onDepositChange(deposit);
      }
    }))), /*#__PURE__*/React.createElement("div", {
      className: "bg-lma-gray py-4 mb-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center"
    }, /*#__PURE__*/React.createElement("p", {
      className: "flex flex-1 truncate px-4 mb-2"
    }, t('Contract duration')), /*#__PURE__*/React.createElement("p", {
      className: "flex-none pr-4 text-right"
    }, (activeRate === null || activeRate === void 0 ? void 0 : activeRate.months) + ' ' + t('months'))), /*#__PURE__*/React.createElement("div", {
      className: "px-4 w-full md:w-72"
    }, /*#__PURE__*/React.createElement(Slider, {
      min: parseInt(min(availableMonths)),
      max: parseInt(max(availableMonths)),
      step: null,
      marks: monthMarks,
      dotStyle: {
        display: 'none'
      },
      value: monthsAmount,
      onChange: function onChange(months) {
        onMonthsChange(months);
      }
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center bg-lma-gray py-4 mb-4"
    }, /*#__PURE__*/React.createElement("p", {
      className: "flex flex-1 truncate px-4"
    }, t('Annual percentage rate (APR)')), /*#__PURE__*/React.createElement("p", {
      className: "flex-none pr-4 text-right"
    }, activeRate === null || activeRate === void 0 ? void 0 : activeRate.interest_rate, " %")), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center bg-lma-gray py-4 mb-4"
    }, /*#__PURE__*/React.createElement("p", {
      className: "flex flex-1 truncate px-4"
    }, t('Total amount after payment')), /*#__PURE__*/React.createElement("p", {
      className: "flex-none pr-4 text-right"
    }, "\u20AC ", formatNumberToMin2Digits(activeRate === null || activeRate === void 0 ? void 0 : activeRate.investment))), (activeRate === null || activeRate === void 0 ? void 0 : activeRate.balloon_rate) && (activeRate === null || activeRate === void 0 ? void 0 : activeRate.balloon_rate) !== undefined && /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center bg-lma-gray py-4 mb-4"
    }, /*#__PURE__*/React.createElement("p", {
      className: "flex flex-1 truncate px-4"
    }, t('Last monthly payment')), /*#__PURE__*/React.createElement("p", {
      className: "flex-none pr-4 text-right"
    }, "\u20AC ", formatNumberToMin2Digits(activeRate.balloon_rate))), renderLegalInfo());
  };
  return /*#__PURE__*/React.createElement(Fade, {
    duration: 300,
    spy: clientSettings.isProfessional
  }, clientSettings.isProfessional ? renderProfessionalBox() : renderPrivateBox());
};

var _initialFormData$2;
var FormFields$2 = {
  title: 'title',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  message: 'message',
  origin: 'origin',
  consent: 'consent',
  privacy: 'privacy'
};
var initialFormData$2 = (_initialFormData$2 = {}, _initialFormData$2[FormFields$2.title] = '', _initialFormData$2[FormFields$2.firstName] = '', _initialFormData$2[FormFields$2.lastName] = '', _initialFormData$2[FormFields$2.email] = '', _initialFormData$2[FormFields$2.phone] = '', _initialFormData$2[FormFields$2.message] = '', _initialFormData$2[FormFields$2.origin] = '', _initialFormData$2[FormFields$2.privacy] = false, _initialFormData$2);
var validator$2 = function validator(data, t) {
  var errors = {};
  if (!hasValue(data.title)) {
    errors[FormFields$2.title] = t('Title is required.');
  }
  if (!hasValue(data.firstName)) {
    errors[FormFields$2.firstName] = t('First name is required.');
  }
  if (!hasValue(data.lastName)) {
    errors[FormFields$2.lastName] = t('Last name is required.');
  }
  if (!hasValue(data.email)) {
    errors[FormFields$2.email] = t('Email address is required.');
  } else if (!isValidEmail(data.email)) {
    errors[FormFields$2.email] = t('Email address is not valid.');
  }
  if (!hasValue(data.phone)) {
    errors[FormFields$2.phone] = t('Phone is required.');
  }
  if (!hasValue(data.message)) {
    errors[FormFields$2.message] = t('Message is required.');
  }
  if (data.privacy === false) {
    errors[FormFields$2.privacy] = '';
  }
  return errors;
};
var submitDataMapper$2 = function submitDataMapper(formData, additionalData, context) {
  return {
    title: formData.title,
    first_name: formData.firstName,
    last_name: formData.lastName,
    email: formData.email,
    phone: formData.phone,
    message: formData.message,
    privacy: formData.privacy,
    vehicle: {
      id: additionalData.vehicle.id,
      reference: additionalData.vehicle.reference,
      identification: additionalData.vehicle.identification,
      vehicleUrl: hasWindow() ? window.location.href : ''
    },
    financial: additionalData.financialData ? {
      price: additionalData.financialData.price,
      deposit: additionalData.financialData.deposit,
      months: additionalData.financialData.months,
      financePrice: additionalData.financialData.financePrice,
      financeType: additionalData.financialData.financeType
    } : {}
  };
};
var OfferForm = function OfferForm(_ref) {
  var formData = _ref.formData,
    additionalData = _ref.additionalData,
    submit = _ref.submit,
    submitting = _ref.submitting,
    submitSuccess = _ref.submitSuccess,
    submitError = _ref.submitError,
    validationErrors = _ref.validationErrors,
    setFormValue = _ref.setFormValue,
    onClose = _ref.onClose,
    context = _ref.context,
    label = _ref.label;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAnalytics = useAnalytics(context),
    toolCompleteEventAnalytics = _useAnalytics.toolCompleteEventAnalytics;
  useEffect(function () {
    setMessageValue();
  }, []);
  useEffect(function () {
    if (submitSuccess || submitError) {
      if (submitSuccess) {
        toolCompleteEventAnalytics({
          vehicle: additionalData === null || additionalData === void 0 ? void 0 : additionalData.vehicle,
          toolType: additionalData === null || additionalData === void 0 ? void 0 : additionalData.toolType,
          toolName: additionalData === null || additionalData === void 0 ? void 0 : additionalData.toolName,
          toolStep: 'thank-you',
          toolStepOption: additionalData === null || additionalData === void 0 ? void 0 : additionalData.toolStepOption,
          requestType: additionalData === null || additionalData === void 0 ? void 0 : additionalData.requestType
        });
      }
    }
  }, [submitSuccess, submitError]);
  useEffect(function () {
    if (!isEmpty(validationErrors)) ;
  }, [validationErrors]);
  var setMessageValue = function setMessageValue() {
    var initMessage = initialMessage(context.culture);
    setFormValue(FormFields$2.message, initMessage);
  };
  return /*#__PURE__*/React.createElement("form", {
    id: "offer-form",
    action: "",
    className: "relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center w-full text-gray-800 mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 text-24 text-secondary font-bold"
  }, t('Request free offer')), /*#__PURE__*/React.createElement("i", {
    className: "fal fa-times text-xl cursor-pointer",
    onClick: onClose
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full text-secondary font-light mb-10"
  }, t('Send us your details and we will make you a nice proposal!')), validationErrors && validationErrors['result'] && /*#__PURE__*/React.createElement("div", {
    className: "mb-4 px-5 md:px-0",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: validationErrors['result']
  })), submitError && submitError !== '' && /*#__PURE__*/React.createElement("div", {
    className: "mb-4 px-5 md:px-0",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: submitError
  })), submitSuccess && /*#__PURE__*/React.createElement("div", {
    className: "px-5 md:px-0 absolute",
    style: {
      top: 40,
      right: '0.75rem',
      left: '0.75rem'
    }
  }, /*#__PURE__*/React.createElement(SuccessIndicator, {
    success: t('Your request has been sent!')
  })), /*#__PURE__*/React.createElement("div", {
    id: "offer-form-content",
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(RadioInput, {
    options: genderOptions(t),
    label: t('Title'),
    errorText: validationErrors[FormFields$2.title],
    value: formData.title,
    onChange: function onChange(value) {
      return setFormValue(FormFields$2.title, value);
    },
    required: true,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 md:mb-0 mr-1",
    inputClass: "rounded-4",
    label: t('First name'),
    placeholder: "John",
    value: formData.firstName,
    onChange: function onChange(value) {
      return setFormValue(FormFields$2.firstName, value);
    },
    errorText: validationErrors[FormFields$2.firstName],
    required: true
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 md:mb-0 ml-1",
    inputClass: "rounded-4",
    label: t('Last name'),
    placeholder: "Doe",
    value: formData.lastName,
    onChange: function onChange(value) {
      return setFormValue(FormFields$2.lastName, value);
    },
    errorText: validationErrors[FormFields$2.lastName],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: " mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full mb-2 md:mb-0",
    inputClass: "rounded-4",
    label: t('Email address'),
    placeholder: "john.doe@gmail.com",
    value: formData.email,
    onChange: function onChange(value) {
      return setFormValue(FormFields$2.email, value);
    },
    errorText: validationErrors[FormFields$2.email],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: " mb-5"
  }, /*#__PURE__*/React.createElement(PhoneInputField, {
    containerClass: "w-full mb-2 md:mb-0",
    inputClass: "rounded-4",
    label: t('Phone'),
    value: formData.phone,
    onChange: function onChange(value) {
      return setFormValue(FormFields$2.phone, value);
    },
    errorText: validationErrors[FormFields$2.phone],
    required: true,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-1"
  }, /*#__PURE__*/React.createElement(TextAreaField, {
    containerClass: "md:w-full md:mb-0",
    inputClass: "rounded-4",
    label: t('Message'),
    placeholder: t('I am interested in purchasing this car and would like to know if it is still available?'),
    value: formData.message,
    heightClass: "h-30",
    onChange: function onChange(value) {
      return setFormValue(FormFields$2.message, value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row w-full items-start md:items-center justify-between mt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center border-2 p-1 mr-2 w-6 h-6 cursor-pointer " + (validationErrors['privacy'] !== undefined ? 'border-red-400' : 'border-gray-200'),
    onClick: function onClick() {
      return setFormValue(FormFields$2.privacy, !formData.privacy);
    }
  }, formData.privacy && /*#__PURE__*/React.createElement("div", {
    className: "h-full w-full bg-primary"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex " + (validationErrors['privacy'] !== undefined ? 'text-red-400' : 'text-secondary')
  }, /*#__PURE__*/React.createElement("div", {
    className: "mr-2"
  }, t('I agree to the')), /*#__PURE__*/React.createElement(ExternalLink, {
    url: privacyUrl(context),
    className: "underline",
    context: context
  }, t('privacy terms'), "."))), /*#__PURE__*/React.createElement(BtnBasic, {
    onClick: submit,
    className: "mt-4 md:mt-0 self-end md:self-auto",
    disabled: submitting,
    text: submitting ? t('Sending') : t('Send'),
    label: label
  })));
};
var OfferForm$1 = baseDealerContactForm(DealerContactTypes.vehicleOffer, initialFormData$2, validator$2, submitDataMapper$2, OfferForm);

var Financing = function Financing(_ref) {
  var financingTypes = _ref.financingTypes,
    allAvailableFinancingTypes = _ref.allAvailableFinancingTypes,
    activeFinancingType = _ref.activeFinancingType,
    _onFinancingTypeChange = _ref.onFinancingTypeChange,
    depositAmount = _ref.depositAmount,
    monthsAmount = _ref.monthsAmount,
    onDepositChange = _ref.onDepositChange,
    onMonthsChange = _ref.onMonthsChange,
    activeRate = _ref.activeRate,
    vehicle = _ref.vehicle,
    label = _ref.label,
    context = _ref.context;
  var _useState = useState(false),
    offerFormVisible = _useState[0],
    setOfferFormVisible = _useState[1];
  var _useClientSettings = useClientSettings(),
    clientSettings = _useClientSettings.clientSettings;
  var isProfessional = clientSettings.isProfessional;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var CarFinanceRef = useRef();
  useContentBlockImpressionWhenInViewport(CarFinanceRef, 'financing', context);
  var renderOfferForm = function renderOfferForm() {
    var additionalData = {
      vehicle: vehicle
    };
    if (activeFinancingType.key !== FINANCING_TYPE_KEYS.LONG_TERM_RENTAL) {
      var financialData = {
        price: isProfessional ? formatNumber(vehicle === null || vehicle === void 0 ? void 0 : vehicle.priceExcl, 2, 2) : formatNumber(vehicle === null || vehicle === void 0 ? void 0 : vehicle.price, 2, 2),
        deposit: depositAmount,
        months: monthsAmount,
        financePrice: isProfessional ? formatNumber(vehicle === null || vehicle === void 0 ? void 0 : vehicle.price, 2, 2) : formatNumber(vehicle === null || vehicle === void 0 ? void 0 : vehicle.monthlyPrice, 2, 2),
        financeType: activeFinancingType
      };
      additionalData = {
        vehicle: vehicle,
        financialData: financialData,
        toolType: 'simulation',
        toolName: 'dealersite-financing',
        toolStepStart: 'financing-info',
        toolStepComplete: 'thank-you',
        toolStepError: 'financing-info',
        toolStepOption: financialData.financeType.key + " | " + financialData.financePrice + " | " + financialData.months,
        requestType: financialData.financeType.key === 'balloon' ? 'autocredit' : financialData.financeType.key === 'classic' ? 'classic-financing' : ''
      };
    }
    return /*#__PURE__*/React.createElement(OfferForm$1, {
      context: context,
      label: label,
      additionalData: additionalData,
      onClose: function onClose() {
        return setOfferFormVisible(false);
      }
    });
  };
  var hasPrivateValues = some(allAvailableFinancingTypes, function (ft) {
    var _ft$rates;
    return ft.type === 'private' && (ft === null || ft === void 0 ? void 0 : (_ft$rates = ft.rates) === null || _ft$rates === void 0 ? void 0 : _ft$rates.length) > 0;
  });
  var hasProfessionalValues = some(allAvailableFinancingTypes, function (ft) {
    var _ft$rates2;
    return ft.type === 'professional' && (ft === null || ft === void 0 ? void 0 : (_ft$rates2 = ft.rates) === null || _ft$rates2 === void 0 ? void 0 : _ft$rates2.length) > 0;
  });
  var showClientTypeSwitch = hasPrivateValues && hasProfessionalValues;
  return /*#__PURE__*/React.createElement("div", {
    ref: CarFinanceRef
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-secondary font-bold text-24 md:text-32 mb-5"
  }, t('Calculate your financing')), showClientTypeSwitch && /*#__PURE__*/React.createElement("div", {
    className: "mb-10"
  }, /*#__PURE__*/React.createElement(ClientTypeSwitch, {
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "border-0 lg:border p-0 lg:p-5",
    style: {
      borderColor: 'dfe7f5'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-10"
  }, /*#__PURE__*/React.createElement(FinancingTypes, {
    financingTypes: financingTypes,
    activeFinancingType: activeFinancingType,
    onFinancingTypeChange: function onFinancingTypeChange(key) {
      setOfferFormVisible(false);
      _onFinancingTypeChange(key);
    }
  })), !offerFormVisible && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FinancingAmounts, {
    vehicle: vehicle,
    rates: activeFinancingType === null || activeFinancingType === void 0 ? void 0 : activeFinancingType.rates,
    defaultRate: activeFinancingType === null || activeFinancingType === void 0 ? void 0 : activeFinancingType["default"],
    activeFinancingType: activeFinancingType,
    depositAmount: depositAmount,
    monthsAmount: monthsAmount,
    onDepositChange: onDepositChange,
    onMonthsChange: onMonthsChange,
    activeRate: activeRate,
    context: context,
    label: label
  }), /*#__PURE__*/React.createElement(BtnBasic, {
    onClick: function onClick() {
      return setOfferFormVisible(true);
    },
    className: "mt-4",
    text: t('Receive a free quote'),
    label: label
  })), offerFormVisible && renderOfferForm()));
};

var TAB_KEYS = {
  specification: 'content-specification',
  vehicleTracking: 'content-vehicle-tracking',
  options: 'content-options',
  financing: 'content-financing'
};
var ContentBase = function ContentBase(_ref) {
  var vehicle = _ref.vehicle,
    advertisement = _ref.advertisement,
    financingTypes = _ref.financingTypes,
    allAvailableFinancingTypes = _ref.allAvailableFinancingTypes,
    activeFinancingType = _ref.activeFinancingType,
    onFinancingTypeChange = _ref.onFinancingTypeChange,
    depositAmount = _ref.depositAmount,
    monthsAmount = _ref.monthsAmount,
    onDepositChange = _ref.onDepositChange,
    onMonthsChange = _ref.onMonthsChange,
    activeRate = _ref.activeRate,
    context = _ref.context;
  var _useState = useState(TAB_KEYS.specification),
    currentTab = _useState[0],
    setCurrentTab = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var financingEnabled = context.financing;
  var scrollToTab = function scrollToTab(key) {
    if (hasDocument()) {
      var el = getElementByClassName(key);
      if (el) {
        scrollToTargetV2(el);
      }
    }
  };
  var headerTabs = [{
    key: TAB_KEYS.specification,
    label: t('Specifications')
  }, {
    key: TAB_KEYS.vehicleTracking,
    label: t('Vehicle tracking')
  }, {
    key: TAB_KEYS.options,
    label: t('Options')
  }, {
    key: TAB_KEYS.financing,
    label: t('Financing')
  }];
  var financingBlockVisible = !!financingEnabled && (activeFinancingType.key === FINANCING_TYPE_KEYS.LONG_TERM_RENTAL || !!activeRate);
  var CarSpecsRef = useRef();
  useContentBlockImpressionWhenInViewport(CarSpecsRef, 'vehicle-details', context);
  var CarEquipmentRef = useRef();
  useContentBlockImpressionWhenInViewport(CarEquipmentRef, 'equipment', context);
  var CarQuotationRef = useRef();
  useContentBlockImpressionWhenInViewport(CarQuotationRef, 'car-quotation', context);
  return /*#__PURE__*/React.createElement("div", {
    className: "py-5 md:py-13"
  }, /*#__PURE__*/React.createElement(ContentHeader, {
    headerTabs: financingBlockVisible ? headerTabs : filter(headerTabs, function (t) {
      return t.key !== TAB_KEYS.financing;
    }),
    currentTab: currentTab,
    changeTab: function changeTab(key) {
      setCurrentTab(key);
      scrollToTab(key);
    },
    context: context
  }), /*#__PURE__*/React.createElement("div", {
    className: TAB_KEYS.specification + " mt-16",
    ref: CarSpecsRef
  }, /*#__PURE__*/React.createElement(Specifications, {
    vehicle: vehicle,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: TAB_KEYS.vehicleTracking + " mt-16"
  }, /*#__PURE__*/React.createElement(Tracking, {
    vehicle: vehicle,
    context: context
  })), advertisement && advertisement !== '' && /*#__PURE__*/React.createElement("div", {
    className: "mt-16",
    ref: CarQuotationRef
  }, /*#__PURE__*/React.createElement(AdvertiseComponent$1, {
    groupName: advertisement,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: TAB_KEYS.options + " mt-16",
    ref: CarEquipmentRef
  }, /*#__PURE__*/React.createElement(Options, {
    vehicle: vehicle,
    context: context
  })), financingBlockVisible && /*#__PURE__*/React.createElement("div", {
    className: TAB_KEYS.financing + " finance-id-" + vehicle.identification + " mt-16"
  }, /*#__PURE__*/React.createElement(Financing, {
    vehicle: vehicle,
    financingTypes: financingTypes,
    allAvailableFinancingTypes: allAvailableFinancingTypes,
    activeFinancingType: activeFinancingType,
    onFinancingTypeChange: onFinancingTypeChange,
    depositAmount: depositAmount,
    monthsAmount: monthsAmount,
    onDepositChange: onDepositChange,
    onMonthsChange: onMonthsChange,
    activeRate: activeRate,
    context: context
  })));
};

var DetailsRightSkeleton = function DetailsRightSkeleton() {
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-0 py-2 md:px-50px md:py-50px lg:px-30px lg:py-30px lg2:px-50px lg2:py-50px mb-8 md:shadow-bs-myway"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block paragraph-small text-secondary-four leading-2.3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-4 w-30 mr-2 mb-3"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-4 w-40 mb-6"
  })), /*#__PURE__*/React.createElement("div", {
    className: "title flex w-full mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-8 w-40 mr-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-8 w-40"
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-24 w-full"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-24 w-full"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex w-full mt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-2 w-40 mr-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-2 w-40"
  })), /*#__PURE__*/React.createElement("div", {
    className: "title flex w-full mt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-8 w-1/2 mr-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-8 w-1/2"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full mt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-8 w-40 mb-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-6 w-30 mb-3"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-4 w-40 mb-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-4 w-40"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "hidden lg2:flex items-center justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 340,
      height: 480
    },
    className: "bg-gray-200 animate-pulse"
  })));
};
var Skeleton = function Skeleton() {
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex py-7 px-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-4 w-20 md:w-40 mr-7"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-4 w-10 md:w-20 mr-4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-4 w-10 md:w-20 mr-4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-4 w-10 md:w-20"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col lg:flex-row px-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full lg:w-2/3 lg:mr-5 md:flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col overflow-hidden h-300 md:h-650"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse w-full h-full"
  }), /*#__PURE__*/React.createElement("div", {
    className: "space-x-2 mt-4 hidden md:flex",
    style: {
      height: 150
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: '25%',
      height: 150
    },
    className: "bg-gray-200 animate-pulse"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '25%',
      height: 150
    },
    className: "bg-gray-200 animate-pulse"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '25%',
      height: 150
    },
    className: "bg-gray-200 animate-pulse"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '25%',
      height: 150
    },
    className: "bg-gray-200 animate-pulse"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex md:hidden flex flex-col mt-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-4 w-40 mb-3.5"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-4 w-20"
  })), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:grid grid-cols-4 gap-4 py-10 paragraph-xsmall w-full border-b mb-10"
  }, times(4, function (index) {
    return /*#__PURE__*/React.createElement("div", {
      key: 'skeleton-faq-' + index,
      className: "h-5 bg-gray-200 animate-pulse"
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "block md:hidden w-full"
  }, /*#__PURE__*/React.createElement(DetailsRightSkeleton, null)), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-8 w-80 bg-gray-200 animate-pulse mb-8"
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, times(16, function (item) {
    var isLast = item === 16;
    return /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 py-0 md:py-3 text-secondary border-gray-100 " + (isLast ? 'border-none' : 'border-none md:border-b '),
      key: "spec-" + item
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-start h-5 w-56 bg-gray-200 animate-pulse"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-end"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-5 w-40  bg-gray-200 animate-pulse"
    })));
  })))), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block w-full lg:w-1/3 md:mt-5 lg:mt-0 shadow-sm"
  }, /*#__PURE__*/React.createElement(DetailsRightSkeleton, null)))));
};

var VIEWS = {
  images: 'images',
  images360: 'images360'
};
var ImageViewerSwitch = function ImageViewerSwitch(_ref) {
  var currentView = _ref.currentView,
    onSwitchType = _ref.onSwitchType;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "rounded-full inline-flex h-10 sm:py-1 relative",
    style: {
      background: '#f2f2f2'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute top-0 w-27 " + (currentView === VIEWS.images360 ? 'transform translate-x-0' : 'transform translate-x-27') + " bg-secondary rounded-full shadow-xl h-12 -mt-1 transition-transform",
    style: {
      zIndex: 1
    }
  }), /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      if (currentView !== VIEWS.images360) {
        onSwitchType(VIEWS.images360);
      }
    },
    className: "flex-none flex justify-center items-center w-27 cursor-pointer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative transition-colors truncate px-1 text-base\n              " + (currentView === VIEWS.images360 ? 'text-white' : 'text-secondary') + "\n            ",
    style: {
      zIndex: 2
    }
  }, "360")), /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      if (currentView !== VIEWS.images) {
        onSwitchType(VIEWS.images);
      }
    },
    className: "flex-none flex justify-center items-center w-27 cursor-pointer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative transition-colors truncate px-1 text-base\n              " + (currentView === VIEWS.images ? 'text-white' : 'text-secondary') + "\n            ",
    style: {
      zIndex: 2
    }
  }, t('Images'))));
};
ImageViewerSwitch.defaultProps = {
  baseState: false
};

var VIEWS$1 = {
  images: 'images',
  images360: 'images360'
};
var ImageViewer360 = function ImageViewer360(_ref) {
  var images = _ref.images,
    images360 = _ref.images360;
  var _useState = useState(0),
    currentIndex = _useState[0],
    setCurrentIndex = _useState[1];
  var _useState2 = useState(images360 && images360.length > 0 ? VIEWS$1.images360 : VIEWS$1.images),
    currentView = _useState2[0],
    setCurrentView = _useState2[1];
  var _useState3 = useState(false),
    hoveringViewer = _useState3[0],
    setHoveringViewer = _useState3[1];
  var _useState4 = useState(false),
    lightboxVisible = _useState4[0],
    setLightboxVisible = _useState4[1];
  var mapVehicleImagesForViewer = function mapVehicleImagesForViewer(images) {
    var isArray = images instanceof Array;
    return isArray ? images.map(function (img) {
      return img === null || img === void 0 ? void 0 : img.uri;
    }) : [images === null || images === void 0 ? void 0 : images.uri];
  };
  useEffect(function () {
    if (currentView === VIEWS$1.images360 && currentIndex !== 0) {
      setCurrentView(VIEWS$1.images);
    }
  }, [currentIndex]);
  var getThumbs = function getThumbs() {
    var thumbs = [];
    forEach(images, function (image, index) {
      thumbs.push(/*#__PURE__*/React.createElement("div", {
        className: "cursor-pointer flex w-full"
      }, /*#__PURE__*/React.createElement("img", {
        key: "thumbnail-" + index,
        src: (image === null || image === void 0 ? void 0 : image.uri) + "?width=200",
        alt: "Vehicle thumbnail",
        title: "Vehicle thumbnail",
        className: "w-full"
      })));
    });
    return thumbs;
  };
  var renderViewerArrows = function renderViewerArrows(handlePrevClick, handleNextClick, currentIndex) {
    return /*#__PURE__*/React.createElement("div", {
      className: "text-white transition-opacity " + (hoveringViewer ? 'opacity-100' : 'opacity-0')
    }, currentIndex > 0 && /*#__PURE__*/React.createElement("div", {
      className: "bg-secondary flex items-center justify-center cursor-pointer z-20 absolute left-5 rounded-full",
      style: {
        width: 44,
        height: 44,
        top: '50%',
        transform: 'translateY(-50%)'
      },
      onClick: function onClick(e) {
        e.preventDefault();
        handlePrevClick(e);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-chevron-left"
    })), currentIndex < images.length - 1 && /*#__PURE__*/React.createElement("div", {
      className: "bg-secondary flex items-center justify-center cursor-pointer z-20 absolute right-5 rounded-full",
      style: {
        width: 44,
        height: 44,
        top: '50%',
        transform: 'translateY(-50%)'
      },
      onClick: function onClick(e) {
        e.preventDefault();
        handleNextClick(e);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-chevron-right"
    })));
  };
  var renderViewer = function renderViewer() {
    return /*#__PURE__*/React.createElement(Fade, {
      spy: currentView,
      duration: 200
    }, /*#__PURE__*/React.createElement("div", {
      className: "absolute inset-0 bg-gray-200 animate-pulse"
    }), /*#__PURE__*/React.createElement("div", {
      className: "absolute inset-0",
      onMouseEnter: function onMouseEnter() {
        return setHoveringViewer(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setHoveringViewer(false);
      }
    }, currentView === VIEWS$1.images && /*#__PURE__*/React.createElement(ImageViewer, {
      images: mapVehicleImagesForViewer(images),
      currentIndex: currentIndex,
      onCurrentIndexChanged: function onCurrentIndexChanged(index) {
        return setCurrentIndex(index);
      },
      onClick: function onClick() {
        return setLightboxVisible(true);
      },
      renderArrows: renderViewerArrows
    }), currentView === VIEWS$1.images360 && /*#__PURE__*/React.createElement(Turntable, {
      images: map(images360, function (image) {
        return image === null || image === void 0 ? void 0 : image.uri;
      })
    })));
  };
  var onThumbnailClick = function onThumbnailClick(index) {
    if (index !== currentIndex && index >= 0) {
      setCurrentIndex(index);
    }
  };
  var onArrowClick = function onArrowClick(next) {
    var newIndex;
    next ? newIndex = currentIndex + 1 : newIndex = currentIndex - 1;
    if (newIndex >= 0 && newIndex < (images === null || images === void 0 ? void 0 : images.length)) {
      setCurrentIndex(newIndex);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, lightboxVisible && /*#__PURE__*/React.createElement(ImageLightBox, {
    images: mapVehicleImagesForViewer(images),
    currentIndex: currentIndex,
    onClose: function onClose() {
      return setLightboxVisible(false);
    },
    onIndexChanged: function onIndexChanged(index) {
      return setCurrentIndex(index);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative ",
    style: {
      paddingTop: '75%'
    }
  }, renderViewer(), images360 && images360.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "absolute top-5 left-5 z-10"
  }, /*#__PURE__*/React.createElement(ImageViewerSwitch, {
    currentView: currentView,
    onSwitchType: function onSwitchType(type) {
      return setCurrentView(type);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:block relative mt-5"
  }, /*#__PURE__*/React.createElement(ImageThumbnails, {
    type: "horizontal",
    currentIndex: currentIndex,
    items: getThumbs(),
    onItemClick: onThumbnailClick
  }), currentIndex > 0 && /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary flex items-center justify-center cursor-pointer z-20 absolute left-0 rounded-r",
    style: {
      width: 25,
      height: 35,
      top: '50%',
      transform: 'translateY(-50%)'
    },
    onClick: function onClick() {
      return onArrowClick(false);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-chevron-left text-white"
  })), currentIndex < images.length - 1 && /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary flex items-center justify-center cursor-pointer z-20 absolute right-0 rounded-l",
    style: {
      width: 25,
      height: 35,
      top: '50%',
      transform: 'translateY(-50%)'
    },
    onClick: function onClick() {
      return onArrowClick(true);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-chevron-right text-white"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex lg:hidden my-3",
    style: {
      height: 2,
      background: '#e3e3e3'
    }
  }, map(images, function (image, index) {
    if (index === currentIndex) {
      return /*#__PURE__*/React.createElement("div", {
        className: "h-2px flex-1",
        style: {
          background: '#0d3b5c'
        }
      });
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: "py-4 flex-1 cursor-pointer",
        onClick: function onClick() {
          try {
            var _temp2 = function _temp2() {
              setCurrentIndex(index);
            };
            var _temp = function () {
              if (currentView !== VIEWS$1.images) {
                return Promise.resolve(setCurrentView(VIEWS$1.images)).then(function () {});
              }
            }();
            return Promise.resolve(_temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp));
          } catch (e) {
            return Promise.reject(e);
          }
        }
      });
    }
  }))));
};

var VEHICLE_QUERY = "query Vehicle ($reference: String!) {\n  vehicle (reference: $reference) {\n        id\n        reference\n        vin\n        identification\n        language\n        creationDate\n        lastUpdate\n        \n        make\n        model\n        modelFamily\n        version\n        firstRegistrationMonth\n        firstRegistrationYear\n        mileage\n        doors\n        seats\n        kw\n        hp\n        engineCc\n        co2\n        euroNorm\n        interiorColor\n        exteriorColor\n        \n        \n        category\n        body\n        fuel\n        gearbox\n        \n        images\n        images360\n        images360SpinnerUrl\n        equipments\n        comments\n        \n        financeRates\n        defaultFinanceRate\n        balloonRates\n        defaultBalloonRate\n        leaseRates\n        defaultLeaseRate\n        rentingRates\n        defaultRentingRate\n        \n        price\n        priceExcl\n        brutoPrice\n        tradeInDiscount\n        monthlyPrice\n        monthlyPriceType\n        monthlyLastPayment\n        monthlyPriceProf\n        monthlyPriceTypeProf\n        \n        sold\n        carpass\n        warranty\n        vatRegime\n        deliveryCost\n        \n        reserved\n        labels\n        labelsV2 {\n          key\n          name\n          logo\n          warrantyData\n        }\n        \n        dealer {\n            name\n            legalName\n            reference\n            externalReference  \n            analyticsDealerId          \n            group {\n              name\n              legalName\n              reference\n              externalReference\n              consentEntitiesExternal\n              dealerships {\n                name\n                legalName\n              }\n            }\n            isPartOfManufacturer\n            address\n            postal\n            city\n            tel\n            contactUrl\n            videoCallUrl\n            appointmentUrl\n            mobile\n        }\n        \n        makeKey\n        makeFamilyKey\n        modelKey\n        modelFamilyKey\n        bodyKey\n        gearboxKey\n        categoryKey\n        fuelKey\n        exteriorColorKey\n        interiorColorKey\n        interiorUpholsteryKey\n        availability\n        segmentKey\n        productsAndServices {\n          code\n          offeringType\n          name\n          priceIncl\n          priceExcl\n          description\n        }\n  }\n}";
var labelAdvertisements = [{
  name: 'label'
}];
var resolveBrandingByVehicle = function resolveBrandingByVehicle(vehicle) {
  if (!vehicle) return undefined;
  return getBrandByLabelsV2(vehicle.labelsV2);
};
var resolveLabelAdvertisementByBrandV2 = function resolveLabelAdvertisementByBrandV2(brand, label) {
  return label + "-" + brand;
};
var getAdvertisementByLocation = function getAdvertisementByLocation(advertisements, location, brand) {
  if (!advertisements || advertisements.length === 0) {
    return undefined;
  }
  if (brand === BRANDING.aap) {
    return "vehicle-detail-" + location + "-aap";
  } else {
    return "vehicle-detail-" + location + "-myway";
  }
};
var getBackgroundByBrandingLabel = function getBackgroundByBrandingLabel(label) {
  switch (label) {
    case BRANDING.myway:
      return 'bg-myway-darker';
    case BRANDING.aap:
      return 'bg-aap-gray';
    default:
      return 'bg-lma-gray';
  }
};
var VehicleDetail = function VehicleDetail(_ref) {
  var vehicle = _ref.vehicle,
    loading = _ref.loading,
    error = _ref.error,
    advertisements = _ref.advertisements,
    context = _ref.context;
  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-screen"
    }, /*#__PURE__*/React.createElement(Skeleton, null));
  }
  if (error) {
    return /*#__PURE__*/React.createElement("div", {
      className: "container mx-auto px-5"
    }, /*#__PURE__*/React.createElement(ErrorIndicator, {
      error: error
    }));
  }
  var _useClientSettings = useClientSettings(),
    clientSettings = _useClientSettings.clientSettings;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState({
      label: undefined
    }),
    branding = _useState[0],
    setBranding = _useState[1];
  var _useState2 = useState({
      key: 'no-financing-type',
      title: '',
      rates: [],
      "default": []
    }),
    activeFinancingType = _useState2[0],
    setActiveFinancingType = _useState2[1];
  var _useState3 = useState(0),
    depositAmount = _useState3[0],
    setDepositAmount = _useState3[1];
  var _useState4 = useState(0),
    monthsAmount = _useState4[0],
    setMonthsAmount = _useState4[1];
  var _useState5 = useState(null),
    activeRate = _useState5[0],
    setActiveRate = _useState5[1];
  var _useState6 = useState([]),
    financingTypes = _useState6[0],
    setFinancingTypes = _useState6[1];
  var FINANCING_TYPES = [{
    key: FINANCING_TYPE_KEYS.CLASSIC,
    type: 'private',
    title: t('Classic financing'),
    disclaimer: '1',
    rates: vehicle === null || vehicle === void 0 ? void 0 : vehicle.financeRates,
    "default": vehicle !== null && vehicle !== void 0 && vehicle.defaultFinanceRate ? vehicle.defaultFinanceRate : vehicle.financeRates[0]
  }, {
    key: FINANCING_TYPE_KEYS.BALLOON,
    type: 'private',
    title: t('AutoCredit'),
    disclaimer: '1',
    rates: vehicle === null || vehicle === void 0 ? void 0 : vehicle.balloonRates,
    "default": vehicle !== null && vehicle !== void 0 && vehicle.defaultBalloonRate ? vehicle.defaultBalloonRate : vehicle.balloonRates[0]
  }, {
    key: FINANCING_TYPE_KEYS.LEASE,
    type: 'professional',
    title: t('Financial leasing'),
    disclaimer: '2',
    rates: vehicle === null || vehicle === void 0 ? void 0 : vehicle.leaseRates,
    "default": vehicle !== null && vehicle !== void 0 && vehicle.defaultLeaseRate ? vehicle.defaultLeaseRate : vehicle.leaseRates[0]
  }, {
    key: FINANCING_TYPE_KEYS.RENT,
    type: 'professional',
    title: t('Financial renting'),
    disclaimer: '2',
    rates: vehicle === null || vehicle === void 0 ? void 0 : vehicle.rentingRates,
    "default": vehicle !== null && vehicle !== void 0 && vehicle.defaultRentingRate ? vehicle.defaultRentingRate : vehicle.rentingRates[0]
  }, {
    key: FINANCING_TYPE_KEYS.LONG_TERM_RENTAL,
    type: 'professional',
    title: t('Long term rental'),
    disclaimer: '2',
    rates: [],
    "default": []
  }];
  var setRatesAndFinanceTypeData = function setRatesAndFinanceTypeData(rates, type) {
    var defaultRate = find(rates, function (fr) {
      return fr["default"];
    });
    var activeRate = defaultRate ? defaultRate : head(rates);
    setActiveRate(activeRate);
    setActiveFinancingType(find(FINANCING_TYPES, function (ft) {
      return ft.key === type;
    }));
  };
  var resetRatesAndFinanceTypeToDefault = function resetRatesAndFinanceTypeToDefault() {
    setActiveRate(undefined);
    setActiveFinancingType({
      key: 'no-finance-type',
      title: '',
      rates: [],
      "default": []
    });
    setFinancingTypes([]);
  };
  useEffect(function () {
    if (hasWindow()) {
      if (!window.location.hash) {
        window.scrollTo({
          top: 0,
          behavior: 'instant'
        });
      }
    }
  }, []);
  useEffect(function () {
    if (hasWindow() && hasDocument()) {
      if (window.location.hash) {
        var el = getElementByClassName("finance-id-" + vehicle.identification);
        if (el) {
          var stickiesOffset = getStickiesOffset() + getStickiesOffset('content-base-header');
          scrollToTargetV2(el, stickiesOffset, 'instant');
        }
      }
    }
  }, [activeFinancingType, activeRate]);
  var setRatesAndFinanceType = function setRatesAndFinanceType() {
    if (clientSettings.isProfessional) {
      var _vehicle$rentingRates, _vehicle$leaseRates;
      if ((vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$rentingRates = vehicle.rentingRates) === null || _vehicle$rentingRates === void 0 ? void 0 : _vehicle$rentingRates.length) > 0) {
        setRatesAndFinanceTypeData(vehicle.rentingRates, 'rent');
      } else if ((vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$leaseRates = vehicle.leaseRates) === null || _vehicle$leaseRates === void 0 ? void 0 : _vehicle$leaseRates.length) > 0) {
        setRatesAndFinanceTypeData(vehicle.leaseRates, 'lease');
      } else {
        resetRatesAndFinanceTypeToDefault();
      }
    } else {
      var _vehicle$balloonRates, _vehicle$financeRates;
      if ((vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$balloonRates = vehicle.balloonRates) === null || _vehicle$balloonRates === void 0 ? void 0 : _vehicle$balloonRates.length) > 0) {
        setRatesAndFinanceTypeData(vehicle.balloonRates, 'balloon');
      } else if ((vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$financeRates = vehicle.financeRates) === null || _vehicle$financeRates === void 0 ? void 0 : _vehicle$financeRates.length) > 0) {
        setRatesAndFinanceTypeData(vehicle.financeRates, 'classic');
      } else {
        resetRatesAndFinanceTypeToDefault();
      }
    }
  };
  var MobileVehicleImageRef = useRef();
  useContentBlockImpressionWhenInViewport(MobileVehicleImageRef, 'vehicle-image', context);
  var DesktopVehicleImageRef = useRef();
  useContentBlockImpressionWhenInViewport(DesktopVehicleImageRef, 'vehicle-image', context);
  var MobileCarDetailsRef = useRef();
  useContentBlockImpressionWhenInViewport(MobileCarDetailsRef, 'vehicle-summary', context);
  var DesktopCarDetailsRef = useRef();
  useContentBlockImpressionWhenInViewport(DesktopCarDetailsRef, 'vehicle-summary', context);
  var MobileCarUSPRef = useRef();
  useContentBlockImpressionWhenInViewport(MobileCarUSPRef, 'usp', context);
  var DesktopCarUSPRef = useRef();
  useContentBlockImpressionWhenInViewport(DesktopCarUSPRef, 'usp', context);
  useEffect(function () {
    setBranding({
      label: resolveBrandingByVehicle(vehicle)
    });
    setRatesAndFinanceType();
  }, [vehicle]);
  useEffect(function () {
    setActiveRate(findCorrectRate(depositAmount, monthsAmount));
  }, [depositAmount, monthsAmount]);
  useEffect(function () {
    var type = clientSettings.isProfessional ? 'professional' : 'private';
    setFinancingTypes(filter(FINANCING_TYPES, function (ft) {
      return ft.type === type;
    }));
    setRatesAndFinanceType();
  }, [clientSettings]);
  var findCorrectRate = function findCorrectRate(deposit, months) {
    return find(activeFinancingType === null || activeFinancingType === void 0 ? void 0 : activeFinancingType.rates, {
      deposit: deposit === null || deposit === void 0 ? void 0 : deposit.toString(),
      months: months === null || months === void 0 ? void 0 : months.toString()
    });
  };
  var renderMobile = function renderMobile() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: getBackgroundByBrandingLabel(branding === null || branding === void 0 ? void 0 : branding.label) + " " + ((branding === null || branding === void 0 ? void 0 : branding.label) === BRANDING.myway ? 'text-white' : 'text-secondary')
    }, /*#__PURE__*/React.createElement(BreadcrumbsDetailMobile, {
      branding: branding === null || branding === void 0 ? void 0 : branding.label,
      context: context
    }), /*#__PURE__*/React.createElement("div", {
      className: "container pb-6"
    }, /*#__PURE__*/React.createElement(TitleDetail, {
      make: vehicle === null || vehicle === void 0 ? void 0 : vehicle.make,
      model: vehicle === null || vehicle === void 0 ? void 0 : vehicle.model,
      version: vehicle === null || vehicle === void 0 ? void 0 : vehicle.version,
      identification: vehicle === null || vehicle === void 0 ? void 0 : vehicle.identification
    }))), /*#__PURE__*/React.createElement("div", {
      className: "relative"
    }, /*#__PURE__*/React.createElement("div", {
      className: "absolute -top-1 " + getBackgroundByBrandingLabel(branding === null || branding === void 0 ? void 0 : branding.label) + " w-full h-2/3"
    }), /*#__PURE__*/React.createElement("div", {
      className: "container",
      ref: MobileVehicleImageRef
    }, /*#__PURE__*/React.createElement(ImageViewer360, {
      images: vehicle === null || vehicle === void 0 ? void 0 : vehicle.images,
      images360: vehicle === null || vehicle === void 0 ? void 0 : vehicle.images360,
      context: context
    }))), /*#__PURE__*/React.createElement("div", {
      className: "container py-6",
      ref: MobileCarDetailsRef
    }, /*#__PURE__*/React.createElement(PriceCard, {
      vehicle: vehicle,
      label: branding === null || branding === void 0 ? void 0 : branding.label,
      context: context,
      activeRate: activeRate,
      activeFinancingType: activeFinancingType
    })), /*#__PURE__*/React.createElement("div", {
      className: "container"
    }, /*#__PURE__*/React.createElement(ContentBase, {
      vehicle: vehicle,
      advertisement: getAdvertisementByLocation(advertisements, 1, branding.label),
      activeFinancingType: activeFinancingType,
      financingTypes: financingTypes,
      allAvailableFinancingTypes: FINANCING_TYPES,
      activeRate: activeRate,
      onFinancingTypeChange: function onFinancingTypeChange(key) {
        var currentFinancingType = find(FINANCING_TYPES, function (ft) {
          return ft.key === key;
        });
        if (currentFinancingType) {
          setActiveFinancingType(currentFinancingType);
          setRatesAndFinanceTypeData(currentFinancingType.rates, currentFinancingType.key);
        }
      },
      depositAmount: depositAmount,
      monthsAmount: monthsAmount,
      onDepositChange: function onDepositChange(deposit) {
        return setDepositAmount(deposit);
      },
      onMonthsChange: function onMonthsChange(months) {
        return setMonthsAmount(months);
      },
      label: branding === null || branding === void 0 ? void 0 : branding.label,
      context: context
    })), (branding === null || branding === void 0 ? void 0 : branding.label) && /*#__PURE__*/React.createElement("div", {
      className: "w-full space-y-5",
      ref: MobileCarUSPRef
    }, map(labelAdvertisements, function (item) {
      return /*#__PURE__*/React.createElement(AdvertiseComponent$1, {
        groupName: resolveLabelAdvertisementByBrandV2(branding.label, item.name),
        vehicleReference: vehicle.reference,
        context: context
      });
    })));
  };
  var renderDesktop = function renderDesktop() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: getBackgroundByBrandingLabel(branding === null || branding === void 0 ? void 0 : branding.label) + " " + ((branding === null || branding === void 0 ? void 0 : branding.label) === BRANDING.myway ? 'text-white' : 'text-secondary')
    }, /*#__PURE__*/React.createElement(BreadcrumbsDetailDesktop, {
      branding: branding === null || branding === void 0 ? void 0 : branding.label,
      make: vehicle === null || vehicle === void 0 ? void 0 : vehicle.make,
      model: vehicle === null || vehicle === void 0 ? void 0 : vehicle.model,
      version: vehicle === null || vehicle === void 0 ? void 0 : vehicle.version,
      context: context
    })), /*#__PURE__*/React.createElement("div", {
      className: "relative"
    }, /*#__PURE__*/React.createElement("div", {
      className: "absolute -top-1 " + getBackgroundByBrandingLabel(branding === null || branding === void 0 ? void 0 : branding.label) + " w-full h-24 z-0"
    }), /*#__PURE__*/React.createElement("div", {
      className: "container flex relative"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-1 overflow-x-hidden",
      ref: DesktopVehicleImageRef
    }, /*#__PURE__*/React.createElement(ImageViewer360, {
      images: vehicle === null || vehicle === void 0 ? void 0 : vehicle.images,
      images360: vehicle === null || vehicle === void 0 ? void 0 : vehicle.images360,
      context: context
    }), /*#__PURE__*/React.createElement(ContentBase, {
      vehicle: vehicle,
      advertisement: getAdvertisementByLocation(advertisements, 1, branding.label),
      activeFinancingType: activeFinancingType,
      financingTypes: financingTypes,
      allAvailableFinancingTypes: FINANCING_TYPES,
      activeRate: activeRate,
      onFinancingTypeChange: function onFinancingTypeChange(key) {
        var currentFinancingType = find(FINANCING_TYPES, function (ft) {
          return ft.key === key;
        });
        if (currentFinancingType) {
          setActiveFinancingType(currentFinancingType);
          setRatesAndFinanceTypeData(currentFinancingType.rates, currentFinancingType.key);
        }
      },
      depositAmount: depositAmount,
      monthsAmount: monthsAmount,
      onDepositChange: function onDepositChange(deposit) {
        return setDepositAmount(deposit);
      },
      onMonthsChange: function onMonthsChange(months) {
        return setMonthsAmount(months);
      },
      label: branding === null || branding === void 0 ? void 0 : branding.label,
      context: context
    })), /*#__PURE__*/React.createElement("div", {
      className: "pl-4 flex-none",
      style: {
        width: 450
      },
      ref: DesktopCarDetailsRef
    }, /*#__PURE__*/React.createElement(PriceCard, {
      vehicle: vehicle,
      label: branding === null || branding === void 0 ? void 0 : branding.label,
      context: context,
      activeRate: activeRate,
      activeFinancingType: activeFinancingType
    }), (branding === null || branding === void 0 ? void 0 : branding.label) && /*#__PURE__*/React.createElement("div", {
      className: "vehicle-right mt-5 space-y-5",
      ref: DesktopCarUSPRef
    }, map(labelAdvertisements, function (item) {
      return /*#__PURE__*/React.createElement(AdvertiseComponent$1, {
        groupName: resolveLabelAdvertisementByBrandV2(branding.label, item.name),
        vehicleReference: vehicle.reference,
        context: context
      });
    }))))), /*#__PURE__*/React.createElement("div", {
      className: "opacity-0 details-page-bottom"
    }), branding.label && /*#__PURE__*/React.createElement(AdvertiseComponent$1, {
      groupName: branding.label,
      vehicleReference: vehicle.reference,
      context: context
    }));
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "block lg:hidden"
  }, renderMobile()), /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:block"
  }, renderDesktop()));
};
var VehicleDetail$1 = baseVehicleDetail(VehicleDetail, {
  query: VEHICLE_QUERY
});

var VehicleDetailWithAdds = function VehicleDetailWithAdds(_ref) {
  var reference = _ref.reference,
    advertisements = _ref.advertisements,
    context = _ref.context,
    resolveAnalyticsData = _ref.resolveAnalyticsData;
  return /*#__PURE__*/React.createElement("div", {
    className: "max-w-screen-2xl mx-auto with-financing"
  }, /*#__PURE__*/React.createElement(VehicleDetail$1, {
    reference: reference,
    additional_vehicle_images: [],
    advertisements: advertisements,
    resolveAnalyticsData: resolveAnalyticsData,
    context: context
  }));
};
VehicleDetailWithAdds.defaultProps = {
  calculate_value_action: DefaultPrimaryAction,
  additional_vehicle_images: DefaultAdditionalVehicleImages
};
VehicleDetailWithAdds.human = {
  nl: '',
  fr: '',
  en: ''
};
VehicleDetailWithAdds.preview = function () {
  return /*#__PURE__*/React.createElement("div", null, "Vehicle Detail");
};

var FilterTemplate = function FilterTemplate(_ref) {
  var handleToggle = _ref.handleToggle,
    isVisible = _ref.isVisible,
    label = _ref.label,
    zIndex = _ref.zIndex,
    children = _ref.children;
  var style = zIndex ? {
    zIndex: zIndex,
    position: 'relative'
  } : {};
  return /*#__PURE__*/React.createElement("div", {
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between cursor-pointer text-secondary pb-5 bg-white border-b border-gray-100 overflow-hidden",
    onClick: handleToggle
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 font-bold text-20"
  }, label), /*#__PURE__*/React.createElement("i", {
    className: "fal " + (isVisible ? 'fa-angle-up' : 'fa-angle-down'),
    style: {
      marginTop: 2,
      fontSize: 26
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "transition-all transform " + (isVisible ? 'opacity-100 translate-y-0 h-full pt-5 pb-3' : 'h-0 -z-10 opacity-0 -translate-y-full'),
    style: style
  }, isVisible && children));
};

var EcoFriendlyFilter = function EcoFriendlyFilter(_ref) {
  var filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var data = {
    label: t('Electric and hybrid vehicles'),
    value: 'eco-friendly'
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
    label: t('Eco friendly'),
    onClick: function onClick(value, e) {
      e.preventDefault();
      e.stopPropagation();
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value, data.label);
      } else {
        filterAdd(data.value, data.label);
      }
    },
    checked: includes(filterValues, data.value)
  }));
};
var EcoFriendlyFilter$1 = baseTypedFilter(FilterTypes.tags, EcoFriendlyFilter);

var BodiesFilter = function BodiesFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    isVisible = _ref.isVisible,
    handleToggle = _ref.handleToggle;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleFilterChange = function handleFilterChange(_ref2) {
    var key = _ref2.key,
      text = _ref2.text;
    if (hasFilterWithValue(key)) {
      filterDelete(key, text);
    } else {
      filterAdd(key, text);
    }
  };
  return /*#__PURE__*/React.createElement(FilterTemplate, {
    isVisible: isVisible,
    handleToggle: handleToggle,
    label: t('Body types')
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "space-y-2"
  }, map(orderBy(filterData, ['text']), function (body) {
    var isSelected = includes(filterValues, body.key);
    return /*#__PURE__*/React.createElement(Checkbox, {
      label: function label() {
        return /*#__PURE__*/React.createElement("div", {
          className: "flex items-center"
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            minWidth: 35
          },
          className: "mr-1"
        }, /*#__PURE__*/React.createElement("img", {
          src: getBodyImageSrc(body.key),
          style: {
            height: 12
          },
          alt: body.text
        })), body.text);
      },
      onClick: function onClick(value, e) {
        e.preventDefault();
        e.stopPropagation();
        handleFilterChange(body);
      },
      checked: isSelected
    });
  }))));
};
var BodiesFilter$1 = baseTypedFilter(FilterTypes.body, BodiesFilter);

var resolveValueFrom = function resolveValueFrom(value) {
  if (!value) return '';
  if (head(value) !== undefined) {
    return {
      label: head(value)
    };
  }
  return '';
};
var resolveValueTo = function resolveValueTo(value) {
  if (!value) return '';
  if (last(value) !== undefined) {
    return {
      label: last(value)
    };
  }
  return '';
};
var GenericRangeSelect = function GenericRangeSelect(_ref) {
  var placeHolderFrom = _ref.placeHolderFrom,
    placeHolderTo = _ref.placeHolderTo,
    optionsFrom = _ref.optionsFrom,
    optionsTo = _ref.optionsTo,
    value = _ref.value,
    handleFilterChanged = _ref.handleFilterChanged;
  var valueFrom = resolveValueFrom(value);
  var valueTo = resolveValueTo(value);
  if (value && value[0] !== undefined) {
    optionsTo = filter(optionsTo, function (y) {
      return y.value >= value[0];
    });
  }
  if (value && value[1]) {
    optionsFrom = filter(optionsFrom, function (y) {
      return y.value <= value[1];
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 w-full gap-4"
  }, /*#__PURE__*/React.createElement(SelectBox, {
    value: valueFrom,
    options: optionsFrom,
    className: "no-right-rounded no-right-border",
    placeholder: placeHolderFrom,
    isLoading: false,
    onChange: function onChange(item) {
      var start = item.value;
      var stop = value && value[1] && value[1] > item.value ? value[1] : undefined;
      handleFilterChanged([start, stop]);
    }
  }), /*#__PURE__*/React.createElement(SelectBox, {
    value: valueTo,
    options: optionsTo,
    className: "no-left-rounded",
    placeholder: placeHolderTo,
    isLoading: false,
    onChange: function onChange(item) {
      var start = value && value[0] && value[0] < item.value ? value[0] : undefined;
      var stop = item.value;
      handleFilterChanged([start, stop]);
    }
  }));
};

var YearFilter = function YearFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    hasFilter = _ref.hasFilter,
    isVisible = _ref.isVisible,
    handleToggle = _ref.handleToggle,
    zIndex = _ref.zIndex;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var yearsFrom = range(filterData.min, filterData.max + 1).map(function (item) {
    return {
      value: item,
      label: item
    };
  });
  var yearsTo = range(filterData.min, filterData.max + 1).map(function (item) {
    return {
      value: item,
      label: item
    };
  });
  return /*#__PURE__*/React.createElement(FilterTemplate, {
    isVisible: isVisible,
    handleToggle: handleToggle,
    label: t('First registration'),
    zIndex: zIndex
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-1"
  }, /*#__PURE__*/React.createElement(GenericRangeSelect, {
    placeHolderFrom: t('From'),
    placeHolderTo: t('To'),
    optionsFrom: orderBy(yearsFrom, ['value'], ['desc']),
    optionsTo: orderBy(yearsTo, ['value'], ['desc']),
    value: filterValues && filterValues.length > 0 ? filterValues[0] : undefined,
    handleFilterChanged: function handleFilterChanged(range) {
      var label = '';
      if (range[0] && range[1]) {
        label = range[0] + " - " + range[1];
      } else {
        if (range[0]) label = t('From') + " " + range[0];
        if (range[1]) label = t('To') + " " + range[1];
      }
      if (hasFilter()) {
        filterUpdate(range, label);
      } else {
        filterAdd(range, label);
      }
    }
  })));
};
var YearFilter$1 = baseTypedFilter(FilterTypes.year, YearFilter);

var getCurrentRangeForSlider = function getCurrentRangeForSlider(type, prices, monthlyPrices) {
  if (type === types.price) {
    return prices;
  } else if (type === types.monthly) {
    return monthlyPrices;
  }
};
var types = {
  price: 'price',
  monthly: 'monthly'
};
var PriceSlider = function PriceSlider(_ref) {
  var values = _ref.values,
    defaultValues = _ref.defaultValues,
    prices = _ref.prices,
    monthlyPrices = _ref.monthlyPrices,
    onChange = _ref.onChange,
    radioButtonSize = _ref.radioButtonSize;
  var _useState = useState(types.price),
    type = _useState[0],
    setType = _useState[1];
  var currentRange = getCurrentRangeForSlider(type, prices, monthlyPrices);
  var valueRange = values[type] ? values[type] : defaultValues[type] ? defaultValues[type] : undefined;
  var currentMaxPrice = valueRange ? valueRange[1] : currentRange.max;
  var _useState2 = useState(currentMaxPrice),
    displayPrice = _useState2[0],
    setDisplayPrice = _useState2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    setDisplayPrice(currentMaxPrice);
  }, [currentMaxPrice]);
  var getDisplayPriceString = function getDisplayPriceString() {
    if (displayPrice !== currentRange.max) {
      return "\u20AC " + formatNumber(displayPrice);
    } else {
      return '-';
    }
  };
  var handleChange = function handleChange(type, value) {
    var newValues = type === types.price ? {
      monthly: undefined,
      price: value
    } : {
      price: undefined,
      monthly: value
    };
    onChange(newValues);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "relative font-normal w-full pr-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "price-slider-header-container flex mb-4 w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "price-slider-header-item flex items-center mr-10 cursor-pointer " + (type === types.price ? 'active' : 'inactive'),
    onClick: function onClick() {
      return setType(types.price);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "price-slider-header-item-radio border-2 border-gray-200 bg-white p-1 mr-2",
    style: {
      height: radioButtonSize,
      width: radioButtonSize
    }
  }, type === types.price && /*#__PURE__*/React.createElement("div", {
    className: "bg-lma h-full w-full"
  })), /*#__PURE__*/React.createElement("span", {
    className: "paragraph-small text-secondary-four"
  }, t('Total'))), /*#__PURE__*/React.createElement("div", {
    className: "price-slider-header-item flex items-center cursor-pointer " + (type === types.monthly ? 'active' : 'inactive'),
    onClick: function onClick() {
      return setType(types.monthly);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "price-slider-header-item-radio border-2 border-gray-200 bg-white p-1 mr-2",
    style: {
      height: radioButtonSize,
      width: radioButtonSize
    }
  }, type === types.monthly && /*#__PURE__*/React.createElement("div", {
    className: "bg-lma h-full w-full"
  })), /*#__PURE__*/React.createElement("span", {
    className: "paragraph-small text-secondary-four"
  }, t('Monthly')))), /*#__PURE__*/React.createElement(Slider, {
    min: currentRange.min,
    max: currentRange.max,
    value: displayPrice,
    step: currentRange.step,
    onAfterChange: function onAfterChange(value) {
      return handleChange(type, [currentRange.min, value]);
    },
    onChange: function onChange(value) {
      setDisplayPrice(value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-end paragraph-default text-secondary inline-block font-semibold"
  }, type === types.price && t('Max. price'), ' ', type === types.monthly && t('Max. amount'), ' ', /*#__PURE__*/React.createElement("span", {
    className: "ml-2"
  }, getDisplayPriceString())));
};
PriceSlider.defaultProps = {
  loading: false,
  radioButtonSize: 16,
  defaultValues: {
    price: undefined,
    monthly: undefined
  },
  isHome: false
};

var PriceFilter = function PriceFilter(_ref) {
  var filters = _ref.filters,
    filterData = _ref.filterData,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    filterDeleteByType = _ref.filterDeleteByType,
    hasFilter = _ref.hasFilter,
    radioButtonSize = _ref.radioButtonSize,
    isVisible = _ref.isVisible,
    handleToggle = _ref.handleToggle;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var priceMax = filterData ? filterData.dataSettings.priceMax : 0;
  var priceStep = filterData ? filterData.dataSettings.priceStep : 0;
  var monthlyMax = filterData ? filterData.dataSettings.monthlyMax : 0;
  var monthlyStep = filterData ? filterData.dataSettings.monthlyStep : 0;
  var prices = {
    min: 0,
    max: priceMax,
    step: priceStep
  };
  var monthlyPrices = {
    min: 0,
    max: monthlyMax,
    step: monthlyStep
  };
  var handleChange = function handleChange(type, range) {
    var typeMax = type === FilterTypes.price ? prices.max : type === FilterTypes.monthlyPrice ? monthlyPrices.max : 0;
    var rangeIsMax = range[1] === typeMax;
    if (!rangeIsMax) {
      var labelPrefix = type === FilterTypes.price ? t('Max.') : type === FilterTypes.monthlyPrice ? t('Monthly max.') : '';
      var label = labelPrefix + " " + formatPrice(range[1]);
      if (hasFilter(type)) {
        filterUpdate(type, range, label);
      } else {
        filterAdd(type, range, label);
      }
    } else {
      filterDeleteByType(type);
    }
  };
  var priceFilter = find(filters, function (f) {
    return f.type === FilterTypes.price;
  });
  var monthlyFilter = find(filters, function (f) {
    return f.type === FilterTypes.monthlyPrice;
  });
  return /*#__PURE__*/React.createElement(FilterTemplate, {
    isVisible: isVisible,
    handleToggle: handleToggle,
    label: t('Price') + "(\u20AC)"
  }, /*#__PURE__*/React.createElement(PriceSlider, {
    prices: prices,
    monthlyPrices: monthlyPrices,
    values: {
      price: priceFilter ? priceFilter.value : undefined,
      monthly: monthlyFilter ? monthlyFilter.value : undefined
    },
    onChange: function onChange(values) {
      if (values.price) {
        handleChange(FilterTypes.price, values.price);
      } else {
        filterDeleteByType(FilterTypes.price);
      }
      if (values.monthly) {
        handleChange(FilterTypes.monthlyPrice, values.monthly);
      } else {
        filterDeleteByType(FilterTypes.monthlyPrice);
      }
    },
    radioButtonSize: radioButtonSize
  }));
};
PriceFilter.defaultProps = {
  radioButtonSize: '1.5rem'
};
baseFilter(PriceFilter);

var GenericList = function GenericList(_ref) {
  var items = _ref.items,
    values = _ref.values,
    handleFilterChanged = _ref.handleFilterChanged,
    renderSubFilters = _ref.renderSubFilters,
    maxVisibleOptions = _ref.maxVisibleOptions,
    onToggleMore = _ref.onToggleMore,
    primaryItems = _ref.primaryItems,
    primaryItemsLabel = _ref.primaryItemsLabel,
    otherItemsLabel = _ref.otherItemsLabel;
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var allItems = [].concat(primaryItems, items);
  var options = map(allItems, function (item) {
    return {
      value: item.key,
      label: item.text,
      priority: item !== null && item !== void 0 && item.priority ? item === null || item === void 0 ? void 0 : item.priority : 0
    };
  });
  var hasMore = options.length > maxVisibleOptions + 1;
  var visibleOptions = options;
  var invisibleOptions = [];
  if (hasMore) {
    visibleOptions = options.slice(0, maxVisibleOptions);
    invisibleOptions = options.slice(maxVisibleOptions, options.length);
  }
  var renderOption = function renderOption(option, index) {
    var isSelected = includes(values, option.value);
    var priorityOneFirstEl = findIndex$1(options, function (el) {
      return el.priority > 0;
    });
    var priorityZeroFirstEl = findIndex$1(options, function (el) {
      return el.priority < 1;
    });
    var showPrimaryLabel = (primaryItems === null || primaryItems === void 0 ? void 0 : primaryItems.length) > 0 && index === priorityOneFirstEl && primaryItemsLabel;
    var showOtherLabel = (primaryItems === null || primaryItems === void 0 ? void 0 : primaryItems.length) > 0 && index === priorityZeroFirstEl && otherItemsLabel;
    return /*#__PURE__*/React.createElement("div", null, showPrimaryLabel && /*#__PURE__*/React.createElement("div", {
      className: "text-16 leading-19px text-secondary font-normal mb-4"
    }, primaryItemsLabel), showOtherLabel && /*#__PURE__*/React.createElement("div", {
      className: "text-16 leading-19px text-secondary font-normal mb-4 mt-10"
    }, otherItemsLabel), /*#__PURE__*/React.createElement("div", {
      key: "filter-" + (option === null || option === void 0 ? void 0 : option.value) + "-" + (option === null || option === void 0 ? void 0 : option.label),
      className: "flex flex-col text-secondary-four mb-1"
    }, /*#__PURE__*/React.createElement(Checkbox, {
      label: option.label,
      onClick: function onClick(value, e) {
        e.preventDefault();
        e.stopPropagation();
        handleFilterChanged(option);
      },
      checked: isSelected
    }), renderSubFilters && typeof renderSubFilters === 'function' && isSelected && renderSubFilters(option)));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "space-y-4"
  }, map(visibleOptions, function (option, index) {
    return renderOption(option, index);
  }), isOpen && map(invisibleOptions, function (option, index) {
    return renderOption(option, index + maxVisibleOptions);
  })), hasMore && /*#__PURE__*/React.createElement("div", {
    className: "text-15 text-primary font-normal underline mt-5 cursor-pointer",
    onClick: function onClick() {
      setIsOpen(!isOpen);
      onToggleMore && typeof onToggleMore === 'function' && onToggleMore(!isOpen);
    }
  }, isOpen ? t('Show less') : t('Show more')));
};
GenericList.defaultProps = {
  renderSubFilters: undefined,
  maxVisibleOptions: 6,
  items: [],
  primaryItems: [],
  primaryItemsLabel: '',
  otherItemsLabel: '',
  onToggleMore: undefined
};

var MileageFilter = function MileageFilter(_ref) {
  var filterData = _ref.filterData,
    filterDeleteByType = _ref.filterDeleteByType,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    hasFilter = _ref.hasFilter,
    isVisible = _ref.isVisible,
    handleToggle = _ref.handleToggle,
    zIndex = _ref.zIndex,
    onToggleMore = _ref.onToggleMore;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var options = [{
    key: 5000,
    text: t('Up to') + " " + formatNumber(5000) + " " + t('km')
  }, {
    key: 10000,
    text: t('Up to') + " " + formatNumber(10000) + " " + t('km')
  }, {
    key: 25000,
    text: t('Up to') + " " + formatNumber(25000) + " " + t('km')
  }, {
    key: 50000,
    text: t('Up to') + " " + formatNumber(50000) + " " + t('km')
  }, {
    key: 100000,
    text: t('Up to') + " " + formatNumber(100000) + " " + t('km')
  }, {
    key: filterData === null || filterData === void 0 ? void 0 : filterData.max,
    text: t('Up to') + " " + formatNumber(100000) + "+ " + t('km')
  }];
  var getValues = function getValues() {
    return map(filterValues, function (filterValue) {
      return last(filterValue);
    });
  };
  return /*#__PURE__*/React.createElement(FilterTemplate, {
    isVisible: isVisible,
    handleToggle: handleToggle,
    label: t('Mileage'),
    zIndex: zIndex
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-1"
  }, /*#__PURE__*/React.createElement(GenericList, {
    items: options,
    values: getValues(),
    onToggleMore: onToggleMore,
    handleFilterChanged: function handleFilterChanged(data) {
      var range = [0, data.value];
      if (hasFilter()) {
        if (isEqual$1(head(filterValues), range)) {
          filterDeleteByType();
        } else {
          filterUpdate(range);
        }
      } else {
        filterAdd(range);
      }
    }
  })));
};
var MileageFilter$1 = baseTypedFilter(FilterTypes.mileage, MileageFilter);

var labels = {
  PK: 'PK',
  KW: 'KW'
};
var initPK = {
  min: '',
  max: ''
};
var initKW = {
  min: '',
  max: ''
};
var PowerFilter = function PowerFilter(_ref) {
  var filters = _ref.filters,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    filterDeleteByType = _ref.filterDeleteByType,
    hasFilter = _ref.hasFilter,
    isVisible = _ref.isVisible,
    handleToggle = _ref.handleToggle,
    zIndex = _ref.zIndex;
  var _useState = useState(labels.PK),
    activeOption = _useState[0],
    setActiveOption = _useState[1];
  var _useState2 = useState(initPK),
    pk = _useState2[0],
    setPk = _useState2[1];
  var _useState3 = useState(initKW),
    kw = _useState3[0],
    setKw = _useState3[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    var pkFilters = head(filter(filters, function (f) {
      return f.type === FilterTypes.pk;
    }));
    var kwFilters = head(filter(filters, function (f) {
      return f.type === FilterTypes.kw;
    }));
    if (pkFilters) {
      setPk({
        min: pkFilters.value[0],
        max: pkFilters.value[1]
      });
    }
    if (kwFilters) {
      setKw({
        min: kwFilters.value[0],
        max: kwFilters.value[1]
      });
    }
  }, []);
  var onPkChange = function onPkChange() {
    if (pk.min !== '' || pk.max !== '') {
      var value = [pk.min, pk.max];
      var label = '';
      if (value[0] && value[1]) {
        label = value[0] + " " + t('pk') + " - " + value[1] + " " + t('pk');
      } else {
        if (value[0]) label = t('From') + " " + value[0] + " " + t('pk');
        if (value[1]) label = t('To') + " " + value[1] + " " + t('pk');
      }
      if (hasFilter(FilterTypes.pk)) {
        filterUpdate(FilterTypes.pk, value, label);
      } else {
        filterAdd(FilterTypes.pk, value, label);
      }
    } else {
      filterDeleteByType(FilterTypes.pk);
    }
  };
  var onKwChange = function onKwChange() {
    if (kw.min !== '' || kw.max !== '') {
      var value = [kw.min, kw.max];
      var label = '';
      if (value[0] && value[1]) {
        label = value[0] + " " + t('kW') + " - " + value[1] + " " + t('kW');
      } else {
        if (value[0]) label = t('From') + " " + value[0] + " " + t('kW');
        if (value[1]) label = t('To') + " " + value[1] + " " + t('kW');
      }
      if (hasFilter(FilterTypes.kw)) {
        filterUpdate(FilterTypes.kw, value, label);
      } else {
        filterAdd(FilterTypes.kw, value, label);
      }
    } else {
      filterDeleteByType(FilterTypes.kw);
    }
  };
  var renderPK = function renderPK() {
    return /*#__PURE__*/React.createElement("div", {
      className: "h-full"
    }, /*#__PURE__*/React.createElement("input", {
      className: "w-1/2 filter-input border border-gray-200 pl-2 rounded-l-4 focus:outline-none h-full ",
      value: pk.min,
      placeholder: t('From'),
      onChange: function onChange(e) {
        return setPk(_extends({}, pk, {
          min: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onPkChange();
      }
    }), /*#__PURE__*/React.createElement("input", {
      className: "w-1/2 filter-input border-r border-t border-b pl-2 border-gray-200 rounded-r-4 focus:outline-none h-full",
      value: pk.max,
      placeholder: t('To'),
      onChange: function onChange(e) {
        return setPk(_extends({}, pk, {
          max: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onPkChange();
      }
    }));
  };
  var renderKW = function renderKW() {
    return /*#__PURE__*/React.createElement("div", {
      className: "h-full"
    }, /*#__PURE__*/React.createElement("input", {
      className: "w-1/2 filter-input border border-gray-200 rounded-l-4 pl-2 focus:outline-none h-full ",
      value: kw.min,
      placeholder: t('From'),
      onChange: function onChange(e) {
        return setKw(_extends({}, kw, {
          min: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onKwChange();
      }
    }), /*#__PURE__*/React.createElement("input", {
      className: "w-1/2 filter-input border-r border-t border-b border-gray-200 pl-2 rounded-r-4 focus:outline-none h-full",
      value: kw.max,
      placeholder: t('To'),
      onChange: function onChange(e) {
        return setKw(_extends({}, kw, {
          max: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onKwChange();
      }
    }));
  };
  return /*#__PURE__*/React.createElement(FilterTemplate, {
    isVisible: isVisible,
    handleToggle: handleToggle,
    label: t('Power'),
    zIndex: zIndex
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col px-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4 flex items-center space-x-4"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    label: t('PK'),
    onClick: function onClick() {
      return setActiveOption(labels.PK);
    },
    checked: activeOption === labels.PK
  }), /*#__PURE__*/React.createElement(Checkbox, {
    label: t('KW'),
    onClick: function onClick() {
      return setActiveOption(labels.KW);
    },
    checked: activeOption === labels.KW
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Fade$1, {
    spy: activeOption,
    duration: 50
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex"
  }, activeOption === labels.PK && renderPK(), activeOption === labels.KW && renderKW())))));
};
var PowerFilter$1 = baseFilter(PowerFilter);

var DoorsFilter = function DoorsFilter(_ref) {
  var filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    filterDeleteByType = _ref.filterDeleteByType,
    hasFilter = _ref.hasFilter,
    isVisible = _ref.isVisible,
    handleToggle = _ref.handleToggle,
    onToggleMore = _ref.onToggleMore;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var items = [{
    key: '2-3',
    text: "2 " + t('to') + " 3 " + t('doors')
  }, {
    key: '4-5',
    text: "4 " + t('to') + " 5 " + t('doors')
  }, {
    key: '6-7',
    text: "6 " + t('to') + " 7 " + t('doors')
  }];
  var values = map(filterValues, function (filterValue) {
    var min = head(filterValue);
    var max = last(filterValue);
    return min + "-" + max;
  });
  return /*#__PURE__*/React.createElement(FilterTemplate, {
    isVisible: isVisible,
    handleToggle: handleToggle,
    label: t('Nr of Doors')
  }, /*#__PURE__*/React.createElement(GenericList, {
    items: items,
    values: values,
    onToggleMore: onToggleMore,
    handleFilterChanged: function handleFilterChanged(data) {
      var min = head(data.value.split('-'));
      var max = last(data.value.split('-'));
      var range = [min, max];
      if (hasFilter()) {
        if (isEqual(head(filterValues), range)) {
          filterDeleteByType();
        } else {
          filterUpdate(range);
        }
      } else {
        filterAdd(range);
      }
    }
  }));
};
var DoorsFilter$1 = baseTypedFilter(FilterTypes.doorsRange, DoorsFilter);

var SeatsFilter = function SeatsFilter(_ref) {
  var filterDeleteByType = _ref.filterDeleteByType,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    hasFilter = _ref.hasFilter,
    isVisible = _ref.isVisible,
    handleToggle = _ref.handleToggle,
    zIndex = _ref.zIndex,
    onToggleMore = _ref.onToggleMore;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var items = [{
    key: '0-2',
    text: "2 " + t('seats')
  }, {
    key: '3-4',
    text: "4 " + t('seats')
  }, {
    key: '5-6',
    text: "5 " + t('seats')
  }, {
    key: '7-8',
    text: "7 " + t('seats')
  }, {
    key: '9-',
    text: "9 " + t('seats')
  }];
  var values = map(filterValues, function (filterValue) {
    var min = head(filterValue);
    var max = last(filterValue);
    return min + "-" + max;
  });
  return /*#__PURE__*/React.createElement(FilterTemplate, {
    isVisible: isVisible,
    handleToggle: handleToggle,
    label: t('Nr of Seats'),
    zIndex: zIndex
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-1"
  }, /*#__PURE__*/React.createElement(GenericList, {
    items: items,
    values: values,
    onToggleMore: onToggleMore,
    handleFilterChanged: function handleFilterChanged(data) {
      var min = head(data.value.split('-'));
      var max = last(data.value.split('-'));
      var range = [min, max];
      if (hasFilter()) {
        if (isEqual$1(head(filterValues), range)) {
          filterDeleteByType();
        } else {
          filterUpdate(range);
        }
      } else {
        filterAdd(range);
      }
    }
  })));
};
var SeatsFilter$1 = baseTypedFilter(FilterTypes.seatsRange, SeatsFilter);

var VatFilter = function VatFilter(_ref) {
  var isVisible = _ref.isVisible,
    handleToggle = _ref.handleToggle,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings,
    setClientSetting = _useClientSettings.setClientSetting;
  var isProfessional = (clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isProfessional) === true;
  var label = t('VAT deductible');
  var handleFilterChanged = function handleFilterChanged() {
    if (hasFilterWithValue('')) {
      filterDelete('');
    } else {
      filterAdd('');
    }
    setClientSetting('isVatFilterModified', true);
  };
  var renderContent = function renderContent() {
    var isSelected = hasFilterWithValue('');
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col text-gray-900"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row cursor-pointer",
      onClick: function onClick() {
        return handleFilterChanged();
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center border-2 border-gray-200 p-1 mr-2 w-6 h-6"
    }, isSelected && /*#__PURE__*/React.createElement("div", {
      className: "h-full w-full bg-lma"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 text-16 leading-19px text-secondary font-light"
    }, /*#__PURE__*/React.createElement("div", {
      className: ""
    }, label))));
  };
  if (isProfessional) {
    return renderContent();
  }
  return /*#__PURE__*/React.createElement(FilterTemplate, {
    isVisible: isVisible,
    handleToggle: handleToggle,
    label: t('VAT')
  }, renderContent());
};
var VatFilter$1 = baseTypedFilter(FilterTypes.vat, VatFilter);

var EquipmentFilter = function EquipmentFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    isVisible = _ref.isVisible,
    handleToggle = _ref.handleToggle;
  var _useState = useState(false),
    searchFocused = _useState[0],
    setSearchFocused = _useState[1];
  var _useState2 = useState(''),
    searchTerm = _useState2[0],
    setSearchTerm = _useState2[1];
  var _useState3 = useState([]),
    items = _useState3[0],
    setItems = _useState3[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    var orderedEquipments = orderBy(filterData, ['text']);
    setItems(orderedEquipments);
  }, []);
  var onSearch = function onSearch(term) {
    setSearchTerm(term);
    var filteredItems = filter(filterData, function (item) {
      return includes(toLower(item.text), toLower(term));
    });
    setItems(filteredItems);
  };
  var renderSearchBox = function renderSearchBox() {
    var isFocused = searchFocused;
    return /*#__PURE__*/React.createElement("div", {
      className: "flex w-full relative bg-white items-center border border-gray rounded-4 whitespace-nowrap hover:border-lma focus:border-lma mx-1 mb-6"
    }, !isFocused && /*#__PURE__*/React.createElement("div", {
      className: "flex justify-center"
    }, /*#__PURE__*/React.createElement("span", {
      className: "flex items-center leading-normal bg-white ml-3 border-0 rounded-10 rounded-r-none"
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-search text-secondary-two cursor-pointer"
    }))), /*#__PURE__*/React.createElement("input", {
      type: "text",
      className: "flex-1 filter-input outline-none pl-2",
      style: {
        minHeight: 44
      },
      placeholder: !isFocused ? t('Search options') : '',
      onFocus: function onFocus() {
        return setSearchFocused(true);
      },
      onBlur: function onBlur() {
        return setSearchFocused(false);
      },
      value: searchTerm,
      onChange: function onChange(e) {
        return onSearch(e.target.value);
      }
    }));
  };
  return /*#__PURE__*/React.createElement(FilterTemplate, {
    isVisible: isVisible,
    handleToggle: handleToggle,
    label: t('Equipments')
  }, /*#__PURE__*/React.createElement("div", null, filterData.length > 10 && renderSearchBox(), /*#__PURE__*/React.createElement("div", null, items.length < 1 && /*#__PURE__*/React.createElement("div", {
    className: "paragraph-small"
  }, t('No equipments found.')), items.length > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GenericList, {
    placeHolder: t('All'),
    items: items,
    values: filterValues,
    maxVisibleOptions: 10,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value, data.label);
      } else {
        filterAdd(data.value, data.label);
      }
    }
  })))));
};
var EquipmentFilter$1 = baseTypedFilter(FilterTypes.equipments, EquipmentFilter);

var ExteriorColorFilter = function ExteriorColorFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    isVisible = _ref.isVisible,
    handleToggle = _ref.handleToggle,
    onToggleMore = _ref.onToggleMore;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(FilterTemplate, {
    isVisible: isVisible,
    handleToggle: handleToggle,
    label: t('Body Color')
  }, /*#__PURE__*/React.createElement(GenericList, {
    items: orderBy(filterData, ['text'], ['asc']),
    values: filterValues,
    onToggleMore: onToggleMore,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
    }
  }));
};
var ExteriorColorFilter$1 = baseTypedFilter(FilterTypes.exteriorColor, ExteriorColorFilter);

var InteriorColorFilter = function InteriorColorFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    isVisible = _ref.isVisible,
    handleToggle = _ref.handleToggle,
    onToggleMore = _ref.onToggleMore;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(FilterTemplate, {
    isVisible: isVisible,
    handleToggle: handleToggle,
    label: t('Interior Color')
  }, /*#__PURE__*/React.createElement(GenericList, {
    items: orderBy(filterData, ['text'], ['asc']),
    values: filterValues,
    onToggleMore: onToggleMore,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
    }
  }));
};
var InteriorColorFilter$1 = baseTypedFilter(FilterTypes.interiorColor, InteriorColorFilter);

var InteriorUpholstery = function InteriorUpholstery(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    isVisible = _ref.isVisible,
    handleToggle = _ref.handleToggle,
    onToggleMore = _ref.onToggleMore;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(FilterTemplate, {
    isVisible: isVisible,
    handleToggle: handleToggle,
    label: t('InteriorUpholstery')
  }, /*#__PURE__*/React.createElement(GenericList, {
    items: orderBy(filterData, [function (data) {
      return data.text.toLowerCase();
    }]),
    values: filterValues,
    onToggleMore: onToggleMore,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value, data.label);
      } else {
        filterAdd(data.value, data.label);
      }
    }
  }));
};
var InteriorUpholsteryFilter = baseTypedFilter(FilterTypes.interiorUpholstery, InteriorUpholstery);

var EuroNormFilter = function EuroNormFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    isVisible = _ref.isVisible,
    handleToggle = _ref.handleToggle,
    zIndex = _ref.zIndex,
    onToggleMore = _ref.onToggleMore;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(FilterTemplate, {
    isVisible: isVisible,
    handleToggle: handleToggle,
    label: t('Euro Emission Class'),
    zIndex: zIndex
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-1"
  }, /*#__PURE__*/React.createElement(GenericList, {
    items: orderBy(filterData, ['priority'], 'asc'),
    values: filterValues,
    onToggleMore: onToggleMore,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
    }
  })));
};
var EuroNormFilter$1 = baseTypedFilter(FilterTypes.euroNorm, EuroNormFilter);

var initCoValue = {
  min: '',
  max: ''
};
var CO2Filter = function CO2Filter(_ref) {
  var filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    filterDeleteByType = _ref.filterDeleteByType,
    hasFilter = _ref.hasFilter,
    isVisible = _ref.isVisible,
    handleToggle = _ref.handleToggle;
  var activeFilter = filterValues && filterValues.length > 0 ? filterValues[0] : undefined;
  var _useState = useState(activeFilter ? {
      min: activeFilter[0],
      max: activeFilter[1]
    } : initCoValue),
    value = _useState[0],
    setValue = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleChange = function handleChange() {
    if (value.min !== '' || value.max !== '') {
      var range = [value.min, value.max];
      var label = '';
      if (range[0] && range[1]) {
        label = range[0] + " g/km - " + range[1] + " g/km";
      } else {
        if (range[0]) label = t('From') + " " + range[0] + " g/km";
        if (range[1]) label = t('To') + " " + range[1] + " g/km";
      }
      if (hasFilter()) {
        filterUpdate(range, label);
      } else {
        filterAdd(range, label);
      }
    } else {
      filterDeleteByType();
    }
  };
  return /*#__PURE__*/React.createElement(FilterTemplate, {
    isVisible: isVisible,
    handleToggle: handleToggle,
    label: t('CO2 (g/km)')
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex text-16 px-1 text-secondary",
    style: {
      minHeight: 49
    }
  }, /*#__PURE__*/React.createElement("input", {
    className: "w-1/2 flex items-center justify-center filter-input border border-gray-200 rounded-l-4 focus:outline-none pl-2",
    value: value.min,
    placeholder: t('From'),
    onChange: function onChange(e) {
      return setValue(_extends({}, value, {
        min: e.target.value
      }));
    },
    onBlur: function onBlur() {
      return handleChange();
    }
  }), /*#__PURE__*/React.createElement("input", {
    className: "w-1/2 flex items-center justify-center filter-input border-r border-t border-b border-gray-200 rounded-r-4 focus:outline-none pl-2",
    value: value.max,
    placeholder: t('To'),
    onChange: function onChange(e) {
      return setValue(_extends({}, value, {
        max: e.target.value
      }));
    },
    onBlur: function onBlur() {
      return handleChange();
    }
  })));
};
var CO2Filter$1 = baseTypedFilter(FilterTypes.co2Range, CO2Filter);

var IdentificationFilter = function IdentificationFilter(_ref) {
  var filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    filterDeleteByType = _ref.filterDeleteByType,
    hasFilter = _ref.hasFilter,
    isVisible = _ref.isVisible,
    handleToggle = _ref.handleToggle;
  var _useState = useState(filterValues ? head(filterValues) : ''),
    identification = _useState[0],
    setIdentification = _useState[1];
  var identificationFilter = head(filterValues);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    if (filterValues) {
      setIdentification(head(filterValues) ? head(filterValues) : '');
    }
  }, [filterValues]);
  var handleFilterChanged = function handleFilterChanged() {
    if (identification && identification !== '') {
      if (hasFilter()) {
        filterUpdate(identification, identification);
      } else {
        filterAdd(identification, identification);
      }
    } else {
      filterDeleteByType();
    }
  };
  var handleKeyPress = function handleKeyPress(event) {
    if (event.keyCode === 13) {
      handleFilterChanged();
    }
  };
  return /*#__PURE__*/React.createElement(FilterTemplate, {
    isVisible: isVisible,
    handleToggle: handleToggle,
    label: t('Identification')
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex w-full relative bg-white items-center border border-gray-200 rounded-4 px-1"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "flex-1 filter-input outline-none pl-2",
    style: {
      minHeight: 44
    },
    placeholder: t('Reference'),
    value: identification,
    onChange: function onChange(e) {
      return setIdentification(e.target.value);
    },
    onBlur: function onBlur() {
      return handleFilterChanged();
    },
    onKeyDown: handleKeyPress
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center",
    onClick: handleFilterChanged
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex items-center leading-normal bg-white mr-5 border-0 rounded-10 rounded-r-none"
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-search text-secondary-two cursor-pointer"
  })))));
};
var IdentificationFilter$1 = baseTypedFilter(FilterTypes.identification, IdentificationFilter);

var ClientTypeSwitch$1 = function ClientTypeSwitch() {
  var _useClientSettings = useClientSettings(),
    clientSettings = _useClientSettings.clientSettings,
    setClientSetting = _useClientSettings.setClientSetting;
  var isProfessional = (clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isProfessional) === true;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
  }, [isProfessional]);
  return /*#__PURE__*/React.createElement("div", {
    className: "rounded-full inline-flex h-10 sm:py-1 relative",
    style: {
      background: '#f2f2f2'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute top-0 w-27 sm:w-32 " + (!isProfessional ? 'transform translate-x-0' : 'transform translate-x-27 sm:translate-x-32') + " bg-secondary rounded-full shadow-xl h-12 -mt-1 transition-transform",
    style: {
      zIndex: 1
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex-none flex justify-center items-center w-27 sm:w-32 cursor-pointer",
    onClick: function onClick() {
      if (isProfessional) {
        setClientSetting('isProfessional', false, true);
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative transition-colors truncate px-1 sm:px-3 text-sm sm:text-base " + (!isProfessional ? 'text-white' : 'text-secondary'),
    style: {
      zIndex: 2
    }
  }, t('Private'))), /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      if (!isProfessional) {
        setClientSetting('isProfessional', true, true);
      }
    },
    className: "flex-none flex justify-center items-center w-27 sm:w-32 cursor-pointer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative transition-colors truncate px-1 sm:px-3 text-sm sm:text-base\n              " + ((clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isProfessional) === true ? 'text-white' : 'text-secondary') + "\n            ",
    style: {
      zIndex: 2
    }
  }, t('Professional'))));
};

var FuelFilterCheckbox = function FuelFilterCheckbox(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange,
    isVisible = _ref.isVisible,
    handleToggle = _ref.handleToggle,
    onToggleMore = _ref.onToggleMore;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(FilterTemplate, {
    isVisible: isVisible,
    handleToggle: handleToggle,
    label: t('Fuel type')
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-1"
  }, /*#__PURE__*/React.createElement(GenericList, {
    items: filterData,
    values: filterValues,
    containerClass: "",
    onToggleMore: onToggleMore,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  })));
};
var FuelFilterCheckbox$1 = baseTypedFilter(FilterTypes.fuel, FuelFilterCheckbox);

var GearboxFilterCheckbox = function GearboxFilterCheckbox(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange,
    isVisible = _ref.isVisible,
    handleToggle = _ref.handleToggle,
    onToggleMore = _ref.onToggleMore;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(FilterTemplate, {
    isVisible: isVisible,
    handleToggle: handleToggle,
    label: t('Gear')
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-1"
  }, /*#__PURE__*/React.createElement(GenericList, {
    items: filterData,
    values: filterValues,
    onToggleMore: onToggleMore,
    containerClass: "",
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  })));
};
var GearboxFilterCheckbox$1 = baseTypedFilter(FilterTypes.transmission, GearboxFilterCheckbox);

var ModelsFilterCheckbox = function ModelsFilterCheckbox(_ref) {
  var filterData = _ref.filterData,
    makeFilterValues = _ref.makeFilterValues,
    modelFilterValues = _ref.modelFilterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    selectedMake = _ref.selectedMake;
  var makes = filterData.makes,
    models = filterData.models;
  var handleFilterChanged = function handleFilterChanged(data) {
    var makeKey = selectedMake.value;
    var modelKey = data.value;
    var value = makeKey + "|" + modelKey;
    if (hasFilterWithValue(value)) {
      filterDelete(value);
      if (filter(makeFilterValues, function (m) {
        return (m === null || m === void 0 ? void 0 : m.toLowerCase()) === (makeKey === null || makeKey === void 0 ? void 0 : makeKey.toLowerCase());
      }).length <= 1) {
        filterAdd(makeKey);
      }
    } else {
      filterAdd(value);
    }
  };
  var availableMakes = makeFilterValues.length > 0 ? filter(makes, function (m) {
    return includes(makeFilterValues, m.key);
  }) : makes;
  var modelsPerMake = filter(models, function (model) {
    return find(availableMakes, function (make) {
      return make.key === model.custom;
    });
  });
  var items = map(filter(modelsPerMake, function (model) {
    return model.custom === (selectedMake === null || selectedMake === void 0 ? void 0 : selectedMake.value);
  }), function (model) {
    return {
      key: model === null || model === void 0 ? void 0 : model.key,
      text: model === null || model === void 0 ? void 0 : model.text,
      value: model === null || model === void 0 ? void 0 : model.value
    };
  });
  return /*#__PURE__*/React.createElement(GenericList, {
    items: items,
    values: map(modelFilterValues, function (modelFilter) {
      return modelFilter.model;
    }),
    containerClass: "",
    handleFilterChanged: handleFilterChanged
  });
};
var ModelsFilterCheckbox$1 = baseModelFilterForMakeModel(ModelsFilterCheckbox);

var MakeModelFilter = function MakeModelFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange,
    label = _ref.label,
    isVisible = _ref.isVisible,
    handleToggle = _ref.handleToggle,
    onToggleMore = _ref.onToggleMore;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var items = filterData;
  if (label === BRANDING.lma) {
    items = filter(items, function (item) {
      return item.key !== 'audi';
    });
  }
  var myWayVisibleMakes = ['volkswagen', 'seat', 'skoda', 'cupra'];
  if (label === BRANDING.myway) {
    items = filter(items, function (make) {
      return some(myWayVisibleMakes, function (m) {
        return make.key.includes(m);
      });
    });
  }
  var primaryMakes = orderBy(filter(items, function (f) {
    return f.priority !== 0;
  }), ['priority'], ['desc']);
  var otherMakes = filter(items, function (f) {
    return f.priority === 0;
  });
  return /*#__PURE__*/React.createElement(FilterTemplate, {
    isVisible: isVisible,
    handleToggle: handleToggle,
    label: t('Makes and model')
  }, /*#__PURE__*/React.createElement(GenericList, {
    items: otherMakes,
    primaryItems: primaryMakes,
    primaryItemsLabel: t('MOST SEARCHED MAKES'),
    otherItemsLabel: t('OTHER MAKES'),
    maxVisibleOptions: (primaryMakes === null || primaryMakes === void 0 ? void 0 : primaryMakes.length) > 0 ? primaryMakes === null || primaryMakes === void 0 ? void 0 : primaryMakes.length : 6,
    values: filterValues,
    containerClass: "",
    onToggleMore: onToggleMore,
    renderSubFilters: function renderSubFilters(option) {
      return /*#__PURE__*/React.createElement("div", {
        className: "pl-4 py-2"
      }, /*#__PURE__*/React.createElement(ModelsFilterCheckbox$1, {
        selectedMake: option
      }));
    },
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  }));
};
var MakeModelFilter$1 = baseMakeFilterForMakeModel(MakeModelFilter);

var myWayLogo = "myway-logo~VGKQWYPT.svg";

var aapLogo = "aap-logo~CMzjEpqK.png";

var LabelFilter = function LabelFilter(_ref) {
  var filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange;
  var labels = [{
    key: LABELS.MYWAY,
    text: 'My Way',
    logo: useAsset(myWayLogo)
  }, {
    key: LABELS.AAP,
    text: 'Audi approved plus',
    logo: useAsset(aapLogo)
  }];
  var handleFilterChanged = function handleFilterChanged(value, e) {
    e.preventDefault();
    e.stopPropagation();
    if (hasFilterWithValue(value)) {
      filterDelete(value);
    } else {
      filterAdd(value);
    }
    onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "px-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "space-y-2"
  }, map(labels, function (_label, i) {
    var isSelected = includes(filterValues, _label.key);
    return /*#__PURE__*/React.createElement(Checkbox, {
      key: _label.key,
      label: function label() {
        return /*#__PURE__*/React.createElement("img", {
          src: _label.logo,
          alt: _label.text,
          style: {
            height: 16
          }
        });
      },
      onClick: function onClick(value, e) {
        return handleFilterChanged(_label.key, e);
      },
      checked: isSelected
    });
  })));
};
var LabelFilter$1 = baseTypedFilter(FilterTypes.label, LabelFilter);

var NewVehiclesFilter = function NewVehiclesFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var data = head(map(filter(filterData, function (fd) {
    return fd.key === 'new';
  }), function (f) {
    return {
      value: f.key,
      label: f.text
    };
  }));
  if (!data) {
    return /*#__PURE__*/React.createElement("div", {
      className: "hidden"
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "border-b border-aap-gray pb-5"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    label: t('New cars'),
    onClick: function onClick(value, e) {
      e.preventDefault();
      e.stopPropagation();
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value, data.label);
      } else {
        filterAdd(data.value, data.label);
      }
    },
    checked: includes(filterValues, data.value)
  }));
};
var NewVehiclesFilter$1 = baseTypedFilter(FilterTypes.category, NewVehiclesFilter);

var ModelsFilter = function ModelsFilter(_ref) {
  var selectedMakes = _ref.selectedMakes,
    filterData = _ref.filterData,
    isVisible = _ref.isVisible,
    handleToggle = _ref.handleToggle;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var items = filterData.filter(function (f) {
    return selectedMakes.includes(f.key);
  }).map(function (item) {
    return {
      value: item.key,
      label: item.text,
      priority: item !== null && item !== void 0 && item.priority ? item === null || item === void 0 ? void 0 : item.priority : 0
    };
  });
  return /*#__PURE__*/React.createElement(FilterTemplate, {
    isVisible: isVisible,
    handleToggle: handleToggle,
    label: t('Model')
  }, items.length > 0 && items.map(function (make) {
    return /*#__PURE__*/React.createElement(ModelsFilterCheckbox$1, {
      selectedMake: make
    });
  }));
};
var ModelsFilter$1 = baseMakeFilterForMakeModel(ModelsFilter);

var DisplayPrices = function DisplayPrices(_ref) {
  var initialRange = _ref.initialRange,
    ranges = _ref.ranges,
    currentRange = _ref.currentRange,
    onUpdate = _ref.onUpdate;
  var _useState = useState(initialRange.min),
    minValue = _useState[0],
    setMinValue = _useState[1];
  var _useState2 = useState(initialRange.max + "+"),
    maxValue = _useState2[0],
    setMaxValue = _useState2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    setMinValue(formatNumber(currentRange === null || currentRange === void 0 ? void 0 : currentRange.min));
    setMaxValue(!(currentRange !== null && currentRange !== void 0 && currentRange.max) || (currentRange === null || currentRange === void 0 ? void 0 : currentRange.max) == initialRange.max ? formatNumber(initialRange.max) + "+" : formatNumber(currentRange === null || currentRange === void 0 ? void 0 : currentRange.max));
  }, [currentRange]);
  var handleFilterUpdate = function handleFilterUpdate(e) {
    e.preventDefault();
    var cleanedMinValue = cleanInputValue(minValue) !== '' ? parseInt$1(cleanInputValue(minValue)) : 0;
    var cleanedMaxValue = cleanInputValue(maxValue) !== '' ? parseInt$1(cleanInputValue(maxValue)) : 0;
    var min = cleanedMinValue < 0 ? 0 : cleanedMinValue;
    min = min > initialRange.max ? initialRange.max : min;
    min = min > cleanedMaxValue ? cleanedMaxValue : min;
    var max = cleanedMaxValue < 0 ? 0 : cleanedMaxValue;
    max = max > initialRange.max ? initialRange.max : max;
    max = max < min ? min : max;
    var minValueCurrentRange = find(ranges, function (item) {
      return item.min < min && min < item.max;
    });
    if (minValueCurrentRange) {
      min = Math.abs(minValueCurrentRange.max - min) < Math.abs(minValueCurrentRange.min - min) ? minValueCurrentRange.max : minValueCurrentRange.min;
    }
    var maxValueCurrentRange = find(ranges, function (item) {
      return item.min < min && min < item.max;
    });
    if (maxValueCurrentRange) {
      max = Math.abs(maxValueCurrentRange.max - min) < Math.abs(maxValueCurrentRange.min - min) ? maxValueCurrentRange.max : maxValueCurrentRange.min;
    }
    onUpdate(min, max);
  };
  var regex = /^[0-9]+$|^$/;
  var cleanInputValue = function cleanInputValue(value) {
    if (value === '') return '';
    return value.replaceAll('.', '').replaceAll('+', '');
  };
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handleFilterUpdate
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between mt-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "border border-gray rounded-4 p-3 hover:border-lma focus:border-lma",
    style: {
      width: '45%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-secondary font-light text-11 whitespace-nowrap"
  }, t('Minimum price')), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center mt-1 whitespace-nowrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-medium text-secondary text-16 mr-1"
  }, "\u20AC"), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("input", {
    value: minValue,
    onChange: function onChange(e) {
      var cleaned = cleanInputValue(e.target.value);
      if (regex.test(cleaned)) {
        setMinValue(e.target.value);
      }
    },
    pattern: "[0-9.+-]*",
    inputMode: "numeric",
    title: "",
    onBlur: function onBlur(e) {
      return handleFilterUpdate(e);
    },
    className: "w-full outline-none text-15 font-medium text-secondary cursor-text "
  })))), "-", /*#__PURE__*/React.createElement("div", {
    className: "border border-gray rounded-4 p-3 whitespace-nowrap hover:border-lma focus:border-lma",
    style: {
      width: '45%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-secondary font-light text-11 whitespace-nowrap"
  }, t('Maximum price')), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center mt-1 whitespace-nowrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-medium text-secondary text-16 mr-1"
  }, "\u20AC"), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("input", {
    value: maxValue,
    onChange: function onChange(e) {
      var cleaned = cleanInputValue(e.target.value);
      if (regex.test(cleaned)) {
        setMaxValue(e.target.value);
      }
    },
    pattern: "[0-9.+-]*",
    inputMode: "numeric",
    title: "",
    onBlur: function onBlur(e) {
      return handleFilterUpdate(e);
    },
    className: "w-full outline-none text-15 font-medium text-secondary cursor-text"
  }))))), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "hidden"
  }));
};

var priceTypes = {
  PRICE: 'price',
  MONTHLY_PRICE: 'monthly'
};
var getCurrentRangeForSlider$1 = function getCurrentRangeForSlider(type, prices, monthlyPrices) {
  if (type === priceTypes.PRICE) {
    return prices;
  } else if (type === priceTypes.MONTHLY_PRICE) {
    return monthlyPrices;
  }
};
var getValueRangeForSlider = function getValueRangeForSlider(type, values, defaultValues) {
  if (values[type]) {
    return {
      min: head(values[type]),
      max: last(values[type])
    };
  }
  if (defaultValues[type]) {
    return {
      min: head(defaultValues[type]),
      max: last(defaultValues[type])
    };
  }
  return undefined;
};
var getRanges = function getRanges(min, max, step) {
  var data = [];
  each(range(min, max, step), function (value) {
    data.push({
      min: value,
      max: value + step
    });
  });
  return data;
};
var getPriceType = function getPriceType(clientSettings, activeTypeProp) {
  if (clientSettings.priceType) return clientSettings.priceType;
  if (activeTypeProp) return activeTypeProp;
  return priceTypes.PRICE;
};
var PriceRangeSlider = function PriceRangeSlider(_ref) {
  var values = _ref.values,
    defaultValues = _ref.defaultValues,
    prices = _ref.prices,
    monthlyPrices = _ref.monthlyPrices,
    onChange = _ref.onChange,
    label = _ref.label,
    activeType = _ref.activeType,
    onTypeChange = _ref.onTypeChange,
    onSlideChange = _ref.onSlideChange,
    context = _ref.context;
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings,
    setClientSetting = _useClientSettings.setClientSetting;
  var _useState = useState(getPriceType(clientSettings, activeType)),
    type = _useState[0],
    setType = _useState[1];
  var currentRange = getCurrentRangeForSlider$1(type, prices, monthlyPrices);
  var _useState2 = useState(undefined),
    sliderDisplayPrice = _useState2[0],
    setSliderDisplayPrice = _useState2[1];
  var _useState3 = useState((sliderDisplayPrice === null || sliderDisplayPrice === void 0 ? void 0 : sliderDisplayPrice.min) + "-" + (sliderDisplayPrice === null || sliderDisplayPrice === void 0 ? void 0 : sliderDisplayPrice.max) + "-" + type),
    key = _useState3[0],
    setKey = _useState3[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var setDisplayPrice = function setDisplayPrice() {
    var valueRange = getValueRangeForSlider(type, values, defaultValues);
    var priceRange = valueRange ? valueRange : currentRange;
    setSliderDisplayPrice({
      min: priceRange !== null && priceRange !== void 0 && priceRange.min ? priceRange === null || priceRange === void 0 ? void 0 : priceRange.min : 0,
      max: priceRange !== null && priceRange !== void 0 && priceRange.max ? priceRange === null || priceRange === void 0 ? void 0 : priceRange.max : currentRange === null || currentRange === void 0 ? void 0 : currentRange.max
    });
  };
  useEffect(function () {
    setDisplayPrice();
  }, [type, activeType, values]);
  useEffect(function () {
    setKey((sliderDisplayPrice === null || sliderDisplayPrice === void 0 ? void 0 : sliderDisplayPrice.min) + "-" + (sliderDisplayPrice === null || sliderDisplayPrice === void 0 ? void 0 : sliderDisplayPrice.max) + "-" + type);
  }, [type, activeType, values]);
  var handleChange = function handleChange(type, value) {
    var min = value[0];
    var max = value[1];
    var valueRange;
    if (min === currentRange.min && max === currentRange.max) {
      valueRange = undefined;
    } else {
      max = max === currentRange.max ? undefined : max;
      valueRange = [min, max];
    }
    var newValues = type === priceTypes.PRICE ? {
      monthly: undefined,
      price: valueRange
    } : {
      price: undefined,
      monthly: valueRange
    };
    onChange(newValues);
  };
  var handleTypeChange = function handleTypeChange(type) {
    setType(type);
    onTypeChange && typeof onTypeChange === 'function' && onTypeChange(type);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, label && /*#__PURE__*/React.createElement("div", {
    className: ""
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "relative font-normal w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-8 mb-6"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    label: t('Total'),
    checked: type === priceTypes.PRICE,
    onClick: function onClick() {
      handleTypeChange(priceTypes.PRICE);
      setClientSetting('priceType', priceTypes.PRICE, true);
    }
  }), /*#__PURE__*/React.createElement(Checkbox, {
    label: t('Monthly'),
    checked: type === priceTypes.MONTHLY_PRICE,
    onClick: function onClick() {
      handleTypeChange(priceTypes.MONTHLY_PRICE);
      setClientSetting('priceType', priceTypes.MONTHLY_PRICE, true);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "px-3"
  }, /*#__PURE__*/React.createElement(Range, {
    key: key + "-" + sliderDisplayPrice,
    value: [sliderDisplayPrice === null || sliderDisplayPrice === void 0 ? void 0 : sliderDisplayPrice.min, sliderDisplayPrice === null || sliderDisplayPrice === void 0 ? void 0 : sliderDisplayPrice.max],
    defaultValue: [sliderDisplayPrice === null || sliderDisplayPrice === void 0 ? void 0 : sliderDisplayPrice.min, sliderDisplayPrice === null || sliderDisplayPrice === void 0 ? void 0 : sliderDisplayPrice.max],
    min: currentRange.min,
    max: currentRange.max,
    step: currentRange.step,
    allowCross: false,
    onAfterChange: function onAfterChange(value) {
      handleChange(type, [value[0], value[1]]);
    },
    onChange: function onChange(value) {
      setSliderDisplayPrice({
        min: value[0],
        max: value[1]
      });
      if (onSlideChange && typeof onSlideChange === 'function') {
        onSlideChange();
      }
    }
  })), /*#__PURE__*/React.createElement(DisplayPrices, {
    currentRange: sliderDisplayPrice,
    initialRange: currentRange,
    ranges: getRanges(currentRange.min, currentRange.max, currentRange.step),
    onUpdate: function onUpdate(minValue, maxValue) {
      return handleChange(type, [minValue, maxValue]);
    }
  })));
};
PriceRangeSlider.defaultProps = {
  loading: false,
  defaultValues: {
    price: undefined,
    monthly: undefined
  },
  label: undefined,
  activeType: priceTypes.PRICE,
  onTypeChange: undefined,
  onSlideChange: undefined
};

var getPriceType$1 = function getPriceType(clientSettings) {
  var isProfessional = clientSettings.isProfessional;
  var isInclVat = (clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isInclVat) === true;
  var priceType = FilterTypes.price;
  if (isProfessional && !isInclVat) priceType = FilterTypes.priceExcl;
  return priceType;
};
var getMonthlyPriceType = function getMonthlyPriceType(clientSettings) {
  var isProfessional = clientSettings.isProfessional;
  var isInclVat = (clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isInclVat) === true;
  var monthlyPriceType = FilterTypes.monthlyPrice;
  if (isProfessional) {
    if (!isInclVat) monthlyPriceType = FilterTypes.monthlyPriceProf;
    if (isInclVat) monthlyPriceType = FilterTypes.monthlyPriceProfIncl;
  }
  return monthlyPriceType;
};
var PriceRangeFilter = function PriceRangeFilter(_ref) {
  var _filterData$prices;
  var filters = _ref.filters,
    filterData = _ref.filterData,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    filterDeleteByType = _ref.filterDeleteByType,
    hasFilter = _ref.hasFilter,
    context = _ref.context,
    onFilterChange = _ref.onFilterChange,
    isVisible = _ref.isVisible,
    handleToggle = _ref.handleToggle;
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings;
  var isInitialRef = useRef(true);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var priceMax = filterData ? filterData.dataSettings.priceMax : 0;
  var priceStep = filterData ? filterData.dataSettings.priceStep : 0;
  var monthlyMax = filterData ? filterData.dataSettings.monthlyMax : 0;
  var monthlyStep = filterData ? filterData.dataSettings.monthlyStep : 0;
  var prices = {
    min: 0,
    max: priceMax,
    step: priceStep
  };
  var monthlyPrices = {
    min: 0,
    max: monthlyMax,
    step: monthlyStep
  };
  var averagePrice = filterData !== null && filterData !== void 0 && filterData.prices ? filterData === null || filterData === void 0 ? void 0 : (_filterData$prices = filterData.prices) === null || _filterData$prices === void 0 ? void 0 : _filterData$prices.avg : undefined;
  var priceType = getPriceType$1(clientSettings);
  var monthlyPriceType = getMonthlyPriceType(clientSettings);
  var handleChange = function handleChange(type, range) {
    var typeMax = type === priceType ? prices.max : type === monthlyPriceType ? monthlyPrices.max : 0;
    var typeMin = type === priceType ? prices.min : type === monthlyPriceType ? monthlyPrices.min : 0;
    var rangeIsMax = range[0] === typeMin && range[1] === typeMax;
    if (!rangeIsMax) {
      if (hasFilter(type)) {
        filterUpdate(type, range);
      } else {
        filterAdd(type, range);
      }
    } else {
      filterDeleteByType(type);
    }
    onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
  };
  var priceFilter = find(filters, function (f) {
    return f.type === priceType;
  });
  var monthlyFilter = find(filters, function (f) {
    return f.type === monthlyPriceType;
  });
  useEffect(function () {
    if (isInitialRef.current) {
      if (!monthlyFilter && clientSettings.priceType === priceTypes.MONTHLY_PRICE) {
        handleChange(monthlyPriceType, [0, undefined]);
      }
      isInitialRef.current = false;
    }
  }, [isInitialRef]);
  return /*#__PURE__*/React.createElement(FilterTemplate, {
    isVisible: isVisible,
    handleToggle: handleToggle,
    label: t('Price') + "(\u20AC)"
  }, /*#__PURE__*/React.createElement(PriceRangeSlider, {
    prices: prices,
    monthlyPrices: monthlyPrices,
    averagePrice: averagePrice,
    context: context,
    onSlideChange: function onSlideChange() {
      if (isInitialRef.current) {
        isInitialRef.current = false;
      }
    },
    onTypeChange: function onTypeChange(selectedType) {
      if (selectedType === priceTypes.MONTHLY_PRICE) {
        handleChange(monthlyPriceType, [0, undefined]);
      } else {
        filterDeleteByType(monthlyPriceType);
      }
    },
    values: {
      price: priceFilter ? priceFilter.value : undefined,
      monthly: monthlyFilter ? monthlyFilter.value : undefined
    },
    onChange: function onChange(values) {
      if (values.price) {
        handleChange(priceType, values.price);
      } else {
        filterDeleteByType(priceType);
      }
      if (values.monthly) {
        handleChange(monthlyPriceType, values.monthly);
      } else {
        filterDeleteByType(monthlyPriceType);
      }
    }
  }));
};
var PriceRangeFilter$1 = baseFilter(PriceRangeFilter);

var Filters = function Filters(_ref) {
  var filtersClear = _ref.filtersClear,
    context = _ref.context,
    UIState = _ref.UIState,
    UIStateSave = _ref.UIStateSave,
    label = _ref.label;
  var _useState = useState([]),
    filtersWithMoreExpanded = _useState[0],
    setFiltersWithMoreExpanded = _useState[1];
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings;
  var isProfessional = (clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isProfessional) === true;
  var activeFiltersFromUIState = UIState !== null && UIState !== void 0 && UIState.activeFilters ? UIState === null || UIState === void 0 ? void 0 : UIState.activeFilters : [FilterTypes.body, FilterTypes.make, FilterTypes.model, FilterTypes.year, FilterTypes.price, FilterTypes.fuel, FilterTypes.mileage, FilterTypes.transmission];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isVisible = function isVisible(key) {
    return includes(activeFiltersFromUIState, key);
  };
  var handleToggleFilter = function handleToggleFilter(key) {
    var newActiveFilters;
    if (isVisible(key)) {
      newActiveFilters = filter(activeFiltersFromUIState, function (f) {
        return f !== key;
      });
    } else {
      newActiveFilters = [].concat(activeFiltersFromUIState, [key]);
    }
    UIStateSave(_extends({}, UIState, {
      activeFilters: newActiveFilters
    }));
  };
  var handleToggleMore = function handleToggleMore(filterKey) {
    var isExisting = find(filtersWithMoreExpanded, function (key) {
      return key === filterKey;
    });
    setFiltersWithMoreExpanded(isExisting ? filter(filtersWithMoreExpanded, function (key) {
      return key !== filterKey;
    }) : [].concat(filtersWithMoreExpanded, [filterKey]));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "mx-5 md:mx-0 relative w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between text-24 text-secondary font-bold bg-white overflow-hidden pb-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1"
  }, t('Filters')), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center cursor-pointer text-secondary",
    onClick: function onClick() {
      return filtersClear();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-undo mr-2 text-14"
  }), /*#__PURE__*/React.createElement("div", {
    className: " text-14"
  }, t('Reset')))), /*#__PURE__*/React.createElement("div", {
    className: "mb-10"
  }, /*#__PURE__*/React.createElement(ClientTypeSwitch$1, {
    context: context
  })), isProfessional && /*#__PURE__*/React.createElement("div", {
    className: "mb-8 px-1 border-b border-gray-100 pb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(VatTypeSwitch, {
    context: context
  })), /*#__PURE__*/React.createElement(VatFilter$1, {
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-8"
  }, /*#__PURE__*/React.createElement(LabelFilter$1, {
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(PriceRangeFilter$1, {
    context: context,
    isVisible: isVisible(FilterTypes.price),
    handleToggle: function handleToggle() {
      return handleToggleFilter(FilterTypes.price);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(FuelFilterCheckbox$1, {
    context: context,
    isVisible: isVisible(FilterTypes.fuel),
    handleToggle: function handleToggle() {
      return handleToggleFilter(FilterTypes.fuel);
    },
    onToggleMore: function onToggleMore() {
      return handleToggleMore(FilterTypes.fuel);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "px-1 space-y-5"
  }, label !== BRANDING.aap && /*#__PURE__*/React.createElement(MakeModelFilter$1, {
    context: context,
    isVisible: isVisible(FilterTypes.make),
    label: label,
    handleToggle: function handleToggle() {
      return handleToggleFilter(FilterTypes.make);
    },
    onToggleMore: function onToggleMore() {
      return handleToggleMore(FilterTypes.make);
    }
  }), label === BRANDING.aap && /*#__PURE__*/React.createElement(ModelsFilter$1, {
    selectedMakes: ['audi'],
    context: context,
    isVisible: isVisible(FilterTypes.model),
    handleToggle: function handleToggle() {
      return handleToggleFilter(FilterTypes.model);
    },
    onToggleMore: function onToggleMore() {
      return handleToggleMore(FilterTypes.model);
    }
  }), /*#__PURE__*/React.createElement(MileageFilter$1, {
    context: context,
    isVisible: isVisible(FilterTypes.mileage),
    handleToggle: function handleToggle() {
      return handleToggleFilter(FilterTypes.mileage);
    },
    onToggleMore: function onToggleMore() {
      return handleToggleMore(FilterTypes.mileage);
    }
  }), /*#__PURE__*/React.createElement(YearFilter$1, {
    context: context,
    isVisible: isVisible(FilterTypes.year),
    handleToggle: function handleToggle() {
      return handleToggleFilter(FilterTypes.year);
    },
    zIndex: 10
  }), /*#__PURE__*/React.createElement(GearboxFilterCheckbox$1, {
    context: context,
    isVisible: isVisible(FilterTypes.transmission),
    handleToggle: function handleToggle() {
      return handleToggleFilter(FilterTypes.transmission);
    },
    onToggleMore: function onToggleMore() {
      return handleToggleMore(FilterTypes.transmission);
    }
  }), /*#__PURE__*/React.createElement(BodiesFilter$1, {
    context: context,
    isVisible: isVisible(FilterTypes.body),
    handleToggle: function handleToggle() {
      return handleToggleFilter(FilterTypes.body);
    },
    onToggleMore: function onToggleMore() {
      return handleToggleMore(FilterTypes.body);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "border-t border-b border-aap-gray py-5"
  }, /*#__PURE__*/React.createElement(EcoFriendlyFilter$1, {
    context: context
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NewVehiclesFilter$1, {
    context: context
  })), /*#__PURE__*/React.createElement(EquipmentFilter$1, {
    context: context,
    isVisible: isVisible(FilterTypes.equipments),
    handleToggle: function handleToggle() {
      return handleToggleFilter(FilterTypes.equipments);
    }
  }), /*#__PURE__*/React.createElement(EuroNormFilter$1, {
    context: context,
    isVisible: isVisible(FilterTypes.euroNorm),
    handleToggle: function handleToggle() {
      return handleToggleFilter(FilterTypes.euroNorm);
    },
    onToggleMore: function onToggleMore() {
      return handleToggleMore(FilterTypes.euroNorm);
    }
  }), /*#__PURE__*/React.createElement(CO2Filter$1, {
    context: context,
    isVisible: isVisible(FilterTypes.co2),
    handleToggle: function handleToggle() {
      return handleToggleFilter(FilterTypes.co2);
    }
  }), /*#__PURE__*/React.createElement(PowerFilter$1, {
    context: context,
    isVisible: isVisible(FilterTypes.pk),
    handleToggle: function handleToggle() {
      return handleToggleFilter(FilterTypes.pk);
    },
    zIndex: 8
  }), /*#__PURE__*/React.createElement(ExteriorColorFilter$1, {
    context: context,
    isVisible: isVisible(FilterTypes.exteriorColor),
    handleToggle: function handleToggle() {
      return handleToggleFilter(FilterTypes.exteriorColor);
    },
    onToggleMore: function onToggleMore() {
      return handleToggleMore(FilterTypes.exteriorColor);
    }
  }), /*#__PURE__*/React.createElement(InteriorColorFilter$1, {
    context: context,
    isVisible: isVisible(FilterTypes.interiorColor),
    handleToggle: function handleToggle() {
      return handleToggleFilter(FilterTypes.interiorColor);
    },
    onToggleMore: function onToggleMore() {
      return handleToggleMore(FilterTypes.interiorColor);
    }
  }), /*#__PURE__*/React.createElement(InteriorUpholsteryFilter, {
    context: context,
    isVisible: isVisible(FilterTypes.interiorUpholstery),
    handleToggle: function handleToggle() {
      return handleToggleFilter(FilterTypes.interiorUpholstery);
    },
    onToggleMore: function onToggleMore() {
      return handleToggleMore(FilterTypes.interiorUpholstery);
    }
  }), /*#__PURE__*/React.createElement(DoorsFilter$1, {
    context: context,
    isVisible: isVisible(FilterTypes.doors),
    handleToggle: function handleToggle() {
      return handleToggleFilter(FilterTypes.doors);
    },
    onToggleMore: function onToggleMore() {
      return handleToggleMore(FilterTypes.doors);
    }
  }), /*#__PURE__*/React.createElement(SeatsFilter$1, {
    context: context,
    isVisible: isVisible(FilterTypes.seats),
    handleToggle: function handleToggle() {
      return handleToggleFilter(FilterTypes.seats);
    },
    onToggleMore: function onToggleMore() {
      return handleToggleMore(FilterTypes.seats);
    }
  }), !isProfessional && /*#__PURE__*/React.createElement(VatFilter$1, {
    context: context,
    isVisible: isVisible(FilterTypes.vat),
    handleToggle: function handleToggle() {
      return handleToggleFilter(FilterTypes.vat);
    }
  }), /*#__PURE__*/React.createElement(IdentificationFilter$1, {
    context: context,
    isVisible: isVisible(FilterTypes.identification),
    handleToggle: function handleToggle() {
      return handleToggleFilter(FilterTypes.identification);
    }
  })));
};
var Filters$1 = withFilters(Filters);

var FiltersMobile = function FiltersMobile(_ref) {
  var UIState = _ref.UIState,
    UIStateSave = _ref.UIStateSave,
    toggleSmallFilters = _ref.toggleSmallFilters,
    totalCountByFilters = _ref.totalCountByFilters,
    context = _ref.context;
  var _useState = useState(0),
    contentHeight = _useState[0],
    setContentHeight = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useWindowDimensions = useWindowDimensions(),
    height = _useWindowDimensions.height;
  var headerRef = useRef();
  var buttonRef = useRef();
  var isCompareVisible = compareBannerVisible();
  useEffect(function () {
    if (height > 0) {
      var contentHeightTmp = height - getStickiesOffset();
      if (isCompareVisible) {
        contentHeightTmp = contentHeightTmp - 70;
      }
      if (headerRef && headerRef.current) {
        contentHeightTmp = contentHeightTmp - headerRef.current.clientHeight;
      }
      if (buttonRef && buttonRef.current) {
        contentHeightTmp = contentHeightTmp - buttonRef.current.clientHeight;
      }
      setContentHeight(contentHeightTmp);
    }
  }, [height, totalCountByFilters]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      maxHeight: '100%',
      maxWidth: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: headerRef,
    className: "flex justify-between items-center py-8 px-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center text-primary"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-chevron-left mr-2",
    style: {
      marginTop: 2
    },
    onClick: function onClick() {
      return toggleSmallFilters();
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-20"
  }, t('Advanced search')))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 overflow-y-auto w-full",
    style: {
      height: contentHeight
    }
  }, /*#__PURE__*/React.createElement(Filters$1, {
    context: context,
    toggleSmallFilters: toggleSmallFilters,
    UIState: UIState,
    UIStateSave: UIStateSave
  })), /*#__PURE__*/React.createElement("div", {
    ref: buttonRef,
    className: "pt-3 px-5 " + (isCompareVisible ? 'pb-3' : 'pb-8')
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex md:hidden p-4 bg-secondary-two font-secondary text-primary rounded-10 text-16 font-semibold text-center items-center justify-center",
    onClick: function onClick() {
      return toggleSmallFilters ? toggleSmallFilters() : undefined;
    }
  }, totalCountByFilters >= 0 ? totalCountByFilters + ' ' + t('results') : t('Back to last results'))));
};
var FiltersMobile$1 = withFilters(FiltersMobile);

var CarSearchAgentBanner = function CarSearchAgentBanner(_ref) {
  var context = _ref.context,
    contentClass = _ref.contentClass,
    blockClassName = _ref.blockClassName;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-start justify-center w-full my-4 " + blockClassName
  }, /*#__PURE__*/React.createElement(InternalLink, {
    page: context.defaultPageNames.vehicleSearchAgent,
    className: "flex items-center justify-center bg-primary px-5 md:px-10 py-3 md:py-5 rounded-4 cursor-pointer " + contentClass,
    context: context,
    analyticsButtonCategory: "inbound-link",
    analyticsButtonName: "to-newsletter",
    analyticsButtonText: t("Haven't found your dream car yet? We search for you.")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tex-24 font-semibold text-white"
  }, t("Haven't found your dream car yet? We search for you.")), /*#__PURE__*/React.createElement("i", {
    className: "far fa-long-arrow-right ml-4 md:ml-8 text-white",
    style: {
      marginTop: 4
    }
  }))));
};
CarSearchAgentBanner.defaultProps = {
  contentClass: '',
  blockClassName: ''
};

var FiltersAndSortBadges = function FiltersAndSortBadges(_ref) {
  var filters = _ref.filters,
    sorter = _ref.sorter,
    filterDelete = _ref.filterDelete,
    sortDelete = _ref.sortDelete,
    filtersClear = _ref.filtersClear;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (filters.filter(function (f) {
    return (f === null || f === void 0 ? void 0 : f.label) !== undefined;
  }).length === 0) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 w-full px-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 overflow-x-auto md:overflow-auto"
  }, filters.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-14 font-semibold mr-2 hidden md:inline-block whitespace-nowrap text-secondary"
  }, t('Selected filters'), ":"), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-nowrap md:flex-wrap gap-2"
  }, map(filters, function (filter, index) {
    var labelExists = filter.label && filter.label !== '' && filter.label !== undefined;
    return /*#__PURE__*/React.createElement("div", {
      key: "filter.type" + index,
      className: "h-12 flex flex-row bg-gray-50 px-5 rounded-full " + (labelExists ? '' : 'hidden')
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row items-center"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-14 text-secondary w-full truncate capitalize"
    }, filter.label && filter.label !== '' ? filter.label : filter.key), /*#__PURE__*/React.createElement("div", {
      className: "cursor-pointer ml-2 md:ml-4 text-secondary hover:text-primary",
      onClick: function onClick() {
        return filterDelete(filter);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-trash-alt "
    }))));
  }))), sorter && /*#__PURE__*/React.createElement("div", {
    className: "" + (filters.length > 0 ? 'flex items-center border-l border-gray-200 ml-2 pl-4 ' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row bg-gray-50 px-5 py-1 mr-2",
    style: {
      borderRadius: 50
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex capitalize items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mr-2 " + (sorter.direction === 'asc' ? 'fas fa-sort-numeric-down' : 'fas fa-sort-numeric-up'),
    style: {
      marginTop: 2
    }
  }), /*#__PURE__*/React.createElement("span", null, sorter.label)), /*#__PURE__*/React.createElement("div", {
    className: "cursor-pointer ml-2 md:ml-4 text-secondary hover:text-primary",
    onClick: sortDelete
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-trash-alt ",
    style: {
      marginTop: 2
    }
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "text-secondary flex items-center justify-end cursor-pointer font-semibold ml-2",
    onClick: function onClick() {
      return filtersClear();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-undo mr-2 text-12"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-16"
  }, t('Remove all'))));
};
var FiltersAndSortBadges$1 = withFilters(FiltersAndSortBadges);

var NoSearchResults = function NoSearchResults(_ref) {
  var filters = _ref.filters,
    filterDelete = _ref.filterDelete,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleBackClick = function handleBackClick() {
    if (filters.length >= 1) filterDelete(filters.pop());
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "mb-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex w-full justify-between items-center mb-6 pb-6 border-b border-secondary-five"
  }, filters && filters.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "paragraph-large font-semibold text-primary cursor-pointer",
    onClick: function onClick() {
      return handleBackClick();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-chevron-left mr-2"
  }), ' ', t('Back to last results'))), /*#__PURE__*/React.createElement("div", {
    className: "pb-6"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "font-semibold text-primary mb-4"
  }, t('Unfortunately, your search returned no results...')), /*#__PURE__*/React.createElement("div", {
    className: "paragraph-large text-secondary-four"
  }, t('Please try again, but now with fewer or modified search criteria.'))), /*#__PURE__*/React.createElement(FiltersAndSortBadges$1, {
    context: context
  })), /*#__PURE__*/React.createElement(CarSearchAgentBanner, {
    context: context,
    contentClass: "w-full"
  }));
};
var NoSearchResults$1 = withFilters(NoSearchResults);

var calculateNumberOfCards = function calculateNumberOfCards(width) {
  var numberOfCards = 3;
  if (width >= 768 && width < 940) numberOfCards = 1;
  if (width >= 940 && width < 1476) numberOfCards = 2;
  if (width >= 1476) numberOfCards = 3;
  return numberOfCards;
};
var SegmentBlock = function SegmentBlock(_ref) {
  var segment = _ref.segment,
    onSegmentClick = _ref.onSegmentClick,
    onSegmentVehicleClick = _ref.onSegmentVehicleClick,
    brandingLabel = _ref.brandingLabel,
    grid = _ref.grid,
    context = _ref.context;
  var _useWindowDimensions = useWindowDimensions(),
    width = _useWindowDimensions.width;
  var _useState = useState(null),
    contentWidth = _useState[0],
    setContentWidth = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var contentRef = useRef();
  useEffect(function () {
    if (contentRef && contentRef.current) {
      setContentWidth(contentRef.current.clientWidth);
    }
  }, [width]);
  var renderButton = function renderButton() {
    return /*#__PURE__*/React.createElement("div", {
      className: "mt-6"
    }, brandingLabel === BRANDING.myway && /*#__PURE__*/React.createElement("button", {
      className: "button myway-button",
      onClick: function onClick() {
        return onSegmentClick(segment);
      }
    }, t('All MyWay second hands vehicles'), " (", segment === null || segment === void 0 ? void 0 : segment.totalVehiclesCountByFilters, ")"), brandingLabel === BRANDING.aap && /*#__PURE__*/React.createElement("button", {
      className: "button aap-button",
      onClick: function onClick() {
        return onSegmentClick(segment);
      }
    }, context.culture === 'fr' ? 'Tous les véhicules d’occasion Audi Approved :plus' : 'Alle Audi Approved :plus tweedehandswagens', ' ', "(", segment === null || segment === void 0 ? void 0 : segment.totalVehiclesCountByFilters, ")"), brandingLabel === BRANDING.lma && /*#__PURE__*/React.createElement("button", {
      className: "button primary-button",
      onClick: function onClick() {
        return onSegmentClick(segment);
      }
    }, t('All other second hands vehicles'), " (", segment === null || segment === void 0 ? void 0 : segment.totalVehiclesCountByFilters, ")"));
  };
  var renderMobile = function renderMobile() {
    var vehiclesToShowMobile = 3;
    return /*#__PURE__*/React.createElement("div", {
      key: "segment-main-" + segment.key
    }, /*#__PURE__*/React.createElement("div", {
      className: "overflow-x-auto"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-nowrap space-x-5",
      style: {
        width: 'min-content'
      }
    }, map(segment.vehicles.slice(0, vehiclesToShowMobile), function (vehicle, i) {
      return /*#__PURE__*/React.createElement("div", {
        key: "segment-vehicle-" + i,
        className: "segment-vehicle",
        style: {
          width: contentWidth ? contentWidth : 290
        }
      }, /*#__PURE__*/React.createElement(VehicleCard$1, {
        key: vehicle.reference,
        vehicle: vehicle,
        context: context,
        onClick: function onClick(vehicle) {
          onSegmentVehicleClick(vehicle);
        }
      }));
    }))), brandingLabel && renderButton());
  };
  var renderDesktop = function renderDesktop() {
    var vehiclesToShowDesktop = calculateNumberOfCards(width);
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: grid
    }, map(segment.vehicles.slice(0, vehiclesToShowDesktop), function (vehicle, i) {
      return /*#__PURE__*/React.createElement("div", {
        key: "segment-vehicle-" + i
      }, /*#__PURE__*/React.createElement(VehicleCard$1, {
        key: vehicle.reference,
        vehicle: vehicle,
        context: context,
        onClick: function onClick(vehicle) {
          onSegmentVehicleClick(vehicle);
        }
      }));
    })), brandingLabel && renderButton());
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: contentRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "block md:hidden"
  }, renderMobile()), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block"
  }, renderDesktop()));
};

var NotifyMeButton = function NotifyMeButton(_ref) {
  var initializeSearchAgentCriteria = _ref.initializeSearchAgentCriteria,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(InternalLink, {
    page: context.defaultPageNames.vehicleSearchAgent,
    context: context,
    analyticsButtonName: "save-search",
    analyticsButtonType: "inbound-link",
    analyticsButtonText: t('Find me a car'),
    onClick: function onClick() {
      return initializeSearchAgentCriteria();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-12 md3:w-auto h-12 bg-aap-gray flex items-center justify-center rounded-full px-0 md3:px-5"
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-bell mr-0 md3:mr-2",
    style: {
      marginTop: 1
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "hidden md3:block flex-none ml-2"
  }, t('Find me a car'))));
};
var NotifyMeButton$1 = baseNotifyBtn(NotifyMeButton);

var SegmentsTopBar = function SegmentsTopBar(_ref) {
  var onToggleSmallFilters = _ref.onToggleSmallFilters,
    totalVehicles = _ref.totalVehicles,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col pt-2"
  }, /*#__PURE__*/React.createElement("p", {
    className: "flex flex-1 text-base md:text-24 font-bold text-secondary truncate"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mr-1"
  }, totalVehicles), clientSettings.isProfessional ? t('results for professionals') : t('results for private')), /*#__PURE__*/React.createElement(Sticky, {
    enabled: true,
    top: getStickiesOffset(),
    bottomBoundary: ".bottom-container",
    activeClass: "bg-white w-full",
    innerZ: 21
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col space-y-2 md:space-y-4 bg-white py-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("button", {
    className: "block md:hidden button alternate-button",
    style: {
      borderRadius: 50
    },
    onClick: onToggleSmallFilters
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-sliders-h mr-2 text-12"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-sm md:text-base"
  }, t('Filters'))), /*#__PURE__*/React.createElement(NotifyMeButton$1, {
    context: context
  })), /*#__PURE__*/React.createElement(FiltersAndSortBadges$1, {
    context: context
  }))));
};

var Pagination = function Pagination(_ref) {
  var goToNextPage = _ref.goToNextPage,
    goToPreviousPage = _ref.goToPreviousPage,
    goToPage = _ref.goToPage,
    currentPage = _ref.currentPage,
    pages = _ref.pages,
    amountOfPages = _ref.amountOfPages;
  var firstShownPage = pages[0];
  var lastShownPage = pages[pages.length - 1];
  var renderPreviousButton = function renderPreviousButton() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center bg-gray-200 rounded-4 w-10 h-10 cursor-pointer hover:bg-secondary-eight",
      onClick: function onClick() {
        return goToPreviousPage();
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-chevron-left"
    }));
  };
  var renderGoToFirstPage = function renderGoToFirstPage() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center w-10 h-10 cursor-pointer",
      onClick: function onClick() {
        return goToPage(1);
      }
    }, "1"), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center w-10 h-10"
    }, "..."));
  };
  var renderPageNumber = function renderPageNumber(page) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center w-10 h-10 cursor-pointer " + (page === currentPage ? 'text-secondary-two' : ''),
      onClick: function onClick() {
        return goToPage(page);
      }
    }, page);
  };
  var renderGoToLastPage = function renderGoToLastPage() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center w-10 h-10"
    }, "..."), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center w-10 h-10 cursor-pointer",
      onClick: function onClick() {
        return goToPage(amountOfPages);
      }
    }, amountOfPages));
  };
  var renderNextButton = function renderNextButton() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center bg-gray-200 rounded-4 w-10 h-10 cursor-pointer hover:bg-secondary-eight",
      onClick: function onClick() {
        return goToNextPage();
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-chevron-right"
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex w-full justify-center mt-8"
  }, currentPage > 1 && renderPreviousButton(), firstShownPage > 2 && renderGoToFirstPage(), pages.map(function (page) {
    return renderPageNumber(page);
  }), lastShownPage < amountOfPages - 1 && renderGoToLastPage(), currentPage < amountOfPages && renderNextButton());
};
var Pagination$1 = basePagination(Pagination);

var List = function List(_ref) {
  var loading = _ref.loading,
    vehiclesFetching = _ref.vehiclesFetching,
    hasMore = _ref.hasMore,
    grid = _ref.grid,
    deviceType = _ref.deviceType,
    cards = _ref.cards,
    selectVehicle = _ref.selectVehicle,
    goToNextPage = _ref.goToNextPage,
    goToPreviousPage = _ref.goToPreviousPage,
    goToPage = _ref.goToPage,
    currentPage = _ref.currentPage,
    batchSize = _ref.batchSize,
    totalCount = _ref.totalCount,
    filters = _ref.filters,
    customCardsByBatch = _ref.customCardsByBatch,
    context = _ref.context;
  var renderSkeleton = function renderSkeleton() {
    return /*#__PURE__*/React.createElement("div", {
      className: grid + " px-5 md:px-0 space-y-5 md:space-y-0"
    }, times(12, function (item) {
      return /*#__PURE__*/React.createElement(VehicleCardSkeleton, {
        key: "list-vehicle-card-" + item
      });
    }));
  };
  if (loading) {
    return renderSkeleton();
  }
  if (vehiclesFetching && deviceType !== 'mobile') {
    return /*#__PURE__*/React.createElement("div", {
      className: "hidden md:block"
    }, renderSkeleton());
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "vehicles-list px-0 " + grid
  }, map(cards, function (card, index) {
    if (card._type === 'vehicle') {
      return /*#__PURE__*/React.createElement(VehicleCard$1, {
        key: index,
        vehicle: card,
        context: context,
        cardClass: "vehicle-card",
        onClick: selectVehicle,
        index: index,
        totalCount: totalCount,
        filters: filters
      });
    } else if (card._type === 'banner') {
      var _card$image, _card$image2, _card$image3, _card$image4, _card$image5;
      return /*#__PURE__*/React.createElement(ActionLink, {
        key: index,
        action: card.action,
        className: "vehicle-card shadow-xl overflow-hidden hover:opacity relative cursor-pointer h-full",
        style: {
          marginBottom: '2%'
        },
        context: context
      }, /*#__PURE__*/React.createElement("img", {
        srcSet: ((_card$image = card.image) === null || _card$image === void 0 ? void 0 : _card$image.mobile) + " 300w, " + ((_card$image2 = card.image) === null || _card$image2 === void 0 ? void 0 : _card$image2.tablet) + " 768w, " + ((_card$image3 = card.image) === null || _card$image3 === void 0 ? void 0 : _card$image3.desktop) + " 1280w",
        src: (_card$image4 = card.image) === null || _card$image4 === void 0 ? void 0 : _card$image4.mobile,
        alt: (_card$image5 = card.image) === null || _card$image5 === void 0 ? void 0 : _card$image5.alt,
        className: "object-cover h-full w-full",
        style: {
          width: '100%',
          height: '100%'
        }
      }));
    }
  })), totalCount > batchSize && /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block"
  }, /*#__PURE__*/React.createElement(Pagination$1, {
    goToNextPage: goToNextPage,
    goToPreviousPage: goToPreviousPage,
    goToPage: goToPage,
    currentPage: currentPage,
    batchSize: batchSize,
    totalCount: totalCount,
    pageRange: 2,
    customCardsByBatch: customCardsByBatch
  })), !hasMore && /*#__PURE__*/React.createElement(CarSearchAgentBanner, {
    context: context
  }));
};
var List$1 = baseVehiclesPaged(List);

var NoFavoriteSearchResults = function NoFavoriteSearchResults(_ref) {
  var context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(InternalLink, {
    page: context.defaultPageNames.vehicles,
    className: "flex items-center paragraph-small text-secondary-two cursor-pointer font-semibold",
    context: context
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-chevron-left mr-2"
  }), /*#__PURE__*/React.createElement("span", null, t('Back to results'))), /*#__PURE__*/React.createElement("div", {
    className: "py-6 my-6 border-t border-b border-secondary-five"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "font-semibold text-primary mb-2"
  }, t(' You have not selected any favorites yet.')), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center paragraph-large text-secondary-four"
  }, /*#__PURE__*/React.createElement("div", null, t('Add cars by clicking the heart icon.')), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center rounded-full bg-gray-50 ml-1",
    style: {
      width: 36,
      height: 36
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-heart text-primary",
    style: {
      fontSize: 17
    }
  })))), /*#__PURE__*/React.createElement(CarSearchAgentBanner, {
    context: context,
    contentClass: "w-full"
  }));
};
var NoFavoriteSearchResults$1 = withFilters(NoFavoriteSearchResults);

var SortCombo = function SortCombo(_ref) {
  var sorter = _ref.sorter,
    sortDelete = _ref.sortDelete,
    sortChange = _ref.sortChange,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAnalytics = useAnalytics(context),
    buttonClickEventAnalytics = _useAnalytics.buttonClickEventAnalytics;
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings;
  var isProfessional = (clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.isProfessional) === true;
  var defaultButtonData = {
    analyticsButtonType: 'list',
    analyticsButtonName: 'sort',
    analyticsButtonCategory: 'interaction'
  };
  var customSorters = [{
    value: 'publicationDate',
    label: t('Recently published'),
    ascending: false
  }, {
    value: 'price',
    label: t('Price - low to high'),
    ascending: true
  }, {
    value: 'price',
    label: t('Price - high to low'),
    ascending: false
  }, {
    value: 'mileage',
    label: t('Mileage - low to high'),
    ascending: true
  }, {
    value: 'mileage',
    label: t('Mileage - high to low'),
    ascending: false
  }, {
    value: 'vaa',
    label: t('VAA - low to high'),
    ascending: true
  }, {
    value: 'vaa',
    label: t('VAA - high to low'),
    ascending: false
  }];
  var defaultSorter = {
    value: 'publicationDate',
    label: t('Recently published'),
    ascending: true
  };
  var currentSorter = sorter ? {
    value: sorter.field,
    label: t(sorter.label),
    ascending: sorter.direction !== 'desc'
  } : defaultSorter;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center w-full md:w-auto"
  }, /*#__PURE__*/React.createElement(SelectBox, {
    value: currentSorter,
    options: customSorters,
    containerClass: "min-w-sort w-full md:w-max",
    className: "w-full rounded-l-4 rounded-r-4 cursor-pointer",
    placeholder: t('Sort'),
    customComponents: {
      Option: function Option(_ref2) {
        var _innerProps$id;
        var innerProps = _ref2.innerProps,
          isDisabled = _ref2.isDisabled,
          data = _ref2.data;
        var index = parseInt$1(last(innerProps === null || innerProps === void 0 ? void 0 : (_innerProps$id = innerProps.id) === null || _innerProps$id === void 0 ? void 0 : _innerProps$id.split('-')));
        var isSelected = currentSorter.value === data.value && currentSorter.ascending === data.ascending;
        if (!isProfessional && data.value === 'vaa') {
          return;
        }
        var handleClickOption = function handleClickOption(e) {
          buttonClickEventAnalytics(_extends({}, defaultButtonData, {
            analyticsButtonText: data === null || data === void 0 ? void 0 : data.label
          }));
          if (isSelected) {
            sortDelete();
          } else {
            sortChange({
              value: data.value
            }, data.ascending);
          }
        };
        return !isDisabled ? /*#__PURE__*/React.createElement("div", _extends({}, innerProps, {
          className: "px-3 mb-2 " + (index === 0 ? 'mt-2' : '')
        }), /*#__PURE__*/React.createElement(Checkbox, {
          label: function label() {
            return /*#__PURE__*/React.createElement("div", null, data.label);
          },
          onClick: handleClickOption,
          checked: isSelected
        })) : null;
      }
    },
    isLoading: false
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-24 text-secondary-two ml-2"
  }, /*#__PURE__*/React.createElement("i", {
    className: currentSorter !== null && currentSorter !== void 0 && currentSorter.ascending ? 'fal fa-sort-amount-down-alt' : 'fal fa-sort-amount-down'
  })));
};
var SortCombo$1 = withSort(SortCombo);

var SegmentSelectorDesktop = function SegmentSelectorDesktop(_ref) {
  var segments = _ref.segments,
    _onClick = _ref.onClick,
    brandingLabel = _ref.brandingLabel,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var renderSegmentButton = function renderSegmentButton(segment) {
    var _context$dealerGroup, _context$dealerGroup2;
    if (segment.totalVehiclesCountByFilters < 1) {
      return /*#__PURE__*/React.createElement("div", {
        className: "hidden"
      });
    }
    var isCurrent = segment.key === brandingLabel;
    if (segment.key === BRANDING.myway) {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex px-4 py-3 cursor-pointer text-center text-16 font-bold cursor-pointer " + (isCurrent ? 'bg-myway-darker text-white' : 'bg-gray-200 text-gray-500'),
        onClick: function onClick() {
          return _onClick(segment);
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: isCurrent ? IMAGES['myway-white-text-logo-nl'] : IMAGES['myway-dark-text-logo-nl'],
        className: "h-24px",
        alt: "My Way logo"
      }), /*#__PURE__*/React.createElement("span", {
        className: "ml-2"
      }, "(", segment.totalVehiclesCountByFilters, ")"));
    } else if (segment.key === BRANDING.aap) {
      var imageSrc = isCurrent ? IMAGES["aap-white-logo-" + context.culture.toLowerCase()] : IMAGES["aap-red-logo-" + context.culture.toLowerCase()];
      return /*#__PURE__*/React.createElement("div", {
        className: "flex px-4 py-3 cursor-pointer text-center text-16 font-bold cursor-pointer " + (isCurrent ? 'bg-aap text-white' : 'bg-gray-200 text-gray-500'),
        onClick: function onClick() {
          return _onClick(segment);
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: imageSrc,
        className: "h-20px md:h-24px",
        alt: "Audi approved plus"
      }), /*#__PURE__*/React.createElement("span", {
        className: "ml-2"
      }, "(", segment.totalVehiclesCountByFilters, ")"));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "px-4 py-3 cursor-pointer text-center text-16 font-bold cursor-pointer " + (isCurrent ? 'bg-primary text-white' : 'bg-gray-200 text-gray-500'),
      onClick: function onClick() {
        return _onClick(segment);
      }
    }, context !== null && context !== void 0 && (_context$dealerGroup = context.dealerGroup) !== null && _context$dealerGroup !== void 0 && _context$dealerGroup.name ? (context === null || context === void 0 ? void 0 : (_context$dealerGroup2 = context.dealerGroup) === null || _context$dealerGroup2 === void 0 ? void 0 : _context$dealerGroup2.name) + " " + t('vehicles') : t('Other vehicles'), ' ', /*#__PURE__*/React.createElement("span", {
      className: "ml-2"
    }, "(", segment.totalVehiclesCountByFilters, ")"));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex overflow-x-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-nowrap space-x-2.5"
  }, map(orderBy(segments, ['priority']), function (segment) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        minWidth: 'fit-content'
      }
    }, renderSegmentButton(segment));
  })));
};

var SegmentSelectorMobile = function SegmentSelectorMobile(_ref) {
  var segments = _ref.segments,
    currentSegment = _ref.currentSegment,
    _onClick = _ref.onClick,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    expanded = _useState[0],
    setExpanded = _useState[1];
  var segmentsToShow = currentSegment ? segments.filter(function (os) {
    return os.key !== currentSegment.key;
  }) : segments;
  var renderSegmentButton = function renderSegmentButton(segment) {
    var _context$dealerGroup, _context$dealerGroup2;
    if (segment.key === BRANDING.myway) {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex items-center",
        onClick: function onClick() {
          return _onClick(segment);
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: IMAGES['myway-dark-text-logo-nl'],
        className: "h-6",
        alt: "My Way logo"
      }), /*#__PURE__*/React.createElement("span", {
        className: "ml-1"
      }, "(", segment.totalVehiclesCountByFilters, ' ', segment.totalVehiclesCountByFilters > 1 ? t('results') : t('result'), ")", ' '));
    } else if (segment.key === BRANDING.aap) {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex items-center",
        onClick: function onClick() {
          return _onClick(segment);
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: IMAGES["aap-red-logo-" + context.culture.toLowerCase()],
        alt: "Audi approved plus",
        className: "h-6"
      }), /*#__PURE__*/React.createElement("span", {
        className: "ml-1"
      }, "(", segment.totalVehiclesCountByFilters, ' ', segment.totalVehiclesCountByFilters > 1 ? t('results') : t('result'), ")"));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center",
      onClick: function onClick() {
        return _onClick(segment);
      }
    }, context !== null && context !== void 0 && (_context$dealerGroup = context.dealerGroup) !== null && _context$dealerGroup !== void 0 && _context$dealerGroup.name ? (context === null || context === void 0 ? void 0 : (_context$dealerGroup2 = context.dealerGroup) === null || _context$dealerGroup2 === void 0 ? void 0 : _context$dealerGroup2.name) + " " + t('vehicles') : t('Other vehicles'), ' ', /*#__PURE__*/React.createElement("span", {
      className: "ml-1"
    }, "(", segment.totalVehiclesCountByFilters, ' ', segment.totalVehiclesCountByFilters > 1 ? t('results') : t('result'), ")"));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "segments-top-bar bg-white"
  }, currentSegment && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between p-3 text-16 font-bold text-secondary w-full truncate cursor-pointer text-center bg-white border-primary " + (expanded ? 'border-t-2 border-l-2 border-r-2 border-b' : 'border-2'),
    onClick: function onClick() {
      return setExpanded(!expanded);
    }
  }, renderSegmentButton(currentSegment), ' ', /*#__PURE__*/React.createElement("i", {
    className: "far fa-angle-down text-primary ml-2 "
  })), !currentSegment && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between p-3 capitalize text-primary w-full truncate cursor-pointer text-center bg-white border-2 border-primary",
    onClick: function onClick() {
      return setExpanded(!expanded);
    }
  }, t('Choose'), " ", /*#__PURE__*/React.createElement("i", {
    className: "far fa-angle-down text-primary ml-2"
  })), expanded && /*#__PURE__*/React.createElement("div", {
    className: "border-r-2 border-l-2 border-b-2 border-primary"
  }, map(segmentsToShow, function (segment) {
    if (segment.totalVehiclesCountByFilters > 0) {
      return /*#__PURE__*/React.createElement("div", {
        key: "segment-" + segment.key,
        onClick: function onClick() {
          return _onClick(segment);
        },
        className: "flex items-center justify-between p-3 text-primary w-full truncate cursor-pointer text-center"
      }, renderSegmentButton(segment), ' ', /*#__PURE__*/React.createElement("i", {
        className: "fal fa-long-arrow-right ml-2 font-normal"
      }));
    }
  })));
};

var SegmentSelector = function SegmentSelector(_ref) {
  var segments = _ref.segments,
    currentSegment = _ref.currentSegment,
    onClick = _ref.onClick,
    brandingLabel = _ref.brandingLabel,
    context = _ref.context;
  if (segments && segments.length > 0) {
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "block md:hidden"
    }, /*#__PURE__*/React.createElement(SegmentSelectorMobile, {
      segments: segments,
      onClick: onClick,
      currentSegment: currentSegment,
      brandingLabel: brandingLabel,
      context: context
    })), /*#__PURE__*/React.createElement("div", {
      className: "hidden md:block"
    }, /*#__PURE__*/React.createElement(SegmentSelectorDesktop, {
      segments: segments,
      onClick: onClick,
      brandingLabel: brandingLabel,
      context: context
    })));
  }
  return null;
};

var VehiclesTopBar = function VehiclesTopBar(_ref) {
  var onToggleSmallFilters = _ref.onToggleSmallFilters,
    vehiclesCountByFilters = _ref.vehiclesCountByFilters,
    vehiclesFetching = _ref.vehiclesFetching,
    context = _ref.context,
    segments = _ref.segments,
    currentSegment = _ref.currentSegment,
    onClick = _ref.onClick,
    brandingLabel = _ref.brandingLabel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useClientSettings = useClientSettings(context),
    clientSettings = _useClientSettings.clientSettings;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col pt-4 md:pt-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between"
  }, /*#__PURE__*/React.createElement("p", {
    className: "flex items-center text-base md:text-24 font-bold text-secondary truncate"
  }, vehiclesFetching && /*#__PURE__*/React.createElement("div", {
    className: "w-5 min-w-5 min-h-5 h-5 bg-aap-gray animate-pulse rounded-full mr-1"
  }), !vehiclesFetching && /*#__PURE__*/React.createElement("span", {
    className: "mr-1"
  }, vehiclesCountByFilters), /*#__PURE__*/React.createElement("span", {
    className: "hidden lg:inline mr-2"
  }, clientSettings.isProfessional ? t('results for professionals') : t('results for private')), context.vehicleSegmentation && /*#__PURE__*/React.createElement("span", {
    className: "inline lg:hidden"
  }, t('results, of which'), ":"), !context.vehicleSegmentation && /*#__PURE__*/React.createElement("span", {
    className: "inline lg:hidden"
  }, t('results'))), /*#__PURE__*/React.createElement("div", {
    className: "md:hidden"
  }, /*#__PURE__*/React.createElement(NotifyMeButton$1, {
    context: context
  }))), /*#__PURE__*/React.createElement(Sticky, {
    enabled: true,
    top: getStickiesOffset(),
    bottomBoundary: ".bottom-container",
    activeClass: "vehicle-filter-bar-sticky bg-lma-gray sm:bg-white w-full",
    innerZ: 21
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col space-y-2 md:space-y-4 bg-transparent sm:bg-white pt-4 pb-4 lg:pt-0 " + (context.vehicleSegmentation ? '' : 'mt-0 lg:mt-4')
  }, context.vehicleSegmentation && /*#__PURE__*/React.createElement("div", {
    className: "block lg:hidden mb-2 w-full"
  }, /*#__PURE__*/React.createElement(SegmentSelectorMobile, {
    segments: segments,
    currentSegment: currentSegment,
    onClick: onClick,
    brandingLabel: brandingLabel,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between space-x-4 md:space-x-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 items-center justify-between md:justify-start space-x-4 md:space-x-0"
  }, /*#__PURE__*/React.createElement("button", {
    className: "flex-none block md:hidden button alternate-button",
    style: {
      borderRadius: 50
    },
    onClick: onToggleSmallFilters
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-sliders-h mr-0 xs:mr-2 text-base xs:text-12"
  }), /*#__PURE__*/React.createElement("span", {
    className: "hidden xs:inline text-sm md:text-base"
  }, t('Filters'))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center vehicles-sort w-full md:w-auto sort-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:block lg:mr-2 whitespace-nowrap text-16 leading-19px text-secondary font-light"
  }, t('Sort by')), /*#__PURE__*/React.createElement(SortCombo$1, {
    context: context
  }))), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block"
  }, /*#__PURE__*/React.createElement(NotifyMeButton$1, {
    context: context
  }))), context.vehicleSegmentation && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:block"
  }, /*#__PURE__*/React.createElement(SegmentSelector, {
    segments: segments,
    currentSegment: currentSegment,
    onClick: onClick,
    brandingLabel: brandingLabel,
    context: context
  }))), /*#__PURE__*/React.createElement(FiltersAndSortBadges$1, {
    context: context
  }))));
};

var FiltersAndVehiclesSkeleton = function FiltersAndVehiclesSkeleton(_ref) {
  var advertise_top_images = _ref.advertise_top_images,
    grid = _ref.grid;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col",
    style: {
      minHeight: '100vh'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block bg-white mr-6 lg:mr-10",
    style: {
      width: 320,
      minWidth: 320,
      maxWidth: 320
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "overflow-y-auto ",
    style: {
      height: "calc(100vh - " + getStickiesOffset() + "px)",
      top: "calc(" + getStickiesOffset() + "px + 1.25rem)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-full"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "vehicles-list-container flex flex-col w-full"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, advertise_top_images && /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block bg-gray-200 animate-pulse h-60 mb-5"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-6 w-40"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-6 w-16 mr-4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-6 w-16 "
  }))), /*#__PURE__*/React.createElement("div", {
    className: grid
  }, times(12, function (item) {
    return /*#__PURE__*/React.createElement(VehicleCardSkeleton, {
      key: "vehicles-list-card-" + item,
      options: {
        width: '100%'
      }
    });
  }))))));
};

var SegmentsSkeleton = function SegmentsSkeleton(_ref) {
  var advertise_top_images = _ref.advertise_top_images,
    grid = _ref.grid;
  return /*#__PURE__*/React.createElement("div", {
    className: "vehicles-list-container flex flex-col w-full"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, advertise_top_images && /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block bg-gray-200 animate-pulse h-60 mb-5"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-6 w-40"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-6 w-16 mr-4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-6 w-16 "
  }))), /*#__PURE__*/React.createElement("div", {
    className: grid
  }, times(12, function (item) {
    return /*#__PURE__*/React.createElement(VehicleCardSkeleton, {
      key: "vehicles-list-card-" + item,
      options: {
        width: '100%'
      }
    });
  }))));
};

var HeaderBreadcrumb = function HeaderBreadcrumb(_ref) {
  var context = _ref.context,
    className = _ref.className,
    linksClassName = _ref.linksClassName;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var renderDesktop = function renderDesktop() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex"
    }, /*#__PURE__*/React.createElement(InternalLink, {
      page: context.defaultPageNames.home,
      className: "font-semibold underline " + linksClassName,
      context: context
    }, t('Home')), /*#__PURE__*/React.createElement("span", {
      className: "mx-2"
    }, "-"), /*#__PURE__*/React.createElement(InternalLink, {
      page: context.defaultPageNames.vehicles,
      className: "font-semibold underline " + linksClassName,
      context: context
    }, t('Vehicles')), /*#__PURE__*/React.createElement("span", {
      className: "mx-2"
    }, "-"), /*#__PURE__*/React.createElement("span", {
      className: "font-light"
    }, t('Used car search')));
  };
  var renderMobile = function renderMobile() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-long-arrow-alt-left mr-2"
    }), /*#__PURE__*/React.createElement(InternalLink, {
      page: context.defaultPageNames.vehicles,
      className: "font-light " + linksClassName,
      context: context
    }, t('Vehicles')));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex " + className
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block"
  }, renderDesktop()), /*#__PURE__*/React.createElement("div", {
    className: "block md:hidden"
  }, renderMobile()));
};
HeaderBreadcrumb.defaultProps = {
  className: 'text-white',
  linksClassName: 'text-white'
};

var ListHeader = function ListHeader(_ref) {
  var context = _ref.context,
    brand = _ref.brand,
    UIState = _ref.UIState,
    UIStateSave = _ref.UIStateSave;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    titleHasOverflow = _useState[0],
    setTitleHasOverflow = _useState[1];
  var dealerNameRef = useRef();
  useEffect(function () {
    if (hasDocument()) {
      var el = document.getElementById('list-branded-header');
      UIStateSave(_extends({}, UIState, {
        offsetTop: el === null || el === void 0 ? void 0 : el.clientHeight
      }));
    }
  }, []);
  useEffect(function () {
    if (dealerNameRef !== null && dealerNameRef !== void 0 && dealerNameRef.current) {
      if (dealerNameRef.current.clientHeight + 12 < dealerNameRef.current.scrollHeight) {
        setTitleHasOverflow(true);
      }
    }
  }, [dealerNameRef]);
  var renderMyWayHeader = function renderMyWayHeader() {
    return /*#__PURE__*/React.createElement("div", {
      className: "bg-myway-darker relative"
    }, /*#__PURE__*/React.createElement("div", {
      className: "container pt-6 pb-12 space-y-6 md:space-y-14 text-white"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HeaderBreadcrumb, {
      context: context
    })), context.culture === 'fr' && /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col text-32 md:text-60 leading-none space-y-1 md:space-y-3.5"
    }, /*#__PURE__*/React.createElement("div", null, t('Looking for a used car')), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement("img", {
      src: IMAGES['myway-white-text-logo-nl'],
      alt: "My Way logo",
      className: "mt-0 md:mt-2.5 h-30px md:h-60px mr-4"
    }), "?")), context.culture !== 'fr' && /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col text-32 md:text-60 leading-none space-y-1"
    }, /*#__PURE__*/React.createElement("div", null, t('Looking for a')), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement("img", {
      src: IMAGES['myway-white-text-logo-nl'],
      alt: "My Way logo",
      className: "mt-0 md:mt-2.5 mr-0 md:mr-4 h-30px md:h-60px"
    }), /*#__PURE__*/React.createElement("span", {
      className: "hidden md:block font-bold"
    }, t('used car'), "?")), /*#__PURE__*/React.createElement("span", {
      className: "block md:hidden font-bold"
    }, t('used car'), "?"))), /*#__PURE__*/React.createElement("div", {
      className: "absolute w-full bg-myway-darker h-40",
      style: {
        zIndex: -1
      }
    }));
  };
  var renderAapHeader = function renderAapHeader() {
    return /*#__PURE__*/React.createElement("div", {
      className: "bg-aap-gray relative"
    }, /*#__PURE__*/React.createElement("div", {
      className: "container pt-6 pb-12 space-y-6 md:space-y-14 text-gray-500"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HeaderBreadcrumb, {
      className: "text-gray-500",
      linksClassName: "text-primary",
      context: context
    })), context.culture === 'fr' && /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col text-32 md:text-60 leading-none space-y-1 md:space-y-3.5"
    }, /*#__PURE__*/React.createElement("div", null, t('Looking for a used car')), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement("img", {
      src: IMAGES["aap-red-logo-" + context.culture.toLowerCase()],
      alt: "Audi approved plus",
      className: "mt-0 md:mt-2.5 h-30px md:h-60px mr-4"
    }), "?")), context.culture !== 'fr' && /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col text-32 md:text-60 leading-none space-y-1"
    }, /*#__PURE__*/React.createElement("div", null, t('Looking for a')), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement("img", {
      src: IMAGES["aap-red-logo-" + context.culture.toLowerCase()],
      alt: "Audi approved plus",
      className: "mt-0 md:mt-2.5 mr-0 md:mr-4 h-30px md:h-60px"
    }), /*#__PURE__*/React.createElement("span", {
      className: "hidden md:block font-bold"
    }, t('used car'), "?")), /*#__PURE__*/React.createElement("span", {
      className: "block md:hidden font-bold"
    }, t('used car'), "?"))), /*#__PURE__*/React.createElement("div", {
      className: "absolute w-full bg-aap-gray h-40",
      style: {
        zIndex: -1
      }
    }));
  };
  var renderLmaHeader = function renderLmaHeader() {
    var _context$dealerGroup, _context$dealerGroups, _context$dealerGroups2, _context$dealerGroup2, _context$dealerGroups3, _context$dealerGroups4;
    return /*#__PURE__*/React.createElement("div", {
      className: "bg-lma-gray relative"
    }, /*#__PURE__*/React.createElement("div", {
      className: "container pt-6 pb-12 space-y-6 md:space-y-14 text-secondary"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HeaderBreadcrumb, {
      className: "text-gray-500",
      linksClassName: "text-primary",
      context: context
    })), context.culture === 'fr' && /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col text-32 md:text-60 leading-none space-y-1 md:space-y-3.5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mb-0 md:mb-2.5"
    }, t('Looking for a used car')), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center mt-0 md:mt-2.5 h-30px md:h-60px"
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-bold text-lma mr-4"
    }, (context === null || context === void 0 ? void 0 : (_context$dealerGroup = context.dealerGroup) === null || _context$dealerGroup === void 0 ? void 0 : _context$dealerGroup.name) || (context === null || context === void 0 ? void 0 : (_context$dealerGroups = context.dealerGroups) === null || _context$dealerGroups === void 0 ? void 0 : (_context$dealerGroups2 = _context$dealerGroups[0]) === null || _context$dealerGroups2 === void 0 ? void 0 : _context$dealerGroups2.name) || ''), "?")), context.culture !== 'fr' && /*#__PURE__*/React.createElement("div", {
      ref: dealerNameRef,
      className: "flex flex-col leading-none space-y-1 md:space-y-3.5 " + (titleHasOverflow ? 'text-32 sm:text-28 md2:text-30 lg2:text-48' : 'text-32 md:text-48 lg2:text-60')
    }, /*#__PURE__*/React.createElement("div", {
      className: ""
    }, t('Looking for a')), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center md:h-60px"
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-bold text-lma mr-4"
    }, (context === null || context === void 0 ? void 0 : (_context$dealerGroup2 = context.dealerGroup) === null || _context$dealerGroup2 === void 0 ? void 0 : _context$dealerGroup2.name) || (context === null || context === void 0 ? void 0 : (_context$dealerGroups3 = context.dealerGroups) === null || _context$dealerGroups3 === void 0 ? void 0 : (_context$dealerGroups4 = _context$dealerGroups3[0]) === null || _context$dealerGroups4 === void 0 ? void 0 : _context$dealerGroups4.name) || ''), /*#__PURE__*/React.createElement("div", {
      className: "hidden md:block font-bold"
    }, ' ', t('used car'), "?")), /*#__PURE__*/React.createElement("span", {
      className: "block md:hidden font-bold"
    }, t('used car'), "?"))), /*#__PURE__*/React.createElement("div", {
      className: "absolute w-full bg-lma-gray h-40",
      style: {
        zIndex: -1
      }
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "list-branded-header"
  }, brand === BRANDING.myway && renderMyWayHeader(), brand === BRANDING.aap && renderAapHeader(), brand === undefined && renderLmaHeader());
};

var resolveFirstAddByFilters = function resolveFirstAddByFilters(filters) {
  var labelFilters = filter(filters, function (f) {
    return f.type === FilterTypes.label;
  });
  var brand = BRANDING.lma;
  if ((labelFilters === null || labelFilters === void 0 ? void 0 : labelFilters.length) === 1) {
    var _head;
    brand = (_head = head(labelFilters)) === null || _head === void 0 ? void 0 : _head.value;
  }
  return brand;
};
var resolveSecondAddByFilters = function resolveSecondAddByFilters(filters) {
  var labelFilters = filter(filters, function (f) {
    return f.type === FilterTypes.label;
  });
  var brand = 'myway-selfcheck-aap';
  if ((labelFilters === null || labelFilters === void 0 ? void 0 : labelFilters.length) === 1) {
    var _head2;
    brand = ((_head2 = head(labelFilters)) === null || _head2 === void 0 ? void 0 : _head2.value) === LABELS.AAP ? "selfcheck-" + BRANDING.aap : "selfcheck-" + BRANDING.myway;
  }
  return brand;
};
var resolveBrandingByFilters = function resolveBrandingByFilters(filters) {
  var labelFilters = filter(filters, function (f) {
    return f.type === FilterTypes.label;
  });
  var brand = undefined;
  if ((labelFilters === null || labelFilters === void 0 ? void 0 : labelFilters.length) === 1) {
    var _head3;
    var value = (_head3 = head(labelFilters)) === null || _head3 === void 0 ? void 0 : _head3.value;
    if (value === LABELS.MYWAY) {
      brand = BRANDING.myway;
    } else if (value === LABELS.AAP) {
      brand = BRANDING.aap;
    }
  }
  return brand;
};
var FiltersAndListPaged = function FiltersAndListPaged(props) {
  var _advertise_top_images, _advertise_top_images2, _advertise_top_images3, _advertise_top_images4, _advertise_top_images5;
  var view = props.view,
    loading = props.loading,
    defaultFilterModalStyles = props.defaultFilterModalStyles,
    context = props.context;
  var advertise_top_images = props.advertise_top_images,
    advertise_list_images = props.advertise_list_images,
    customCardsByBatch = props.customCardsByBatch;
  var selectVehicle = props.selectVehicle,
    batchSize = props.batchSize,
    vehiclesCountByFilters = props.vehiclesCountByFilters,
    vehiclesFetching = props.vehiclesFetching;
  var filters = props.filters;
  var _useState = useState({
      label: resolveBrandingByFilters(filters),
      addGroup1: resolveFirstAddByFilters(filters),
      addGroup2: resolveSecondAddByFilters(filters)
    }),
    branding = _useState[0],
    setBranding = _useState[1];
  var UIState = props.UIState,
    UIStateSave = props.UIStateSave;
  var _useScrollPosition = useScrollPosition();
  var _useWindowDimensions = useWindowDimensions(),
    width = _useWindowDimensions.width;
  var segments = props.segments,
    currentSegment = props.currentSegment,
    hasSegmentsData = props.hasSegmentsData,
    segmentSelect = props.segmentSelect;
  useEffect(function () {
    setBranding({
      label: resolveBrandingByFilters(filters),
      addGroup1: resolveFirstAddByFilters(filters),
      addGroup2: resolveSecondAddByFilters(filters)
    });
  }, [filters]);
  var _useState2 = useState(UIState !== null && UIState !== void 0 && UIState.mobileFilterModalVisible ? UIState === null || UIState === void 0 ? void 0 : UIState.mobileFilterModalVisible : false),
    mobileFilterModalVisible = _useState2[0],
    setMobileFilterModalVisible = _useState2[1];
  var grid = "grid grid-cols-1 sm:grid-cols-2 " + (width > 940 ? 'md:grid-cols-2 md:gap-4' : 'md:grid-cols-1 md:gap-0') + " lg:grid-cols-2 lg2:grid-cols-3 xl:grid-cols-3 sm:gap-4 lg:gap-4";
  var renderLoadingIndicator = function renderLoadingIndicator() {
    return /*#__PURE__*/React.createElement("div", {
      className: "container py-5 lg:py-19 bg-white w-full"
    }, /*#__PURE__*/React.createElement(FiltersAndVehiclesSkeleton, {
      advertise_top_images: advertise_top_images && advertise_top_images.length > 0,
      grid: grid
    }), ";");
  };
  var renderRight = function renderRight() {
    switch (view) {
      case 'FiltersAndSegments':
        return renderSegments();
      case 'FiltersAndVehicles':
        return renderVehicles();
      case 'NoResults':
        return renderNoResults();
      case 'NoResultsFavorites':
        return renderNoFavoritesResults();
      default:
        return /*#__PURE__*/React.createElement("div", null, "No view defined");
    }
  };
  var renderSegments = function renderSegments() {
    if (!hasSegmentsData) return /*#__PURE__*/React.createElement("div", {
      className: "w-full"
    }, /*#__PURE__*/React.createElement(SegmentsSkeleton, {
      advertise_top_images: advertise_top_images && advertise_top_images.length > 0,
      grid: grid
    }), ";");
    var totalVehicles = segments === null || segments === void 0 ? void 0 : segments.reduce(function (n, _ref) {
      var totalVehiclesCountByFilters = _ref.totalVehiclesCountByFilters;
      return n + totalVehiclesCountByFilters;
    }, 0);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "w-full"
    }, /*#__PURE__*/React.createElement(SegmentsTopBar, {
      onToggleSmallFilters: function onToggleSmallFilters() {
        return setMobileFilterModalVisible(!mobileFilterModalVisible);
      },
      totalVehicles: totalVehicles,
      context: context
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col flex-1 space-y-8 md:space-y-16"
    }, map(segments, function (segment) {
      if (segment.totalVehiclesCountByFilters > 0) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AdvertiseComponent$1, {
          groupName: "segment-" + segment.key,
          context: context
        }), /*#__PURE__*/React.createElement(SegmentBlock, {
          segment: segment,
          onSegmentClick: segmentSelect,
          onSegmentVehicleClick: selectVehicle,
          brandingLabel: segment.key,
          context: context,
          grid: grid
        }));
      }
    })));
  };
  var renderVehicles = function renderVehicles() {
    var totalVehicles = segments ? segments.reduce(function (n, _ref2) {
      var totalVehiclesCountByFilters = _ref2.totalVehiclesCountByFilters;
      return n + totalVehiclesCountByFilters;
    }, 0) : vehiclesCountByFilters;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "bg-white px-8 md:px-0 -mx-8 md:mx-0 space-y-8"
    }, /*#__PURE__*/React.createElement(VehiclesTopBar, {
      onToggleSmallFilters: function onToggleSmallFilters() {
        return setMobileFilterModalVisible(!mobileFilterModalVisible);
      },
      vehiclesCountByFilters: totalVehicles,
      vehiclesFetching: vehiclesFetching,
      context: context,
      segments: segments,
      currentSegment: currentSegment,
      onClick: segmentSelect,
      brandingLabel: currentSegment ? currentSegment.key : undefined
    })), /*#__PURE__*/React.createElement("div", {
      id: "render-vehicles-list"
    }, /*#__PURE__*/React.createElement(List$1, {
      advertise_list_images: advertise_list_images,
      customCardsByBatch: customCardsByBatch,
      vehiclesFetching: vehiclesFetching,
      context: context,
      batchSize: batchSize,
      grid: grid,
      filters: filters
    })));
  };
  var renderNoResults = function renderNoResults() {
    return /*#__PURE__*/React.createElement(NoSearchResults$1, {
      context: context
    });
  };
  var renderNoFavoritesResults = function renderNoFavoritesResults() {
    return /*#__PURE__*/React.createElement(NoFavoriteSearchResults$1, {
      context: context
    });
  };
  if (loading) {
    return renderLoadingIndicator();
  }
  return /*#__PURE__*/React.createElement("div", {
    id: "vehicles-list-wrapper",
    className: "flex flex-col relative"
  }, /*#__PURE__*/React.createElement("div", {
    id: "filters-and-list-header"
  }, /*#__PURE__*/React.createElement(ListHeader, {
    brand: branding.label,
    context: context,
    UIState: UIState,
    UIStateSave: UIStateSave
  })), /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block absolute w-full h-full top-0 left-0 right-0 mx-auto bg-white border-t border-secondary-two",
    style: {
      maxWidth: 1600,
      zIndex: '-1'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "hidden lg3:block absolute w-1/2 h-full right-0 bg-white border-t border-secondary-two top-0",
    style: {
      zIndex: '-1'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col container pt-0 pb-5 md:pt-5 lg:pb-19 w-full ",
    style: {
      minHeight: '100vh'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block mr-6 lg:mr-10 bg-white items-start justify-start sticky top-0",
    style: {
      width: 320,
      minWidth: 320,
      maxWidth: 320,
      height: 'auto'
    }
  }, /*#__PURE__*/React.createElement(Filters$1, {
    context: context,
    UIState: UIState,
    UIStateSave: UIStateSave,
    label: branding === null || branding === void 0 ? void 0 : branding.label
  })), /*#__PURE__*/React.createElement("div", {
    className: "vehicles-list-container flex flex-col w-full"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, advertise_top_images && advertise_top_images.length > 0 && /*#__PURE__*/React.createElement(ActionLink, {
    action: advertise_top_images[0].action,
    className: "hidden md:block cursor-pointer mb-5",
    style: {
      maxHeight: 250
    },
    context: context
  }, /*#__PURE__*/React.createElement("img", {
    srcSet: ((_advertise_top_images = advertise_top_images[0].image) === null || _advertise_top_images === void 0 ? void 0 : _advertise_top_images.mobile) + " 300w, " + ((_advertise_top_images2 = advertise_top_images[0].image) === null || _advertise_top_images2 === void 0 ? void 0 : _advertise_top_images2.tablet) + " 768w, " + ((_advertise_top_images3 = advertise_top_images[0].image) === null || _advertise_top_images3 === void 0 ? void 0 : _advertise_top_images3.desktop) + " 1280w",
    src: (_advertise_top_images4 = advertise_top_images[0].image) === null || _advertise_top_images4 === void 0 ? void 0 : _advertise_top_images4.mobile,
    alt: (_advertise_top_images5 = advertise_top_images[0].image) === null || _advertise_top_images5 === void 0 ? void 0 : _advertise_top_images5.alt,
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  })), renderRight()))))), /*#__PURE__*/React.createElement(Modal, {
    isOpen: mobileFilterModalVisible,
    style: {
      content: _extends({}, defaultFilterModalStyles.content),
      overlay: _extends({}, defaultFilterModalStyles.overlay, {
        top: 80,
        zIndex: 999,
        bottom: compareBannerVisible() ? 70 : 0
      })
    },
    appElement: hasDocument() ? document.getElementById('root') : undefined
  }, /*#__PURE__*/React.createElement(FiltersMobile$1, {
    context: context,
    UIState: UIState,
    UIStateSave: UIStateSave,
    toggleSmallFilters: function toggleSmallFilters(value) {
      var val = value ? value : !mobileFilterModalVisible;
      setMobileFilterModalVisible(val);
      UIStateSave(_extends({}, UIState, {
        mobileFilterModalVisible: val
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    id: "bottom-container",
    className: "opacity-0 bottom-container"
  }), /*#__PURE__*/React.createElement(AdvertiseComponent$1, {
    groupName: branding.addGroup1,
    context: context
  }), /*#__PURE__*/React.createElement(AdvertiseComponent$1, {
    groupName: branding.addGroup2,
    context: context
  }));
};
var FiltersAndListPaged$1 = baseVehiclesAndFilters(FiltersAndListPaged);

var VehicleListWithAdds = function VehicleListWithAdds(_ref) {
  var advertise_top_images = _ref.advertise_top_images,
    advertise_list_images = _ref.advertise_list_images,
    context = _ref.context;
  return /*#__PURE__*/React.createElement(FiltersAndListPaged$1, {
    advertise_top_images: advertise_top_images,
    advertise_list_images: advertise_list_images,
    context: context
  });
};
VehicleListWithAdds.defaultProps = {
  advertise_top_images: [],
  advertise_list_images: []
};
VehicleListWithAdds.human = {
  nl: '',
  fr: '',
  en: ''
};
VehicleListWithAdds.preview = function () {
  return /*#__PURE__*/React.createElement("div", null, "Vehicles with adds");
};

var MakesFilter = function MakesFilter(_ref) {
  var criteriaData = _ref.criteriaData,
    criteriaValues = _ref.criteriaValues,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-secondary mb-2 mt-5"
  }, t('Make')), /*#__PURE__*/React.createElement(GenericSelect, {
    placeHolder: t('All'),
    items: criteriaData,
    values: criteriaValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    }
  }));
};
var MakesFilter$1 = baseMakeSearchAgentCriteriaForMakeModel(MakesFilter);

var ModelsFilter$2 = function ModelsFilter(_ref) {
  var criteriaData = _ref.criteriaData,
    makeCriteriaValues = _ref.makeCriteriaValues,
    modelCriteriaValues = _ref.modelCriteriaValues,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var makes = criteriaData.makes;
  var makesInFilters = filter(makes, function (m) {
    return includes(makeCriteriaValues, m.key);
  });
  var modelOptions = map(makesInFilters, function (make) {
    return {
      value: make.key,
      label: make.text,
      options: make.models ? orderBy(map(make.models, function (model) {
        return {
          label: model.text,
          value: model.key,
          makeKey: make.key
        };
      }), ['label']) : []
    };
  });
  var modelsArr = [];
  if (!isEmpty(modelCriteriaValues) && !isEmpty(makes)) {
    modelCriteriaValues.map(function (modelItem) {
      var make = find(makes, function (make) {
        return make.key === modelItem.make;
      });
      var model = find(make.models, function (model) {
        return model.key === modelItem.model;
      });
      modelsArr.push(make.text + " " + model.text);
    });
  }
  var modelLabel = modelsArr.join(', ');
  var handleFilterChanged = function handleFilterChanged(data) {
    var value = data.makeKey + "|" + data.value;
    if (hasCriteriaWithValue(value)) {
      criteriaDelete(value);
    } else if (hasCriteriaWithValue(data.makeKey)) {
      criteriaDelete(data.makeKey);
      criteriaAdd(value);
    } else {
      criteriaAdd(value);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-secondary mb-2 mt-5"
  }, t('Model')), /*#__PURE__*/React.createElement(SelectBox, {
    value: modelLabel ? {
      label: modelLabel
    } : '',
    options: orderBy(modelOptions, ['label']),
    closeMenuOnSelect: false,
    placeholder: t('All'),
    customComponents: {
      Option: function Option(_ref2) {
        var innerProps = _ref2.innerProps,
          isDisabled = _ref2.isDisabled,
          data = _ref2.data;
        var isSelected = filter(modelCriteriaValues, function (f) {
          return f.model === data.value;
        }).length > 0;
        return !isDisabled ? /*#__PURE__*/React.createElement("div", innerProps, /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row py-1 cursor-pointer hover:text-primary ml-5 text-secondary-four",
          onClick: function onClick() {
            return handleFilterChanged(data);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center"
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center justify-center rounded border mr-2 w-4 h-4 " + (isSelected ? 'bg-secondary-one border-secondary-one' : 'border-primary')
        }, isSelected && /*#__PURE__*/React.createElement("div", {
          className: "h-full w-full bg-primary"
        }))), /*#__PURE__*/React.createElement("div", {
          className: "flex flex-1 text-16 font-light font-semibold relative " + (isSelected ? 'text-secondary' : 'text-secondary')
        }, /*#__PURE__*/React.createElement("div", {
          className: "capitalize"
        }, data.label)))) : null;
      }
    },
    isLoading: false
  }));
};
var ModelsFilter$3 = baseModelSearchAgentCriteriaForModel(ModelsFilter$2);

var BodiesFilter$2 = function BodiesFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation();
  var onFilterChanged = function onFilterChanged(data) {
    if (hasCriteriaWithValue(data.key)) {
      criteriaDelete(data.key);
    } else {
      criteriaAdd(data.key);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center mx-auto overflow-x-auto py-4 space-x-4"
  }, map(orderBy(data, ['priority', 'text']), function (bt, i) {
    var isSelected = includes(value, bt.key);
    return /*#__PURE__*/React.createElement("div", {
      key: "body-type-" + i,
      onClick: function onClick() {
        return onFilterChanged(bt);
      },
      className: "w-32 h-32 flex-none border-2 " + (isSelected ? 'border-primary' : 'border-gray-100') + " rounded-lg py-4 px-6 cursor-pointer shadow-md hover:border-secondary-three transition"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-center justify-center outline-none text-secondary py-6"
    }, /*#__PURE__*/React.createElement("img", {
      src: getBodyImageSrc(bt.key),
      style: {
        height: 35
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "mt-3 text-14 truncate leading-24 w-full text-center"
    }, bt.text)));
  }));
};
var BodyFilter = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.body, BodiesFilter$2);

var FuelFilter = function FuelFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-secondary mb-2 mt-5"
  }, t('Fuel type')), /*#__PURE__*/React.createElement(GenericSelect, {
    placeHolder: t('All'),
    items: orderBy(data, ['text']),
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    }
  }));
};
var FuelFilter$1 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.fuel, FuelFilter);

var GearboxFilter = function GearboxFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-secondary mb-2 mt-5"
  }, t('Gear')), /*#__PURE__*/React.createElement(GenericSelect, {
    placeHolder: t('All'),
    items: orderBy(data, ['text']),
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    }
  }));
};
var GearboxFilter$1 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.transmission, GearboxFilter);

var GenericRangeSelect$1 = function GenericRangeSelect(_ref) {
  var placeHolderFrom = _ref.placeHolderFrom,
    placeHolderTo = _ref.placeHolderTo,
    optionsFrom = _ref.optionsFrom,
    optionsTo = _ref.optionsTo,
    value = _ref.value,
    handleFilterChanged = _ref.handleFilterChanged;
  var valueFrom = value ? {
    label: value[0] ? value[0] : ''
  } : '';
  var valueTo = value ? {
    label: value[1] ? value[1] : ''
  } : '';
  if (value && value[0]) {
    optionsTo = filter(optionsTo, function (y) {
      return y.value >= value[0];
    });
  }
  if (value && value[1]) {
    optionsFrom = filter(optionsFrom, function (y) {
      return y.value <= value[1];
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 w-full space-x-2"
  }, /*#__PURE__*/React.createElement(SelectBox, {
    value: valueFrom,
    options: optionsFrom,
    placeholder: placeHolderFrom,
    isLoading: false,
    onChange: function onChange(item) {
      var start = item.value;
      var stop = value && value[1] && value[1] > item.value ? value[1] : undefined;
      handleFilterChanged([start, stop]);
    }
  }), /*#__PURE__*/React.createElement(SelectBox, {
    value: valueTo,
    options: optionsTo,
    placeholder: placeHolderTo,
    isLoading: false,
    onChange: function onChange(item) {
      var start = value && value[0] && value[0] < item.value ? value[0] : undefined;
      var stop = item.value;
      handleFilterChanged([start, stop]);
    }
  }));
};

var YearFilter$2 = function YearFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaUpdate = _ref.criteriaUpdate;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var yearsFrom = range(data.min, data.max + 1).map(function (item) {
    return {
      value: item,
      label: item
    };
  });
  var yearsTo = range(data.min, data.max + 1).map(function (item) {
    return {
      value: item,
      label: item
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-secondary mb-2 mt-5"
  }, t('First registration')), /*#__PURE__*/React.createElement(GenericRangeSelect$1, {
    placeHolderFrom: t('From'),
    placeHolderTo: t('To'),
    optionsFrom: orderBy(yearsFrom, ['value'], ['desc']),
    optionsTo: orderBy(yearsTo, ['value'], ['desc']),
    value: value && value.length > 0 ? value[0] : undefined,
    handleFilterChanged: function handleFilterChanged(range) {
      if (value.length > 0) {
        criteriaUpdate(range);
      } else {
        criteriaAdd(range);
      }
    }
  }));
};
var YearFilter$3 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.year, YearFilter$2);

var MileageFilter$2 = function MileageFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaUpdate = _ref.criteriaUpdate;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var mileagesFrom = range(data.min, data.max + 1, 5000).map(function (mileage) {
    return {
      value: Math.round(mileage / 1000) * 1000,
      label: formatNumber(Math.round(mileage / 1000) * 1000) + " km"
    };
  });
  var mileagesTo = range(data.min, data.max + 1, 5000).map(function (mileage) {
    return {
      value: Math.round(mileage / 1000) * 1000,
      label: formatNumber(Math.round(mileage / 1000) * 1000) + " km"
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-secondary mb-2 mt-5"
  }, t('Mileage')), /*#__PURE__*/React.createElement(GenericRangeSelect$1, {
    placeHolderFrom: t('From'),
    placeHolderTo: t('To'),
    optionsFrom: mileagesFrom,
    optionsTo: mileagesTo,
    value: value && value.length > 0 ? value[0] : undefined,
    handleFilterChanged: function handleFilterChanged(range) {
      if (value.length > 0) {
        criteriaUpdate(range);
      } else {
        criteriaAdd(range);
      }
    }
  }));
};
var MileageFilter$3 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.mileage, MileageFilter$2);

var DoorsFilter$2 = function DoorsFilter(_ref) {
  var value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaUpdate = _ref.criteriaUpdate,
    criteriaDelete = _ref.criteriaDelete;
  var doorsRangeValue = value && value.length > 0 ? value[0] : undefined;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var filterExists = function filterExists(range) {
    return doorsRangeValue ? includes(doorsRangeValue, range[0]) && includes(doorsRangeValue, range[1]) : false;
  };
  var handleFilterChanged = function handleFilterChanged(range) {
    if (value.length > 0) {
      criteriaUpdate(range);
    } else {
      criteriaAdd(range);
    }
  };
  var handleRemoveFilter = function handleRemoveFilter() {
    criteriaDelete(FilterTypes.doorsRangeValue);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-secondary mb-2 mt-5"
  }, t('Nr. of Doors')), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-4 text-14",
    style: {
      height: 42
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center items-center cursor-pointer text-center border border-gray-200 rounded-l " + (!doorsRangeValue ? 'bg-secondary text-white' : 'text-secondary'),
    onClick: function onClick() {
      return handleRemoveFilter();
    }
  }, t('All')), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center items-center cursor-pointer text-center border-t border-b border-gray-200 " + (filterExists([2, 3]) ? 'bg-secondary text-white' : 'text-secondary'),
    onClick: function onClick() {
      return handleFilterChanged([2, 3]);
    }
  }, "2/3"), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center items-center cursor-pointer text-center border-t border-b border-l border-gray-200 " + (filterExists([4, 5]) ? 'bg-secondary text-white' : 'text-secondary'),
    onClick: function onClick() {
      return handleFilterChanged([4, 5]);
    }
  }, "4/5"), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center items-center cursor-pointer text-center border border-gray-200 rounded-r " + (filterExists([6, 7]) ? 'bg-secondary text-white' : 'text-secondary'),
    onClick: function onClick() {
      return handleFilterChanged([6, 7]);
    }
  }, "6/7")));
};
var DoorsFilter$3 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.doorsRange, DoorsFilter$2);

var GenericListSecondary = function GenericListSecondary(_ref) {
  var items = _ref.items,
    values = _ref.values,
    handleFilterChanged = _ref.handleFilterChanged,
    containerClass = _ref.containerClass;
  var options = orderBy(map(items, function (item) {
    return {
      value: item.key,
      label: item.text
    };
  }), ['label']);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: containerClass
  }, map(options, function (option, i) {
    var isSelected = includes(values, option.value);
    return /*#__PURE__*/React.createElement("div", {
      key: "filter-" + option.value + "-" + i,
      className: "flex items-center py-1 cursor-pointer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row rounded cursor-pointer text-primary",
      onClick: function onClick() {
        return handleFilterChanged(option);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center border-2 border-gray-200 p-1 mr-2 w-6 h-6"
    }, isSelected && /*#__PURE__*/React.createElement("div", {
      className: "h-full w-full bg-primary"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row justify-between flex-1 relative truncate " + (isSelected ? 'font-semibold' : 'font-normal')
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-secondary capitalize truncate"
    }, option.label))));
  })));
};
GenericListSecondary.defaultProps = {
  containerClass: 'space-y-2'
};

var CategoryFilter = function CategoryFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-secondary mb-2 mt-5"
  }, t('Vehicle condition')), /*#__PURE__*/React.createElement(GenericListSecondary, {
    items: data,
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    },
    containerClass: "flex flex-row space-x-4"
  }));
};
baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.category, CategoryFilter);

var VatFilter$2 = function VatFilter(_ref) {
  var value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleFilterChanged = function handleFilterChanged() {
    if (hasCriteriaWithValue(true)) {
      criteriaDelete(true);
    } else {
      criteriaAdd(true);
    }
  };
  var isSelected = includes(value, true);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-secondary mb-2 mt-5"
  }, t('VAT')), /*#__PURE__*/React.createElement("div", {
    key: "filter-vat",
    className: "flex flex-col text-gray-900 mb-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row py-2 px-1 rounded hover:bg-secondary-five cursor-pointer hover:text-primary",
    onClick: function onClick() {
      return handleFilterChanged();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center border-2 border-gray-200 p-1 mr-2 w-6 h-6"
  }, isSelected && /*#__PURE__*/React.createElement("div", {
    className: "h-full w-full bg-primary"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row justify-between flex-1 relative text-secondary " + (isSelected ? 'font-semibold' : 'font-normal')
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, t('VAT deductible'))))));
};
var VatFilter$3 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.vat, VatFilter$2);

var SeatsFilter$2 = function SeatsFilter(_ref) {
  var value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaUpdate = _ref.criteriaUpdate,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var seatsRangeValue = value && value.length > 0 ? value[0] : undefined;
  var filterExists = function filterExists(seats) {
    return seatsRangeValue && seatsRangeValue[0] === seats ? true : false;
  };
  var handleFilterChanged = function handleFilterChanged(range) {
    if (value.length <= 0) {
      criteriaAdd(range);
    } else {
      if (hasCriteriaWithValue(range)) {
        criteriaDelete();
      } else {
        criteriaUpdate(range);
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-secondary mb-2 mt-5"
  }, t('Nr. of Seats')), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap text-14"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-24 h-24 border " + (filterExists(2) ? 'border-secondary' : 'border-gray-200') + " rounded-lg py-4 px-6 cursor-pointer mr-4 mb-4 md:mb-0 shadow-md hover:border-secondary transition",
    onClick: function onClick() {
      return handleFilterChanged([2]);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center outline-none text-secondary"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-family-small",
    style: {
      fontSize: 29
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-3 text-14 truncate leading-24 w-full text-center"
  }, "S"))), /*#__PURE__*/React.createElement("div", {
    className: "w-24 h-24 border " + (filterExists(3) ? 'border-secondary' : 'border-gray-200') + " rounded-lg py-4 px-6 cursor-pointer mr-4 mb-4 md:mb-0 shadow-md hover:border-secondary  transition",
    onClick: function onClick() {
      return handleFilterChanged([3]);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center outline-none text-secondary"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-family-medium",
    style: {
      fontSize: 29
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-3 text-14 truncate leading-24 w-full text-center"
  }, "M"))), /*#__PURE__*/React.createElement("div", {
    className: "w-24 h-24 border " + (filterExists(4) ? 'border-secondary' : 'border-gray-200') + " rounded-lg py-4 px-6 cursor-pointer mr-4 mb-4 md:mb-0 shadow-md hover:border-secondary  transition",
    onClick: function onClick() {
      return handleFilterChanged([4]);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center outline-none text-secondary"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-family-large",
    style: {
      fontSize: 29
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-3 text-14 truncate leading-24 w-full text-center"
  }, "L"))), /*#__PURE__*/React.createElement("div", {
    className: "w-24 h-24 border " + (filterExists(5) ? 'border-secondary' : 'border-gray-200') + " rounded-lg py-4 px-6 cursor-pointer mr-4 mb-4 md:mb-0 shadow-md hover:border-secondary  transition",
    onClick: function onClick() {
      return handleFilterChanged([5]);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center outline-none text-secondary"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-family-xlarge",
    style: {
      fontSize: 29
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-3 text-14 truncate leading-24 w-full text-center"
  }, "XL")))));
};
var SeatFilter = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.seatsRange, SeatsFilter$2);

var EquipmentFilter$2 = function EquipmentFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var handleFilterChanged = function handleFilterChanged(equipment) {
    if (hasCriteriaWithValue(equipment.key)) {
      criteriaDelete(equipment.key);
    } else {
      criteriaAdd(equipment.key);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-3 gap-1"
  }, map(orderBy(data, ['text']), function (eq) {
    var isSelected = includes(value, eq.key);
    return /*#__PURE__*/React.createElement("div", {
      key: "filter-eq-" + eq.key,
      className: "flex flex-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-secondary flex flex-row p-2 hover:bg-gray-200 rounded cursor-pointer transition",
      onClick: function onClick() {
        return handleFilterChanged(eq);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center border-2 border-gray-200 p-1 mr-2 w-6 h-6"
    }, isSelected && /*#__PURE__*/React.createElement("div", {
      className: "h-full w-full bg-primary"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row justify-between flex-1 relative " + (isSelected ? 'font-semibold' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "capitalize"
    }, eq.text), /*#__PURE__*/React.createElement("div", null, eq.value))));
  }));
};
var EquipmentFilter$3 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.equipments, EquipmentFilter$2);

var GenericColorListSecondary = function GenericColorListSecondary(_ref) {
  var items = _ref.items,
    values = _ref.values,
    handleFilterChanged = _ref.handleFilterChanged,
    gridClass = _ref.gridClass;
  var options = orderBy(map(items, function (item) {
    return {
      value: item.key,
      label: item.text,
      color: item.custom
    };
  }), ['label']);
  return /*#__PURE__*/React.createElement("div", {
    className: gridClass
  }, map(options, function (option) {
    var isSelected = includes(values, option.value);
    return /*#__PURE__*/React.createElement("div", {
      key: "filter-" + option.value,
      className: "flex items-center py-1 cursor-pointer",
      onClick: function onClick() {
        return handleFilterChanged(option);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center w-4 h-4 rounded mr-2 " + (option.color === '#fff' ? 'border border-secondary-three' : ''),
      style: {
        backgroundColor: option.color
      }
    }, isSelected && /*#__PURE__*/React.createElement("i", {
      className: "far fa-check font-bold " + (option.color === '#fff' ? 'text-primary' : 'text-white'),
      style: {
        fontSize: 10
      }
    })), /*#__PURE__*/React.createElement("span", {
      className: "text-primary capitalize"
    }, option.label));
  }), ";");
};
GenericColorListSecondary.defaultProps = {
  gridClass: 'grid grid-cols-2 gap-1'
};

var ExteriorColorFilter$2 = function ExteriorColorFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-secondary mb-2 mt-2"
  }, t('Body Color')), /*#__PURE__*/React.createElement(GenericColorListSecondary, {
    placeHolder: t('All'),
    items: orderBy(data, ['text']),
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    },
    gridClass: "grid grid-cols-3 md:grid-cols-4 gap-1"
  }));
};
var ExteriorColorFilter$3 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.exteriorColor, ExteriorColorFilter$2);

var InteriorColorFilter$2 = function InteriorColorFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-secondary mb-2 mt-2"
  }, t('Interior Color')), /*#__PURE__*/React.createElement(GenericColorListSecondary, {
    placeHolder: t('All'),
    items: orderBy(data, ['text']),
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    },
    gridClass: "grid grid-cols-3 md:grid-cols-4 gap-1"
  }));
};
var InteriorColorFilter$3 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.interiorColor, InteriorColorFilter$2);

var InteriorUpholstery$1 = function InteriorUpholstery(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-secondary mt-5"
  }, t('Upholstery')), /*#__PURE__*/React.createElement(GenericListSecondary, {
    items: orderBy(data, ['text']),
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    },
    containerClass: "grid grid-cols-3 md:grid-cols-4 gap-1"
  }));
};
var InteriorUpholsteryFilter$1 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.interiorUpholstery, InteriorUpholstery$1);

var initCoValue$1 = {
  min: '',
  max: ''
};
var CO2Filter$2 = function CO2Filter(_ref) {
  var currentValue = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaUpdate = _ref.criteriaUpdate,
    criteriaDelete = _ref.criteriaDelete;
  var activeFilter = currentValue && currentValue.length > 0 ? currentValue[0] : undefined;
  var _useState = useState(activeFilter ? {
      min: activeFilter[0],
      max: activeFilter[1]
    } : initCoValue$1),
    value = _useState[0],
    setValue = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleChange = function handleChange() {
    if (value.min !== '' || value.max !== '') {
      var range = [value.min, value.max];
      if (currentValue.length > 0) {
        criteriaUpdate(range);
      } else {
        criteriaAdd(range);
      }
    } else {
      criteriaDelete();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-secondary mb-2 mt-5"
  }, t('CO2 (g/km)')), /*#__PURE__*/React.createElement("div", {
    className: "flex",
    style: {
      height: 44
    }
  }, /*#__PURE__*/React.createElement("input", {
    className: "px-2 w-1/2 filter-input border border-gray-200 text-primary rounded-l focus:outline-none",
    value: value.min,
    style: {
      maxHeight: 46
    },
    placeholder: t('From'),
    onChange: function onChange(e) {
      return setValue(_extends({}, value, {
        min: e.target.value
      }));
    },
    onBlur: function onBlur() {
      return handleChange();
    }
  }), /*#__PURE__*/React.createElement("input", {
    className: "px-2 w-1/2 filter-input border-t border-b border-r border-gray-200 text-primary rounded-r focus:outline-none",
    value: value.max,
    style: {
      maxHeight: 46
    },
    placeholder: t('To'),
    onChange: function onChange(e) {
      return setValue(_extends({}, value, {
        max: e.target.value
      }));
    },
    onBlur: function onBlur() {
      return handleChange();
    }
  })));
};
var CO2Filter$3 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.co2Range, CO2Filter$2);

var EuroNormFilter$2 = function EuroNormFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-secondary mb-2 mt-5"
  }, t('Euro Emission Class')), /*#__PURE__*/React.createElement(GenericSelect, {
    placeHolder: t('All'),
    items: data,
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    }
  }));
};
var EuroNormFilter$3 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.euroNorm, EuroNormFilter$2);

var PriceFilter$1 = function PriceFilter(_ref) {
  var criteria = _ref.criteria;
  var _useTranslation = useTranslation();
  var priceFilter = find(criteria, function (f) {
    return f.type === SearchAgentCriteriaTypes.price;
  });
  var monthlyFilter = find(criteria, function (f) {
    return f.type === SearchAgentCriteriaTypes.monthlyPrice;
  });
  return (
    /*#__PURE__*/
    React.createElement("div", null, "TODO")
  );
};
PriceFilter$1.defaultProps = {
  radioButtonSize: 24
};
var PriceFilter$2 = baseSearchAgentCriteria(PriceFilter$1);

var labels$1 = {
  PK: 'PK',
  KW: 'KW'
};
var initPK$1 = {
  min: '',
  max: ''
};
var initKW$1 = {
  min: '',
  max: ''
};
var PowerFilter$2 = function PowerFilter(_ref) {
  var criteria = _ref.criteria,
    criteriaAdd = _ref.criteriaAdd,
    criteriaUpdate = _ref.criteriaUpdate,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteria = _ref.hasCriteria;
  var _useState = useState(labels$1.PK),
    activeOption = _useState[0],
    setActiveOption = _useState[1];
  var _useState2 = useState(initPK$1),
    pk = _useState2[0],
    setPk = _useState2[1];
  var _useState3 = useState(initKW$1),
    kw = _useState3[0],
    setKw = _useState3[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    var pkFilters = head(filter(criteria, function (f) {
      return f.type === SearchAgentCriteriaTypes.pk;
    }));
    var kwFilters = head(filter(criteria, function (f) {
      return f.type === SearchAgentCriteriaTypes.kw;
    }));
    if (pkFilters) {
      setPk({
        min: pkFilters.value[0],
        max: pkFilters.value[1]
      });
    }
    if (kwFilters) {
      setKw({
        min: kwFilters.value[0],
        max: kwFilters.value[1]
      });
    }
  }, []);
  var powerOptions = [{
    value: labels$1.PK,
    label: t('hp')
  }, {
    value: labels$1.KW,
    label: t('kW')
  }];
  var onPkChange = function onPkChange() {
    if (pk.min !== '' || pk.max !== '') {
      var value = [pk.min, pk.max];
      if (hasCriteria(criteria, SearchAgentCriteriaTypes.pk)) {
        criteriaUpdate(SearchAgentCriteriaTypes.pk, value);
      } else {
        criteriaAdd(SearchAgentCriteriaTypes.pk, value);
      }
    } else {
      criteriaDelete(SearchAgentCriteriaTypes.pk);
    }
  };
  var onKwChange = function onKwChange() {
    if (kw.min !== '' || kw.max !== '') {
      var value = [kw.min, kw.max];
      if (hasCriteria(criteria, SearchAgentCriteriaTypes.kw)) {
        criteriaUpdate(SearchAgentCriteriaTypes.kw, value);
      } else {
        criteriaAdd(SearchAgentCriteriaTypes.kw, value);
      }
    } else {
      criteriaDelete(FilterTypes.kw);
    }
  };
  var renderPK = function renderPK() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      className: "px-2 w-1/2 filter-input border border-gray-200 text-14 text-secondary rounded-l focus:outline-none",
      value: pk.min,
      style: {
        maxHeight: 46
      },
      placeholder: t('From'),
      onChange: function onChange(e) {
        return setPk(_extends({}, pk, {
          min: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onPkChange();
      }
    }), /*#__PURE__*/React.createElement("input", {
      className: "px-2 w-1/2 filter-input border-t border-b border-r border-gray-200 text-14 text-secondary rounded-r focus:outline-none",
      value: pk.max,
      style: {
        maxHeight: 46
      },
      placeholder: t('To'),
      onChange: function onChange(e) {
        return setPk(_extends({}, pk, {
          max: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onPkChange();
      }
    }));
  };
  var renderKW = function renderKW() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      className: "px-2 w-1/2 filter-input border border-gray-200 text-14 text-secondary rounded-l focus:outline-none",
      value: kw.min,
      style: {
        maxHeight: 46
      },
      placeholder: t('From'),
      onChange: function onChange(e) {
        return setKw(_extends({}, kw, {
          min: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onKwChange();
      }
    }), /*#__PURE__*/React.createElement("input", {
      className: "px-2 w-1/2 filter-input border-t border-b border-r border-gray-200 text-14 text-secondary rounded-r focus:outline-none",
      value: kw.max,
      style: {
        maxHeight: 46
      },
      placeholder: t('To'),
      onChange: function onChange(e) {
        return setKw(_extends({}, kw, {
          max: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onKwChange();
      }
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-semibold text-secondary mb-2 mt-5"
  }, t('Power')), /*#__PURE__*/React.createElement("div", {
    className: "flex text-14"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-2/5 mr-2"
  }, /*#__PURE__*/React.createElement(SelectBox, {
    value: find(powerOptions, function (i) {
      return i.value === activeOption;
    }),
    options: powerOptions,
    className: "focus:outline-none",
    isLoading: false,
    onChange: function onChange(option) {
      return setActiveOption(option.value);
    }
  })), /*#__PURE__*/React.createElement(Fade$1, {
    spy: activeOption
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-3/5 w-full flex"
  }, activeOption === labels$1.PK && renderPK(), activeOption === labels$1.KW && renderKW()))));
};
var PowerFilter$3 = baseSearchAgentCriteria(PowerFilter$2);

var WishesTextArea = function WishesTextArea(_ref) {
  var value = _ref.value,
    fieldUpdate = _ref.fieldUpdate;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(TextAreaField, {
    containerClass: "appearance-none block w-full focus:outline-none focus:border-gray-300 rounded-10",
    heightClass: "h-30",
    placeholder: t('Special wishes'),
    value: value.wishes,
    onChange: function onChange(value) {
      return fieldUpdate('wishes', value);
    },
    required: false
  });
};
var WishesTextArea$1 = baseSearchAgentField(WishesTextArea);

var keys = {
  basic: 'basic',
  equipments: 'equipments',
  exterior: 'exterior',
  upholstery: 'upholstery',
  environment: 'environment',
  extra: 'extra'
};
var searchAgentCategories = [{
  key: keys.basic,
  translation: function translation(t) {
    return t('Basic specifications');
  },
  priority: 1
}, {
  key: keys.equipments,
  translation: function translation(t) {
    return t('Equipment');
  },
  priority: 2
}, {
  key: keys.exterior,
  translation: function translation(t) {
    return t('Exterior');
  },
  priority: 3
}, {
  key: keys.upholstery,
  translation: function translation(t) {
    return t('Interior');
  },
  priority: 4
}, {
  key: keys.environment,
  translation: function translation(t) {
    return t('Milieu');
  },
  priority: 5
}, {
  key: keys.extra,
  translation: function translation(t) {
    return t('Do you have any special wishes or comments?');
  },
  priority: 6
}];
var SearchAgentCriteria = function SearchAgentCriteria(_ref) {
  var context = _ref.context;
  var _useState = useState(keys.basic),
    activeCategory = _useState[0],
    setActiveCategory = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    var element = document.getElementById(activeCategory);
    if (element) {
      var headerOffset = 71;
      var bodyRect = document.body.getBoundingClientRect().top;
      var elementRect = element.getBoundingClientRect().top;
      var elementPosition = elementRect - bodyRect;
      var offsetPosition = elementPosition - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'instant'
      });
    }
  }, [activeCategory]);
  var renderContent = function renderContent(key) {
    switch (key) {
      case keys.basic:
        return /*#__PURE__*/React.createElement("div", {
          className: "px-5 mb-5"
        }, /*#__PURE__*/React.createElement("div", {
          className: "grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4 mb-2"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MakesFilter$1, {
          context: context
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ModelsFilter$3, {
          context: context
        }))), /*#__PURE__*/React.createElement("div", {
          className: "mt-4"
        }, /*#__PURE__*/React.createElement(BodyFilter, {
          context: context
        })), /*#__PURE__*/React.createElement("div", {
          className: "grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4 mb-2"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FuelFilter$1, {
          context: context
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GearboxFilter$1, {
          context: context
        }))), /*#__PURE__*/React.createElement("div", {
          className: "md:w-1/2 pr-6"
        }, /*#__PURE__*/React.createElement(PriceFilter$2, {
          context: context
        })), /*#__PURE__*/React.createElement("div", {
          className: "grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4 mb-0 md:mb-2"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(YearFilter$3, {
          context: context
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MileageFilter$3, {
          context: context
        }))), /*#__PURE__*/React.createElement("div", {
          className: "grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4 mb-2"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PowerFilter$3, {
          context: context
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DoorsFilter$3, {
          context: context
        }))), /*#__PURE__*/React.createElement("div", {
          className: "grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4 mb-2"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(VatFilter$3, {
          context: context
        }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SeatFilter, {
          context: context
        })));
      case keys.equipments:
        return /*#__PURE__*/React.createElement("div", {
          className: "p-5"
        }, /*#__PURE__*/React.createElement(EquipmentFilter$3, {
          context: context
        }));
      case keys.exterior:
        return /*#__PURE__*/React.createElement("div", {
          className: "p-5"
        }, /*#__PURE__*/React.createElement(ExteriorColorFilter$3, {
          context: context
        }));
      case keys.upholstery:
        return /*#__PURE__*/React.createElement("div", {
          className: "p-5"
        }, /*#__PURE__*/React.createElement(InteriorColorFilter$3, {
          context: context
        }), /*#__PURE__*/React.createElement(InteriorUpholsteryFilter$1, {
          context: context
        }));
      case keys.environment:
        return /*#__PURE__*/React.createElement("div", {
          className: "px-5 mb-5"
        }, /*#__PURE__*/React.createElement("div", {
          className: "grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4 mb-2"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(EuroNormFilter$3, {
          context: context
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CO2Filter$3, {
          context: context
        }))));
      case keys.extra:
        return /*#__PURE__*/React.createElement("div", {
          className: "p-5"
        }, /*#__PURE__*/React.createElement(WishesTextArea$1, null));
      default:
        return /*#__PURE__*/React.createElement("div", null);
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "rounded border border-secondary-two relative"
  }, map(orderBy(searchAgentCategories, ['priority']), function (searchAgentCategory, i) {
    var isFirst = i === 0;
    var isLast = searchAgentCategories.length - 1 === i;
    var isActive = searchAgentCategory.key === activeCategory;
    return /*#__PURE__*/React.createElement("div", {
      key: "filter-category-" + i,
      id: searchAgentCategory.key,
      className: "border-secondary-two text-white " + (isLast ? '' : 'border-b')
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between cursor-pointer p-5 bg-secondary text-white " + (isFirst && 'rounded-t') + " " + (isLast && !isActive && 'rounded-b'),
      onClick: function onClick() {
        return setActiveCategory(searchAgentCategory.key !== activeCategory ? searchAgentCategory.key : '');
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 font-semibold"
    }, searchAgentCategory.translation(t)), /*#__PURE__*/React.createElement("i", {
      className: "fal " + (searchAgentCategory.key === activeCategory ? 'fa-angle-up' : 'fa-angle-down') + " text-white",
      style: {
        marginTop: 2
      }
    })), isActive && renderContent(searchAgentCategory.key));
  })));
};

var SearchAgentTopBar = function SearchAgentTopBar(_ref) {
  var criteria = _ref.criteria,
    criteriaDelete = _ref.criteriaDelete;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if ((criteria === null || criteria === void 0 ? void 0 : criteria.length) === 0) return /*#__PURE__*/React.createElement("div", null);
  return /*#__PURE__*/React.createElement(Sticky, {
    top: getStickiesOffset() + 1,
    activeClass: "w-full bg-white",
    innerZ: 50
  }, /*#__PURE__*/React.createElement(Scrollbars, {
    autoHeight: true,
    universal: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center bg-white py-5 overflow-x-auto"
  }, /*#__PURE__*/React.createElement("span", {
    className: "w-max flex-none pr-3 font-semibold"
  }, t('Selected filters'), ":"), map(filter(criteria, function (c) {
    return c.type !== FilterTypes.segment;
  }), function (c, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center px-5 py-2 " + (index === 0 ? 'ml-0' : 'ml-3') + " rounded bg-gray-100 hover:bg-gray-200 cursor-pointer transition",
      key: "filter-type-" + index,
      onClick: function onClick() {
        return criteriaDelete(c);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "w-max capitalize pr-3"
    }, c.label), ' ', /*#__PURE__*/React.createElement("i", {
      className: "fal fa-trash-alt font-normal"
    }));
  }))));
};
var SearchAgentTopBar$1 = baseSearchAgentTopBar(SearchAgentTopBar);

var SearchAgentUserForm = function SearchAgentUserForm(_ref) {
  var value = _ref.value,
    userFieldUpdate = _ref.userFieldUpdate,
    fieldUpdate = _ref.fieldUpdate,
    submit = _ref.submit,
    submitting = _ref.submitting,
    submitSuccess = _ref.submitSuccess,
    submitError = _ref.submitError,
    onPrevious = _ref.onPrevious,
    context = _ref.context;
  var _useState = useState(undefined),
    errors = _useState[0],
    setErrors = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var validate = function validate() {
    var errors = {};
    if (!hasValue(value.user.email)) {
      errors['email'] = t('Please fill in your e-mail address.');
    } else if (!isValidEmail(value.user.email)) {
      errors['email'] = t('Invalid email address');
    }
    if (!hasValue(value.user.title)) {
      errors['title'] = t('Please choose your gender.');
    }
    if (!hasValue(value.user.firstName)) {
      errors['firstName'] = t('Please fill in your first name.');
    }
    if (!hasValue(value.user.lastName)) {
      errors['lastName'] = t('Please fill in your first name.');
    }
    if (!hasValue(value.user.privacy)) {
      errors['privacy'] = t('Please accept the privacy terms.');
    }
    if (value.criteria.length < 1) {
      errors['criteria'] = t('Please choose at least one criteria.');
    }
    setErrors(errors);
    return keys$1(errors).length <= 0;
  };
  var handleSubmit = function handleSubmit() {
    if (validate()) {
      submit(value);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: ""
  }, submitSuccess && /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(SuccessIndicator, {
    success: t('Your request has been sent!')
  })), submitError && /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: t('Your request has NOT been sent!')
  })), /*#__PURE__*/React.createElement("div", {
    className: "rounded border border-secondary-four p-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(RadioInput, {
    options: genderOptions(t),
    label: t('Title'),
    errorText: errors && errors['title'] ? errors['title'] : undefined,
    value: value.user.title,
    onChange: function onChange(value) {
      return userFieldUpdate('title', value);
    },
    required: true,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "appearance-none block w-full focus:outline-none focus:border-gray-300 rounded mb-2 md:mb-0",
    label: t('First name'),
    placeholder: t('First name'),
    value: value.user.firstName,
    onChange: function onChange(value) {
      return userFieldUpdate('firstName', value);
    },
    errorText: errors && errors['firstName'] ? errors['firstName'] : undefined,
    required: true
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "appearance-none block w-full focus:outline-none focus:border-gray-300 rounded",
    label: t('Last name'),
    placeholder: t('Last name'),
    value: value.user.lastName,
    onChange: function onChange(value) {
      return userFieldUpdate('lastName', value);
    },
    errorText: errors && errors['lastName'] ? errors['lastName'] : undefined,
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "appearance-none block w-full focus:outline-none focus:border-gray-300 rounded mb-2 md:mb-0",
    label: t('Email'),
    placeholder: t('Email'),
    value: value.user.email,
    onChange: function onChange(value) {
      return userFieldUpdate('email', value);
    },
    errorText: errors && errors['email'] ? errors['email'] : undefined,
    required: true
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "appearance-none block w-full focus:outline-none focus:border-gray-300 rounded",
    label: t('Telephone'),
    placeholder: t('Telephone'),
    value: value.user.telephone,
    onChange: function onChange(value) {
      return userFieldUpdate('telephone', value);
    }
  })), /*#__PURE__*/React.createElement(TextAreaField, {
    containerClass: "appearance-none block w-full focus:outline-none focus:border-gray-300 rounded",
    heightClass: "h-30",
    label: t('Any comments'),
    placeholder: t('Comments'),
    value: value.notes,
    onChange: function onChange(value) {
      return fieldUpdate('notes', value);
    },
    required: false
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex my-6 text-secondary  " + (errors && errors['privacy'] !== undefined ? 'text-red-400' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center cursor-pointer",
    onClick: function onClick() {
      return userFieldUpdate('privacy', !value.user.privacy);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center border-2 border-gray-200 p-1 mr-2 w-6 h-6"
  }, value.user.privacy && /*#__PURE__*/React.createElement("div", {
    className: "h-full w-full bg-primary"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "mr-1 ml-2 " + (errors && errors['privacy'] !== undefined ? 'text-red-400' : '')
  }, t('I agree to the'), ' '), /*#__PURE__*/React.createElement(ExternalLink, {
    url: privacyUrl(context),
    className: "underline cursor-pointer " + (errors && errors['privacy'] !== undefined ? 'text-red-400' : ''),
    context: context
  }, t('privacy terms')), "."), errors && errors['criteria'] && /*#__PURE__*/React.createElement("div", {
    className: "flex md:hidden flex-1 items-center justify-center px-5 text-red-400 mt-5"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-exclamation-triangle mr-2"
  }), ' ', errors['criteria']), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between w-full mt-5"
  }, /*#__PURE__*/React.createElement("button", {
    className: "button alternate-button",
    onClick: onPrevious
  }, t('Modify filters')), errors && errors['criteria'] && /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex flex-1 items-center justify-end px-5 text-red-400"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-exclamation-triangle mr-2"
  }), ' ', errors['criteria']), /*#__PURE__*/React.createElement("button", {
    className: "button primary-button",
    onClick: handleSubmit
  }, submitting ? t('Sending...') : t('Send'))));
};
var SearchAgentUserForm$1 = baseSearchAgentForm(SearchAgentUserForm);

var viewTypes = {
  SearchCriteria: 'SearchCriteria',
  UserInfo: 'UserInfo'
};
var SearchAgent = function SearchAgent(_ref) {
  var data = _ref.data,
    loading = _ref.loading,
    context = _ref.context;
  var _useState = useState(viewTypes.SearchCriteria),
    currentView = _useState[0],
    setCurrentView = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (loading || !data) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, currentView === viewTypes.SearchCriteria && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchAgentTopBar$1, {
    context: context
  }), /*#__PURE__*/React.createElement(SearchAgentCriteria, {
    context: context
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end w-full mt-5"
  }, /*#__PURE__*/React.createElement("button", {
    className: "button primary-button",
    onClick: function onClick() {
      return setCurrentView(viewTypes.UserInfo);
    }
  }, t('Next'), ' '))), currentView === viewTypes.UserInfo && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SearchAgentTopBar$1, {
    context: context
  }), /*#__PURE__*/React.createElement(SearchAgentUserForm$1, {
    context: context,
    onPrevious: function onPrevious() {
      return setCurrentView(viewTypes.SearchCriteria);
    }
  }))));
};
var SearchAgent$1 = baseSearchAgent(SearchAgent);

var VehicleSearchAgent = function VehicleSearchAgent(_ref) {
  var text = _ref.text,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "mx-auto px-5 md:px-10 py-10",
    style: {
      maxWidth: 1000
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-5 xl:mb-12"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: text,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "py-10"
  }, /*#__PURE__*/React.createElement(SearchAgent$1, {
    context: context
  })));
};
VehicleSearchAgent.defaultProps = {
  text: DefaultText
};
VehicleSearchAgent.human = {
  nl: '',
  fr: '',
  en: ''
};

var SearchSuggestions = function SearchSuggestions(_ref) {
  var hits = _ref.hits,
    nbHits = _ref.nbHits,
    allUrl = _ref.allUrl,
    onAllResultClick = _ref.onAllResultClick,
    inputValue = _ref.inputValue,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAnalytics = useAnalytics(context),
    searchResultClickEventAnalytics = _useAnalytics.searchResultClickEventAnalytics;
  if (nbHits <= 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "absolute bg-white mt-1 w-full z-10 shadow-2xl px-8 py-6",
      style: {
        top: '3.25rem'
      }
    }, /*#__PURE__*/React.createElement("h3", {
      className: "mb-2 text-secondary font-bold leading-29"
    }, t('No results found'), "."), /*#__PURE__*/React.createElement("p", {
      className: "mb-4 text-secondary font-light leading-32"
    }, t('Let our Car Agent know which criteria you find important and we will search in our network for your dream car'), "."), /*#__PURE__*/React.createElement(InternalLink, {
      page: context.defaultPageNames.vehicleSearchAgent,
      className: "button primary-button inline-block px-9",
      context: context
    }, t('Find a car for me')));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "absolute top-12 bg-white mt-1 w-full z-10 shadow-2xl"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "underline px-8 pb-4 pt-8 cursor-pointer",
    onClick: onAllResultClick
  }, /*#__PURE__*/React.createElement("a", {
    href: allUrl
  }, nbHits, " ", t('results'))), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-4 gap-4 px-8 py-4"
  }, map(hits.slice(0, 8), function (searchResult, index) {
    var _JSON$parse$;
    return /*#__PURE__*/React.createElement("div", {
      onClick: function onClick(e) {
        searchResultClickEventAnalytics({
          searchResultCount: nbHits,
          filter: inputValue || '',
          searchResultPosition: index + 1,
          searchResult: searchResult.make + " " + searchResult.model
        });
        onAllResultClick(e);
      }
    }, /*#__PURE__*/React.createElement(InternalLink, {
      key: searchResult.reference,
      url: searchResult.url,
      context: context
    }, /*#__PURE__*/React.createElement("div", {
      className: "cursor-pointer"
    }, /*#__PURE__*/React.createElement("img", {
      className: "",
      src: (_JSON$parse$ = JSON.parse(searchResult.images)[0]) === null || _JSON$parse$ === void 0 ? void 0 : _JSON$parse$.uri,
      alt: "Search result"
    }), /*#__PURE__*/React.createElement("p", {
      className: "text-14 mt-2 text-center font-semibold truncate"
    }, searchResult.make, " ", searchResult.model))));
  })), /*#__PURE__*/React.createElement(InternalLink, {
    url: allUrl,
    context: context
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center bg-primary hover:bg-secondary-three cursor-pointer transition",
    onClick: onAllResultClick
  }, /*#__PURE__*/React.createElement("p", {
    className: " text-white font-semibold py-4"
  }, t('Show all') + (" " + nbHits + " ") + t('results')))));
};

var SearchBoxHero = function SearchBoxHero(_ref) {
  var getSuggestions = _ref.getSuggestions,
    queryResult = _ref.queryResult,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(''),
    inputValue = _useState[0],
    setInputValue = _useState[1];
  var _useState2 = useState(false),
    setLoading = _useState2[1];
  var _useAnalytics = useAnalytics(context),
    _useAnalytics$searchQ = _useAnalytics.searchQueryEventAnalytics,
    searchQueryEventAnalytics = _useAnalytics$searchQ === void 0 ? function (data) {
      return null;
    } : _useAnalytics$searchQ,
    _useAnalytics$buttonC = _useAnalytics.buttonClickEventAnalytics,
    buttonClickEventAnalytics = _useAnalytics$buttonC === void 0 ? function (data) {
      return null;
    } : _useAnalytics$buttonC;
  var onSubmit = function onSubmit(event) {
    event === null || event === void 0 ? void 0 : event.preventDefault();
    buttonClickEventAnalytics({
      analyticsButtonName: 'search',
      analyticsButtonType: 'button',
      analyticsButtonCategory: 'inbound-link',
      analyticsButtonPosition: 'SearchBoxHero',
      url: queryResult === null || queryResult === void 0 ? void 0 : queryResult.allUrl
    });
    if (queryResult !== null && queryResult !== void 0 && queryResult.nbHits && inputValue) {
      setLoading(true);
      setInputValue('');
      navigateInternalUrl(context, queryResult === null || queryResult === void 0 ? void 0 : queryResult.allUrl, false);
    }
  };
  useEffect(function () {
    if (queryResult) {
      searchQueryEventAnalytics({
        searchKeyword: inputValue,
        searchResultCount: queryResult === null || queryResult === void 0 ? void 0 : queryResult.nbHits
      });
    }
  }, [queryResult]);
  return /*#__PURE__*/React.createElement("form", {
    autoComplete: "off",
    className: "w-full flex shadow-xl relative",
    style: {
      maxWidth: 960
    },
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement("input", {
    autoComplete: "off",
    name: "search-box",
    type: "text",
    placeholder: t("I'm searching for a white Volkswagen Golf"),
    onChange: function onChange(input) {
      var _input$target;
      getSuggestions(input);
      setInputValue(input === null || input === void 0 ? void 0 : (_input$target = input.target) === null || _input$target === void 0 ? void 0 : _input$target.value);
    },
    suggestions: queryResult,
    className: "w-full px-5 py-3 outline-none border border-transparent focus-within:border-primary"
  }), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "flex-none bg-primary text-white w-12 h-full"
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-search"
  })), (queryResult === null || queryResult === void 0 ? void 0 : queryResult.nbHits) !== undefined && inputValue && /*#__PURE__*/React.createElement(SearchSuggestions, {
    hits: queryResult.hits,
    nbHits: queryResult.nbHits,
    allUrl: queryResult.allUrl,
    inputValue: inputValue,
    context: context,
    onAllResultClick: function onAllResultClick() {
      return setInputValue('');
    }
  }));
};
var SearchBoxHero$1 = baseSearchBox(SearchBoxHero);

var VehicleSearchText = function VehicleSearchText(_ref) {
  var _context$defaultPageN, _context$defaultPageN2;
  var text = _ref.text,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      background: '#F9F8FA'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container py-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, context !== null && context !== void 0 && context.lmaHomePage ? /*#__PURE__*/React.createElement(ExternalLink, {
    url: context === null || context === void 0 ? void 0 : context.lmaHomePage,
    className: "text-primary underline flex-none",
    target: "_self",
    context: context
  }, t('Home')) : /*#__PURE__*/React.createElement(InternalLink, {
    page: context === null || context === void 0 ? void 0 : (_context$defaultPageN = context.defaultPageNames) === null || _context$defaultPageN === void 0 ? void 0 : _context$defaultPageN.home,
    className: "text-primary underline flex-none",
    context: context
  }, t('Home')), /*#__PURE__*/React.createElement("span", {
    className: " text-secondary mx-2"
  }, "-"), /*#__PURE__*/React.createElement("span", {
    className: "text-secondary font-semibold"
  }, t('Used car vehicles'))), /*#__PURE__*/React.createElement("div", {
    className: "text-center text-28 leading-28 sm:leading-none sm:text-48 md:text-60 pt-10 pb-5 text-secondary"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: text,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center pb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex flex-col items-end mx-0 md:mx-5 lg:mx-26",
    style: {
      maxWidth: 900
    }
  }, /*#__PURE__*/React.createElement(SearchBoxHero$1, {
    context: context
  }), /*#__PURE__*/React.createElement(InternalLink, {
    page: context === null || context === void 0 ? void 0 : (_context$defaultPageN2 = context.defaultPageNames) === null || _context$defaultPageN2 === void 0 ? void 0 : _context$defaultPageN2.vehicles,
    className: "mt-5 text-sm text-secondary",
    context: context,
    analyticsButtonName: "search",
    analyticsButtonText: t('Advanced search')
  }, /*#__PURE__*/React.createElement("span", {
    className: "underline"
  }, t('Advanced search'))))), /*#__PURE__*/React.createElement("div", null))), /*#__PURE__*/React.createElement("div", {
    style: {
      background: '#F9F8FA',
      height: 200,
      zIndex: '-2'
    },
    className: "w-full absolute"
  }));
};
VehicleSearchText.defaultProps = {
  text: DefaultText
};
VehicleSearchText.human = {
  nl: 'Vehicle home search',
  fr: 'Vehicle home search',
  en: 'Vehicle home search'
};
VehicleSearchText.preview = function () {
  return /*#__PURE__*/React.createElement("div", null, "VEHICLE HOME SEARCH");
};

var VehicleSliderSkeleton = function VehicleSliderSkeleton(_ref) {
  var totalSlides = _ref.totalSlides;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "overflow-x-hidden w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-nowrap relative left-0 " + (totalSlides < 2 ? '' : 'space-x-2.5'),
    style: {
      width: 'fit-content'
    }
  }, times(totalSlides, function (slide) {
    return /*#__PURE__*/React.createElement(VehicleCardSkeleton, {
      key: slide
    });
  })))));
};
VehicleSliderSkeleton.defaultProps = {
  totalSlides: 4
};

var VehicleSlider = function VehicleSlider(_ref) {
  var cards = _ref.cards,
    loading = _ref.loading,
    error = _ref.error;
  var sliderRef = useRef(null);
  if (loading) {
    var totalSlides = hasWindow() ? window.innerWidth < 768 ? 1 : 4 : 4;
    return /*#__PURE__*/React.createElement(VehicleSliderSkeleton, {
      totalSlides: totalSlides
    });
  }
  if (error) {
    return /*#__PURE__*/React.createElement("div", null, "Error...");
  }
  var onNextButtonClick = function onNextButtonClick() {
    if (!(sliderRef !== null && sliderRef !== void 0 && sliderRef.current)) return;
    if (sliderRef.current.scrollLeft < sliderRef.current.scrollWidth - sliderRef.current.clientWidth - 5) {
      sliderRef.current.scrollBy({
        left: sliderRef.current.clientWidth,
        behavior: 'smooth'
      });
    } else {
      sliderRef.current.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
    }
  };
  var onPreviousButtonClick = function onPreviousButtonClick() {
    if (!(sliderRef !== null && sliderRef !== void 0 && sliderRef.current)) return;
    if (sliderRef.current.scrollLeft > 5) {
      sliderRef.current.scrollBy({
        left: -sliderRef.current.clientWidth,
        behavior: 'smooth'
      });
    } else {
      sliderRef.current.scrollTo({
        left: sliderRef.current.scrollWidth,
        behavior: 'smooth'
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "relative w-full"
  }, /*#__PURE__*/React.createElement("div", {
    ref: sliderRef,
    className: "flex overflow-x-scroll pb-8 slider-scrollbar scrollbar-snap-x"
  }, map(cards, function (card, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: (index !== 0 ? 'ml-5 lg:ml-4' : '') + " w-full sm:w-half-minus-quarter-rem md3:w-third-minus-half-rem lg2:w-quarter-minus-three-quarter-rem flex-none",
      style: {
        scrollSnapAlign: 'start'
      }
    }, card);
  })), /*#__PURE__*/React.createElement("div", {
    className: "absolute -left-5",
    style: {
      top: 'calc(50% - 1.25rem)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center h-10 w-10 rounded-full bg-secondary cursor-pointer",
    onClick: function onClick() {
      return onPreviousButtonClick();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-chevron-left text-white",
    style: {
      marginRight: 1,
      marginTop: 1
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "absolute -right-5",
    style: {
      top: 'calc(50% - 1.25rem)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center h-10 w-10 rounded-full bg-secondary cursor-pointer",
    onClick: function onClick() {
      return onNextButtonClick();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-chevron-right text-white",
    style: {
      marginLeft: 1,
      marginTop: 1
    }
  }))));
};
var VehicleSlider$1 = baseSliderWithCustomImageCard(VehicleSlider);

var ImageCard = function ImageCard(_ref) {
  var _custom_card$image;
  var custom_card = _ref.custom_card,
    context = _ref.context;
  return /*#__PURE__*/React.createElement(ActionLink, {
    context: context,
    className: "shadow overflow-hidden hover:opacity cursor-pointer rounded-4",
    action: custom_card === null || custom_card === void 0 ? void 0 : custom_card.action,
    style: {
      background: "url(" + (custom_card === null || custom_card === void 0 ? void 0 : (_custom_card$image = custom_card.image) === null || _custom_card$image === void 0 ? void 0 : _custom_card$image.desktop) + ") no-repeat center bottom",
      backgroundSize: 'cover',
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", null));
};

var VehicleSliderWithDraftJsTitle = function VehicleSliderWithDraftJsTitle(_ref) {
  var title = _ref.title,
    filters = _ref.filters,
    custom_card = _ref.custom_card,
    context = _ref.context;
  var eventName = 'deals';
  if (filters !== null && filters !== void 0 && filters.similar) {
    eventName = 'similar';
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "container mb-5 md:mb-12"
  }, title && title !== undefined &&
  /*#__PURE__*/
  React.createElement("div", {
    className: "mb-5 text-32 text-secondary font-bold"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "w-full mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full block md:flex"
  }, /*#__PURE__*/React.createElement(VehicleSlider$1, {
    filters: filters,
    renderVehicleCard: function renderVehicleCard(vehicle, context) {
      return /*#__PURE__*/React.createElement(VehicleCard$1, {
        eventName: eventName,
        vehicle: vehicle,
        context: context
      });
    },
    renderCustomImageCard: custom_card ? function () {
      return /*#__PURE__*/React.createElement(ImageCard, {
        custom_card: custom_card,
        context: context
      });
    } : undefined,
    customImageCardIndex: 0,
    context: context
  }))));
};
VehicleSliderWithDraftJsTitle.defaultProps = {
  title: DefaultText
};
VehicleSliderWithDraftJsTitle.human = {
  nl: 'Vehicles slider with title',
  fr: 'Vehicles slider with title',
  en: 'Vehicles slider with title'
};
VehicleSliderWithDraftJsTitle.preview = function () {
  return /*#__PURE__*/React.createElement("div", null, "Vehicles slider with title");
};

var useVehicleCardSameHeight = function useVehicleCardSameHeight(childWrapperClass, childClass, childMinHeight, childTargetHeight) {
  var getMaxHeight = function getMaxHeight(elements) {
    var heights = map(elements, function (element) {
      var el = getElementByClassNameOrNull(element, childClass);
      return el ? el.clientHeight : 0;
    });
    return max(heights);
  };
  var setElementsMinHeight = function setElementsMinHeight(elements, height) {
    map(elements, function (element) {
      var el = getElementByClassNameOrNull(element, childWrapperClass);
      if (el) {
        el.style.minHeight = height > childMinHeight ? childTargetHeight + "px" : height + "px";
      }
    });
  };
  var _applySameCardSize = function applySameCardSize(numberCards, wrapperClass, separatorClass) {
    var addEvery = numberCards;
    if (addEvery > 1) {
      var cardsWrapper = getDocumentFirstElementByClassName(wrapperClass);
      if (cardsWrapper) {
        var cardsElements = filter(cardsWrapper.children, function (child) {
          return !child.classList.contains(separatorClass);
        });
        flatten(chunk(cardsElements, addEvery).map(function (cardElementsSection) {
          if (addEvery > 1) {
            var maxHeight = getMaxHeight(cardElementsSection);
            setElementsMinHeight(cardElementsSection, maxHeight);
          }
        }));
      }
    }
  };
  return {
    applySameCardSize: function applySameCardSize(numberCards, wrapperClass, separatorClass) {
      return _applySameCardSize(numberCards, wrapperClass, separatorClass);
    }
  };
};

var numberCardsPerScreenWidth = function numberCardsPerScreenWidth(width) {
  var numberCards = 1;
  if (width >= 600 && width < 962) numberCards = 2;
  if (width >= 962 && width < 1200) numberCards = 3;
  if (width >= 1200) numberCards = 4;
  return numberCards;
};
var grid = "grid grid-cols-1 sm:grid-cols-2 sm2:grid-cols-3 md:grid-cols-4 gap-4";
var getNumberOfCardsPerScreen = function getNumberOfCardsPerScreen(width) {
  var screenWidth = width;
  screenWidth = hasWindow() && screenWidth === 0 ? window.innerWidth : screenWidth;
  return numberCardsPerScreenWidth(screenWidth);
};
var VehicleSliderGrid = function VehicleSliderGrid(_ref) {
  var cards = _ref.cards,
    loading = _ref.loading,
    error = _ref.error;
  var _useState = useState(cards),
    cardsWithSeparator = _useState[0],
    setCardsWithSeparator = _useState[1];
  var _useWindowDimensions = useWindowDimensions(),
    width = _useWindowDimensions.width;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useDeviceType = useDeviceType(),
    isMobile = _useDeviceType.isMobile;
  var _useVehicleCardSameHe = useVehicleCardSameHeight('specifications-wrapper', 'specifications', 50, 84),
    applySameCardSize = _useVehicleCardSameHe.applySameCardSize;
  useEffect(function () {
    if (!loading && !isMobile) {
      var numberCards = getNumberOfCardsPerScreen(width);
      applySameCardSize(numberCards, 'vehicles-list', 'separator');
    }
  }, [cardsWithSeparator, width, loading, isMobile]);
  useEffect(function () {
    if (!loading) {
      var vehiclesWithBorderSeparator = addSeparatorToVehiclesList(getNumberOfCardsPerScreen(width), cards, 'separator');
      setCardsWithSeparator(vehiclesWithBorderSeparator);
    }
  }, [loading, cards, width]);
  if (loading || !cardsWithSeparator) {
    return /*#__PURE__*/React.createElement("div", {
      className: grid + " space-y-5 md:space-y-0"
    }, times(8, function (item) {
      return /*#__PURE__*/React.createElement(VehicleCardSkeleton, {
        key: "list-vehicle-card-" + item,
        options: {
          width: '100%',
          height: 536
        }
      });
    }));
  }
  if (error) {
    return /*#__PURE__*/React.createElement("div", {
      className: "text-white"
    }, t('Something went wrong') + '...');
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "vehicles-list " + grid
  }, map(cardsWithSeparator, function (card, index) {
    var isLast = index === cardsWithSeparator.length - 1;
    if ((card === null || card === void 0 ? void 0 : card._type) === 'separator') {
      return /*#__PURE__*/React.createElement("div", {
        key: "card-" + index,
        className: "separator bg-gray-light mb-4 mt-4 col-span-full h-px " + (!isLast ? '' : 'hidden')
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      className: ""
    }, card);
  }));
};
var VehicleSliderGrid$1 = baseSliderWithCustomImageCard(VehicleSliderGrid);

var VehiclesBasicWithAction = function VehiclesBasicWithAction(_ref) {
  var filters = _ref.filters,
    all_action = _ref.all_action,
    context = _ref.context;
  var _useDeviceType = useDeviceType(),
    isMobile = _useDeviceType.isMobile;
  return /*#__PURE__*/React.createElement("div", {
    className: "container mb-5 md:mb-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full mb-16"
  }, /*#__PURE__*/React.createElement(VehicleSliderGrid$1, {
    filters: filters,
    renderVehicleCard: function renderVehicleCard(vehicle, context) {
      return /*#__PURE__*/React.createElement(VehicleCard$1, {
        vehicle: vehicle,
        context: context,
        applySpecificationsMinHeight: !isMobile
      });
    },
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-full"
  }, /*#__PURE__*/React.createElement(ActionLink, {
    action: all_action,
    context: context,
    className: "button primary-button hover:opacity-95 transition text-white font-bold rounded-3 "
  })));
};
VehiclesBasicWithAction.defaultProps = {
  filters: [],
  all_action: DefaultAction
};
VehiclesBasicWithAction.human = {
  nl: 'Vehicle Grid',
  fr: 'Vehicle Grid',
  en: 'Vehicle Grid'
};

export { AdvertisementBanner, BannerJsonImageAndText, BannerMyWaySelfCheckAudiApproved, BannerUspAndTitle, Breadcrumbs, CookieBanner$1 as CookieBanner, DealerLocatorWidget, FavoriteVehicles, FinanceBanner$1 as FinanceBanner, FinancingTextBlock$1 as FinancingTextBlock, FooterMenuContactMenuSocialsCopyrightBottomMenu, FooterMenuContactMenuSocialsCopyrightBottomMenuWithLogo, HeaderLogoMenuWithSubsTopMenu, PageNotFound, Paragraph, SalonDealsHero, Separator, VehicleCompare, VehicleCompareBanner$1 as VehicleCompareBanner, VehicleDetailWithAdds, VehicleListWithAdds, VehicleSearchAgent, VehicleSearchText, VehicleSliderWithDraftJsTitle, VehiclesBasicWithAction, config };
